// AUTO-GENERATED by scripts/build-data.mjs — do not edit by hand.
// Source: @unicode/unicode-16.0.0 (UCD) + UTS#39 confusables 16.0.0.
// Re-run `npm run build:data` after editing src/data/symbols.ts to refresh.

export interface SymbolRecord {
  /** Raw symbol string (may be a multi-codepoint sequence). */
  symbol: string;
  /** URL-safe canonical slug. */
  slug: string;
  /** All codepoints in the sequence. */
  codepoints: number[];
  /** First codepoint — used as the primary lookup key for block/script/gc. */
  primary: number;
  /** Canonical Unicode Name (title-cased) or composed sequence name. */
  name: string;
  /** Where the name came from: real UCD, composed sequence, or fallback. */
  nameSource: "ucd" | "ucd-seq" | "fallback";
  /** Other UCD-recorded aliases (abbreviation, alternate, control, etc.). */
  aliases: string[];
  /** Unicode block name (e.g. "Arrows"). */
  block: string | null;
  /** Unicode script name (e.g. "Latin"). */
  script: string | null;
  /** General_Category long name (e.g. "Math Symbol"). */
  generalCategory: string | null;
  /** Curated category this symbol belongs to. */
  categorySlug: string;
  categoryName: string;
  /** Slugs of visually confusable symbols also in this index (UTS#39). */
  lookalikes: string[];
  /** Slugs of other indexed symbols sharing the same Unicode block. */
  blockNeighbors: string[];
  /** Phase 10 — the primary codepoint carries the Emoji property. */
  isEmoji: boolean;
  /** Single-codepoint emoji that accepts a Fitzpatrick skin-tone modifier. */
  isEmojiModifierBase: boolean;
  /** Single-codepoint emoji that accepts U+FE0E / U+FE0F variation selectors. */
  supportsVariationSelector: boolean;
  /** Default presentation per UCD, or null when the cp is not an emoji. */
  defaultPresentation: "emoji" | "text" | null;
  /** Sequence contains a ZWJ (U+200D) — i.e. it's an emoji ZWJ sequence. */
  hasZwj: boolean;
}

export const SYMBOLS: SymbolRecord[] = [
  {
    "symbol": "♥",
    "slug": "black-heart-suit",
    "codepoints": [
      9829
    ],
    "primary": 9829,
    "name": "Black Heart Suit",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "heart-symbols",
    "categoryName": "Heart Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini",
      "cancer"
    ]
  },
  {
    "symbol": "♡",
    "slug": "white-heart-suit",
    "codepoints": [
      9825
    ],
    "primary": 9825,
    "name": "White Heart Suit",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "heart-symbols",
    "categoryName": "Heart Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini",
      "cancer"
    ]
  },
  {
    "symbol": "❤",
    "slug": "heavy-black-heart",
    "codepoints": [
      10084
    ],
    "primary": 10084,
    "name": "Heavy Black Heart",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "heart-symbols",
    "categoryName": "Heart Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star",
      "heavy-outlined-black-star"
    ]
  },
  {
    "symbol": "❣",
    "slug": "heavy-heart-exclamation-mark-ornament",
    "codepoints": [
      10083
    ],
    "primary": 10083,
    "name": "Heavy Heart Exclamation Mark Ornament",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "heart-symbols",
    "categoryName": "Heart Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star",
      "heavy-outlined-black-star"
    ]
  },
  {
    "symbol": "❥",
    "slug": "rotated-heavy-black-heart-bullet",
    "codepoints": [
      10085
    ],
    "primary": 10085,
    "name": "Rotated Heavy Black Heart Bullet",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "heart-symbols",
    "categoryName": "Heart Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star",
      "heavy-outlined-black-star"
    ]
  },
  {
    "symbol": "❦",
    "slug": "floral-heart",
    "codepoints": [
      10086
    ],
    "primary": 10086,
    "name": "Floral Heart",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "heart-symbols",
    "categoryName": "Heart Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star",
      "heavy-outlined-black-star"
    ]
  },
  {
    "symbol": "❧",
    "slug": "rotated-floral-heart-bullet",
    "codepoints": [
      10087
    ],
    "primary": 10087,
    "name": "Rotated Floral Heart Bullet",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "heart-symbols",
    "categoryName": "Heart Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star",
      "heavy-outlined-black-star"
    ]
  },
  {
    "symbol": "🧡",
    "slug": "orange-heart",
    "codepoints": [
      129505
    ],
    "primary": 129505,
    "name": "Orange Heart",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "heart-symbols",
    "categoryName": "Heart Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan",
      "guide-dog"
    ]
  },
  {
    "symbol": "💛",
    "slug": "yellow-heart",
    "codepoints": [
      128155
    ],
    "primary": 128155,
    "name": "Yellow Heart",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "heart-symbols",
    "categoryName": "Heart Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration",
      "glowing-star"
    ]
  },
  {
    "symbol": "💚",
    "slug": "green-heart",
    "codepoints": [
      128154
    ],
    "primary": 128154,
    "name": "Green Heart",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "heart-symbols",
    "categoryName": "Heart Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration",
      "glowing-star"
    ]
  },
  {
    "symbol": "💙",
    "slug": "blue-heart",
    "codepoints": [
      128153
    ],
    "primary": 128153,
    "name": "Blue Heart",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "heart-symbols",
    "categoryName": "Heart Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration",
      "glowing-star"
    ]
  },
  {
    "symbol": "💜",
    "slug": "purple-heart",
    "codepoints": [
      128156
    ],
    "primary": 128156,
    "name": "Purple Heart",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "heart-symbols",
    "categoryName": "Heart Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration",
      "glowing-star"
    ]
  },
  {
    "symbol": "🖤",
    "slug": "black-heart",
    "codepoints": [
      128420
    ],
    "primary": 128420,
    "name": "Black Heart",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "heart-symbols",
    "categoryName": "Heart Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration",
      "glowing-star"
    ]
  },
  {
    "symbol": "🤍",
    "slug": "white-heart",
    "codepoints": [
      129293
    ],
    "primary": 129293,
    "name": "White Heart",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "heart-symbols",
    "categoryName": "Heart Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan",
      "guide-dog"
    ]
  },
  {
    "symbol": "🤎",
    "slug": "brown-heart",
    "codepoints": [
      129294
    ],
    "primary": 129294,
    "name": "Brown Heart",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "heart-symbols",
    "categoryName": "Heart Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan",
      "guide-dog"
    ]
  },
  {
    "symbol": "🩷",
    "slug": "pink-heart",
    "codepoints": [
      129655
    ],
    "primary": 129655,
    "name": "Pink Heart",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Symbols And Pictographs Extended A",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "heart-symbols",
    "categoryName": "Heart Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "light-blue-heart",
      "grey-heart",
      "stethoscope",
      "adhesive-bandage",
      "crutch",
      "x-ray",
      "drop-of-blood",
      "anatomical-heart",
      "lungs",
      "potted-plant",
      "wood",
      "rock"
    ]
  },
  {
    "symbol": "🩵",
    "slug": "light-blue-heart",
    "codepoints": [
      129653
    ],
    "primary": 129653,
    "name": "Light Blue Heart",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Symbols And Pictographs Extended A",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "heart-symbols",
    "categoryName": "Heart Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "pink-heart",
      "grey-heart",
      "stethoscope",
      "adhesive-bandage",
      "crutch",
      "x-ray",
      "drop-of-blood",
      "anatomical-heart",
      "lungs",
      "potted-plant",
      "wood",
      "rock"
    ]
  },
  {
    "symbol": "🩶",
    "slug": "grey-heart",
    "codepoints": [
      129654
    ],
    "primary": 129654,
    "name": "Grey Heart",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Symbols And Pictographs Extended A",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "heart-symbols",
    "categoryName": "Heart Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "pink-heart",
      "light-blue-heart",
      "stethoscope",
      "adhesive-bandage",
      "crutch",
      "x-ray",
      "drop-of-blood",
      "anatomical-heart",
      "lungs",
      "potted-plant",
      "wood",
      "rock"
    ]
  },
  {
    "symbol": "💕",
    "slug": "two-hearts",
    "codepoints": [
      128149
    ],
    "primary": 128149,
    "name": "Two Hearts",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "heart-symbols",
    "categoryName": "Heart Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration",
      "glowing-star"
    ]
  },
  {
    "symbol": "💖",
    "slug": "sparkling-heart",
    "codepoints": [
      128150
    ],
    "primary": 128150,
    "name": "Sparkling Heart",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "heart-symbols",
    "categoryName": "Heart Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration",
      "glowing-star"
    ]
  },
  {
    "symbol": "💗",
    "slug": "growing-heart",
    "codepoints": [
      128151
    ],
    "primary": 128151,
    "name": "Growing Heart",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "heart-symbols",
    "categoryName": "Heart Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration",
      "glowing-star"
    ]
  },
  {
    "symbol": "💘",
    "slug": "heart-with-arrow",
    "codepoints": [
      128152
    ],
    "primary": 128152,
    "name": "Heart With Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "heart-symbols",
    "categoryName": "Heart Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration",
      "glowing-star"
    ]
  },
  {
    "symbol": "💝",
    "slug": "heart-with-ribbon",
    "codepoints": [
      128157
    ],
    "primary": 128157,
    "name": "Heart With Ribbon",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "heart-symbols",
    "categoryName": "Heart Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "revolving-hearts",
      "heart-decoration",
      "glowing-star"
    ]
  },
  {
    "symbol": "💞",
    "slug": "revolving-hearts",
    "codepoints": [
      128158
    ],
    "primary": 128158,
    "name": "Revolving Hearts",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "heart-symbols",
    "categoryName": "Heart Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "heart-decoration",
      "glowing-star"
    ]
  },
  {
    "symbol": "💟",
    "slug": "heart-decoration",
    "codepoints": [
      128159
    ],
    "primary": 128159,
    "name": "Heart Decoration",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "heart-symbols",
    "categoryName": "Heart Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "glowing-star"
    ]
  },
  {
    "symbol": "★",
    "slug": "black-star",
    "codepoints": [
      9733
    ],
    "primary": 9733,
    "name": "Black Star",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini",
      "cancer"
    ]
  },
  {
    "symbol": "☆",
    "slug": "white-star",
    "codepoints": [
      9734
    ],
    "primary": 9734,
    "name": "White Star",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini",
      "cancer"
    ]
  },
  {
    "symbol": "✦",
    "slug": "black-four-pointed-star",
    "codepoints": [
      10022
    ],
    "primary": 10022,
    "name": "Black Four Pointed Star",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star",
      "heavy-outlined-black-star"
    ]
  },
  {
    "symbol": "✧",
    "slug": "white-four-pointed-star",
    "codepoints": [
      10023
    ],
    "primary": 10023,
    "name": "White Four Pointed Star",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star",
      "heavy-outlined-black-star"
    ]
  },
  {
    "symbol": "✩",
    "slug": "stress-outlined-white-star",
    "codepoints": [
      10025
    ],
    "primary": 10025,
    "name": "Stress Outlined White Star",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star",
      "heavy-outlined-black-star"
    ]
  },
  {
    "symbol": "✪",
    "slug": "circled-white-star",
    "codepoints": [
      10026
    ],
    "primary": 10026,
    "name": "Circled White Star",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star",
      "heavy-outlined-black-star"
    ]
  },
  {
    "symbol": "✫",
    "slug": "open-centre-black-star",
    "codepoints": [
      10027
    ],
    "primary": 10027,
    "name": "Open Centre Black Star",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "black-centre-white-star",
      "outlined-black-star",
      "heavy-outlined-black-star"
    ]
  },
  {
    "symbol": "✬",
    "slug": "black-centre-white-star",
    "codepoints": [
      10028
    ],
    "primary": 10028,
    "name": "Black Centre White Star",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "outlined-black-star",
      "heavy-outlined-black-star"
    ]
  },
  {
    "symbol": "✭",
    "slug": "outlined-black-star",
    "codepoints": [
      10029
    ],
    "primary": 10029,
    "name": "Outlined Black Star",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "heavy-outlined-black-star"
    ]
  },
  {
    "symbol": "✮",
    "slug": "heavy-outlined-black-star",
    "codepoints": [
      10030
    ],
    "primary": 10030,
    "name": "Heavy Outlined Black Star",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "✯",
    "slug": "pinwheel-star",
    "codepoints": [
      10031
    ],
    "primary": 10031,
    "name": "Pinwheel Star",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "✰",
    "slug": "shadowed-white-star",
    "codepoints": [
      10032
    ],
    "primary": 10032,
    "name": "Shadowed White Star",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "⋆",
    "slug": "star-operator",
    "codepoints": [
      8902
    ],
    "primary": 8902,
    "name": "Star Operator",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation",
      "n-ary-product"
    ]
  },
  {
    "symbol": "✴",
    "slug": "eight-pointed-black-star",
    "codepoints": [
      10036
    ],
    "primary": 10036,
    "name": "Eight Pointed Black Star",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "✵",
    "slug": "eight-pointed-pinwheel-star",
    "codepoints": [
      10037
    ],
    "primary": 10037,
    "name": "Eight Pointed Pinwheel Star",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "✶",
    "slug": "six-pointed-black-star",
    "codepoints": [
      10038
    ],
    "primary": 10038,
    "name": "Six Pointed Black Star",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "✷",
    "slug": "eight-pointed-rectilinear-black-star",
    "codepoints": [
      10039
    ],
    "primary": 10039,
    "name": "Eight Pointed Rectilinear Black Star",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "✸",
    "slug": "heavy-eight-pointed-rectilinear-black-star",
    "codepoints": [
      10040
    ],
    "primary": 10040,
    "name": "Heavy Eight Pointed Rectilinear Black Star",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "✹",
    "slug": "twelve-pointed-black-star",
    "codepoints": [
      10041
    ],
    "primary": 10041,
    "name": "Twelve Pointed Black Star",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "✺",
    "slug": "sixteen-pointed-asterisk",
    "codepoints": [
      10042
    ],
    "primary": 10042,
    "name": "Sixteen Pointed Asterisk",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "✻",
    "slug": "teardrop-spoked-asterisk",
    "codepoints": [
      10043
    ],
    "primary": 10043,
    "name": "Teardrop-Spoked Asterisk",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "✼",
    "slug": "open-centre-teardrop-spoked-asterisk",
    "codepoints": [
      10044
    ],
    "primary": 10044,
    "name": "Open Centre Teardrop-Spoked Asterisk",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "❅",
    "slug": "tight-trifoliate-snowflake",
    "codepoints": [
      10053
    ],
    "primary": 10053,
    "name": "Tight Trifoliate Snowflake",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "❆",
    "slug": "heavy-chevron-snowflake",
    "codepoints": [
      10054
    ],
    "primary": 10054,
    "name": "Heavy Chevron Snowflake",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "❉",
    "slug": "balloon-spoked-asterisk",
    "codepoints": [
      10057
    ],
    "primary": 10057,
    "name": "Balloon-Spoked Asterisk",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "❋",
    "slug": "heavy-eight-teardrop-spoked-propeller-asterisk",
    "codepoints": [
      10059
    ],
    "primary": 10059,
    "name": "Heavy Eight Teardrop-Spoked Propeller Asterisk",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "⭑",
    "slug": "black-small-star",
    "codepoints": [
      11089
    ],
    "primary": 11089,
    "name": "Black Small Star",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "white-small-star",
      "white-medium-star",
      "ballot-box-with-light-x",
      "black-pentagon",
      "white-pentagon",
      "white-hexagon",
      "black-hexagon",
      "horizontal-black-hexagon",
      "heavy-circle"
    ]
  },
  {
    "symbol": "⭒",
    "slug": "white-small-star",
    "codepoints": [
      11090
    ],
    "primary": 11090,
    "name": "White Small Star",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-small-star",
      "white-medium-star",
      "ballot-box-with-light-x",
      "black-pentagon",
      "white-pentagon",
      "white-hexagon",
      "black-hexagon",
      "horizontal-black-hexagon",
      "heavy-circle"
    ]
  },
  {
    "symbol": "⚝",
    "slug": "outlined-white-star",
    "codepoints": [
      9885
    ],
    "primary": 9885,
    "name": "Outlined White Star",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini",
      "cancer"
    ]
  },
  {
    "symbol": "✢",
    "slug": "four-teardrop-spoked-asterisk",
    "codepoints": [
      10018
    ],
    "primary": 10018,
    "name": "Four Teardrop-Spoked Asterisk",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "✣",
    "slug": "four-balloon-spoked-asterisk",
    "codepoints": [
      10019
    ],
    "primary": 10019,
    "name": "Four Balloon-Spoked Asterisk",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "✤",
    "slug": "heavy-four-balloon-spoked-asterisk",
    "codepoints": [
      10020
    ],
    "primary": 10020,
    "name": "Heavy Four Balloon-Spoked Asterisk",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "✥",
    "slug": "four-club-spoked-asterisk",
    "codepoints": [
      10021
    ],
    "primary": 10021,
    "name": "Four Club-Spoked Asterisk",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "✽",
    "slug": "heavy-teardrop-spoked-asterisk",
    "codepoints": [
      10045
    ],
    "primary": 10045,
    "name": "Heavy Teardrop-Spoked Asterisk",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "❂",
    "slug": "circled-open-centre-eight-pointed-star",
    "codepoints": [
      10050
    ],
    "primary": 10050,
    "name": "Circled Open Centre Eight Pointed Star",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "❃",
    "slug": "heavy-teardrop-spoked-pinwheel-asterisk",
    "codepoints": [
      10051
    ],
    "primary": 10051,
    "name": "Heavy Teardrop-Spoked Pinwheel Asterisk",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "❊",
    "slug": "eight-teardrop-spoked-propeller-asterisk",
    "codepoints": [
      10058
    ],
    "primary": 10058,
    "name": "Eight Teardrop-Spoked Propeller Asterisk",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "⁂",
    "slug": "asterism",
    "codepoints": [
      8258
    ],
    "primary": 8258,
    "name": "Asterism",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark",
      "double-question-mark"
    ]
  },
  {
    "symbol": "⁑",
    "slug": "two-asterisks-aligned-vertically",
    "codepoints": [
      8273
    ],
    "primary": 8273,
    "name": "Two Asterisks Aligned Vertically",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark",
      "double-question-mark"
    ]
  },
  {
    "symbol": "⭐",
    "slug": "white-medium-star",
    "codepoints": [
      11088
    ],
    "primary": 11088,
    "name": "White Medium Star",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-small-star",
      "white-small-star",
      "ballot-box-with-light-x",
      "black-pentagon",
      "white-pentagon",
      "white-hexagon",
      "black-hexagon",
      "horizontal-black-hexagon",
      "heavy-circle"
    ]
  },
  {
    "symbol": "🌟",
    "slug": "glowing-star",
    "codepoints": [
      127775
    ],
    "primary": 127775,
    "name": "Glowing Star",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "✨",
    "slug": "sparkles",
    "codepoints": [
      10024
    ],
    "primary": 10024,
    "name": "Sparkles",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "💫",
    "slug": "dizzy-symbol",
    "codepoints": [
      128171
    ],
    "primary": 128171,
    "name": "Dizzy Symbol",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🌠",
    "slug": "shooting-star",
    "codepoints": [
      127776
    ],
    "primary": 127776,
    "name": "Shooting Star",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "star-symbols",
    "categoryName": "Star Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "←",
    "slug": "leftwards-arrow",
    "codepoints": [
      8592
    ],
    "primary": 8592,
    "name": "Leftwards Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow",
      "rightwards-double-arrow"
    ]
  },
  {
    "symbol": "↑",
    "slug": "upwards-arrow",
    "codepoints": [
      8593
    ],
    "primary": 8593,
    "name": "Upwards Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow",
      "rightwards-double-arrow"
    ]
  },
  {
    "symbol": "→",
    "slug": "rightwards-arrow",
    "codepoints": [
      8594
    ],
    "primary": 8594,
    "name": "Rightwards Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow",
      "rightwards-double-arrow"
    ]
  },
  {
    "symbol": "↓",
    "slug": "downwards-arrow",
    "codepoints": [
      8595
    ],
    "primary": 8595,
    "name": "Downwards Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow",
      "rightwards-double-arrow"
    ]
  },
  {
    "symbol": "↖",
    "slug": "north-west-arrow",
    "codepoints": [
      8598
    ],
    "primary": 8598,
    "name": "North West Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow",
      "rightwards-double-arrow"
    ]
  },
  {
    "symbol": "↗",
    "slug": "north-east-arrow",
    "codepoints": [
      8599
    ],
    "primary": 8599,
    "name": "North East Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow",
      "rightwards-double-arrow"
    ]
  },
  {
    "symbol": "↘",
    "slug": "south-east-arrow",
    "codepoints": [
      8600
    ],
    "primary": 8600,
    "name": "South East Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow",
      "rightwards-double-arrow"
    ]
  },
  {
    "symbol": "↙",
    "slug": "south-west-arrow",
    "codepoints": [
      8601
    ],
    "primary": 8601,
    "name": "South West Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow",
      "rightwards-double-arrow"
    ]
  },
  {
    "symbol": "↔",
    "slug": "left-right-arrow",
    "codepoints": [
      8596
    ],
    "primary": 8596,
    "name": "Left Right Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow",
      "rightwards-double-arrow"
    ]
  },
  {
    "symbol": "↕",
    "slug": "up-down-arrow",
    "codepoints": [
      8597
    ],
    "primary": 8597,
    "name": "Up Down Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow",
      "rightwards-double-arrow"
    ]
  },
  {
    "symbol": "⇐",
    "slug": "leftwards-double-arrow",
    "codepoints": [
      8656
    ],
    "primary": 8656,
    "name": "Leftwards Double Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "upwards-double-arrow",
      "rightwards-double-arrow"
    ]
  },
  {
    "symbol": "⇑",
    "slug": "upwards-double-arrow",
    "codepoints": [
      8657
    ],
    "primary": 8657,
    "name": "Upwards Double Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "rightwards-double-arrow"
    ]
  },
  {
    "symbol": "⇒",
    "slug": "rightwards-double-arrow",
    "codepoints": [
      8658
    ],
    "primary": 8658,
    "name": "Rightwards Double Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "⇓",
    "slug": "downwards-double-arrow",
    "codepoints": [
      8659
    ],
    "primary": 8659,
    "name": "Downwards Double Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "⇔",
    "slug": "left-right-double-arrow",
    "codepoints": [
      8660
    ],
    "primary": 8660,
    "name": "Left Right Double Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "⇕",
    "slug": "up-down-double-arrow",
    "codepoints": [
      8661
    ],
    "primary": 8661,
    "name": "Up Down Double Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "↞",
    "slug": "leftwards-two-headed-arrow",
    "codepoints": [
      8606
    ],
    "primary": 8606,
    "name": "Leftwards Two Headed Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "↟",
    "slug": "upwards-two-headed-arrow",
    "codepoints": [
      8607
    ],
    "primary": 8607,
    "name": "Upwards Two Headed Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "↠",
    "slug": "rightwards-two-headed-arrow",
    "codepoints": [
      8608
    ],
    "primary": 8608,
    "name": "Rightwards Two Headed Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "↡",
    "slug": "downwards-two-headed-arrow",
    "codepoints": [
      8609
    ],
    "primary": 8609,
    "name": "Downwards Two Headed Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "↢",
    "slug": "leftwards-arrow-with-tail",
    "codepoints": [
      8610
    ],
    "primary": 8610,
    "name": "Leftwards Arrow With Tail",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "↣",
    "slug": "rightwards-arrow-with-tail",
    "codepoints": [
      8611
    ],
    "primary": 8611,
    "name": "Rightwards Arrow With Tail",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "↤",
    "slug": "leftwards-arrow-from-bar",
    "codepoints": [
      8612
    ],
    "primary": 8612,
    "name": "Leftwards Arrow From Bar",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "↥",
    "slug": "upwards-arrow-from-bar",
    "codepoints": [
      8613
    ],
    "primary": 8613,
    "name": "Upwards Arrow From Bar",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "↦",
    "slug": "rightwards-arrow-from-bar",
    "codepoints": [
      8614
    ],
    "primary": 8614,
    "name": "Rightwards Arrow From Bar",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "↧",
    "slug": "downwards-arrow-from-bar",
    "codepoints": [
      8615
    ],
    "primary": 8615,
    "name": "Downwards Arrow From Bar",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "↩",
    "slug": "leftwards-arrow-with-hook",
    "codepoints": [
      8617
    ],
    "primary": 8617,
    "name": "Leftwards Arrow With Hook",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "↪",
    "slug": "rightwards-arrow-with-hook",
    "codepoints": [
      8618
    ],
    "primary": 8618,
    "name": "Rightwards Arrow With Hook",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "↫",
    "slug": "leftwards-arrow-with-loop",
    "codepoints": [
      8619
    ],
    "primary": 8619,
    "name": "Leftwards Arrow With Loop",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "↬",
    "slug": "rightwards-arrow-with-loop",
    "codepoints": [
      8620
    ],
    "primary": 8620,
    "name": "Rightwards Arrow With Loop",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "↭",
    "slug": "left-right-wave-arrow",
    "codepoints": [
      8621
    ],
    "primary": 8621,
    "name": "Left Right Wave Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "↰",
    "slug": "upwards-arrow-with-tip-leftwards",
    "codepoints": [
      8624
    ],
    "primary": 8624,
    "name": "Upwards Arrow With Tip Leftwards",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "↱",
    "slug": "upwards-arrow-with-tip-rightwards",
    "codepoints": [
      8625
    ],
    "primary": 8625,
    "name": "Upwards Arrow With Tip Rightwards",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "↲",
    "slug": "downwards-arrow-with-tip-leftwards",
    "codepoints": [
      8626
    ],
    "primary": 8626,
    "name": "Downwards Arrow With Tip Leftwards",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "↳",
    "slug": "downwards-arrow-with-tip-rightwards",
    "codepoints": [
      8627
    ],
    "primary": 8627,
    "name": "Downwards Arrow With Tip Rightwards",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "↶",
    "slug": "anticlockwise-top-semicircle-arrow",
    "codepoints": [
      8630
    ],
    "primary": 8630,
    "name": "Anticlockwise Top Semicircle Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "↷",
    "slug": "clockwise-top-semicircle-arrow",
    "codepoints": [
      8631
    ],
    "primary": 8631,
    "name": "Clockwise Top Semicircle Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "↺",
    "slug": "anticlockwise-open-circle-arrow",
    "codepoints": [
      8634
    ],
    "primary": 8634,
    "name": "Anticlockwise Open Circle Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "↻",
    "slug": "clockwise-open-circle-arrow",
    "codepoints": [
      8635
    ],
    "primary": 8635,
    "name": "Clockwise Open Circle Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "⟲",
    "slug": "anticlockwise-gapped-circle-arrow",
    "codepoints": [
      10226
    ],
    "primary": 10226,
    "name": "Anticlockwise Gapped Circle Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Arrows A",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "clockwise-gapped-circle-arrow",
      "long-leftwards-arrow",
      "long-rightwards-arrow",
      "long-left-right-arrow"
    ]
  },
  {
    "symbol": "⟳",
    "slug": "clockwise-gapped-circle-arrow",
    "codepoints": [
      10227
    ],
    "primary": 10227,
    "name": "Clockwise Gapped Circle Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Arrows A",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "anticlockwise-gapped-circle-arrow",
      "long-leftwards-arrow",
      "long-rightwards-arrow",
      "long-left-right-arrow"
    ]
  },
  {
    "symbol": "⇄",
    "slug": "rightwards-arrow-over-leftwards-arrow",
    "codepoints": [
      8644
    ],
    "primary": 8644,
    "name": "Rightwards Arrow Over Leftwards Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "⇅",
    "slug": "upwards-arrow-leftwards-of-downwards-arrow",
    "codepoints": [
      8645
    ],
    "primary": 8645,
    "name": "Upwards Arrow Leftwards Of Downwards Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "⇆",
    "slug": "leftwards-arrow-over-rightwards-arrow",
    "codepoints": [
      8646
    ],
    "primary": 8646,
    "name": "Leftwards Arrow Over Rightwards Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "⇇",
    "slug": "leftwards-paired-arrows",
    "codepoints": [
      8647
    ],
    "primary": 8647,
    "name": "Leftwards Paired Arrows",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "⇈",
    "slug": "upwards-paired-arrows",
    "codepoints": [
      8648
    ],
    "primary": 8648,
    "name": "Upwards Paired Arrows",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "⇉",
    "slug": "rightwards-paired-arrows",
    "codepoints": [
      8649
    ],
    "primary": 8649,
    "name": "Rightwards Paired Arrows",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "⇊",
    "slug": "downwards-paired-arrows",
    "codepoints": [
      8650
    ],
    "primary": 8650,
    "name": "Downwards Paired Arrows",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "⇚",
    "slug": "leftwards-triple-arrow",
    "codepoints": [
      8666
    ],
    "primary": 8666,
    "name": "Leftwards Triple Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "⇛",
    "slug": "rightwards-triple-arrow",
    "codepoints": [
      8667
    ],
    "primary": 8667,
    "name": "Rightwards Triple Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "⇠",
    "slug": "leftwards-dashed-arrow",
    "codepoints": [
      8672
    ],
    "primary": 8672,
    "name": "Leftwards Dashed Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "⇡",
    "slug": "upwards-dashed-arrow",
    "codepoints": [
      8673
    ],
    "primary": 8673,
    "name": "Upwards Dashed Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "⇢",
    "slug": "rightwards-dashed-arrow",
    "codepoints": [
      8674
    ],
    "primary": 8674,
    "name": "Rightwards Dashed Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "⇣",
    "slug": "downwards-dashed-arrow",
    "codepoints": [
      8675
    ],
    "primary": 8675,
    "name": "Downwards Dashed Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "⟵",
    "slug": "long-leftwards-arrow",
    "codepoints": [
      10229
    ],
    "primary": 10229,
    "name": "Long Leftwards Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Arrows A",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "anticlockwise-gapped-circle-arrow",
      "clockwise-gapped-circle-arrow",
      "long-rightwards-arrow",
      "long-left-right-arrow"
    ]
  },
  {
    "symbol": "⟶",
    "slug": "long-rightwards-arrow",
    "codepoints": [
      10230
    ],
    "primary": 10230,
    "name": "Long Rightwards Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Arrows A",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "anticlockwise-gapped-circle-arrow",
      "clockwise-gapped-circle-arrow",
      "long-leftwards-arrow",
      "long-left-right-arrow"
    ]
  },
  {
    "symbol": "⟷",
    "slug": "long-left-right-arrow",
    "codepoints": [
      10231
    ],
    "primary": 10231,
    "name": "Long Left Right Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Arrows A",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "anticlockwise-gapped-circle-arrow",
      "clockwise-gapped-circle-arrow",
      "long-leftwards-arrow",
      "long-rightwards-arrow"
    ]
  },
  {
    "symbol": "➔",
    "slug": "heavy-wide-headed-rightwards-arrow",
    "codepoints": [
      10132
    ],
    "primary": 10132,
    "name": "Heavy Wide-Headed Rightwards Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "➜",
    "slug": "heavy-round-tipped-rightwards-arrow",
    "codepoints": [
      10140
    ],
    "primary": 10140,
    "name": "Heavy Round-Tipped Rightwards Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "➝",
    "slug": "triangle-headed-rightwards-arrow",
    "codepoints": [
      10141
    ],
    "primary": 10141,
    "name": "Triangle-Headed Rightwards Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "➞",
    "slug": "heavy-triangle-headed-rightwards-arrow",
    "codepoints": [
      10142
    ],
    "primary": 10142,
    "name": "Heavy Triangle-Headed Rightwards Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "➟",
    "slug": "dashed-triangle-headed-rightwards-arrow",
    "codepoints": [
      10143
    ],
    "primary": 10143,
    "name": "Dashed Triangle-Headed Rightwards Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "➠",
    "slug": "heavy-dashed-triangle-headed-rightwards-arrow",
    "codepoints": [
      10144
    ],
    "primary": 10144,
    "name": "Heavy Dashed Triangle-Headed Rightwards Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "➢",
    "slug": "three-d-top-lighted-rightwards-arrowhead",
    "codepoints": [
      10146
    ],
    "primary": 10146,
    "name": "Three-D Top-Lighted Rightwards Arrowhead",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "➣",
    "slug": "three-d-bottom-lighted-rightwards-arrowhead",
    "codepoints": [
      10147
    ],
    "primary": 10147,
    "name": "Three-D Bottom-Lighted Rightwards Arrowhead",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "➤",
    "slug": "black-rightwards-arrowhead",
    "codepoints": [
      10148
    ],
    "primary": 10148,
    "name": "Black Rightwards Arrowhead",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "➥",
    "slug": "heavy-black-curved-downwards-and-rightwards-arrow",
    "codepoints": [
      10149
    ],
    "primary": 10149,
    "name": "Heavy Black Curved Downwards And Rightwards Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "➦",
    "slug": "heavy-black-curved-upwards-and-rightwards-arrow",
    "codepoints": [
      10150
    ],
    "primary": 10150,
    "name": "Heavy Black Curved Upwards And Rightwards Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "➨",
    "slug": "heavy-concave-pointed-black-rightwards-arrow",
    "codepoints": [
      10152
    ],
    "primary": 10152,
    "name": "Heavy Concave-Pointed Black Rightwards Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "➩",
    "slug": "right-shaded-white-rightwards-arrow",
    "codepoints": [
      10153
    ],
    "primary": 10153,
    "name": "Right-Shaded White Rightwards Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "➫",
    "slug": "back-tilted-shadowed-white-rightwards-arrow",
    "codepoints": [
      10155
    ],
    "primary": 10155,
    "name": "Back-Tilted Shadowed White Rightwards Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "➬",
    "slug": "front-tilted-shadowed-white-rightwards-arrow",
    "codepoints": [
      10156
    ],
    "primary": 10156,
    "name": "Front-Tilted Shadowed White Rightwards Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "➭",
    "slug": "heavy-lower-right-shadowed-white-rightwards-arrow",
    "codepoints": [
      10157
    ],
    "primary": 10157,
    "name": "Heavy Lower Right-Shadowed White Rightwards Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "➮",
    "slug": "heavy-upper-right-shadowed-white-rightwards-arrow",
    "codepoints": [
      10158
    ],
    "primary": 10158,
    "name": "Heavy Upper Right-Shadowed White Rightwards Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "➯",
    "slug": "notched-lower-right-shadowed-white-rightwards-arrow",
    "codepoints": [
      10159
    ],
    "primary": 10159,
    "name": "Notched Lower Right-Shadowed White Rightwards Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "➱",
    "slug": "notched-upper-right-shadowed-white-rightwards-arrow",
    "codepoints": [
      10161
    ],
    "primary": 10161,
    "name": "Notched Upper Right-Shadowed White Rightwards Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "➲",
    "slug": "circled-heavy-white-rightwards-arrow",
    "codepoints": [
      10162
    ],
    "primary": 10162,
    "name": "Circled Heavy White Rightwards Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "➳",
    "slug": "white-feathered-rightwards-arrow",
    "codepoints": [
      10163
    ],
    "primary": 10163,
    "name": "White-Feathered Rightwards Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "➵",
    "slug": "black-feathered-rightwards-arrow",
    "codepoints": [
      10165
    ],
    "primary": 10165,
    "name": "Black-Feathered Rightwards Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "➸",
    "slug": "heavy-black-feathered-rightwards-arrow",
    "codepoints": [
      10168
    ],
    "primary": 10168,
    "name": "Heavy Black-Feathered Rightwards Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "➻",
    "slug": "heavy-teardrop-shanked-rightwards-arrow",
    "codepoints": [
      10171
    ],
    "primary": 10171,
    "name": "Heavy Teardrop-Shanked Rightwards Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "➼",
    "slug": "wedge-tailed-rightwards-arrow",
    "codepoints": [
      10172
    ],
    "primary": 10172,
    "name": "Wedge-Tailed Rightwards Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "➽",
    "slug": "heavy-wedge-tailed-rightwards-arrow",
    "codepoints": [
      10173
    ],
    "primary": 10173,
    "name": "Heavy Wedge-Tailed Rightwards Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "➾",
    "slug": "open-outlined-rightwards-arrow",
    "codepoints": [
      10174
    ],
    "primary": 10174,
    "name": "Open-Outlined Rightwards Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "arrow-symbols",
    "categoryName": "Arrow Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "✓",
    "slug": "check-mark",
    "codepoints": [
      10003
    ],
    "primary": 10003,
    "name": "Check Mark",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "check-cross-symbols",
    "categoryName": "Check and Cross Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "✔",
    "slug": "heavy-check-mark",
    "codepoints": [
      10004
    ],
    "primary": 10004,
    "name": "Heavy Check Mark",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "check-cross-symbols",
    "categoryName": "Check and Cross Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "✅",
    "slug": "white-heavy-check-mark",
    "codepoints": [
      9989
    ],
    "primary": 9989,
    "name": "White Heavy Check Mark",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "check-cross-symbols",
    "categoryName": "Check and Cross Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "☑",
    "slug": "ballot-box-with-check",
    "codepoints": [
      9745
    ],
    "primary": 9745,
    "name": "Ballot Box With Check",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "check-cross-symbols",
    "categoryName": "Check and Cross Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini",
      "cancer"
    ]
  },
  {
    "symbol": "☐",
    "slug": "ballot-box",
    "codepoints": [
      9744
    ],
    "primary": 9744,
    "name": "Ballot Box",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "check-cross-symbols",
    "categoryName": "Check and Cross Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini",
      "cancer"
    ]
  },
  {
    "symbol": "⍻",
    "slug": "not-check-mark",
    "codepoints": [
      9083
    ],
    "primary": 9083,
    "name": "Not Check Mark",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "check-cross-symbols",
    "categoryName": "Check and Cross Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock",
      "house"
    ]
  },
  {
    "symbol": "✕",
    "slug": "multiplication-x",
    "codepoints": [
      10005
    ],
    "primary": 10005,
    "name": "Multiplication X",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "check-cross-symbols",
    "categoryName": "Check and Cross Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "✖",
    "slug": "heavy-multiplication-x",
    "codepoints": [
      10006
    ],
    "primary": 10006,
    "name": "Heavy Multiplication X",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "check-cross-symbols",
    "categoryName": "Check and Cross Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "✗",
    "slug": "ballot-x",
    "codepoints": [
      10007
    ],
    "primary": 10007,
    "name": "Ballot X",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "check-cross-symbols",
    "categoryName": "Check and Cross Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "✘",
    "slug": "heavy-ballot-x",
    "codepoints": [
      10008
    ],
    "primary": 10008,
    "name": "Heavy Ballot X",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "check-cross-symbols",
    "categoryName": "Check and Cross Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "☒",
    "slug": "ballot-box-with-x",
    "codepoints": [
      9746
    ],
    "primary": 9746,
    "name": "Ballot Box With X",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "check-cross-symbols",
    "categoryName": "Check and Cross Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "saltire",
      "aries",
      "taurus",
      "gemini",
      "cancer"
    ]
  },
  {
    "symbol": "❌",
    "slug": "cross-mark",
    "codepoints": [
      10060
    ],
    "primary": 10060,
    "name": "Cross Mark",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "check-cross-symbols",
    "categoryName": "Check and Cross Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "❎",
    "slug": "negative-squared-cross-mark",
    "codepoints": [
      10062
    ],
    "primary": 10062,
    "name": "Negative Squared Cross Mark",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "check-cross-symbols",
    "categoryName": "Check and Cross Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "✚",
    "slug": "heavy-greek-cross",
    "codepoints": [
      10010
    ],
    "primary": 10010,
    "name": "Heavy Greek Cross",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "check-cross-symbols",
    "categoryName": "Check and Cross Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "✛",
    "slug": "open-centre-cross",
    "codepoints": [
      10011
    ],
    "primary": 10011,
    "name": "Open Centre Cross",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "check-cross-symbols",
    "categoryName": "Check and Cross Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "✜",
    "slug": "heavy-open-centre-cross",
    "codepoints": [
      10012
    ],
    "primary": 10012,
    "name": "Heavy Open Centre Cross",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "check-cross-symbols",
    "categoryName": "Check and Cross Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "☓",
    "slug": "saltire",
    "codepoints": [
      9747
    ],
    "primary": 9747,
    "name": "Saltire",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "check-cross-symbols",
    "categoryName": "Check and Cross Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "aries",
      "taurus",
      "gemini",
      "cancer"
    ]
  },
  {
    "symbol": "⮽",
    "slug": "ballot-box-with-light-x",
    "codepoints": [
      11197
    ],
    "primary": 11197,
    "name": "Ballot Box With Light X",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "check-cross-symbols",
    "categoryName": "Check and Cross Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-small-star",
      "white-small-star",
      "white-medium-star",
      "black-pentagon",
      "white-pentagon",
      "white-hexagon",
      "black-hexagon",
      "horizontal-black-hexagon",
      "heavy-circle"
    ]
  },
  {
    "symbol": "+",
    "slug": "plus-sign",
    "codepoints": [
      43
    ],
    "primary": 43,
    "name": "Plus Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Basic Latin",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "equals-sign",
      "dollar-sign",
      "vertical-line",
      "left-parenthesis",
      "right-parenthesis",
      "left-square-bracket",
      "right-square-bracket",
      "left-curly-bracket",
      "right-curly-bracket",
      "quotation-mark",
      "apostrophe"
    ]
  },
  {
    "symbol": "−",
    "slug": "minus-sign",
    "codepoints": [
      8722
    ],
    "primary": 8722,
    "name": "Minus Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation",
      "n-ary-product"
    ]
  },
  {
    "symbol": "×",
    "slug": "multiplication-sign",
    "codepoints": [
      215
    ],
    "primary": 215,
    "name": "Multiplication Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Latin 1 Supplement",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "division-sign",
      "plus-minus-sign",
      "not-sign",
      "pound-sign",
      "yen-sign",
      "cent-sign",
      "middle-dot",
      "pilcrow-sign",
      "section-sign",
      "inverted-question-mark",
      "inverted-exclamation-mark",
      "macron"
    ]
  },
  {
    "symbol": "÷",
    "slug": "division-sign",
    "codepoints": [
      247
    ],
    "primary": 247,
    "name": "Division Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Latin 1 Supplement",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "multiplication-sign",
      "plus-minus-sign",
      "not-sign",
      "pound-sign",
      "yen-sign",
      "cent-sign",
      "middle-dot",
      "pilcrow-sign",
      "section-sign",
      "inverted-question-mark",
      "inverted-exclamation-mark",
      "macron"
    ]
  },
  {
    "symbol": "±",
    "slug": "plus-minus-sign",
    "codepoints": [
      177
    ],
    "primary": 177,
    "name": "Plus-Minus Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Latin 1 Supplement",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "multiplication-sign",
      "division-sign",
      "not-sign",
      "pound-sign",
      "yen-sign",
      "cent-sign",
      "middle-dot",
      "pilcrow-sign",
      "section-sign",
      "inverted-question-mark",
      "inverted-exclamation-mark",
      "macron"
    ]
  },
  {
    "symbol": "∓",
    "slug": "minus-or-plus-sign",
    "codepoints": [
      8723
    ],
    "primary": 8723,
    "name": "Minus-Or-Plus Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation",
      "n-ary-product"
    ]
  },
  {
    "symbol": "=",
    "slug": "equals-sign",
    "codepoints": [
      61
    ],
    "primary": 61,
    "name": "Equals Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Basic Latin",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "plus-sign",
      "dollar-sign",
      "vertical-line",
      "left-parenthesis",
      "right-parenthesis",
      "left-square-bracket",
      "right-square-bracket",
      "left-curly-bracket",
      "right-curly-bracket",
      "quotation-mark",
      "apostrophe"
    ]
  },
  {
    "symbol": "≠",
    "slug": "not-equal-to",
    "codepoints": [
      8800
    ],
    "primary": 8800,
    "name": "Not Equal To",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation",
      "n-ary-product"
    ]
  },
  {
    "symbol": "≈",
    "slug": "almost-equal-to",
    "codepoints": [
      8776
    ],
    "primary": 8776,
    "name": "Almost Equal To",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation",
      "n-ary-product"
    ]
  },
  {
    "symbol": "≡",
    "slug": "identical-to",
    "codepoints": [
      8801
    ],
    "primary": 8801,
    "name": "Identical To",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation",
      "n-ary-product"
    ]
  },
  {
    "symbol": "≤",
    "slug": "less-than-or-equal-to",
    "codepoints": [
      8804
    ],
    "primary": 8804,
    "name": "Less-Than Or Equal To",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation",
      "n-ary-product"
    ]
  },
  {
    "symbol": "≥",
    "slug": "greater-than-or-equal-to",
    "codepoints": [
      8805
    ],
    "primary": 8805,
    "name": "Greater-Than Or Equal To",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation",
      "n-ary-product"
    ]
  },
  {
    "symbol": "≪",
    "slug": "much-less-than",
    "codepoints": [
      8810
    ],
    "primary": 8810,
    "name": "Much Less-Than",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-greater-than",
      "infinity",
      "n-ary-summation",
      "n-ary-product"
    ]
  },
  {
    "symbol": "≫",
    "slug": "much-greater-than",
    "codepoints": [
      8811
    ],
    "primary": 8811,
    "name": "Much Greater-Than",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "infinity",
      "n-ary-summation",
      "n-ary-product"
    ]
  },
  {
    "symbol": "∞",
    "slug": "infinity",
    "codepoints": [
      8734
    ],
    "primary": 8734,
    "name": "Infinity",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "n-ary-summation",
      "n-ary-product"
    ]
  },
  {
    "symbol": "∑",
    "slug": "n-ary-summation",
    "codepoints": [
      8721
    ],
    "primary": 8721,
    "name": "N-Ary Summation",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-product"
    ]
  },
  {
    "symbol": "∏",
    "slug": "n-ary-product",
    "codepoints": [
      8719
    ],
    "primary": 8719,
    "name": "N-Ary Product",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "∫",
    "slug": "integral",
    "codepoints": [
      8747
    ],
    "primary": 8747,
    "name": "Integral",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "∮",
    "slug": "contour-integral",
    "codepoints": [
      8750
    ],
    "primary": 8750,
    "name": "Contour Integral",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "∂",
    "slug": "partial-differential",
    "codepoints": [
      8706
    ],
    "primary": 8706,
    "name": "Partial Differential",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "∇",
    "slug": "nabla",
    "codepoints": [
      8711
    ],
    "primary": 8711,
    "name": "Nabla",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "√",
    "slug": "square-root",
    "codepoints": [
      8730
    ],
    "primary": 8730,
    "name": "Square Root",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "∛",
    "slug": "cube-root",
    "codepoints": [
      8731
    ],
    "primary": 8731,
    "name": "Cube Root",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "∜",
    "slug": "fourth-root",
    "codepoints": [
      8732
    ],
    "primary": 8732,
    "name": "Fourth Root",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "∝",
    "slug": "proportional-to",
    "codepoints": [
      8733
    ],
    "primary": 8733,
    "name": "Proportional To",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "∠",
    "slug": "angle",
    "codepoints": [
      8736
    ],
    "primary": 8736,
    "name": "Angle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "∡",
    "slug": "measured-angle",
    "codepoints": [
      8737
    ],
    "primary": 8737,
    "name": "Measured Angle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "∢",
    "slug": "spherical-angle",
    "codepoints": [
      8738
    ],
    "primary": 8738,
    "name": "Spherical Angle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "⊥",
    "slug": "up-tack",
    "codepoints": [
      8869
    ],
    "primary": 8869,
    "name": "Up Tack",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "∥",
    "slug": "parallel-to",
    "codepoints": [
      8741
    ],
    "primary": 8741,
    "name": "Parallel To",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "∈",
    "slug": "element-of",
    "codepoints": [
      8712
    ],
    "primary": 8712,
    "name": "Element Of",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "∉",
    "slug": "not-an-element-of",
    "codepoints": [
      8713
    ],
    "primary": 8713,
    "name": "Not An Element Of",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "∋",
    "slug": "contains-as-member",
    "codepoints": [
      8715
    ],
    "primary": 8715,
    "name": "Contains As Member",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "⊂",
    "slug": "subset-of",
    "codepoints": [
      8834
    ],
    "primary": 8834,
    "name": "Subset Of",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "⊃",
    "slug": "superset-of",
    "codepoints": [
      8835
    ],
    "primary": 8835,
    "name": "Superset Of",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "⊆",
    "slug": "subset-of-or-equal-to",
    "codepoints": [
      8838
    ],
    "primary": 8838,
    "name": "Subset Of Or Equal To",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "⊇",
    "slug": "superset-of-or-equal-to",
    "codepoints": [
      8839
    ],
    "primary": 8839,
    "name": "Superset Of Or Equal To",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "∪",
    "slug": "union",
    "codepoints": [
      8746
    ],
    "primary": 8746,
    "name": "Union",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "∩",
    "slug": "intersection",
    "codepoints": [
      8745
    ],
    "primary": 8745,
    "name": "Intersection",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "∅",
    "slug": "empty-set",
    "codepoints": [
      8709
    ],
    "primary": 8709,
    "name": "Empty Set",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "∀",
    "slug": "for-all",
    "codepoints": [
      8704
    ],
    "primary": 8704,
    "name": "For All",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "∃",
    "slug": "there-exists",
    "codepoints": [
      8707
    ],
    "primary": 8707,
    "name": "There Exists",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "∄",
    "slug": "there-does-not-exist",
    "codepoints": [
      8708
    ],
    "primary": 8708,
    "name": "There Does Not Exist",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "¬",
    "slug": "not-sign",
    "codepoints": [
      172
    ],
    "primary": 172,
    "name": "Not Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Latin 1 Supplement",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "multiplication-sign",
      "division-sign",
      "plus-minus-sign",
      "pound-sign",
      "yen-sign",
      "cent-sign",
      "middle-dot",
      "pilcrow-sign",
      "section-sign",
      "inverted-question-mark",
      "inverted-exclamation-mark",
      "macron"
    ]
  },
  {
    "symbol": "∧",
    "slug": "logical-and",
    "codepoints": [
      8743
    ],
    "primary": 8743,
    "name": "Logical And",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "∨",
    "slug": "logical-or",
    "codepoints": [
      8744
    ],
    "primary": 8744,
    "name": "Logical Or",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "⊕",
    "slug": "circled-plus",
    "codepoints": [
      8853
    ],
    "primary": 8853,
    "name": "Circled Plus",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "⊗",
    "slug": "circled-times",
    "codepoints": [
      8855
    ],
    "primary": 8855,
    "name": "Circled Times",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "≅",
    "slug": "approximately-equal-to",
    "codepoints": [
      8773
    ],
    "primary": 8773,
    "name": "Approximately Equal To",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "≢",
    "slug": "not-identical-to",
    "codepoints": [
      8802
    ],
    "primary": 8802,
    "name": "Not Identical To",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "≮",
    "slug": "not-less-than",
    "codepoints": [
      8814
    ],
    "primary": 8814,
    "name": "Not Less-Than",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "≯",
    "slug": "not-greater-than",
    "codepoints": [
      8815
    ],
    "primary": 8815,
    "name": "Not Greater-Than",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "≲",
    "slug": "less-than-or-equivalent-to",
    "codepoints": [
      8818
    ],
    "primary": 8818,
    "name": "Less-Than Or Equivalent To",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "≳",
    "slug": "greater-than-or-equivalent-to",
    "codepoints": [
      8819
    ],
    "primary": 8819,
    "name": "Greater-Than Or Equivalent To",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "≺",
    "slug": "precedes",
    "codepoints": [
      8826
    ],
    "primary": 8826,
    "name": "Precedes",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "≻",
    "slug": "succeeds",
    "codepoints": [
      8827
    ],
    "primary": 8827,
    "name": "Succeeds",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "≼",
    "slug": "precedes-or-equal-to",
    "codepoints": [
      8828
    ],
    "primary": 8828,
    "name": "Precedes Or Equal To",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "≽",
    "slug": "succeeds-or-equal-to",
    "codepoints": [
      8829
    ],
    "primary": 8829,
    "name": "Succeeds Or Equal To",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "⊄",
    "slug": "not-a-subset-of",
    "codepoints": [
      8836
    ],
    "primary": 8836,
    "name": "Not A Subset Of",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "⊅",
    "slug": "not-a-superset-of",
    "codepoints": [
      8837
    ],
    "primary": 8837,
    "name": "Not A Superset Of",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "⊈",
    "slug": "neither-a-subset-of-nor-equal-to",
    "codepoints": [
      8840
    ],
    "primary": 8840,
    "name": "Neither A Subset Of Nor Equal To",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "⊉",
    "slug": "neither-a-superset-of-nor-equal-to",
    "codepoints": [
      8841
    ],
    "primary": 8841,
    "name": "Neither A Superset Of Nor Equal To",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "⋂",
    "slug": "n-ary-intersection",
    "codepoints": [
      8898
    ],
    "primary": 8898,
    "name": "N-Ary Intersection",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "⋃",
    "slug": "n-ary-union",
    "codepoints": [
      8899
    ],
    "primary": 8899,
    "name": "N-Ary Union",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "∖",
    "slug": "set-minus",
    "codepoints": [
      8726
    ],
    "primary": 8726,
    "name": "Set Minus",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "∁",
    "slug": "complement",
    "codepoints": [
      8705
    ],
    "primary": 8705,
    "name": "Complement",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "⊢",
    "slug": "right-tack",
    "codepoints": [
      8866
    ],
    "primary": 8866,
    "name": "Right Tack",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "⊣",
    "slug": "left-tack",
    "codepoints": [
      8867
    ],
    "primary": 8867,
    "name": "Left Tack",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "⊤",
    "slug": "down-tack",
    "codepoints": [
      8868
    ],
    "primary": 8868,
    "name": "Down Tack",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "⊨",
    "slug": "true",
    "codepoints": [
      8872
    ],
    "primary": 8872,
    "name": "True",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "∴",
    "slug": "therefore",
    "codepoints": [
      8756
    ],
    "primary": 8756,
    "name": "Therefore",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "∵",
    "slug": "because",
    "codepoints": [
      8757
    ],
    "primary": 8757,
    "name": "Because",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "∎",
    "slug": "end-of-proof",
    "codepoints": [
      8718
    ],
    "primary": 8718,
    "name": "End Of Proof",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "∔",
    "slug": "dot-plus",
    "codepoints": [
      8724
    ],
    "primary": 8724,
    "name": "Dot Plus",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "∘",
    "slug": "ring-operator",
    "codepoints": [
      8728
    ],
    "primary": 8728,
    "name": "Ring Operator",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "⊖",
    "slug": "circled-minus",
    "codepoints": [
      8854
    ],
    "primary": 8854,
    "name": "Circled Minus",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "⊘",
    "slug": "circled-division-slash",
    "codepoints": [
      8856
    ],
    "primary": 8856,
    "name": "Circled Division Slash",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "⊙",
    "slug": "circled-dot-operator",
    "codepoints": [
      8857
    ],
    "primary": 8857,
    "name": "Circled Dot Operator",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "⊞",
    "slug": "squared-plus",
    "codepoints": [
      8862
    ],
    "primary": 8862,
    "name": "Squared Plus",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "⊟",
    "slug": "squared-minus",
    "codepoints": [
      8863
    ],
    "primary": 8863,
    "name": "Squared Minus",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "⊠",
    "slug": "squared-times",
    "codepoints": [
      8864
    ],
    "primary": 8864,
    "name": "Squared Times",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "⨁",
    "slug": "n-ary-circled-plus-operator",
    "codepoints": [
      10753
    ],
    "primary": 10753,
    "name": "N-Ary Circled Plus Operator",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "n-ary-circled-times-operator"
    ]
  },
  {
    "symbol": "⨂",
    "slug": "n-ary-circled-times-operator",
    "codepoints": [
      10754
    ],
    "primary": 10754,
    "name": "N-Ary Circled Times Operator",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "n-ary-circled-plus-operator"
    ]
  },
  {
    "symbol": "∬",
    "slug": "double-integral",
    "codepoints": [
      8748
    ],
    "primary": 8748,
    "name": "Double Integral",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "∭",
    "slug": "triple-integral",
    "codepoints": [
      8749
    ],
    "primary": 8749,
    "name": "Triple Integral",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "∐",
    "slug": "n-ary-coproduct",
    "codepoints": [
      8720
    ],
    "primary": 8720,
    "name": "N-Ary Coproduct",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "π",
    "slug": "greek-small-letter-pi",
    "codepoints": [
      960
    ],
    "primary": 960,
    "name": "Greek Small Letter Pi",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Greek And Coptic",
    "script": "Greek",
    "generalCategory": "Lowercase Letter",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "greek-small-letter-tau",
      "greek-small-letter-phi",
      "greek-small-letter-theta",
      "greek-small-letter-lamda",
      "greek-small-letter-mu",
      "greek-small-letter-sigma",
      "greek-capital-letter-sigma",
      "greek-capital-letter-delta",
      "greek-capital-letter-omega",
      "greek-capital-letter-xi"
    ]
  },
  {
    "symbol": "τ",
    "slug": "greek-small-letter-tau",
    "codepoints": [
      964
    ],
    "primary": 964,
    "name": "Greek Small Letter Tau",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Greek And Coptic",
    "script": "Greek",
    "generalCategory": "Lowercase Letter",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "greek-small-letter-pi",
      "greek-small-letter-phi",
      "greek-small-letter-theta",
      "greek-small-letter-lamda",
      "greek-small-letter-mu",
      "greek-small-letter-sigma",
      "greek-capital-letter-sigma",
      "greek-capital-letter-delta",
      "greek-capital-letter-omega",
      "greek-capital-letter-xi"
    ]
  },
  {
    "symbol": "φ",
    "slug": "greek-small-letter-phi",
    "codepoints": [
      966
    ],
    "primary": 966,
    "name": "Greek Small Letter Phi",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Greek And Coptic",
    "script": "Greek",
    "generalCategory": "Lowercase Letter",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "greek-small-letter-pi",
      "greek-small-letter-tau",
      "greek-small-letter-theta",
      "greek-small-letter-lamda",
      "greek-small-letter-mu",
      "greek-small-letter-sigma",
      "greek-capital-letter-sigma",
      "greek-capital-letter-delta",
      "greek-capital-letter-omega",
      "greek-capital-letter-xi"
    ]
  },
  {
    "symbol": "θ",
    "slug": "greek-small-letter-theta",
    "codepoints": [
      952
    ],
    "primary": 952,
    "name": "Greek Small Letter Theta",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Greek And Coptic",
    "script": "Greek",
    "generalCategory": "Lowercase Letter",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "greek-small-letter-pi",
      "greek-small-letter-tau",
      "greek-small-letter-phi",
      "greek-small-letter-lamda",
      "greek-small-letter-mu",
      "greek-small-letter-sigma",
      "greek-capital-letter-sigma",
      "greek-capital-letter-delta",
      "greek-capital-letter-omega",
      "greek-capital-letter-xi"
    ]
  },
  {
    "symbol": "λ",
    "slug": "greek-small-letter-lamda",
    "codepoints": [
      955
    ],
    "primary": 955,
    "name": "Greek Small Letter Lamda",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Greek And Coptic",
    "script": "Greek",
    "generalCategory": "Lowercase Letter",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "greek-small-letter-pi",
      "greek-small-letter-tau",
      "greek-small-letter-phi",
      "greek-small-letter-theta",
      "greek-small-letter-mu",
      "greek-small-letter-sigma",
      "greek-capital-letter-sigma",
      "greek-capital-letter-delta",
      "greek-capital-letter-omega",
      "greek-capital-letter-xi"
    ]
  },
  {
    "symbol": "μ",
    "slug": "greek-small-letter-mu",
    "codepoints": [
      956
    ],
    "primary": 956,
    "name": "Greek Small Letter Mu",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Greek And Coptic",
    "script": "Greek",
    "generalCategory": "Lowercase Letter",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "greek-small-letter-pi",
      "greek-small-letter-tau",
      "greek-small-letter-phi",
      "greek-small-letter-theta",
      "greek-small-letter-lamda",
      "greek-small-letter-sigma",
      "greek-capital-letter-sigma",
      "greek-capital-letter-delta",
      "greek-capital-letter-omega",
      "greek-capital-letter-xi"
    ]
  },
  {
    "symbol": "σ",
    "slug": "greek-small-letter-sigma",
    "codepoints": [
      963
    ],
    "primary": 963,
    "name": "Greek Small Letter Sigma",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Greek And Coptic",
    "script": "Greek",
    "generalCategory": "Lowercase Letter",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "greek-small-letter-pi",
      "greek-small-letter-tau",
      "greek-small-letter-phi",
      "greek-small-letter-theta",
      "greek-small-letter-lamda",
      "greek-small-letter-mu",
      "greek-capital-letter-sigma",
      "greek-capital-letter-delta",
      "greek-capital-letter-omega",
      "greek-capital-letter-xi"
    ]
  },
  {
    "symbol": "Σ",
    "slug": "greek-capital-letter-sigma",
    "codepoints": [
      931
    ],
    "primary": 931,
    "name": "Greek Capital Letter Sigma",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Greek And Coptic",
    "script": "Greek",
    "generalCategory": "Uppercase Letter",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "greek-small-letter-pi",
      "greek-small-letter-tau",
      "greek-small-letter-phi",
      "greek-small-letter-theta",
      "greek-small-letter-lamda",
      "greek-small-letter-mu",
      "greek-small-letter-sigma",
      "greek-capital-letter-delta",
      "greek-capital-letter-omega",
      "greek-capital-letter-xi"
    ]
  },
  {
    "symbol": "Δ",
    "slug": "greek-capital-letter-delta",
    "codepoints": [
      916
    ],
    "primary": 916,
    "name": "Greek Capital Letter Delta",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Greek And Coptic",
    "script": "Greek",
    "generalCategory": "Uppercase Letter",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "greek-small-letter-pi",
      "greek-small-letter-tau",
      "greek-small-letter-phi",
      "greek-small-letter-theta",
      "greek-small-letter-lamda",
      "greek-small-letter-mu",
      "greek-small-letter-sigma",
      "greek-capital-letter-sigma",
      "greek-capital-letter-omega",
      "greek-capital-letter-xi"
    ]
  },
  {
    "symbol": "Ω",
    "slug": "greek-capital-letter-omega",
    "codepoints": [
      937
    ],
    "primary": 937,
    "name": "Greek Capital Letter Omega",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Greek And Coptic",
    "script": "Greek",
    "generalCategory": "Uppercase Letter",
    "categorySlug": "math-symbols",
    "categoryName": "Math Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "greek-small-letter-pi",
      "greek-small-letter-tau",
      "greek-small-letter-phi",
      "greek-small-letter-theta",
      "greek-small-letter-lamda",
      "greek-small-letter-mu",
      "greek-small-letter-sigma",
      "greek-capital-letter-sigma",
      "greek-capital-letter-delta",
      "greek-capital-letter-xi"
    ]
  },
  {
    "symbol": "$",
    "slug": "dollar-sign",
    "codepoints": [
      36
    ],
    "primary": 36,
    "name": "Dollar Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Basic Latin",
    "script": "Common",
    "generalCategory": "Currency Symbol",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "plus-sign",
      "equals-sign",
      "vertical-line",
      "left-parenthesis",
      "right-parenthesis",
      "left-square-bracket",
      "right-square-bracket",
      "left-curly-bracket",
      "right-curly-bracket",
      "quotation-mark",
      "apostrophe"
    ]
  },
  {
    "symbol": "€",
    "slug": "euro-sign",
    "codepoints": [
      8364
    ],
    "primary": 8364,
    "name": "Euro Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Currency Symbols",
    "script": "Common",
    "generalCategory": "Currency Symbol",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "won-sign",
      "indian-rupee-sign",
      "ruble-sign",
      "bitcoin-sign",
      "french-franc-sign",
      "lira-sign",
      "mill-sign",
      "naira-sign",
      "peseta-sign",
      "rupee-sign",
      "new-sheqel-sign",
      "dong-sign"
    ]
  },
  {
    "symbol": "£",
    "slug": "pound-sign",
    "codepoints": [
      163
    ],
    "primary": 163,
    "name": "Pound Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Latin 1 Supplement",
    "script": "Common",
    "generalCategory": "Currency Symbol",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "multiplication-sign",
      "division-sign",
      "plus-minus-sign",
      "not-sign",
      "yen-sign",
      "cent-sign",
      "middle-dot",
      "pilcrow-sign",
      "section-sign",
      "inverted-question-mark",
      "inverted-exclamation-mark",
      "macron"
    ]
  },
  {
    "symbol": "¥",
    "slug": "yen-sign",
    "codepoints": [
      165
    ],
    "primary": 165,
    "name": "Yen Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Latin 1 Supplement",
    "script": "Common",
    "generalCategory": "Currency Symbol",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "multiplication-sign",
      "division-sign",
      "plus-minus-sign",
      "not-sign",
      "pound-sign",
      "cent-sign",
      "middle-dot",
      "pilcrow-sign",
      "section-sign",
      "inverted-question-mark",
      "inverted-exclamation-mark",
      "macron"
    ]
  },
  {
    "symbol": "₩",
    "slug": "won-sign",
    "codepoints": [
      8361
    ],
    "primary": 8361,
    "name": "Won Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Currency Symbols",
    "script": "Common",
    "generalCategory": "Currency Symbol",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "euro-sign",
      "indian-rupee-sign",
      "ruble-sign",
      "bitcoin-sign",
      "french-franc-sign",
      "lira-sign",
      "mill-sign",
      "naira-sign",
      "peseta-sign",
      "rupee-sign",
      "new-sheqel-sign",
      "dong-sign"
    ]
  },
  {
    "symbol": "₹",
    "slug": "indian-rupee-sign",
    "codepoints": [
      8377
    ],
    "primary": 8377,
    "name": "Indian Rupee Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Currency Symbols",
    "script": "Common",
    "generalCategory": "Currency Symbol",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "euro-sign",
      "won-sign",
      "ruble-sign",
      "bitcoin-sign",
      "french-franc-sign",
      "lira-sign",
      "mill-sign",
      "naira-sign",
      "peseta-sign",
      "rupee-sign",
      "new-sheqel-sign",
      "dong-sign"
    ]
  },
  {
    "symbol": "₽",
    "slug": "ruble-sign",
    "codepoints": [
      8381
    ],
    "primary": 8381,
    "name": "Ruble Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Currency Symbols",
    "script": "Common",
    "generalCategory": "Currency Symbol",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "euro-sign",
      "won-sign",
      "indian-rupee-sign",
      "bitcoin-sign",
      "french-franc-sign",
      "lira-sign",
      "mill-sign",
      "naira-sign",
      "peseta-sign",
      "rupee-sign",
      "new-sheqel-sign",
      "dong-sign"
    ]
  },
  {
    "symbol": "¢",
    "slug": "cent-sign",
    "codepoints": [
      162
    ],
    "primary": 162,
    "name": "Cent Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Latin 1 Supplement",
    "script": "Common",
    "generalCategory": "Currency Symbol",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "multiplication-sign",
      "division-sign",
      "plus-minus-sign",
      "not-sign",
      "pound-sign",
      "yen-sign",
      "middle-dot",
      "pilcrow-sign",
      "section-sign",
      "inverted-question-mark",
      "inverted-exclamation-mark",
      "macron"
    ]
  },
  {
    "symbol": "₿",
    "slug": "bitcoin-sign",
    "codepoints": [
      8383
    ],
    "primary": 8383,
    "name": "Bitcoin Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Currency Symbols",
    "script": "Common",
    "generalCategory": "Currency Symbol",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "euro-sign",
      "won-sign",
      "indian-rupee-sign",
      "ruble-sign",
      "french-franc-sign",
      "lira-sign",
      "mill-sign",
      "naira-sign",
      "peseta-sign",
      "rupee-sign",
      "new-sheqel-sign",
      "dong-sign"
    ]
  },
  {
    "symbol": "₣",
    "slug": "french-franc-sign",
    "codepoints": [
      8355
    ],
    "primary": 8355,
    "name": "French Franc Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Currency Symbols",
    "script": "Common",
    "generalCategory": "Currency Symbol",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "euro-sign",
      "won-sign",
      "indian-rupee-sign",
      "ruble-sign",
      "bitcoin-sign",
      "lira-sign",
      "mill-sign",
      "naira-sign",
      "peseta-sign",
      "rupee-sign",
      "new-sheqel-sign",
      "dong-sign"
    ]
  },
  {
    "symbol": "₤",
    "slug": "lira-sign",
    "codepoints": [
      8356
    ],
    "primary": 8356,
    "name": "Lira Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Currency Symbols",
    "script": "Common",
    "generalCategory": "Currency Symbol",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "euro-sign",
      "won-sign",
      "indian-rupee-sign",
      "ruble-sign",
      "bitcoin-sign",
      "french-franc-sign",
      "mill-sign",
      "naira-sign",
      "peseta-sign",
      "rupee-sign",
      "new-sheqel-sign",
      "dong-sign"
    ]
  },
  {
    "symbol": "₥",
    "slug": "mill-sign",
    "codepoints": [
      8357
    ],
    "primary": 8357,
    "name": "Mill Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Currency Symbols",
    "script": "Common",
    "generalCategory": "Currency Symbol",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "euro-sign",
      "won-sign",
      "indian-rupee-sign",
      "ruble-sign",
      "bitcoin-sign",
      "french-franc-sign",
      "lira-sign",
      "naira-sign",
      "peseta-sign",
      "rupee-sign",
      "new-sheqel-sign",
      "dong-sign"
    ]
  },
  {
    "symbol": "₦",
    "slug": "naira-sign",
    "codepoints": [
      8358
    ],
    "primary": 8358,
    "name": "Naira Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Currency Symbols",
    "script": "Common",
    "generalCategory": "Currency Symbol",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "euro-sign",
      "won-sign",
      "indian-rupee-sign",
      "ruble-sign",
      "bitcoin-sign",
      "french-franc-sign",
      "lira-sign",
      "mill-sign",
      "peseta-sign",
      "rupee-sign",
      "new-sheqel-sign",
      "dong-sign"
    ]
  },
  {
    "symbol": "₧",
    "slug": "peseta-sign",
    "codepoints": [
      8359
    ],
    "primary": 8359,
    "name": "Peseta Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Currency Symbols",
    "script": "Common",
    "generalCategory": "Currency Symbol",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "euro-sign",
      "won-sign",
      "indian-rupee-sign",
      "ruble-sign",
      "bitcoin-sign",
      "french-franc-sign",
      "lira-sign",
      "mill-sign",
      "naira-sign",
      "rupee-sign",
      "new-sheqel-sign",
      "dong-sign"
    ]
  },
  {
    "symbol": "₨",
    "slug": "rupee-sign",
    "codepoints": [
      8360
    ],
    "primary": 8360,
    "name": "Rupee Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Currency Symbols",
    "script": "Common",
    "generalCategory": "Currency Symbol",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "euro-sign",
      "won-sign",
      "indian-rupee-sign",
      "ruble-sign",
      "bitcoin-sign",
      "french-franc-sign",
      "lira-sign",
      "mill-sign",
      "naira-sign",
      "peseta-sign",
      "new-sheqel-sign",
      "dong-sign"
    ]
  },
  {
    "symbol": "₪",
    "slug": "new-sheqel-sign",
    "codepoints": [
      8362
    ],
    "primary": 8362,
    "name": "New Sheqel Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Currency Symbols",
    "script": "Common",
    "generalCategory": "Currency Symbol",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "euro-sign",
      "won-sign",
      "indian-rupee-sign",
      "ruble-sign",
      "bitcoin-sign",
      "french-franc-sign",
      "lira-sign",
      "mill-sign",
      "naira-sign",
      "peseta-sign",
      "rupee-sign",
      "dong-sign"
    ]
  },
  {
    "symbol": "₫",
    "slug": "dong-sign",
    "codepoints": [
      8363
    ],
    "primary": 8363,
    "name": "Dong Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Currency Symbols",
    "script": "Common",
    "generalCategory": "Currency Symbol",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "euro-sign",
      "won-sign",
      "indian-rupee-sign",
      "ruble-sign",
      "bitcoin-sign",
      "french-franc-sign",
      "lira-sign",
      "mill-sign",
      "naira-sign",
      "peseta-sign",
      "rupee-sign",
      "new-sheqel-sign"
    ]
  },
  {
    "symbol": "₭",
    "slug": "kip-sign",
    "codepoints": [
      8365
    ],
    "primary": 8365,
    "name": "Kip Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Currency Symbols",
    "script": "Common",
    "generalCategory": "Currency Symbol",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "euro-sign",
      "won-sign",
      "indian-rupee-sign",
      "ruble-sign",
      "bitcoin-sign",
      "french-franc-sign",
      "lira-sign",
      "mill-sign",
      "naira-sign",
      "peseta-sign",
      "rupee-sign",
      "new-sheqel-sign"
    ]
  },
  {
    "symbol": "₮",
    "slug": "tugrik-sign",
    "codepoints": [
      8366
    ],
    "primary": 8366,
    "name": "Tugrik Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Currency Symbols",
    "script": "Common",
    "generalCategory": "Currency Symbol",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "euro-sign",
      "won-sign",
      "indian-rupee-sign",
      "ruble-sign",
      "bitcoin-sign",
      "french-franc-sign",
      "lira-sign",
      "mill-sign",
      "naira-sign",
      "peseta-sign",
      "rupee-sign",
      "new-sheqel-sign"
    ]
  },
  {
    "symbol": "₯",
    "slug": "drachma-sign",
    "codepoints": [
      8367
    ],
    "primary": 8367,
    "name": "Drachma Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Currency Symbols",
    "script": "Common",
    "generalCategory": "Currency Symbol",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "euro-sign",
      "won-sign",
      "indian-rupee-sign",
      "ruble-sign",
      "bitcoin-sign",
      "french-franc-sign",
      "lira-sign",
      "mill-sign",
      "naira-sign",
      "peseta-sign",
      "rupee-sign",
      "new-sheqel-sign"
    ]
  },
  {
    "symbol": "₰",
    "slug": "german-penny-sign",
    "codepoints": [
      8368
    ],
    "primary": 8368,
    "name": "German Penny Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Currency Symbols",
    "script": "Common",
    "generalCategory": "Currency Symbol",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "euro-sign",
      "won-sign",
      "indian-rupee-sign",
      "ruble-sign",
      "bitcoin-sign",
      "french-franc-sign",
      "lira-sign",
      "mill-sign",
      "naira-sign",
      "peseta-sign",
      "rupee-sign",
      "new-sheqel-sign"
    ]
  },
  {
    "symbol": "₱",
    "slug": "peso-sign",
    "codepoints": [
      8369
    ],
    "primary": 8369,
    "name": "Peso Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Currency Symbols",
    "script": "Common",
    "generalCategory": "Currency Symbol",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "euro-sign",
      "won-sign",
      "indian-rupee-sign",
      "ruble-sign",
      "bitcoin-sign",
      "french-franc-sign",
      "lira-sign",
      "mill-sign",
      "naira-sign",
      "peseta-sign",
      "rupee-sign",
      "new-sheqel-sign"
    ]
  },
  {
    "symbol": "₲",
    "slug": "guarani-sign",
    "codepoints": [
      8370
    ],
    "primary": 8370,
    "name": "Guarani Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Currency Symbols",
    "script": "Common",
    "generalCategory": "Currency Symbol",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "euro-sign",
      "won-sign",
      "indian-rupee-sign",
      "ruble-sign",
      "bitcoin-sign",
      "french-franc-sign",
      "lira-sign",
      "mill-sign",
      "naira-sign",
      "peseta-sign",
      "rupee-sign",
      "new-sheqel-sign"
    ]
  },
  {
    "symbol": "₳",
    "slug": "austral-sign",
    "codepoints": [
      8371
    ],
    "primary": 8371,
    "name": "Austral Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Currency Symbols",
    "script": "Common",
    "generalCategory": "Currency Symbol",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "euro-sign",
      "won-sign",
      "indian-rupee-sign",
      "ruble-sign",
      "bitcoin-sign",
      "french-franc-sign",
      "lira-sign",
      "mill-sign",
      "naira-sign",
      "peseta-sign",
      "rupee-sign",
      "new-sheqel-sign"
    ]
  },
  {
    "symbol": "₴",
    "slug": "hryvnia-sign",
    "codepoints": [
      8372
    ],
    "primary": 8372,
    "name": "Hryvnia Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Currency Symbols",
    "script": "Common",
    "generalCategory": "Currency Symbol",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "euro-sign",
      "won-sign",
      "indian-rupee-sign",
      "ruble-sign",
      "bitcoin-sign",
      "french-franc-sign",
      "lira-sign",
      "mill-sign",
      "naira-sign",
      "peseta-sign",
      "rupee-sign",
      "new-sheqel-sign"
    ]
  },
  {
    "symbol": "₵",
    "slug": "cedi-sign",
    "codepoints": [
      8373
    ],
    "primary": 8373,
    "name": "Cedi Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Currency Symbols",
    "script": "Common",
    "generalCategory": "Currency Symbol",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "euro-sign",
      "won-sign",
      "indian-rupee-sign",
      "ruble-sign",
      "bitcoin-sign",
      "french-franc-sign",
      "lira-sign",
      "mill-sign",
      "naira-sign",
      "peseta-sign",
      "rupee-sign",
      "new-sheqel-sign"
    ]
  },
  {
    "symbol": "₶",
    "slug": "livre-tournois-sign",
    "codepoints": [
      8374
    ],
    "primary": 8374,
    "name": "Livre Tournois Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Currency Symbols",
    "script": "Common",
    "generalCategory": "Currency Symbol",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "euro-sign",
      "won-sign",
      "indian-rupee-sign",
      "ruble-sign",
      "bitcoin-sign",
      "french-franc-sign",
      "lira-sign",
      "mill-sign",
      "naira-sign",
      "peseta-sign",
      "rupee-sign",
      "new-sheqel-sign"
    ]
  },
  {
    "symbol": "₷",
    "slug": "spesmilo-sign",
    "codepoints": [
      8375
    ],
    "primary": 8375,
    "name": "Spesmilo Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Currency Symbols",
    "script": "Common",
    "generalCategory": "Currency Symbol",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "euro-sign",
      "won-sign",
      "indian-rupee-sign",
      "ruble-sign",
      "bitcoin-sign",
      "french-franc-sign",
      "lira-sign",
      "mill-sign",
      "naira-sign",
      "peseta-sign",
      "rupee-sign",
      "new-sheqel-sign"
    ]
  },
  {
    "symbol": "₸",
    "slug": "tenge-sign",
    "codepoints": [
      8376
    ],
    "primary": 8376,
    "name": "Tenge Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Currency Symbols",
    "script": "Common",
    "generalCategory": "Currency Symbol",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "euro-sign",
      "won-sign",
      "indian-rupee-sign",
      "ruble-sign",
      "bitcoin-sign",
      "french-franc-sign",
      "lira-sign",
      "mill-sign",
      "naira-sign",
      "peseta-sign",
      "rupee-sign",
      "new-sheqel-sign"
    ]
  },
  {
    "symbol": "₺",
    "slug": "turkish-lira-sign",
    "codepoints": [
      8378
    ],
    "primary": 8378,
    "name": "Turkish Lira Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Currency Symbols",
    "script": "Common",
    "generalCategory": "Currency Symbol",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "euro-sign",
      "won-sign",
      "indian-rupee-sign",
      "ruble-sign",
      "bitcoin-sign",
      "french-franc-sign",
      "lira-sign",
      "mill-sign",
      "naira-sign",
      "peseta-sign",
      "rupee-sign",
      "new-sheqel-sign"
    ]
  },
  {
    "symbol": "₻",
    "slug": "nordic-mark-sign",
    "codepoints": [
      8379
    ],
    "primary": 8379,
    "name": "Nordic Mark Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Currency Symbols",
    "script": "Common",
    "generalCategory": "Currency Symbol",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "euro-sign",
      "won-sign",
      "indian-rupee-sign",
      "ruble-sign",
      "bitcoin-sign",
      "french-franc-sign",
      "lira-sign",
      "mill-sign",
      "naira-sign",
      "peseta-sign",
      "rupee-sign",
      "new-sheqel-sign"
    ]
  },
  {
    "symbol": "₼",
    "slug": "manat-sign",
    "codepoints": [
      8380
    ],
    "primary": 8380,
    "name": "Manat Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Currency Symbols",
    "script": "Common",
    "generalCategory": "Currency Symbol",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "euro-sign",
      "won-sign",
      "indian-rupee-sign",
      "ruble-sign",
      "bitcoin-sign",
      "french-franc-sign",
      "lira-sign",
      "mill-sign",
      "naira-sign",
      "peseta-sign",
      "rupee-sign",
      "new-sheqel-sign"
    ]
  },
  {
    "symbol": "₾",
    "slug": "lari-sign",
    "codepoints": [
      8382
    ],
    "primary": 8382,
    "name": "Lari Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Currency Symbols",
    "script": "Common",
    "generalCategory": "Currency Symbol",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "euro-sign",
      "won-sign",
      "indian-rupee-sign",
      "ruble-sign",
      "bitcoin-sign",
      "french-franc-sign",
      "lira-sign",
      "mill-sign",
      "naira-sign",
      "peseta-sign",
      "rupee-sign",
      "new-sheqel-sign"
    ]
  },
  {
    "symbol": "￠",
    "slug": "fullwidth-cent-sign",
    "codepoints": [
      65504
    ],
    "primary": 65504,
    "name": "Fullwidth Cent Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Halfwidth And Fullwidth Forms",
    "script": "Common",
    "generalCategory": "Currency Symbol",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "fullwidth-pound-sign",
      "fullwidth-yen-sign",
      "fullwidth-won-sign",
      "fullwidth-low-line",
      "fullwidth-macron",
      "fullwidth-vertical-line",
      "fullwidth-broken-bar",
      "fullwidth-solidus",
      "fullwidth-reverse-solidus",
      "fullwidth-left-parenthesis",
      "fullwidth-right-parenthesis",
      "fullwidth-left-square-bracket"
    ]
  },
  {
    "symbol": "￡",
    "slug": "fullwidth-pound-sign",
    "codepoints": [
      65505
    ],
    "primary": 65505,
    "name": "Fullwidth Pound Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Halfwidth And Fullwidth Forms",
    "script": "Common",
    "generalCategory": "Currency Symbol",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "fullwidth-cent-sign",
      "fullwidth-yen-sign",
      "fullwidth-won-sign",
      "fullwidth-low-line",
      "fullwidth-macron",
      "fullwidth-vertical-line",
      "fullwidth-broken-bar",
      "fullwidth-solidus",
      "fullwidth-reverse-solidus",
      "fullwidth-left-parenthesis",
      "fullwidth-right-parenthesis",
      "fullwidth-left-square-bracket"
    ]
  },
  {
    "symbol": "￥",
    "slug": "fullwidth-yen-sign",
    "codepoints": [
      65509
    ],
    "primary": 65509,
    "name": "Fullwidth Yen Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Halfwidth And Fullwidth Forms",
    "script": "Common",
    "generalCategory": "Currency Symbol",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "fullwidth-cent-sign",
      "fullwidth-pound-sign",
      "fullwidth-won-sign",
      "fullwidth-low-line",
      "fullwidth-macron",
      "fullwidth-vertical-line",
      "fullwidth-broken-bar",
      "fullwidth-solidus",
      "fullwidth-reverse-solidus",
      "fullwidth-left-parenthesis",
      "fullwidth-right-parenthesis",
      "fullwidth-left-square-bracket"
    ]
  },
  {
    "symbol": "￦",
    "slug": "fullwidth-won-sign",
    "codepoints": [
      65510
    ],
    "primary": 65510,
    "name": "Fullwidth Won Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Halfwidth And Fullwidth Forms",
    "script": "Common",
    "generalCategory": "Currency Symbol",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "fullwidth-cent-sign",
      "fullwidth-pound-sign",
      "fullwidth-yen-sign",
      "fullwidth-low-line",
      "fullwidth-macron",
      "fullwidth-vertical-line",
      "fullwidth-broken-bar",
      "fullwidth-solidus",
      "fullwidth-reverse-solidus",
      "fullwidth-left-parenthesis",
      "fullwidth-right-parenthesis",
      "fullwidth-left-square-bracket"
    ]
  },
  {
    "symbol": "Ƀ",
    "slug": "latin-capital-letter-b-with-stroke",
    "codepoints": [
      579
    ],
    "primary": 579,
    "name": "Latin Capital Letter B With Stroke",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Latin Extended B",
    "script": "Latin",
    "generalCategory": "Uppercase Letter",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": []
  },
  {
    "symbol": "Ξ",
    "slug": "greek-capital-letter-xi",
    "codepoints": [
      926
    ],
    "primary": 926,
    "name": "Greek Capital Letter Xi",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Greek And Coptic",
    "script": "Greek",
    "generalCategory": "Uppercase Letter",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "greek-small-letter-pi",
      "greek-small-letter-tau",
      "greek-small-letter-phi",
      "greek-small-letter-theta",
      "greek-small-letter-lamda",
      "greek-small-letter-mu",
      "greek-small-letter-sigma",
      "greek-capital-letter-sigma",
      "greek-capital-letter-delta",
      "greek-capital-letter-omega"
    ]
  },
  {
    "symbol": "₠",
    "slug": "euro-currency-sign",
    "codepoints": [
      8352
    ],
    "primary": 8352,
    "name": "Euro-Currency Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Currency Symbols",
    "script": "Common",
    "generalCategory": "Currency Symbol",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "euro-sign",
      "won-sign",
      "indian-rupee-sign",
      "ruble-sign",
      "bitcoin-sign",
      "french-franc-sign",
      "lira-sign",
      "mill-sign",
      "naira-sign",
      "peseta-sign",
      "rupee-sign",
      "new-sheqel-sign"
    ]
  },
  {
    "symbol": "₡",
    "slug": "colon-sign",
    "codepoints": [
      8353
    ],
    "primary": 8353,
    "name": "Colon Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Currency Symbols",
    "script": "Common",
    "generalCategory": "Currency Symbol",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "euro-sign",
      "won-sign",
      "indian-rupee-sign",
      "ruble-sign",
      "bitcoin-sign",
      "french-franc-sign",
      "lira-sign",
      "mill-sign",
      "naira-sign",
      "peseta-sign",
      "rupee-sign",
      "new-sheqel-sign"
    ]
  },
  {
    "symbol": "₢",
    "slug": "cruzeiro-sign",
    "codepoints": [
      8354
    ],
    "primary": 8354,
    "name": "Cruzeiro Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Currency Symbols",
    "script": "Common",
    "generalCategory": "Currency Symbol",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "euro-sign",
      "won-sign",
      "indian-rupee-sign",
      "ruble-sign",
      "bitcoin-sign",
      "french-franc-sign",
      "lira-sign",
      "mill-sign",
      "naira-sign",
      "peseta-sign",
      "rupee-sign",
      "new-sheqel-sign"
    ]
  },
  {
    "symbol": "⃀",
    "slug": "som-sign",
    "codepoints": [
      8384
    ],
    "primary": 8384,
    "name": "Som Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Currency Symbols",
    "script": "Common",
    "generalCategory": "Currency Symbol",
    "categorySlug": "currency-symbols",
    "categoryName": "Currency Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "euro-sign",
      "won-sign",
      "indian-rupee-sign",
      "ruble-sign",
      "bitcoin-sign",
      "french-franc-sign",
      "lira-sign",
      "mill-sign",
      "naira-sign",
      "peseta-sign",
      "rupee-sign",
      "new-sheqel-sign"
    ]
  },
  {
    "symbol": "Ⅰ",
    "slug": "roman-numeral-one",
    "codepoints": [
      8544
    ],
    "primary": 8544,
    "name": "Roman Numeral One",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Latin",
    "generalCategory": "Letter Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve",
      "roman-numeral-fifty"
    ]
  },
  {
    "symbol": "Ⅱ",
    "slug": "roman-numeral-two",
    "codepoints": [
      8545
    ],
    "primary": 8545,
    "name": "Roman Numeral Two",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Latin",
    "generalCategory": "Letter Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve",
      "roman-numeral-fifty"
    ]
  },
  {
    "symbol": "Ⅲ",
    "slug": "roman-numeral-three",
    "codepoints": [
      8546
    ],
    "primary": 8546,
    "name": "Roman Numeral Three",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Latin",
    "generalCategory": "Letter Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve",
      "roman-numeral-fifty"
    ]
  },
  {
    "symbol": "Ⅳ",
    "slug": "roman-numeral-four",
    "codepoints": [
      8547
    ],
    "primary": 8547,
    "name": "Roman Numeral Four",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Latin",
    "generalCategory": "Letter Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve",
      "roman-numeral-fifty"
    ]
  },
  {
    "symbol": "Ⅴ",
    "slug": "roman-numeral-five",
    "codepoints": [
      8548
    ],
    "primary": 8548,
    "name": "Roman Numeral Five",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Latin",
    "generalCategory": "Letter Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve",
      "roman-numeral-fifty"
    ]
  },
  {
    "symbol": "Ⅵ",
    "slug": "roman-numeral-six",
    "codepoints": [
      8549
    ],
    "primary": 8549,
    "name": "Roman Numeral Six",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Latin",
    "generalCategory": "Letter Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve",
      "roman-numeral-fifty"
    ]
  },
  {
    "symbol": "Ⅶ",
    "slug": "roman-numeral-seven",
    "codepoints": [
      8550
    ],
    "primary": 8550,
    "name": "Roman Numeral Seven",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Latin",
    "generalCategory": "Letter Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve",
      "roman-numeral-fifty"
    ]
  },
  {
    "symbol": "Ⅷ",
    "slug": "roman-numeral-eight",
    "codepoints": [
      8551
    ],
    "primary": 8551,
    "name": "Roman Numeral Eight",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Latin",
    "generalCategory": "Letter Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve",
      "roman-numeral-fifty"
    ]
  },
  {
    "symbol": "Ⅸ",
    "slug": "roman-numeral-nine",
    "codepoints": [
      8552
    ],
    "primary": 8552,
    "name": "Roman Numeral Nine",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Latin",
    "generalCategory": "Letter Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve",
      "roman-numeral-fifty"
    ]
  },
  {
    "symbol": "Ⅹ",
    "slug": "roman-numeral-ten",
    "codepoints": [
      8553
    ],
    "primary": 8553,
    "name": "Roman Numeral Ten",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Latin",
    "generalCategory": "Letter Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-eleven",
      "roman-numeral-twelve",
      "roman-numeral-fifty"
    ]
  },
  {
    "symbol": "Ⅺ",
    "slug": "roman-numeral-eleven",
    "codepoints": [
      8554
    ],
    "primary": 8554,
    "name": "Roman Numeral Eleven",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Latin",
    "generalCategory": "Letter Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-twelve",
      "roman-numeral-fifty"
    ]
  },
  {
    "symbol": "Ⅻ",
    "slug": "roman-numeral-twelve",
    "codepoints": [
      8555
    ],
    "primary": 8555,
    "name": "Roman Numeral Twelve",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Latin",
    "generalCategory": "Letter Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-fifty"
    ]
  },
  {
    "symbol": "Ⅼ",
    "slug": "roman-numeral-fifty",
    "codepoints": [
      8556
    ],
    "primary": 8556,
    "name": "Roman Numeral Fifty",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Latin",
    "generalCategory": "Letter Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve"
    ]
  },
  {
    "symbol": "Ⅽ",
    "slug": "roman-numeral-one-hundred",
    "codepoints": [
      8557
    ],
    "primary": 8557,
    "name": "Roman Numeral One Hundred",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Latin",
    "generalCategory": "Letter Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve"
    ]
  },
  {
    "symbol": "Ⅾ",
    "slug": "roman-numeral-five-hundred",
    "codepoints": [
      8558
    ],
    "primary": 8558,
    "name": "Roman Numeral Five Hundred",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Latin",
    "generalCategory": "Letter Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve"
    ]
  },
  {
    "symbol": "Ⅿ",
    "slug": "roman-numeral-one-thousand",
    "codepoints": [
      8559
    ],
    "primary": 8559,
    "name": "Roman Numeral One Thousand",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Latin",
    "generalCategory": "Letter Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve"
    ]
  },
  {
    "symbol": "ⅰ",
    "slug": "small-roman-numeral-one",
    "codepoints": [
      8560
    ],
    "primary": 8560,
    "name": "Small Roman Numeral One",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Latin",
    "generalCategory": "Letter Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve"
    ]
  },
  {
    "symbol": "ⅱ",
    "slug": "small-roman-numeral-two",
    "codepoints": [
      8561
    ],
    "primary": 8561,
    "name": "Small Roman Numeral Two",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Latin",
    "generalCategory": "Letter Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve"
    ]
  },
  {
    "symbol": "ⅲ",
    "slug": "small-roman-numeral-three",
    "codepoints": [
      8562
    ],
    "primary": 8562,
    "name": "Small Roman Numeral Three",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Latin",
    "generalCategory": "Letter Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve"
    ]
  },
  {
    "symbol": "ⅳ",
    "slug": "small-roman-numeral-four",
    "codepoints": [
      8563
    ],
    "primary": 8563,
    "name": "Small Roman Numeral Four",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Latin",
    "generalCategory": "Letter Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve"
    ]
  },
  {
    "symbol": "ⅴ",
    "slug": "small-roman-numeral-five",
    "codepoints": [
      8564
    ],
    "primary": 8564,
    "name": "Small Roman Numeral Five",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Latin",
    "generalCategory": "Letter Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve"
    ]
  },
  {
    "symbol": "ⅵ",
    "slug": "small-roman-numeral-six",
    "codepoints": [
      8565
    ],
    "primary": 8565,
    "name": "Small Roman Numeral Six",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Latin",
    "generalCategory": "Letter Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve"
    ]
  },
  {
    "symbol": "ⅶ",
    "slug": "small-roman-numeral-seven",
    "codepoints": [
      8566
    ],
    "primary": 8566,
    "name": "Small Roman Numeral Seven",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Latin",
    "generalCategory": "Letter Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve"
    ]
  },
  {
    "symbol": "ⅷ",
    "slug": "small-roman-numeral-eight",
    "codepoints": [
      8567
    ],
    "primary": 8567,
    "name": "Small Roman Numeral Eight",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Latin",
    "generalCategory": "Letter Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve"
    ]
  },
  {
    "symbol": "ⅸ",
    "slug": "small-roman-numeral-nine",
    "codepoints": [
      8568
    ],
    "primary": 8568,
    "name": "Small Roman Numeral Nine",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Latin",
    "generalCategory": "Letter Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve"
    ]
  },
  {
    "symbol": "ⅹ",
    "slug": "small-roman-numeral-ten",
    "codepoints": [
      8569
    ],
    "primary": 8569,
    "name": "Small Roman Numeral Ten",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Latin",
    "generalCategory": "Letter Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve"
    ]
  },
  {
    "symbol": "ⅺ",
    "slug": "small-roman-numeral-eleven",
    "codepoints": [
      8570
    ],
    "primary": 8570,
    "name": "Small Roman Numeral Eleven",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Latin",
    "generalCategory": "Letter Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve"
    ]
  },
  {
    "symbol": "ⅻ",
    "slug": "small-roman-numeral-twelve",
    "codepoints": [
      8571
    ],
    "primary": 8571,
    "name": "Small Roman Numeral Twelve",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Latin",
    "generalCategory": "Letter Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve"
    ]
  },
  {
    "symbol": "ⅼ",
    "slug": "small-roman-numeral-fifty",
    "codepoints": [
      8572
    ],
    "primary": 8572,
    "name": "Small Roman Numeral Fifty",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Latin",
    "generalCategory": "Letter Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve"
    ]
  },
  {
    "symbol": "ⅽ",
    "slug": "small-roman-numeral-one-hundred",
    "codepoints": [
      8573
    ],
    "primary": 8573,
    "name": "Small Roman Numeral One Hundred",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Latin",
    "generalCategory": "Letter Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve"
    ]
  },
  {
    "symbol": "ⅾ",
    "slug": "small-roman-numeral-five-hundred",
    "codepoints": [
      8574
    ],
    "primary": 8574,
    "name": "Small Roman Numeral Five Hundred",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Latin",
    "generalCategory": "Letter Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve"
    ]
  },
  {
    "symbol": "ⅿ",
    "slug": "small-roman-numeral-one-thousand",
    "codepoints": [
      8575
    ],
    "primary": 8575,
    "name": "Small Roman Numeral One Thousand",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Latin",
    "generalCategory": "Letter Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve"
    ]
  },
  {
    "symbol": "⓪",
    "slug": "circled-digit-zero",
    "codepoints": [
      9450
    ],
    "primary": 9450,
    "name": "Circled Digit Zero",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven",
      "circled-number-twelve"
    ]
  },
  {
    "symbol": "①",
    "slug": "circled-digit-one",
    "codepoints": [
      9312
    ],
    "primary": 9312,
    "name": "Circled Digit One",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven",
      "circled-number-twelve"
    ]
  },
  {
    "symbol": "②",
    "slug": "circled-digit-two",
    "codepoints": [
      9313
    ],
    "primary": 9313,
    "name": "Circled Digit Two",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven",
      "circled-number-twelve"
    ]
  },
  {
    "symbol": "③",
    "slug": "circled-digit-three",
    "codepoints": [
      9314
    ],
    "primary": 9314,
    "name": "Circled Digit Three",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven",
      "circled-number-twelve"
    ]
  },
  {
    "symbol": "④",
    "slug": "circled-digit-four",
    "codepoints": [
      9315
    ],
    "primary": 9315,
    "name": "Circled Digit Four",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven",
      "circled-number-twelve"
    ]
  },
  {
    "symbol": "⑤",
    "slug": "circled-digit-five",
    "codepoints": [
      9316
    ],
    "primary": 9316,
    "name": "Circled Digit Five",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven",
      "circled-number-twelve"
    ]
  },
  {
    "symbol": "⑥",
    "slug": "circled-digit-six",
    "codepoints": [
      9317
    ],
    "primary": 9317,
    "name": "Circled Digit Six",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven",
      "circled-number-twelve"
    ]
  },
  {
    "symbol": "⑦",
    "slug": "circled-digit-seven",
    "codepoints": [
      9318
    ],
    "primary": 9318,
    "name": "Circled Digit Seven",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven",
      "circled-number-twelve"
    ]
  },
  {
    "symbol": "⑧",
    "slug": "circled-digit-eight",
    "codepoints": [
      9319
    ],
    "primary": 9319,
    "name": "Circled Digit Eight",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven",
      "circled-number-twelve"
    ]
  },
  {
    "symbol": "⑨",
    "slug": "circled-digit-nine",
    "codepoints": [
      9320
    ],
    "primary": 9320,
    "name": "Circled Digit Nine",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-number-ten",
      "circled-number-eleven",
      "circled-number-twelve"
    ]
  },
  {
    "symbol": "⑩",
    "slug": "circled-number-ten",
    "codepoints": [
      9321
    ],
    "primary": 9321,
    "name": "Circled Number Ten",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-eleven",
      "circled-number-twelve"
    ]
  },
  {
    "symbol": "⑪",
    "slug": "circled-number-eleven",
    "codepoints": [
      9322
    ],
    "primary": 9322,
    "name": "Circled Number Eleven",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-twelve"
    ]
  },
  {
    "symbol": "⑫",
    "slug": "circled-number-twelve",
    "codepoints": [
      9323
    ],
    "primary": 9323,
    "name": "Circled Number Twelve",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⑬",
    "slug": "circled-number-thirteen",
    "codepoints": [
      9324
    ],
    "primary": 9324,
    "name": "Circled Number Thirteen",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⑭",
    "slug": "circled-number-fourteen",
    "codepoints": [
      9325
    ],
    "primary": 9325,
    "name": "Circled Number Fourteen",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⑮",
    "slug": "circled-number-fifteen",
    "codepoints": [
      9326
    ],
    "primary": 9326,
    "name": "Circled Number Fifteen",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⑯",
    "slug": "circled-number-sixteen",
    "codepoints": [
      9327
    ],
    "primary": 9327,
    "name": "Circled Number Sixteen",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⑰",
    "slug": "circled-number-seventeen",
    "codepoints": [
      9328
    ],
    "primary": 9328,
    "name": "Circled Number Seventeen",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⑱",
    "slug": "circled-number-eighteen",
    "codepoints": [
      9329
    ],
    "primary": 9329,
    "name": "Circled Number Eighteen",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⑲",
    "slug": "circled-number-nineteen",
    "codepoints": [
      9330
    ],
    "primary": 9330,
    "name": "Circled Number Nineteen",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⑳",
    "slug": "circled-number-twenty",
    "codepoints": [
      9331
    ],
    "primary": 9331,
    "name": "Circled Number Twenty",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⓿",
    "slug": "negative-circled-digit-zero",
    "codepoints": [
      9471
    ],
    "primary": 9471,
    "name": "Negative Circled Digit Zero",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "❶",
    "slug": "dingbat-negative-circled-digit-one",
    "codepoints": [
      10102
    ],
    "primary": 10102,
    "name": "Dingbat Negative Circled Digit One",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "❷",
    "slug": "dingbat-negative-circled-digit-two",
    "codepoints": [
      10103
    ],
    "primary": 10103,
    "name": "Dingbat Negative Circled Digit Two",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "❸",
    "slug": "dingbat-negative-circled-digit-three",
    "codepoints": [
      10104
    ],
    "primary": 10104,
    "name": "Dingbat Negative Circled Digit Three",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "❹",
    "slug": "dingbat-negative-circled-digit-four",
    "codepoints": [
      10105
    ],
    "primary": 10105,
    "name": "Dingbat Negative Circled Digit Four",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "❺",
    "slug": "dingbat-negative-circled-digit-five",
    "codepoints": [
      10106
    ],
    "primary": 10106,
    "name": "Dingbat Negative Circled Digit Five",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "❻",
    "slug": "dingbat-negative-circled-digit-six",
    "codepoints": [
      10107
    ],
    "primary": 10107,
    "name": "Dingbat Negative Circled Digit Six",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "❼",
    "slug": "dingbat-negative-circled-digit-seven",
    "codepoints": [
      10108
    ],
    "primary": 10108,
    "name": "Dingbat Negative Circled Digit Seven",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "❽",
    "slug": "dingbat-negative-circled-digit-eight",
    "codepoints": [
      10109
    ],
    "primary": 10109,
    "name": "Dingbat Negative Circled Digit Eight",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "❾",
    "slug": "dingbat-negative-circled-digit-nine",
    "codepoints": [
      10110
    ],
    "primary": 10110,
    "name": "Dingbat Negative Circled Digit Nine",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "❿",
    "slug": "dingbat-negative-circled-number-ten",
    "codepoints": [
      10111
    ],
    "primary": 10111,
    "name": "Dingbat Negative Circled Number Ten",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "⓫",
    "slug": "negative-circled-number-eleven",
    "codepoints": [
      9451
    ],
    "primary": 9451,
    "name": "Negative Circled Number Eleven",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⓬",
    "slug": "negative-circled-number-twelve",
    "codepoints": [
      9452
    ],
    "primary": 9452,
    "name": "Negative Circled Number Twelve",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⓭",
    "slug": "negative-circled-number-thirteen",
    "codepoints": [
      9453
    ],
    "primary": 9453,
    "name": "Negative Circled Number Thirteen",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⓮",
    "slug": "negative-circled-number-fourteen",
    "codepoints": [
      9454
    ],
    "primary": 9454,
    "name": "Negative Circled Number Fourteen",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⓯",
    "slug": "negative-circled-number-fifteen",
    "codepoints": [
      9455
    ],
    "primary": 9455,
    "name": "Negative Circled Number Fifteen",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⓰",
    "slug": "negative-circled-number-sixteen",
    "codepoints": [
      9456
    ],
    "primary": 9456,
    "name": "Negative Circled Number Sixteen",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⓱",
    "slug": "negative-circled-number-seventeen",
    "codepoints": [
      9457
    ],
    "primary": 9457,
    "name": "Negative Circled Number Seventeen",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⓲",
    "slug": "negative-circled-number-eighteen",
    "codepoints": [
      9458
    ],
    "primary": 9458,
    "name": "Negative Circled Number Eighteen",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⓳",
    "slug": "negative-circled-number-nineteen",
    "codepoints": [
      9459
    ],
    "primary": 9459,
    "name": "Negative Circled Number Nineteen",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⓴",
    "slug": "negative-circled-number-twenty",
    "codepoints": [
      9460
    ],
    "primary": 9460,
    "name": "Negative Circled Number Twenty",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⓵",
    "slug": "double-circled-digit-one",
    "codepoints": [
      9461
    ],
    "primary": 9461,
    "name": "Double Circled Digit One",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⓶",
    "slug": "double-circled-digit-two",
    "codepoints": [
      9462
    ],
    "primary": 9462,
    "name": "Double Circled Digit Two",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⓷",
    "slug": "double-circled-digit-three",
    "codepoints": [
      9463
    ],
    "primary": 9463,
    "name": "Double Circled Digit Three",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⓸",
    "slug": "double-circled-digit-four",
    "codepoints": [
      9464
    ],
    "primary": 9464,
    "name": "Double Circled Digit Four",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⓹",
    "slug": "double-circled-digit-five",
    "codepoints": [
      9465
    ],
    "primary": 9465,
    "name": "Double Circled Digit Five",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⓺",
    "slug": "double-circled-digit-six",
    "codepoints": [
      9466
    ],
    "primary": 9466,
    "name": "Double Circled Digit Six",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⓻",
    "slug": "double-circled-digit-seven",
    "codepoints": [
      9467
    ],
    "primary": 9467,
    "name": "Double Circled Digit Seven",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⓼",
    "slug": "double-circled-digit-eight",
    "codepoints": [
      9468
    ],
    "primary": 9468,
    "name": "Double Circled Digit Eight",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⓽",
    "slug": "double-circled-digit-nine",
    "codepoints": [
      9469
    ],
    "primary": 9469,
    "name": "Double Circled Digit Nine",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⓾",
    "slug": "double-circled-number-ten",
    "codepoints": [
      9470
    ],
    "primary": 9470,
    "name": "Double Circled Number Ten",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⑴",
    "slug": "parenthesized-digit-one",
    "codepoints": [
      9332
    ],
    "primary": 9332,
    "name": "Parenthesized Digit One",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⑵",
    "slug": "parenthesized-digit-two",
    "codepoints": [
      9333
    ],
    "primary": 9333,
    "name": "Parenthesized Digit Two",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⑶",
    "slug": "parenthesized-digit-three",
    "codepoints": [
      9334
    ],
    "primary": 9334,
    "name": "Parenthesized Digit Three",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⑷",
    "slug": "parenthesized-digit-four",
    "codepoints": [
      9335
    ],
    "primary": 9335,
    "name": "Parenthesized Digit Four",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⑸",
    "slug": "parenthesized-digit-five",
    "codepoints": [
      9336
    ],
    "primary": 9336,
    "name": "Parenthesized Digit Five",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⑹",
    "slug": "parenthesized-digit-six",
    "codepoints": [
      9337
    ],
    "primary": 9337,
    "name": "Parenthesized Digit Six",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⑺",
    "slug": "parenthesized-digit-seven",
    "codepoints": [
      9338
    ],
    "primary": 9338,
    "name": "Parenthesized Digit Seven",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⑻",
    "slug": "parenthesized-digit-eight",
    "codepoints": [
      9339
    ],
    "primary": 9339,
    "name": "Parenthesized Digit Eight",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⑼",
    "slug": "parenthesized-digit-nine",
    "codepoints": [
      9340
    ],
    "primary": 9340,
    "name": "Parenthesized Digit Nine",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⑽",
    "slug": "parenthesized-number-ten",
    "codepoints": [
      9341
    ],
    "primary": 9341,
    "name": "Parenthesized Number Ten",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⑾",
    "slug": "parenthesized-number-eleven",
    "codepoints": [
      9342
    ],
    "primary": 9342,
    "name": "Parenthesized Number Eleven",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⑿",
    "slug": "parenthesized-number-twelve",
    "codepoints": [
      9343
    ],
    "primary": 9343,
    "name": "Parenthesized Number Twelve",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⒀",
    "slug": "parenthesized-number-thirteen",
    "codepoints": [
      9344
    ],
    "primary": 9344,
    "name": "Parenthesized Number Thirteen",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⒁",
    "slug": "parenthesized-number-fourteen",
    "codepoints": [
      9345
    ],
    "primary": 9345,
    "name": "Parenthesized Number Fourteen",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⒂",
    "slug": "parenthesized-number-fifteen",
    "codepoints": [
      9346
    ],
    "primary": 9346,
    "name": "Parenthesized Number Fifteen",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⒃",
    "slug": "parenthesized-number-sixteen",
    "codepoints": [
      9347
    ],
    "primary": 9347,
    "name": "Parenthesized Number Sixteen",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⒄",
    "slug": "parenthesized-number-seventeen",
    "codepoints": [
      9348
    ],
    "primary": 9348,
    "name": "Parenthesized Number Seventeen",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⒅",
    "slug": "parenthesized-number-eighteen",
    "codepoints": [
      9349
    ],
    "primary": 9349,
    "name": "Parenthesized Number Eighteen",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⒆",
    "slug": "parenthesized-number-nineteen",
    "codepoints": [
      9350
    ],
    "primary": 9350,
    "name": "Parenthesized Number Nineteen",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⒇",
    "slug": "parenthesized-number-twenty",
    "codepoints": [
      9351
    ],
    "primary": 9351,
    "name": "Parenthesized Number Twenty",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⒈",
    "slug": "digit-one-full-stop",
    "codepoints": [
      9352
    ],
    "primary": 9352,
    "name": "Digit One Full Stop",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⒉",
    "slug": "digit-two-full-stop",
    "codepoints": [
      9353
    ],
    "primary": 9353,
    "name": "Digit Two Full Stop",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⒊",
    "slug": "digit-three-full-stop",
    "codepoints": [
      9354
    ],
    "primary": 9354,
    "name": "Digit Three Full Stop",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⒋",
    "slug": "digit-four-full-stop",
    "codepoints": [
      9355
    ],
    "primary": 9355,
    "name": "Digit Four Full Stop",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⒌",
    "slug": "digit-five-full-stop",
    "codepoints": [
      9356
    ],
    "primary": 9356,
    "name": "Digit Five Full Stop",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⒍",
    "slug": "digit-six-full-stop",
    "codepoints": [
      9357
    ],
    "primary": 9357,
    "name": "Digit Six Full Stop",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⒎",
    "slug": "digit-seven-full-stop",
    "codepoints": [
      9358
    ],
    "primary": 9358,
    "name": "Digit Seven Full Stop",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⒏",
    "slug": "digit-eight-full-stop",
    "codepoints": [
      9359
    ],
    "primary": 9359,
    "name": "Digit Eight Full Stop",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⒐",
    "slug": "digit-nine-full-stop",
    "codepoints": [
      9360
    ],
    "primary": 9360,
    "name": "Digit Nine Full Stop",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⒑",
    "slug": "number-ten-full-stop",
    "codepoints": [
      9361
    ],
    "primary": 9361,
    "name": "Number Ten Full Stop",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⒒",
    "slug": "number-eleven-full-stop",
    "codepoints": [
      9362
    ],
    "primary": 9362,
    "name": "Number Eleven Full Stop",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⒓",
    "slug": "number-twelve-full-stop",
    "codepoints": [
      9363
    ],
    "primary": 9363,
    "name": "Number Twelve Full Stop",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⒔",
    "slug": "number-thirteen-full-stop",
    "codepoints": [
      9364
    ],
    "primary": 9364,
    "name": "Number Thirteen Full Stop",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⒕",
    "slug": "number-fourteen-full-stop",
    "codepoints": [
      9365
    ],
    "primary": 9365,
    "name": "Number Fourteen Full Stop",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⒖",
    "slug": "number-fifteen-full-stop",
    "codepoints": [
      9366
    ],
    "primary": 9366,
    "name": "Number Fifteen Full Stop",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⒗",
    "slug": "number-sixteen-full-stop",
    "codepoints": [
      9367
    ],
    "primary": 9367,
    "name": "Number Sixteen Full Stop",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⒘",
    "slug": "number-seventeen-full-stop",
    "codepoints": [
      9368
    ],
    "primary": 9368,
    "name": "Number Seventeen Full Stop",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⒙",
    "slug": "number-eighteen-full-stop",
    "codepoints": [
      9369
    ],
    "primary": 9369,
    "name": "Number Eighteen Full Stop",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⒚",
    "slug": "number-nineteen-full-stop",
    "codepoints": [
      9370
    ],
    "primary": 9370,
    "name": "Number Nineteen Full Stop",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "⒛",
    "slug": "number-twenty-full-stop",
    "codepoints": [
      9371
    ],
    "primary": 9371,
    "name": "Number Twenty Full Stop",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumerics",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "number-symbols",
    "categoryName": "Number Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-digit-zero",
      "circled-digit-one",
      "circled-digit-two",
      "circled-digit-three",
      "circled-digit-four",
      "circled-digit-five",
      "circled-digit-six",
      "circled-digit-seven",
      "circled-digit-eight",
      "circled-digit-nine",
      "circled-number-ten",
      "circled-number-eleven"
    ]
  },
  {
    "symbol": "…",
    "slug": "horizontal-ellipsis",
    "codepoints": [
      8230
    ],
    "primary": 8230,
    "name": "Horizontal Ellipsis",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "punctuation-symbols",
    "categoryName": "Punctuation Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark",
      "double-question-mark"
    ]
  },
  {
    "symbol": "–",
    "slug": "en-dash",
    "codepoints": [
      8211
    ],
    "primary": 8211,
    "name": "En Dash",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Dash Punctuation",
    "categorySlug": "punctuation-symbols",
    "categoryName": "Punctuation Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark",
      "double-question-mark"
    ]
  },
  {
    "symbol": "—",
    "slug": "em-dash",
    "codepoints": [
      8212
    ],
    "primary": 8212,
    "name": "Em Dash",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Dash Punctuation",
    "categorySlug": "punctuation-symbols",
    "categoryName": "Punctuation Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark",
      "double-question-mark"
    ]
  },
  {
    "symbol": "‐",
    "slug": "hyphen",
    "codepoints": [
      8208
    ],
    "primary": 8208,
    "name": "Hyphen",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Dash Punctuation",
    "categorySlug": "punctuation-symbols",
    "categoryName": "Punctuation Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark",
      "double-question-mark"
    ]
  },
  {
    "symbol": "‑",
    "slug": "non-breaking-hyphen",
    "codepoints": [
      8209
    ],
    "primary": 8209,
    "name": "Non-Breaking Hyphen",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Dash Punctuation",
    "categorySlug": "punctuation-symbols",
    "categoryName": "Punctuation Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark",
      "double-question-mark"
    ]
  },
  {
    "symbol": "‒",
    "slug": "figure-dash",
    "codepoints": [
      8210
    ],
    "primary": 8210,
    "name": "Figure Dash",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Dash Punctuation",
    "categorySlug": "punctuation-symbols",
    "categoryName": "Punctuation Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark",
      "double-question-mark"
    ]
  },
  {
    "symbol": "―",
    "slug": "horizontal-bar",
    "codepoints": [
      8213
    ],
    "primary": 8213,
    "name": "Horizontal Bar",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Dash Punctuation",
    "categorySlug": "punctuation-symbols",
    "categoryName": "Punctuation Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark",
      "double-question-mark"
    ]
  },
  {
    "symbol": "·",
    "slug": "middle-dot",
    "codepoints": [
      183
    ],
    "primary": 183,
    "name": "Middle Dot",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Latin 1 Supplement",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "punctuation-symbols",
    "categoryName": "Punctuation Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "multiplication-sign",
      "division-sign",
      "plus-minus-sign",
      "not-sign",
      "pound-sign",
      "yen-sign",
      "cent-sign",
      "pilcrow-sign",
      "section-sign",
      "inverted-question-mark",
      "inverted-exclamation-mark",
      "macron"
    ]
  },
  {
    "symbol": "‧",
    "slug": "hyphenation-point",
    "codepoints": [
      8231
    ],
    "primary": 8231,
    "name": "Hyphenation Point",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "punctuation-symbols",
    "categoryName": "Punctuation Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "reference-mark",
      "double-exclamation-mark",
      "double-question-mark"
    ]
  },
  {
    "symbol": "※",
    "slug": "reference-mark",
    "codepoints": [
      8251
    ],
    "primary": 8251,
    "name": "Reference Mark",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "punctuation-symbols",
    "categoryName": "Punctuation Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "double-exclamation-mark",
      "double-question-mark"
    ]
  },
  {
    "symbol": "‼",
    "slug": "double-exclamation-mark",
    "codepoints": [
      8252
    ],
    "primary": 8252,
    "name": "Double Exclamation Mark",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "punctuation-symbols",
    "categoryName": "Punctuation Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-question-mark"
    ]
  },
  {
    "symbol": "⁇",
    "slug": "double-question-mark",
    "codepoints": [
      8263
    ],
    "primary": 8263,
    "name": "Double Question Mark",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "punctuation-symbols",
    "categoryName": "Punctuation Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark"
    ]
  },
  {
    "symbol": "⁈",
    "slug": "question-exclamation-mark",
    "codepoints": [
      8264
    ],
    "primary": 8264,
    "name": "Question Exclamation Mark",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "punctuation-symbols",
    "categoryName": "Punctuation Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark"
    ]
  },
  {
    "symbol": "⁉",
    "slug": "exclamation-question-mark",
    "codepoints": [
      8265
    ],
    "primary": 8265,
    "name": "Exclamation Question Mark",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "punctuation-symbols",
    "categoryName": "Punctuation Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark"
    ]
  },
  {
    "symbol": "‽",
    "slug": "interrobang",
    "codepoints": [
      8253
    ],
    "primary": 8253,
    "name": "Interrobang",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "punctuation-symbols",
    "categoryName": "Punctuation Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark"
    ]
  },
  {
    "symbol": "¶",
    "slug": "pilcrow-sign",
    "codepoints": [
      182
    ],
    "primary": 182,
    "name": "Pilcrow Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Latin 1 Supplement",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "punctuation-symbols",
    "categoryName": "Punctuation Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "multiplication-sign",
      "division-sign",
      "plus-minus-sign",
      "not-sign",
      "pound-sign",
      "yen-sign",
      "cent-sign",
      "middle-dot",
      "section-sign",
      "inverted-question-mark",
      "inverted-exclamation-mark",
      "macron"
    ]
  },
  {
    "symbol": "§",
    "slug": "section-sign",
    "codepoints": [
      167
    ],
    "primary": 167,
    "name": "Section Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Latin 1 Supplement",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "punctuation-symbols",
    "categoryName": "Punctuation Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "multiplication-sign",
      "division-sign",
      "plus-minus-sign",
      "not-sign",
      "pound-sign",
      "yen-sign",
      "cent-sign",
      "middle-dot",
      "pilcrow-sign",
      "inverted-question-mark",
      "inverted-exclamation-mark",
      "macron"
    ]
  },
  {
    "symbol": "¿",
    "slug": "inverted-question-mark",
    "codepoints": [
      191
    ],
    "primary": 191,
    "name": "Inverted Question Mark",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Latin 1 Supplement",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "punctuation-symbols",
    "categoryName": "Punctuation Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "multiplication-sign",
      "division-sign",
      "plus-minus-sign",
      "not-sign",
      "pound-sign",
      "yen-sign",
      "cent-sign",
      "middle-dot",
      "pilcrow-sign",
      "section-sign",
      "inverted-exclamation-mark",
      "macron"
    ]
  },
  {
    "symbol": "¡",
    "slug": "inverted-exclamation-mark",
    "codepoints": [
      161
    ],
    "primary": 161,
    "name": "Inverted Exclamation Mark",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Latin 1 Supplement",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "punctuation-symbols",
    "categoryName": "Punctuation Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "multiplication-sign",
      "division-sign",
      "plus-minus-sign",
      "not-sign",
      "pound-sign",
      "yen-sign",
      "cent-sign",
      "middle-dot",
      "pilcrow-sign",
      "section-sign",
      "inverted-question-mark",
      "macron"
    ]
  },
  {
    "symbol": "✱",
    "slug": "heavy-asterisk",
    "codepoints": [
      10033
    ],
    "primary": 10033,
    "name": "Heavy Asterisk",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "punctuation-symbols",
    "categoryName": "Punctuation Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "✲",
    "slug": "open-centre-asterisk",
    "codepoints": [
      10034
    ],
    "primary": 10034,
    "name": "Open Centre Asterisk",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "punctuation-symbols",
    "categoryName": "Punctuation Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "✳",
    "slug": "eight-spoked-asterisk",
    "codepoints": [
      10035
    ],
    "primary": 10035,
    "name": "Eight Spoked Asterisk",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "punctuation-symbols",
    "categoryName": "Punctuation Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "†",
    "slug": "dagger",
    "codepoints": [
      8224
    ],
    "primary": 8224,
    "name": "Dagger",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "punctuation-symbols",
    "categoryName": "Punctuation Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark"
    ]
  },
  {
    "symbol": "‡",
    "slug": "double-dagger",
    "codepoints": [
      8225
    ],
    "primary": 8225,
    "name": "Double Dagger",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "punctuation-symbols",
    "categoryName": "Punctuation Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark"
    ]
  },
  {
    "symbol": "‰",
    "slug": "per-mille-sign",
    "codepoints": [
      8240
    ],
    "primary": 8240,
    "name": "Per Mille Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "punctuation-symbols",
    "categoryName": "Punctuation Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark"
    ]
  },
  {
    "symbol": "‱",
    "slug": "per-ten-thousand-sign",
    "codepoints": [
      8241
    ],
    "primary": 8241,
    "name": "Per Ten Thousand Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "punctuation-symbols",
    "categoryName": "Punctuation Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark"
    ]
  },
  {
    "symbol": "‸",
    "slug": "caret",
    "codepoints": [
      8248
    ],
    "primary": 8248,
    "name": "Caret",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "punctuation-symbols",
    "categoryName": "Punctuation Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark"
    ]
  },
  {
    "symbol": "⸮",
    "slug": "reversed-question-mark",
    "codepoints": [
      11822
    ],
    "primary": 11822,
    "name": "Reversed Question Mark",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Punctuation",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "punctuation-symbols",
    "categoryName": "Punctuation Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "inverted-interrobang",
      "ring-point",
      "two-em-dash",
      "three-em-dash"
    ]
  },
  {
    "symbol": "⸘",
    "slug": "inverted-interrobang",
    "codepoints": [
      11800
    ],
    "primary": 11800,
    "name": "Inverted Interrobang",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Punctuation",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "punctuation-symbols",
    "categoryName": "Punctuation Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "reversed-question-mark",
      "ring-point",
      "two-em-dash",
      "three-em-dash"
    ]
  },
  {
    "symbol": "⁎",
    "slug": "low-asterisk",
    "codepoints": [
      8270
    ],
    "primary": 8270,
    "name": "Low Asterisk",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "punctuation-symbols",
    "categoryName": "Punctuation Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark"
    ]
  },
  {
    "symbol": "◆",
    "slug": "black-diamond",
    "codepoints": [
      9670
    ],
    "primary": 9670,
    "name": "Black Diamond",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "geometric-shape-symbols",
    "categoryName": "Geometric Shape Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle",
      "fisheye"
    ]
  },
  {
    "symbol": "◇",
    "slug": "white-diamond",
    "codepoints": [
      9671
    ],
    "primary": 9671,
    "name": "White Diamond",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "geometric-shape-symbols",
    "categoryName": "Geometric Shape Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle",
      "fisheye"
    ]
  },
  {
    "symbol": "◈",
    "slug": "white-diamond-containing-black-small-diamond",
    "codepoints": [
      9672
    ],
    "primary": 9672,
    "name": "White Diamond Containing Black Small Diamond",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "geometric-shape-symbols",
    "categoryName": "Geometric Shape Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle",
      "fisheye"
    ]
  },
  {
    "symbol": "◊",
    "slug": "lozenge",
    "codepoints": [
      9674
    ],
    "primary": 9674,
    "name": "Lozenge",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "geometric-shape-symbols",
    "categoryName": "Geometric Shape Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle",
      "fisheye"
    ]
  },
  {
    "symbol": "⬟",
    "slug": "black-pentagon",
    "codepoints": [
      11039
    ],
    "primary": 11039,
    "name": "Black Pentagon",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "geometric-shape-symbols",
    "categoryName": "Geometric Shape Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-small-star",
      "white-small-star",
      "white-medium-star",
      "ballot-box-with-light-x",
      "white-pentagon",
      "white-hexagon",
      "black-hexagon",
      "horizontal-black-hexagon",
      "heavy-circle"
    ]
  },
  {
    "symbol": "⬠",
    "slug": "white-pentagon",
    "codepoints": [
      11040
    ],
    "primary": 11040,
    "name": "White Pentagon",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "geometric-shape-symbols",
    "categoryName": "Geometric Shape Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-small-star",
      "white-small-star",
      "white-medium-star",
      "ballot-box-with-light-x",
      "black-pentagon",
      "white-hexagon",
      "black-hexagon",
      "horizontal-black-hexagon",
      "heavy-circle"
    ]
  },
  {
    "symbol": "⬡",
    "slug": "white-hexagon",
    "codepoints": [
      11041
    ],
    "primary": 11041,
    "name": "White Hexagon",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "geometric-shape-symbols",
    "categoryName": "Geometric Shape Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-small-star",
      "white-small-star",
      "white-medium-star",
      "ballot-box-with-light-x",
      "black-pentagon",
      "white-pentagon",
      "black-hexagon",
      "horizontal-black-hexagon",
      "heavy-circle"
    ]
  },
  {
    "symbol": "⬢",
    "slug": "black-hexagon",
    "codepoints": [
      11042
    ],
    "primary": 11042,
    "name": "Black Hexagon",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "geometric-shape-symbols",
    "categoryName": "Geometric Shape Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-small-star",
      "white-small-star",
      "white-medium-star",
      "ballot-box-with-light-x",
      "black-pentagon",
      "white-pentagon",
      "white-hexagon",
      "horizontal-black-hexagon",
      "heavy-circle"
    ]
  },
  {
    "symbol": "⬣",
    "slug": "horizontal-black-hexagon",
    "codepoints": [
      11043
    ],
    "primary": 11043,
    "name": "Horizontal Black Hexagon",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "geometric-shape-symbols",
    "categoryName": "Geometric Shape Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-small-star",
      "white-small-star",
      "white-medium-star",
      "ballot-box-with-light-x",
      "black-pentagon",
      "white-pentagon",
      "white-hexagon",
      "black-hexagon",
      "heavy-circle"
    ]
  },
  {
    "symbol": "▬",
    "slug": "black-rectangle",
    "codepoints": [
      9644
    ],
    "primary": 9644,
    "name": "Black Rectangle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "geometric-shape-symbols",
    "categoryName": "Geometric Shape Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle",
      "fisheye"
    ]
  },
  {
    "symbol": "▭",
    "slug": "white-rectangle",
    "codepoints": [
      9645
    ],
    "primary": 9645,
    "name": "White Rectangle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "geometric-shape-symbols",
    "categoryName": "Geometric Shape Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle",
      "fisheye"
    ]
  },
  {
    "symbol": "▮",
    "slug": "black-vertical-rectangle",
    "codepoints": [
      9646
    ],
    "primary": 9646,
    "name": "Black Vertical Rectangle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "geometric-shape-symbols",
    "categoryName": "Geometric Shape Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle",
      "fisheye"
    ]
  },
  {
    "symbol": "▯",
    "slug": "white-vertical-rectangle",
    "codepoints": [
      9647
    ],
    "primary": 9647,
    "name": "White Vertical Rectangle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "geometric-shape-symbols",
    "categoryName": "Geometric Shape Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle",
      "fisheye"
    ]
  },
  {
    "symbol": "▰",
    "slug": "black-parallelogram",
    "codepoints": [
      9648
    ],
    "primary": 9648,
    "name": "Black Parallelogram",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "geometric-shape-symbols",
    "categoryName": "Geometric Shape Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "white-parallelogram",
      "black-circle",
      "white-circle",
      "fisheye"
    ]
  },
  {
    "symbol": "▱",
    "slug": "white-parallelogram",
    "codepoints": [
      9649
    ],
    "primary": 9649,
    "name": "White Parallelogram",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "geometric-shape-symbols",
    "categoryName": "Geometric Shape Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "black-circle",
      "white-circle",
      "fisheye"
    ]
  },
  {
    "symbol": "●",
    "slug": "black-circle",
    "codepoints": [
      9679
    ],
    "primary": 9679,
    "name": "Black Circle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "circle-symbols",
    "categoryName": "Circle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "white-circle",
      "fisheye"
    ]
  },
  {
    "symbol": "○",
    "slug": "white-circle",
    "codepoints": [
      9675
    ],
    "primary": 9675,
    "name": "White Circle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "circle-symbols",
    "categoryName": "Circle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "fisheye"
    ]
  },
  {
    "symbol": "◉",
    "slug": "fisheye",
    "codepoints": [
      9673
    ],
    "primary": 9673,
    "name": "Fisheye",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "circle-symbols",
    "categoryName": "Circle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◎",
    "slug": "bullseye",
    "codepoints": [
      9678
    ],
    "primary": 9678,
    "name": "Bullseye",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "circle-symbols",
    "categoryName": "Circle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◌",
    "slug": "dotted-circle",
    "codepoints": [
      9676
    ],
    "primary": 9676,
    "name": "Dotted Circle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "circle-symbols",
    "categoryName": "Circle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◍",
    "slug": "circle-with-vertical-fill",
    "codepoints": [
      9677
    ],
    "primary": 9677,
    "name": "Circle With Vertical Fill",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "circle-symbols",
    "categoryName": "Circle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◐",
    "slug": "circle-with-left-half-black",
    "codepoints": [
      9680
    ],
    "primary": 9680,
    "name": "Circle With Left Half Black",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "circle-symbols",
    "categoryName": "Circle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◑",
    "slug": "circle-with-right-half-black",
    "codepoints": [
      9681
    ],
    "primary": 9681,
    "name": "Circle With Right Half Black",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "circle-symbols",
    "categoryName": "Circle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◒",
    "slug": "circle-with-lower-half-black",
    "codepoints": [
      9682
    ],
    "primary": 9682,
    "name": "Circle With Lower Half Black",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "circle-symbols",
    "categoryName": "Circle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◓",
    "slug": "circle-with-upper-half-black",
    "codepoints": [
      9683
    ],
    "primary": 9683,
    "name": "Circle With Upper Half Black",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "circle-symbols",
    "categoryName": "Circle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◔",
    "slug": "circle-with-upper-right-quadrant-black",
    "codepoints": [
      9684
    ],
    "primary": 9684,
    "name": "Circle With Upper Right Quadrant Black",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "circle-symbols",
    "categoryName": "Circle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◕",
    "slug": "circle-with-all-but-upper-left-quadrant-black",
    "codepoints": [
      9685
    ],
    "primary": 9685,
    "name": "Circle With All But Upper Left Quadrant Black",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "circle-symbols",
    "categoryName": "Circle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◖",
    "slug": "left-half-black-circle",
    "codepoints": [
      9686
    ],
    "primary": 9686,
    "name": "Left Half Black Circle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "circle-symbols",
    "categoryName": "Circle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◗",
    "slug": "right-half-black-circle",
    "codepoints": [
      9687
    ],
    "primary": 9687,
    "name": "Right Half Black Circle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "circle-symbols",
    "categoryName": "Circle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◙",
    "slug": "inverse-white-circle",
    "codepoints": [
      9689
    ],
    "primary": 9689,
    "name": "Inverse White Circle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "circle-symbols",
    "categoryName": "Circle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◚",
    "slug": "upper-half-inverse-white-circle",
    "codepoints": [
      9690
    ],
    "primary": 9690,
    "name": "Upper Half Inverse White Circle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "circle-symbols",
    "categoryName": "Circle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◛",
    "slug": "lower-half-inverse-white-circle",
    "codepoints": [
      9691
    ],
    "primary": 9691,
    "name": "Lower Half Inverse White Circle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "circle-symbols",
    "categoryName": "Circle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◠",
    "slug": "upper-half-circle",
    "codepoints": [
      9696
    ],
    "primary": 9696,
    "name": "Upper Half Circle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "circle-symbols",
    "categoryName": "Circle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◡",
    "slug": "lower-half-circle",
    "codepoints": [
      9697
    ],
    "primary": 9697,
    "name": "Lower Half Circle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "circle-symbols",
    "categoryName": "Circle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◯",
    "slug": "large-circle",
    "codepoints": [
      9711
    ],
    "primary": 9711,
    "name": "Large Circle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "circle-symbols",
    "categoryName": "Circle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◴",
    "slug": "white-circle-with-upper-left-quadrant",
    "codepoints": [
      9716
    ],
    "primary": 9716,
    "name": "White Circle With Upper Left Quadrant",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "circle-symbols",
    "categoryName": "Circle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◵",
    "slug": "white-circle-with-lower-left-quadrant",
    "codepoints": [
      9717
    ],
    "primary": 9717,
    "name": "White Circle With Lower Left Quadrant",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "circle-symbols",
    "categoryName": "Circle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◶",
    "slug": "white-circle-with-lower-right-quadrant",
    "codepoints": [
      9718
    ],
    "primary": 9718,
    "name": "White Circle With Lower Right Quadrant",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "circle-symbols",
    "categoryName": "Circle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◷",
    "slug": "white-circle-with-upper-right-quadrant",
    "codepoints": [
      9719
    ],
    "primary": 9719,
    "name": "White Circle With Upper Right Quadrant",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "circle-symbols",
    "categoryName": "Circle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "■",
    "slug": "black-square",
    "codepoints": [
      9632
    ],
    "primary": 9632,
    "name": "Black Square",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "square-symbols",
    "categoryName": "Square Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "□",
    "slug": "white-square",
    "codepoints": [
      9633
    ],
    "primary": 9633,
    "name": "White Square",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "square-symbols",
    "categoryName": "Square Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "▢",
    "slug": "white-square-with-rounded-corners",
    "codepoints": [
      9634
    ],
    "primary": 9634,
    "name": "White Square With Rounded Corners",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "square-symbols",
    "categoryName": "Square Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "▣",
    "slug": "white-square-containing-black-small-square",
    "codepoints": [
      9635
    ],
    "primary": 9635,
    "name": "White Square Containing Black Small Square",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "square-symbols",
    "categoryName": "Square Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "▤",
    "slug": "square-with-horizontal-fill",
    "codepoints": [
      9636
    ],
    "primary": 9636,
    "name": "Square With Horizontal Fill",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "square-symbols",
    "categoryName": "Square Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "▥",
    "slug": "square-with-vertical-fill",
    "codepoints": [
      9637
    ],
    "primary": 9637,
    "name": "Square With Vertical Fill",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "square-symbols",
    "categoryName": "Square Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "▦",
    "slug": "square-with-orthogonal-crosshatch-fill",
    "codepoints": [
      9638
    ],
    "primary": 9638,
    "name": "Square With Orthogonal Crosshatch Fill",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "square-symbols",
    "categoryName": "Square Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "▧",
    "slug": "square-with-upper-left-to-lower-right-fill",
    "codepoints": [
      9639
    ],
    "primary": 9639,
    "name": "Square With Upper Left To Lower Right Fill",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "square-symbols",
    "categoryName": "Square Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "▨",
    "slug": "square-with-upper-right-to-lower-left-fill",
    "codepoints": [
      9640
    ],
    "primary": 9640,
    "name": "Square With Upper Right To Lower Left Fill",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "square-symbols",
    "categoryName": "Square Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "▩",
    "slug": "square-with-diagonal-crosshatch-fill",
    "codepoints": [
      9641
    ],
    "primary": 9641,
    "name": "Square With Diagonal Crosshatch Fill",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "square-symbols",
    "categoryName": "Square Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "▪",
    "slug": "black-small-square",
    "codepoints": [
      9642
    ],
    "primary": 9642,
    "name": "Black Small Square",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "square-symbols",
    "categoryName": "Square Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "▫",
    "slug": "white-small-square",
    "codepoints": [
      9643
    ],
    "primary": 9643,
    "name": "White Small Square",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "square-symbols",
    "categoryName": "Square Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◧",
    "slug": "square-with-left-half-black",
    "codepoints": [
      9703
    ],
    "primary": 9703,
    "name": "Square With Left Half Black",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "square-symbols",
    "categoryName": "Square Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◨",
    "slug": "square-with-right-half-black",
    "codepoints": [
      9704
    ],
    "primary": 9704,
    "name": "Square With Right Half Black",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "square-symbols",
    "categoryName": "Square Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◩",
    "slug": "square-with-upper-left-diagonal-half-black",
    "codepoints": [
      9705
    ],
    "primary": 9705,
    "name": "Square With Upper Left Diagonal Half Black",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "square-symbols",
    "categoryName": "Square Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◪",
    "slug": "square-with-lower-right-diagonal-half-black",
    "codepoints": [
      9706
    ],
    "primary": 9706,
    "name": "Square With Lower Right Diagonal Half Black",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "square-symbols",
    "categoryName": "Square Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◫",
    "slug": "white-square-with-vertical-bisecting-line",
    "codepoints": [
      9707
    ],
    "primary": 9707,
    "name": "White Square With Vertical Bisecting Line",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "square-symbols",
    "categoryName": "Square Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◰",
    "slug": "white-square-with-upper-left-quadrant",
    "codepoints": [
      9712
    ],
    "primary": 9712,
    "name": "White Square With Upper Left Quadrant",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "square-symbols",
    "categoryName": "Square Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◱",
    "slug": "white-square-with-lower-left-quadrant",
    "codepoints": [
      9713
    ],
    "primary": 9713,
    "name": "White Square With Lower Left Quadrant",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "square-symbols",
    "categoryName": "Square Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◲",
    "slug": "white-square-with-lower-right-quadrant",
    "codepoints": [
      9714
    ],
    "primary": 9714,
    "name": "White Square With Lower Right Quadrant",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "square-symbols",
    "categoryName": "Square Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◳",
    "slug": "white-square-with-upper-right-quadrant",
    "codepoints": [
      9715
    ],
    "primary": 9715,
    "name": "White Square With Upper Right Quadrant",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "square-symbols",
    "categoryName": "Square Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "△",
    "slug": "white-up-pointing-triangle",
    "codepoints": [
      9651
    ],
    "primary": 9651,
    "name": "White Up-Pointing Triangle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "triangle-symbols",
    "categoryName": "Triangle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "▲",
    "slug": "black-up-pointing-triangle",
    "codepoints": [
      9650
    ],
    "primary": 9650,
    "name": "Black Up-Pointing Triangle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "triangle-symbols",
    "categoryName": "Triangle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "▽",
    "slug": "white-down-pointing-triangle",
    "codepoints": [
      9661
    ],
    "primary": 9661,
    "name": "White Down-Pointing Triangle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "triangle-symbols",
    "categoryName": "Triangle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "▼",
    "slug": "black-down-pointing-triangle",
    "codepoints": [
      9660
    ],
    "primary": 9660,
    "name": "Black Down-Pointing Triangle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "triangle-symbols",
    "categoryName": "Triangle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◁",
    "slug": "white-left-pointing-triangle",
    "codepoints": [
      9665
    ],
    "primary": 9665,
    "name": "White Left-Pointing Triangle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "triangle-symbols",
    "categoryName": "Triangle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◀",
    "slug": "black-left-pointing-triangle",
    "codepoints": [
      9664
    ],
    "primary": 9664,
    "name": "Black Left-Pointing Triangle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "triangle-symbols",
    "categoryName": "Triangle Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "▷",
    "slug": "white-right-pointing-triangle",
    "codepoints": [
      9655
    ],
    "primary": 9655,
    "name": "White Right-Pointing Triangle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "triangle-symbols",
    "categoryName": "Triangle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "▶",
    "slug": "black-right-pointing-triangle",
    "codepoints": [
      9654
    ],
    "primary": 9654,
    "name": "Black Right-Pointing Triangle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "triangle-symbols",
    "categoryName": "Triangle Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "▴",
    "slug": "black-up-pointing-small-triangle",
    "codepoints": [
      9652
    ],
    "primary": 9652,
    "name": "Black Up-Pointing Small Triangle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "triangle-symbols",
    "categoryName": "Triangle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "▵",
    "slug": "white-up-pointing-small-triangle",
    "codepoints": [
      9653
    ],
    "primary": 9653,
    "name": "White Up-Pointing Small Triangle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "triangle-symbols",
    "categoryName": "Triangle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "▸",
    "slug": "black-right-pointing-small-triangle",
    "codepoints": [
      9656
    ],
    "primary": 9656,
    "name": "Black Right-Pointing Small Triangle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "triangle-symbols",
    "categoryName": "Triangle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "▹",
    "slug": "white-right-pointing-small-triangle",
    "codepoints": [
      9657
    ],
    "primary": 9657,
    "name": "White Right-Pointing Small Triangle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "triangle-symbols",
    "categoryName": "Triangle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "▾",
    "slug": "black-down-pointing-small-triangle",
    "codepoints": [
      9662
    ],
    "primary": 9662,
    "name": "Black Down-Pointing Small Triangle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "triangle-symbols",
    "categoryName": "Triangle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "▿",
    "slug": "white-down-pointing-small-triangle",
    "codepoints": [
      9663
    ],
    "primary": 9663,
    "name": "White Down-Pointing Small Triangle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "triangle-symbols",
    "categoryName": "Triangle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◂",
    "slug": "black-left-pointing-small-triangle",
    "codepoints": [
      9666
    ],
    "primary": 9666,
    "name": "Black Left-Pointing Small Triangle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "triangle-symbols",
    "categoryName": "Triangle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◃",
    "slug": "white-left-pointing-small-triangle",
    "codepoints": [
      9667
    ],
    "primary": 9667,
    "name": "White Left-Pointing Small Triangle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "triangle-symbols",
    "categoryName": "Triangle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◢",
    "slug": "black-lower-right-triangle",
    "codepoints": [
      9698
    ],
    "primary": 9698,
    "name": "Black Lower Right Triangle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "triangle-symbols",
    "categoryName": "Triangle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◣",
    "slug": "black-lower-left-triangle",
    "codepoints": [
      9699
    ],
    "primary": 9699,
    "name": "Black Lower Left Triangle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "triangle-symbols",
    "categoryName": "Triangle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◤",
    "slug": "black-upper-left-triangle",
    "codepoints": [
      9700
    ],
    "primary": 9700,
    "name": "Black Upper Left Triangle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "triangle-symbols",
    "categoryName": "Triangle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◥",
    "slug": "black-upper-right-triangle",
    "codepoints": [
      9701
    ],
    "primary": 9701,
    "name": "Black Upper Right Triangle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "triangle-symbols",
    "categoryName": "Triangle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◸",
    "slug": "upper-left-triangle",
    "codepoints": [
      9720
    ],
    "primary": 9720,
    "name": "Upper Left Triangle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "triangle-symbols",
    "categoryName": "Triangle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◹",
    "slug": "upper-right-triangle",
    "codepoints": [
      9721
    ],
    "primary": 9721,
    "name": "Upper Right Triangle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "triangle-symbols",
    "categoryName": "Triangle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◺",
    "slug": "lower-left-triangle",
    "codepoints": [
      9722
    ],
    "primary": 9722,
    "name": "Lower Left Triangle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "triangle-symbols",
    "categoryName": "Triangle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◿",
    "slug": "lower-right-triangle",
    "codepoints": [
      9727
    ],
    "primary": 9727,
    "name": "Lower Right Triangle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "triangle-symbols",
    "categoryName": "Triangle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◬",
    "slug": "white-up-pointing-triangle-with-dot",
    "codepoints": [
      9708
    ],
    "primary": 9708,
    "name": "White Up-Pointing Triangle With Dot",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "triangle-symbols",
    "categoryName": "Triangle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◭",
    "slug": "up-pointing-triangle-with-left-half-black",
    "codepoints": [
      9709
    ],
    "primary": 9709,
    "name": "Up-Pointing Triangle With Left Half Black",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "triangle-symbols",
    "categoryName": "Triangle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◮",
    "slug": "up-pointing-triangle-with-right-half-black",
    "codepoints": [
      9710
    ],
    "primary": 9710,
    "name": "Up-Pointing Triangle With Right Half Black",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "triangle-symbols",
    "categoryName": "Triangle Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "♈",
    "slug": "aries",
    "codepoints": [
      9800
    ],
    "primary": 9800,
    "name": "Aries",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "zodiac-symbols",
    "categoryName": "Zodiac Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "taurus",
      "gemini",
      "cancer"
    ]
  },
  {
    "symbol": "♉",
    "slug": "taurus",
    "codepoints": [
      9801
    ],
    "primary": 9801,
    "name": "Taurus",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "zodiac-symbols",
    "categoryName": "Zodiac Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "gemini",
      "cancer"
    ]
  },
  {
    "symbol": "♊",
    "slug": "gemini",
    "codepoints": [
      9802
    ],
    "primary": 9802,
    "name": "Gemini",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "zodiac-symbols",
    "categoryName": "Zodiac Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "cancer"
    ]
  },
  {
    "symbol": "♋",
    "slug": "cancer",
    "codepoints": [
      9803
    ],
    "primary": 9803,
    "name": "Cancer",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "zodiac-symbols",
    "categoryName": "Zodiac Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♌",
    "slug": "leo",
    "codepoints": [
      9804
    ],
    "primary": 9804,
    "name": "Leo",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "zodiac-symbols",
    "categoryName": "Zodiac Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♍",
    "slug": "virgo",
    "codepoints": [
      9805
    ],
    "primary": 9805,
    "name": "Virgo",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "zodiac-symbols",
    "categoryName": "Zodiac Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♎",
    "slug": "libra",
    "codepoints": [
      9806
    ],
    "primary": 9806,
    "name": "Libra",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "zodiac-symbols",
    "categoryName": "Zodiac Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♏",
    "slug": "scorpius",
    "codepoints": [
      9807
    ],
    "primary": 9807,
    "name": "Scorpius",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "zodiac-symbols",
    "categoryName": "Zodiac Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♐",
    "slug": "sagittarius",
    "codepoints": [
      9808
    ],
    "primary": 9808,
    "name": "Sagittarius",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "zodiac-symbols",
    "categoryName": "Zodiac Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♑",
    "slug": "capricorn",
    "codepoints": [
      9809
    ],
    "primary": 9809,
    "name": "Capricorn",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "zodiac-symbols",
    "categoryName": "Zodiac Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♒",
    "slug": "aquarius",
    "codepoints": [
      9810
    ],
    "primary": 9810,
    "name": "Aquarius",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "zodiac-symbols",
    "categoryName": "Zodiac Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♓",
    "slug": "pisces",
    "codepoints": [
      9811
    ],
    "primary": 9811,
    "name": "Pisces",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "zodiac-symbols",
    "categoryName": "Zodiac Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "⛎",
    "slug": "ophiuchus",
    "codepoints": [
      9934
    ],
    "primary": 9934,
    "name": "Ophiuchus",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "zodiac-symbols",
    "categoryName": "Zodiac Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♔",
    "slug": "white-chess-king",
    "codepoints": [
      9812
    ],
    "primary": 9812,
    "name": "White Chess King",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "chess-symbols",
    "categoryName": "Chess Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♕",
    "slug": "white-chess-queen",
    "codepoints": [
      9813
    ],
    "primary": 9813,
    "name": "White Chess Queen",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "chess-symbols",
    "categoryName": "Chess Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♖",
    "slug": "white-chess-rook",
    "codepoints": [
      9814
    ],
    "primary": 9814,
    "name": "White Chess Rook",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "chess-symbols",
    "categoryName": "Chess Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♗",
    "slug": "white-chess-bishop",
    "codepoints": [
      9815
    ],
    "primary": 9815,
    "name": "White Chess Bishop",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "chess-symbols",
    "categoryName": "Chess Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♘",
    "slug": "white-chess-knight",
    "codepoints": [
      9816
    ],
    "primary": 9816,
    "name": "White Chess Knight",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "chess-symbols",
    "categoryName": "Chess Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♙",
    "slug": "white-chess-pawn",
    "codepoints": [
      9817
    ],
    "primary": 9817,
    "name": "White Chess Pawn",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "chess-symbols",
    "categoryName": "Chess Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♚",
    "slug": "black-chess-king",
    "codepoints": [
      9818
    ],
    "primary": 9818,
    "name": "Black Chess King",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "chess-symbols",
    "categoryName": "Chess Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♛",
    "slug": "black-chess-queen",
    "codepoints": [
      9819
    ],
    "primary": 9819,
    "name": "Black Chess Queen",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "chess-symbols",
    "categoryName": "Chess Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♜",
    "slug": "black-chess-rook",
    "codepoints": [
      9820
    ],
    "primary": 9820,
    "name": "Black Chess Rook",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "chess-symbols",
    "categoryName": "Chess Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♝",
    "slug": "black-chess-bishop",
    "codepoints": [
      9821
    ],
    "primary": 9821,
    "name": "Black Chess Bishop",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "chess-symbols",
    "categoryName": "Chess Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♞",
    "slug": "black-chess-knight",
    "codepoints": [
      9822
    ],
    "primary": 9822,
    "name": "Black Chess Knight",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "chess-symbols",
    "categoryName": "Chess Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♟",
    "slug": "black-chess-pawn",
    "codepoints": [
      9823
    ],
    "primary": 9823,
    "name": "Black Chess Pawn",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "chess-symbols",
    "categoryName": "Chess Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♩",
    "slug": "quarter-note",
    "codepoints": [
      9833
    ],
    "primary": 9833,
    "name": "Quarter Note",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "music-symbols",
    "categoryName": "Music Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♪",
    "slug": "eighth-note",
    "codepoints": [
      9834
    ],
    "primary": 9834,
    "name": "Eighth Note",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "music-symbols",
    "categoryName": "Music Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♫",
    "slug": "beamed-eighth-notes",
    "codepoints": [
      9835
    ],
    "primary": 9835,
    "name": "Beamed Eighth Notes",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "music-symbols",
    "categoryName": "Music Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♬",
    "slug": "beamed-sixteenth-notes",
    "codepoints": [
      9836
    ],
    "primary": 9836,
    "name": "Beamed Sixteenth Notes",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "music-symbols",
    "categoryName": "Music Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♭",
    "slug": "music-flat-sign",
    "codepoints": [
      9837
    ],
    "primary": 9837,
    "name": "Music Flat Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "music-symbols",
    "categoryName": "Music Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♮",
    "slug": "music-natural-sign",
    "codepoints": [
      9838
    ],
    "primary": 9838,
    "name": "Music Natural Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "music-symbols",
    "categoryName": "Music Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♯",
    "slug": "music-sharp-sign",
    "codepoints": [
      9839
    ],
    "primary": 9839,
    "name": "Music Sharp Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "music-symbols",
    "categoryName": "Music Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "𝄞",
    "slug": "musical-symbol-g-clef",
    "codepoints": [
      119070
    ],
    "primary": 119070,
    "name": "Musical Symbol G Clef",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Musical Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "music-symbols",
    "categoryName": "Music Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "musical-symbol-f-clef",
      "musical-symbol-double-sharp",
      "musical-symbol-double-flat",
      "musical-symbol-fermata",
      "musical-symbol-fermata-below",
      "musical-symbol-breath-mark",
      "musical-symbol-caesura",
      "musical-symbol-brace",
      "musical-symbol-bracket",
      "musical-symbol-one-line-staff",
      "musical-symbol-two-line-staff",
      "musical-symbol-three-line-staff"
    ]
  },
  {
    "symbol": "𝄢",
    "slug": "musical-symbol-f-clef",
    "codepoints": [
      119074
    ],
    "primary": 119074,
    "name": "Musical Symbol F Clef",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Musical Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "music-symbols",
    "categoryName": "Music Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "musical-symbol-g-clef",
      "musical-symbol-double-sharp",
      "musical-symbol-double-flat",
      "musical-symbol-fermata",
      "musical-symbol-fermata-below",
      "musical-symbol-breath-mark",
      "musical-symbol-caesura",
      "musical-symbol-brace",
      "musical-symbol-bracket",
      "musical-symbol-one-line-staff",
      "musical-symbol-two-line-staff",
      "musical-symbol-three-line-staff"
    ]
  },
  {
    "symbol": "𝄪",
    "slug": "musical-symbol-double-sharp",
    "codepoints": [
      119082
    ],
    "primary": 119082,
    "name": "Musical Symbol Double Sharp",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Musical Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "music-symbols",
    "categoryName": "Music Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "musical-symbol-g-clef",
      "musical-symbol-f-clef",
      "musical-symbol-double-flat",
      "musical-symbol-fermata",
      "musical-symbol-fermata-below",
      "musical-symbol-breath-mark",
      "musical-symbol-caesura",
      "musical-symbol-brace",
      "musical-symbol-bracket",
      "musical-symbol-one-line-staff",
      "musical-symbol-two-line-staff",
      "musical-symbol-three-line-staff"
    ]
  },
  {
    "symbol": "𝄫",
    "slug": "musical-symbol-double-flat",
    "codepoints": [
      119083
    ],
    "primary": 119083,
    "name": "Musical Symbol Double Flat",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Musical Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "music-symbols",
    "categoryName": "Music Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "musical-symbol-g-clef",
      "musical-symbol-f-clef",
      "musical-symbol-double-sharp",
      "musical-symbol-fermata",
      "musical-symbol-fermata-below",
      "musical-symbol-breath-mark",
      "musical-symbol-caesura",
      "musical-symbol-brace",
      "musical-symbol-bracket",
      "musical-symbol-one-line-staff",
      "musical-symbol-two-line-staff",
      "musical-symbol-three-line-staff"
    ]
  },
  {
    "symbol": "𝄐",
    "slug": "musical-symbol-fermata",
    "codepoints": [
      119056
    ],
    "primary": 119056,
    "name": "Musical Symbol Fermata",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Musical Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "music-symbols",
    "categoryName": "Music Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "musical-symbol-g-clef",
      "musical-symbol-f-clef",
      "musical-symbol-double-sharp",
      "musical-symbol-double-flat",
      "musical-symbol-fermata-below",
      "musical-symbol-breath-mark",
      "musical-symbol-caesura",
      "musical-symbol-brace",
      "musical-symbol-bracket",
      "musical-symbol-one-line-staff",
      "musical-symbol-two-line-staff",
      "musical-symbol-three-line-staff"
    ]
  },
  {
    "symbol": "𝄑",
    "slug": "musical-symbol-fermata-below",
    "codepoints": [
      119057
    ],
    "primary": 119057,
    "name": "Musical Symbol Fermata Below",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Musical Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "music-symbols",
    "categoryName": "Music Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "musical-symbol-g-clef",
      "musical-symbol-f-clef",
      "musical-symbol-double-sharp",
      "musical-symbol-double-flat",
      "musical-symbol-fermata",
      "musical-symbol-breath-mark",
      "musical-symbol-caesura",
      "musical-symbol-brace",
      "musical-symbol-bracket",
      "musical-symbol-one-line-staff",
      "musical-symbol-two-line-staff",
      "musical-symbol-three-line-staff"
    ]
  },
  {
    "symbol": "𝄒",
    "slug": "musical-symbol-breath-mark",
    "codepoints": [
      119058
    ],
    "primary": 119058,
    "name": "Musical Symbol Breath Mark",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Musical Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "music-symbols",
    "categoryName": "Music Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "musical-symbol-g-clef",
      "musical-symbol-f-clef",
      "musical-symbol-double-sharp",
      "musical-symbol-double-flat",
      "musical-symbol-fermata",
      "musical-symbol-fermata-below",
      "musical-symbol-caesura",
      "musical-symbol-brace",
      "musical-symbol-bracket",
      "musical-symbol-one-line-staff",
      "musical-symbol-two-line-staff",
      "musical-symbol-three-line-staff"
    ]
  },
  {
    "symbol": "𝄓",
    "slug": "musical-symbol-caesura",
    "codepoints": [
      119059
    ],
    "primary": 119059,
    "name": "Musical Symbol Caesura",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Musical Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "music-symbols",
    "categoryName": "Music Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "musical-symbol-g-clef",
      "musical-symbol-f-clef",
      "musical-symbol-double-sharp",
      "musical-symbol-double-flat",
      "musical-symbol-fermata",
      "musical-symbol-fermata-below",
      "musical-symbol-breath-mark",
      "musical-symbol-brace",
      "musical-symbol-bracket",
      "musical-symbol-one-line-staff",
      "musical-symbol-two-line-staff",
      "musical-symbol-three-line-staff"
    ]
  },
  {
    "symbol": "𝄔",
    "slug": "musical-symbol-brace",
    "codepoints": [
      119060
    ],
    "primary": 119060,
    "name": "Musical Symbol Brace",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Musical Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "music-symbols",
    "categoryName": "Music Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "musical-symbol-g-clef",
      "musical-symbol-f-clef",
      "musical-symbol-double-sharp",
      "musical-symbol-double-flat",
      "musical-symbol-fermata",
      "musical-symbol-fermata-below",
      "musical-symbol-breath-mark",
      "musical-symbol-caesura",
      "musical-symbol-bracket",
      "musical-symbol-one-line-staff",
      "musical-symbol-two-line-staff",
      "musical-symbol-three-line-staff"
    ]
  },
  {
    "symbol": "𝄕",
    "slug": "musical-symbol-bracket",
    "codepoints": [
      119061
    ],
    "primary": 119061,
    "name": "Musical Symbol Bracket",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Musical Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "music-symbols",
    "categoryName": "Music Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "musical-symbol-g-clef",
      "musical-symbol-f-clef",
      "musical-symbol-double-sharp",
      "musical-symbol-double-flat",
      "musical-symbol-fermata",
      "musical-symbol-fermata-below",
      "musical-symbol-breath-mark",
      "musical-symbol-caesura",
      "musical-symbol-brace",
      "musical-symbol-one-line-staff",
      "musical-symbol-two-line-staff",
      "musical-symbol-three-line-staff"
    ]
  },
  {
    "symbol": "𝄖",
    "slug": "musical-symbol-one-line-staff",
    "codepoints": [
      119062
    ],
    "primary": 119062,
    "name": "Musical Symbol One-Line Staff",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Musical Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "music-symbols",
    "categoryName": "Music Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "musical-symbol-g-clef",
      "musical-symbol-f-clef",
      "musical-symbol-double-sharp",
      "musical-symbol-double-flat",
      "musical-symbol-fermata",
      "musical-symbol-fermata-below",
      "musical-symbol-breath-mark",
      "musical-symbol-caesura",
      "musical-symbol-brace",
      "musical-symbol-bracket",
      "musical-symbol-two-line-staff",
      "musical-symbol-three-line-staff"
    ]
  },
  {
    "symbol": "𝄗",
    "slug": "musical-symbol-two-line-staff",
    "codepoints": [
      119063
    ],
    "primary": 119063,
    "name": "Musical Symbol Two-Line Staff",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Musical Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "music-symbols",
    "categoryName": "Music Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "musical-symbol-g-clef",
      "musical-symbol-f-clef",
      "musical-symbol-double-sharp",
      "musical-symbol-double-flat",
      "musical-symbol-fermata",
      "musical-symbol-fermata-below",
      "musical-symbol-breath-mark",
      "musical-symbol-caesura",
      "musical-symbol-brace",
      "musical-symbol-bracket",
      "musical-symbol-one-line-staff",
      "musical-symbol-three-line-staff"
    ]
  },
  {
    "symbol": "𝄘",
    "slug": "musical-symbol-three-line-staff",
    "codepoints": [
      119064
    ],
    "primary": 119064,
    "name": "Musical Symbol Three-Line Staff",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Musical Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "music-symbols",
    "categoryName": "Music Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "musical-symbol-g-clef",
      "musical-symbol-f-clef",
      "musical-symbol-double-sharp",
      "musical-symbol-double-flat",
      "musical-symbol-fermata",
      "musical-symbol-fermata-below",
      "musical-symbol-breath-mark",
      "musical-symbol-caesura",
      "musical-symbol-brace",
      "musical-symbol-bracket",
      "musical-symbol-one-line-staff",
      "musical-symbol-two-line-staff"
    ]
  },
  {
    "symbol": "𝄙",
    "slug": "musical-symbol-four-line-staff",
    "codepoints": [
      119065
    ],
    "primary": 119065,
    "name": "Musical Symbol Four-Line Staff",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Musical Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "music-symbols",
    "categoryName": "Music Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "musical-symbol-g-clef",
      "musical-symbol-f-clef",
      "musical-symbol-double-sharp",
      "musical-symbol-double-flat",
      "musical-symbol-fermata",
      "musical-symbol-fermata-below",
      "musical-symbol-breath-mark",
      "musical-symbol-caesura",
      "musical-symbol-brace",
      "musical-symbol-bracket",
      "musical-symbol-one-line-staff",
      "musical-symbol-two-line-staff"
    ]
  },
  {
    "symbol": "𝄚",
    "slug": "musical-symbol-five-line-staff",
    "codepoints": [
      119066
    ],
    "primary": 119066,
    "name": "Musical Symbol Five-Line Staff",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Musical Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "music-symbols",
    "categoryName": "Music Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "musical-symbol-g-clef",
      "musical-symbol-f-clef",
      "musical-symbol-double-sharp",
      "musical-symbol-double-flat",
      "musical-symbol-fermata",
      "musical-symbol-fermata-below",
      "musical-symbol-breath-mark",
      "musical-symbol-caesura",
      "musical-symbol-brace",
      "musical-symbol-bracket",
      "musical-symbol-one-line-staff",
      "musical-symbol-two-line-staff"
    ]
  },
  {
    "symbol": "𝄛",
    "slug": "musical-symbol-six-line-staff",
    "codepoints": [
      119067
    ],
    "primary": 119067,
    "name": "Musical Symbol Six-Line Staff",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Musical Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "music-symbols",
    "categoryName": "Music Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "musical-symbol-g-clef",
      "musical-symbol-f-clef",
      "musical-symbol-double-sharp",
      "musical-symbol-double-flat",
      "musical-symbol-fermata",
      "musical-symbol-fermata-below",
      "musical-symbol-breath-mark",
      "musical-symbol-caesura",
      "musical-symbol-brace",
      "musical-symbol-bracket",
      "musical-symbol-one-line-staff",
      "musical-symbol-two-line-staff"
    ]
  },
  {
    "symbol": "𝄜",
    "slug": "musical-symbol-six-string-fretboard",
    "codepoints": [
      119068
    ],
    "primary": 119068,
    "name": "Musical Symbol Six-String Fretboard",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Musical Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "music-symbols",
    "categoryName": "Music Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "musical-symbol-g-clef",
      "musical-symbol-f-clef",
      "musical-symbol-double-sharp",
      "musical-symbol-double-flat",
      "musical-symbol-fermata",
      "musical-symbol-fermata-below",
      "musical-symbol-breath-mark",
      "musical-symbol-caesura",
      "musical-symbol-brace",
      "musical-symbol-bracket",
      "musical-symbol-one-line-staff",
      "musical-symbol-two-line-staff"
    ]
  },
  {
    "symbol": "𝄝",
    "slug": "musical-symbol-four-string-fretboard",
    "codepoints": [
      119069
    ],
    "primary": 119069,
    "name": "Musical Symbol Four-String Fretboard",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Musical Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "music-symbols",
    "categoryName": "Music Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "musical-symbol-g-clef",
      "musical-symbol-f-clef",
      "musical-symbol-double-sharp",
      "musical-symbol-double-flat",
      "musical-symbol-fermata",
      "musical-symbol-fermata-below",
      "musical-symbol-breath-mark",
      "musical-symbol-caesura",
      "musical-symbol-brace",
      "musical-symbol-bracket",
      "musical-symbol-one-line-staff",
      "musical-symbol-two-line-staff"
    ]
  },
  {
    "symbol": "𝄟",
    "slug": "musical-symbol-g-clef-ottava-alta",
    "codepoints": [
      119071
    ],
    "primary": 119071,
    "name": "Musical Symbol G Clef Ottava Alta",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Musical Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "music-symbols",
    "categoryName": "Music Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "musical-symbol-g-clef",
      "musical-symbol-f-clef",
      "musical-symbol-double-sharp",
      "musical-symbol-double-flat",
      "musical-symbol-fermata",
      "musical-symbol-fermata-below",
      "musical-symbol-breath-mark",
      "musical-symbol-caesura",
      "musical-symbol-brace",
      "musical-symbol-bracket",
      "musical-symbol-one-line-staff",
      "musical-symbol-two-line-staff"
    ]
  },
  {
    "symbol": "𝄠",
    "slug": "musical-symbol-g-clef-ottava-bassa",
    "codepoints": [
      119072
    ],
    "primary": 119072,
    "name": "Musical Symbol G Clef Ottava Bassa",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Musical Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "music-symbols",
    "categoryName": "Music Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "musical-symbol-g-clef",
      "musical-symbol-f-clef",
      "musical-symbol-double-sharp",
      "musical-symbol-double-flat",
      "musical-symbol-fermata",
      "musical-symbol-fermata-below",
      "musical-symbol-breath-mark",
      "musical-symbol-caesura",
      "musical-symbol-brace",
      "musical-symbol-bracket",
      "musical-symbol-one-line-staff",
      "musical-symbol-two-line-staff"
    ]
  },
  {
    "symbol": "𝄡",
    "slug": "musical-symbol-c-clef",
    "codepoints": [
      119073
    ],
    "primary": 119073,
    "name": "Musical Symbol C Clef",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Musical Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "music-symbols",
    "categoryName": "Music Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "musical-symbol-g-clef",
      "musical-symbol-f-clef",
      "musical-symbol-double-sharp",
      "musical-symbol-double-flat",
      "musical-symbol-fermata",
      "musical-symbol-fermata-below",
      "musical-symbol-breath-mark",
      "musical-symbol-caesura",
      "musical-symbol-brace",
      "musical-symbol-bracket",
      "musical-symbol-one-line-staff",
      "musical-symbol-two-line-staff"
    ]
  },
  {
    "symbol": "𝅗",
    "slug": "musical-symbol-void-notehead",
    "codepoints": [
      119127
    ],
    "primary": 119127,
    "name": "Musical Symbol Void Notehead",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Musical Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "music-symbols",
    "categoryName": "Music Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "musical-symbol-g-clef",
      "musical-symbol-f-clef",
      "musical-symbol-double-sharp",
      "musical-symbol-double-flat",
      "musical-symbol-fermata",
      "musical-symbol-fermata-below",
      "musical-symbol-breath-mark",
      "musical-symbol-caesura",
      "musical-symbol-brace",
      "musical-symbol-bracket",
      "musical-symbol-one-line-staff",
      "musical-symbol-two-line-staff"
    ]
  },
  {
    "symbol": "𝅘",
    "slug": "musical-symbol-notehead-black",
    "codepoints": [
      119128
    ],
    "primary": 119128,
    "name": "Musical Symbol Notehead Black",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Musical Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "music-symbols",
    "categoryName": "Music Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "musical-symbol-g-clef",
      "musical-symbol-f-clef",
      "musical-symbol-double-sharp",
      "musical-symbol-double-flat",
      "musical-symbol-fermata",
      "musical-symbol-fermata-below",
      "musical-symbol-breath-mark",
      "musical-symbol-caesura",
      "musical-symbol-brace",
      "musical-symbol-bracket",
      "musical-symbol-one-line-staff",
      "musical-symbol-two-line-staff"
    ]
  },
  {
    "symbol": "🎵",
    "slug": "musical-note",
    "codepoints": [
      127925
    ],
    "primary": 127925,
    "name": "Musical Note",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "music-symbols",
    "categoryName": "Music Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🎶",
    "slug": "multiple-musical-notes",
    "codepoints": [
      127926
    ],
    "primary": 127926,
    "name": "Multiple Musical Notes",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "music-symbols",
    "categoryName": "Music Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🎼",
    "slug": "musical-score",
    "codepoints": [
      127932
    ],
    "primary": 127932,
    "name": "Musical Score",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "music-symbols",
    "categoryName": "Music Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🎤",
    "slug": "microphone",
    "codepoints": [
      127908
    ],
    "primary": 127908,
    "name": "Microphone",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "music-symbols",
    "categoryName": "Music Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🎧",
    "slug": "headphone",
    "codepoints": [
      127911
    ],
    "primary": 127911,
    "name": "Headphone",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "music-symbols",
    "categoryName": "Music Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🎷",
    "slug": "saxophone",
    "codepoints": [
      127927
    ],
    "primary": 127927,
    "name": "Saxophone",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "music-symbols",
    "categoryName": "Music Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🎸",
    "slug": "guitar",
    "codepoints": [
      127928
    ],
    "primary": 127928,
    "name": "Guitar",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "music-symbols",
    "categoryName": "Music Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🎹",
    "slug": "musical-keyboard",
    "codepoints": [
      127929
    ],
    "primary": 127929,
    "name": "Musical Keyboard",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "music-symbols",
    "categoryName": "Music Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🎺",
    "slug": "trumpet",
    "codepoints": [
      127930
    ],
    "primary": 127930,
    "name": "Trumpet",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "music-symbols",
    "categoryName": "Music Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🎻",
    "slug": "violin",
    "codepoints": [
      127931
    ],
    "primary": 127931,
    "name": "Violin",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "music-symbols",
    "categoryName": "Music Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🥁",
    "slug": "drum-with-drumsticks",
    "codepoints": [
      129345
    ],
    "primary": 129345,
    "name": "Drum With Drumsticks",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "music-symbols",
    "categoryName": "Music Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan",
      "guide-dog"
    ]
  },
  {
    "symbol": "☀",
    "slug": "black-sun-with-rays",
    "codepoints": [
      9728
    ],
    "primary": 9728,
    "name": "Black Sun With Rays",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "weather-symbols",
    "categoryName": "Weather Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "☁",
    "slug": "cloud",
    "codepoints": [
      9729
    ],
    "primary": 9729,
    "name": "Cloud",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "weather-symbols",
    "categoryName": "Weather Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "☂",
    "slug": "umbrella",
    "codepoints": [
      9730
    ],
    "primary": 9730,
    "name": "Umbrella",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "weather-symbols",
    "categoryName": "Weather Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "☃",
    "slug": "snowman",
    "codepoints": [
      9731
    ],
    "primary": 9731,
    "name": "Snowman",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "weather-symbols",
    "categoryName": "Weather Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♨",
    "slug": "hot-springs",
    "codepoints": [
      9832
    ],
    "primary": 9832,
    "name": "Hot Springs",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "weather-symbols",
    "categoryName": "Weather Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "❄",
    "slug": "snowflake",
    "codepoints": [
      10052
    ],
    "primary": 10052,
    "name": "Snowflake",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "weather-symbols",
    "categoryName": "Weather Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "☔",
    "slug": "umbrella-with-rain-drops",
    "codepoints": [
      9748
    ],
    "primary": 9748,
    "name": "Umbrella With Rain Drops",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "weather-symbols",
    "categoryName": "Weather Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "☼",
    "slug": "white-sun-with-rays",
    "codepoints": [
      9788
    ],
    "primary": 9788,
    "name": "White Sun With Rays",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "weather-symbols",
    "categoryName": "Weather Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "🌤",
    "slug": "white-sun-with-small-cloud",
    "codepoints": [
      127780
    ],
    "primary": 127780,
    "name": "White Sun With Small Cloud",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "weather-symbols",
    "categoryName": "Weather Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🌥",
    "slug": "white-sun-behind-cloud",
    "codepoints": [
      127781
    ],
    "primary": 127781,
    "name": "White Sun Behind Cloud",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "weather-symbols",
    "categoryName": "Weather Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🌦",
    "slug": "white-sun-behind-cloud-with-rain",
    "codepoints": [
      127782
    ],
    "primary": 127782,
    "name": "White Sun Behind Cloud With Rain",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "weather-symbols",
    "categoryName": "Weather Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🌧",
    "slug": "cloud-with-rain",
    "codepoints": [
      127783
    ],
    "primary": 127783,
    "name": "Cloud With Rain",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "weather-symbols",
    "categoryName": "Weather Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🌨",
    "slug": "cloud-with-snow",
    "codepoints": [
      127784
    ],
    "primary": 127784,
    "name": "Cloud With Snow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "weather-symbols",
    "categoryName": "Weather Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🌩",
    "slug": "cloud-with-lightning",
    "codepoints": [
      127785
    ],
    "primary": 127785,
    "name": "Cloud With Lightning",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "weather-symbols",
    "categoryName": "Weather Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🌪",
    "slug": "cloud-with-tornado",
    "codepoints": [
      127786
    ],
    "primary": 127786,
    "name": "Cloud With Tornado",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "weather-symbols",
    "categoryName": "Weather Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🌫",
    "slug": "fog",
    "codepoints": [
      127787
    ],
    "primary": 127787,
    "name": "Fog",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "weather-symbols",
    "categoryName": "Weather Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🌬",
    "slug": "wind-blowing-face",
    "codepoints": [
      127788
    ],
    "primary": 127788,
    "name": "Wind Blowing Face",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "weather-symbols",
    "categoryName": "Weather Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🌈",
    "slug": "rainbow",
    "codepoints": [
      127752
    ],
    "primary": 127752,
    "name": "Rainbow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "weather-symbols",
    "categoryName": "Weather Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🌊",
    "slug": "water-wave",
    "codepoints": [
      127754
    ],
    "primary": 127754,
    "name": "Water Wave",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "weather-symbols",
    "categoryName": "Weather Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🔥",
    "slug": "fire",
    "codepoints": [
      128293
    ],
    "primary": 128293,
    "name": "Fire",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "weather-symbols",
    "categoryName": "Weather Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "💧",
    "slug": "droplet",
    "codepoints": [
      128167
    ],
    "primary": 128167,
    "name": "Droplet",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "weather-symbols",
    "categoryName": "Weather Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "⛅",
    "slug": "sun-behind-cloud",
    "codepoints": [
      9925
    ],
    "primary": 9925,
    "name": "Sun Behind Cloud",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "weather-symbols",
    "categoryName": "Weather Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "⛈",
    "slug": "thunder-cloud-and-rain",
    "codepoints": [
      9928
    ],
    "primary": 9928,
    "name": "Thunder Cloud And Rain",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "weather-symbols",
    "categoryName": "Weather Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "⛄",
    "slug": "snowman-without-snow",
    "codepoints": [
      9924
    ],
    "primary": 9924,
    "name": "Snowman Without Snow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "weather-symbols",
    "categoryName": "Weather Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "🌞",
    "slug": "sun-with-face",
    "codepoints": [
      127774
    ],
    "primary": 127774,
    "name": "Sun With Face",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "weather-symbols",
    "categoryName": "Weather Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🌝",
    "slug": "full-moon-with-face",
    "codepoints": [
      127773
    ],
    "primary": 127773,
    "name": "Full Moon With Face",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "weather-symbols",
    "categoryName": "Weather Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🌙",
    "slug": "crescent-moon",
    "codepoints": [
      127769
    ],
    "primary": 127769,
    "name": "Crescent Moon",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "weather-symbols",
    "categoryName": "Weather Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "⌽",
    "slug": "apl-functional-symbol-circle-stile",
    "codepoints": [
      9021
    ],
    "primary": 9021,
    "name": "Apl Functional Symbol Circle Stile",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "technical-symbols",
    "categoryName": "Technical Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock",
      "house"
    ]
  },
  {
    "symbol": "⌚",
    "slug": "watch",
    "codepoints": [
      8986
    ],
    "primary": 8986,
    "name": "Watch",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "technical-symbols",
    "categoryName": "Technical Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock",
      "house"
    ]
  },
  {
    "symbol": "⌖",
    "slug": "position-indicator",
    "codepoints": [
      8982
    ],
    "primary": 8982,
    "name": "Position Indicator",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "technical-symbols",
    "categoryName": "Technical Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock",
      "house"
    ]
  },
  {
    "symbol": "⌗",
    "slug": "viewdata-square",
    "codepoints": [
      8983
    ],
    "primary": 8983,
    "name": "Viewdata Square",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "technical-symbols",
    "categoryName": "Technical Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock",
      "house"
    ]
  },
  {
    "symbol": "⌬",
    "slug": "benzene-ring",
    "codepoints": [
      9004
    ],
    "primary": 9004,
    "name": "Benzene Ring",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "technical-symbols",
    "categoryName": "Technical Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock",
      "house"
    ]
  },
  {
    "symbol": "⏻",
    "slug": "power-symbol",
    "codepoints": [
      9211
    ],
    "primary": 9211,
    "name": "Power Symbol",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "technical-symbols",
    "categoryName": "Technical Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock",
      "house"
    ]
  },
  {
    "symbol": "⏼",
    "slug": "power-on-off-symbol",
    "codepoints": [
      9212
    ],
    "primary": 9212,
    "name": "Power On-Off Symbol",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "technical-symbols",
    "categoryName": "Technical Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock",
      "house"
    ]
  },
  {
    "symbol": "⏽",
    "slug": "power-on-symbol",
    "codepoints": [
      9213
    ],
    "primary": 9213,
    "name": "Power On Symbol",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "technical-symbols",
    "categoryName": "Technical Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock",
      "house"
    ]
  },
  {
    "symbol": "⭘",
    "slug": "heavy-circle",
    "codepoints": [
      11096
    ],
    "primary": 11096,
    "name": "Heavy Circle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "technical-symbols",
    "categoryName": "Technical Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-small-star",
      "white-small-star",
      "white-medium-star",
      "ballot-box-with-light-x",
      "black-pentagon",
      "white-pentagon",
      "white-hexagon",
      "black-hexagon",
      "horizontal-black-hexagon"
    ]
  },
  {
    "symbol": "⏾",
    "slug": "power-sleep-symbol",
    "codepoints": [
      9214
    ],
    "primary": 9214,
    "name": "Power Sleep Symbol",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "technical-symbols",
    "categoryName": "Technical Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock",
      "house"
    ]
  },
  {
    "symbol": "⚙",
    "slug": "gear",
    "codepoints": [
      9881
    ],
    "primary": 9881,
    "name": "Gear",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "technical-symbols",
    "categoryName": "Technical Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "⚛",
    "slug": "atom-symbol",
    "codepoints": [
      9883
    ],
    "primary": 9883,
    "name": "Atom Symbol",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "technical-symbols",
    "categoryName": "Technical Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♻",
    "slug": "black-universal-recycling-symbol",
    "codepoints": [
      9851
    ],
    "primary": 9851,
    "name": "Black Universal Recycling Symbol",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "technical-symbols",
    "categoryName": "Technical Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "✉",
    "slug": "envelope",
    "codepoints": [
      9993
    ],
    "primary": 9993,
    "name": "Envelope",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "technical-symbols",
    "categoryName": "Technical Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "✎",
    "slug": "lower-right-pencil",
    "codepoints": [
      9998
    ],
    "primary": 9998,
    "name": "Lower Right Pencil",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "technical-symbols",
    "categoryName": "Technical Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "✏",
    "slug": "pencil",
    "codepoints": [
      9999
    ],
    "primary": 9999,
    "name": "Pencil",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "technical-symbols",
    "categoryName": "Technical Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "✐",
    "slug": "upper-right-pencil",
    "codepoints": [
      10000
    ],
    "primary": 10000,
    "name": "Upper Right Pencil",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "technical-symbols",
    "categoryName": "Technical Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "✒",
    "slug": "black-nib",
    "codepoints": [
      10002
    ],
    "primary": 10002,
    "name": "Black Nib",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "technical-symbols",
    "categoryName": "Technical Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "⌧",
    "slug": "x-in-a-rectangle-box",
    "codepoints": [
      8999
    ],
    "primary": 8999,
    "name": "X In A Rectangle Box",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "technical-symbols",
    "categoryName": "Technical Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "alarm-clock",
      "house"
    ]
  },
  {
    "symbol": "⏰",
    "slug": "alarm-clock",
    "codepoints": [
      9200
    ],
    "primary": 9200,
    "name": "Alarm Clock",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "technical-symbols",
    "categoryName": "Technical Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "house"
    ]
  },
  {
    "symbol": "☎",
    "slug": "black-telephone",
    "codepoints": [
      9742
    ],
    "primary": 9742,
    "name": "Black Telephone",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "technical-symbols",
    "categoryName": "Technical Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "✆",
    "slug": "telephone-location-sign",
    "codepoints": [
      9990
    ],
    "primary": 9990,
    "name": "Telephone Location Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "technical-symbols",
    "categoryName": "Technical Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "✇",
    "slug": "tape-drive",
    "codepoints": [
      9991
    ],
    "primary": 9991,
    "name": "Tape Drive",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "technical-symbols",
    "categoryName": "Technical Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "⌂",
    "slug": "house",
    "codepoints": [
      8962
    ],
    "primary": 8962,
    "name": "House",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "technical-symbols",
    "categoryName": "Technical Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "⌛",
    "slug": "hourglass",
    "codepoints": [
      8987
    ],
    "primary": 8987,
    "name": "Hourglass",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "technical-symbols",
    "categoryName": "Technical Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "⌕",
    "slug": "telephone-recorder",
    "codepoints": [
      8981
    ],
    "primary": 8981,
    "name": "Telephone Recorder",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "technical-symbols",
    "categoryName": "Technical Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "⌲",
    "slug": "conical-taper",
    "codepoints": [
      9010
    ],
    "primary": 9010,
    "name": "Conical Taper",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "technical-symbols",
    "categoryName": "Technical Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "⎈",
    "slug": "helm-symbol",
    "codepoints": [
      9096
    ],
    "primary": 9096,
    "name": "Helm Symbol",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "technical-symbols",
    "categoryName": "Technical Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "⎌",
    "slug": "undo-symbol",
    "codepoints": [
      9100
    ],
    "primary": 9100,
    "name": "Undo Symbol",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "technical-symbols",
    "categoryName": "Technical Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "⎓",
    "slug": "direct-current-symbol-form-two",
    "codepoints": [
      9107
    ],
    "primary": 9107,
    "name": "Direct Current Symbol Form Two",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "technical-symbols",
    "categoryName": "Technical Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "⎙",
    "slug": "print-screen-symbol",
    "codepoints": [
      9113
    ],
    "primary": 9113,
    "name": "Print Screen Symbol",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "technical-symbols",
    "categoryName": "Technical Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "⏣",
    "slug": "benzene-ring-with-circle",
    "codepoints": [
      9187
    ],
    "primary": 9187,
    "name": "Benzene Ring With Circle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "technical-symbols",
    "categoryName": "Technical Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "⏱",
    "slug": "stopwatch",
    "codepoints": [
      9201
    ],
    "primary": 9201,
    "name": "Stopwatch",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "technical-symbols",
    "categoryName": "Technical Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "⏳",
    "slug": "hourglass-with-flowing-sand",
    "codepoints": [
      9203
    ],
    "primary": 9203,
    "name": "Hourglass With Flowing Sand",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "technical-symbols",
    "categoryName": "Technical Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "⏺",
    "slug": "black-circle-for-record",
    "codepoints": [
      9210
    ],
    "primary": 9210,
    "name": "Black Circle For Record",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "technical-symbols",
    "categoryName": "Technical Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "⌘",
    "slug": "place-of-interest-sign",
    "codepoints": [
      8984
    ],
    "primary": 8984,
    "name": "Place Of Interest Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "keyboard-symbols",
    "categoryName": "Keyboard Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "⌥",
    "slug": "option-key",
    "codepoints": [
      8997
    ],
    "primary": 8997,
    "name": "Option Key",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "keyboard-symbols",
    "categoryName": "Keyboard Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "⇧",
    "slug": "upwards-white-arrow",
    "codepoints": [
      8679
    ],
    "primary": 8679,
    "name": "Upwards White Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "keyboard-symbols",
    "categoryName": "Keyboard Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "⌃",
    "slug": "up-arrowhead",
    "codepoints": [
      8963
    ],
    "primary": 8963,
    "name": "Up Arrowhead",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "keyboard-symbols",
    "categoryName": "Keyboard Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "⎋",
    "slug": "broken-circle-with-northwest-arrow",
    "codepoints": [
      9099
    ],
    "primary": 9099,
    "name": "Broken Circle With Northwest Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "keyboard-symbols",
    "categoryName": "Keyboard Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "⏎",
    "slug": "return-symbol",
    "codepoints": [
      9166
    ],
    "primary": 9166,
    "name": "Return Symbol",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "keyboard-symbols",
    "categoryName": "Keyboard Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "⌫",
    "slug": "erase-to-the-left",
    "codepoints": [
      9003
    ],
    "primary": 9003,
    "name": "Erase To The Left",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "keyboard-symbols",
    "categoryName": "Keyboard Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "⌦",
    "slug": "erase-to-the-right",
    "codepoints": [
      8998
    ],
    "primary": 8998,
    "name": "Erase To The Right",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "keyboard-symbols",
    "categoryName": "Keyboard Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "⇪",
    "slug": "upwards-white-arrow-from-bar",
    "codepoints": [
      8682
    ],
    "primary": 8682,
    "name": "Upwards White Arrow From Bar",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "keyboard-symbols",
    "categoryName": "Keyboard Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "⇥",
    "slug": "rightwards-arrow-to-bar",
    "codepoints": [
      8677
    ],
    "primary": 8677,
    "name": "Rightwards Arrow To Bar",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "keyboard-symbols",
    "categoryName": "Keyboard Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "⇤",
    "slug": "leftwards-arrow-to-bar",
    "codepoints": [
      8676
    ],
    "primary": 8676,
    "name": "Leftwards Arrow To Bar",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Arrows",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "keyboard-symbols",
    "categoryName": "Keyboard Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "leftwards-arrow",
      "upwards-arrow",
      "rightwards-arrow",
      "downwards-arrow",
      "north-west-arrow",
      "north-east-arrow",
      "south-east-arrow",
      "south-west-arrow",
      "left-right-arrow",
      "up-down-arrow",
      "leftwards-double-arrow",
      "upwards-double-arrow"
    ]
  },
  {
    "symbol": "⏏",
    "slug": "eject-symbol",
    "codepoints": [
      9167
    ],
    "primary": 9167,
    "name": "Eject Symbol",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "keyboard-symbols",
    "categoryName": "Keyboard Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "⌨",
    "slug": "keyboard",
    "codepoints": [
      9000
    ],
    "primary": 9000,
    "name": "Keyboard",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "keyboard-symbols",
    "categoryName": "Keyboard Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "⎇",
    "slug": "alternative-key-symbol",
    "codepoints": [
      9095
    ],
    "primary": 9095,
    "name": "Alternative Key Symbol",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "keyboard-symbols",
    "categoryName": "Keyboard Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "␣",
    "slug": "open-box",
    "codepoints": [
      9251
    ],
    "primary": 9251,
    "name": "Open Box",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Control Pictures",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "keyboard-symbols",
    "categoryName": "Keyboard Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": []
  },
  {
    "symbol": "⎆",
    "slug": "enter-symbol",
    "codepoints": [
      9094
    ],
    "primary": 9094,
    "name": "Enter Symbol",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "keyboard-symbols",
    "categoryName": "Keyboard Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "⎀",
    "slug": "insertion-symbol",
    "codepoints": [
      9088
    ],
    "primary": 9088,
    "name": "Insertion Symbol",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "keyboard-symbols",
    "categoryName": "Keyboard Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "⎚",
    "slug": "clear-screen-symbol",
    "codepoints": [
      9114
    ],
    "primary": 9114,
    "name": "Clear Screen Symbol",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "keyboard-symbols",
    "categoryName": "Keyboard Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "•",
    "slug": "bullet",
    "codepoints": [
      8226
    ],
    "primary": 8226,
    "name": "Bullet",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "bullet-symbols",
    "categoryName": "Bullet Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark"
    ]
  },
  {
    "symbol": "‣",
    "slug": "triangular-bullet",
    "codepoints": [
      8227
    ],
    "primary": 8227,
    "name": "Triangular Bullet",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "bullet-symbols",
    "categoryName": "Bullet Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark"
    ]
  },
  {
    "symbol": "⁃",
    "slug": "hyphen-bullet",
    "codepoints": [
      8259
    ],
    "primary": 8259,
    "name": "Hyphen Bullet",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "bullet-symbols",
    "categoryName": "Bullet Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark"
    ]
  },
  {
    "symbol": "⁌",
    "slug": "black-leftwards-bullet",
    "codepoints": [
      8268
    ],
    "primary": 8268,
    "name": "Black Leftwards Bullet",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "bullet-symbols",
    "categoryName": "Bullet Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark"
    ]
  },
  {
    "symbol": "⁍",
    "slug": "black-rightwards-bullet",
    "codepoints": [
      8269
    ],
    "primary": 8269,
    "name": "Black Rightwards Bullet",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "bullet-symbols",
    "categoryName": "Bullet Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark"
    ]
  },
  {
    "symbol": "◦",
    "slug": "white-bullet",
    "codepoints": [
      9702
    ],
    "primary": 9702,
    "name": "White Bullet",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "bullet-symbols",
    "categoryName": "Bullet Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "◘",
    "slug": "inverse-bullet",
    "codepoints": [
      9688
    ],
    "primary": 9688,
    "name": "Inverse Bullet",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Geometric Shapes",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "bullet-symbols",
    "categoryName": "Bullet Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-diamond",
      "white-diamond",
      "white-diamond-containing-black-small-diamond",
      "lozenge",
      "black-rectangle",
      "white-rectangle",
      "black-vertical-rectangle",
      "white-vertical-rectangle",
      "black-parallelogram",
      "white-parallelogram",
      "black-circle",
      "white-circle"
    ]
  },
  {
    "symbol": "∙",
    "slug": "bullet-operator",
    "codepoints": [
      8729
    ],
    "primary": 8729,
    "name": "Bullet Operator",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Mathematical Operators",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "bullet-symbols",
    "categoryName": "Bullet Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "star-operator",
      "minus-sign",
      "minus-or-plus-sign",
      "not-equal-to",
      "almost-equal-to",
      "identical-to",
      "less-than-or-equal-to",
      "greater-than-or-equal-to",
      "much-less-than",
      "much-greater-than",
      "infinity",
      "n-ary-summation"
    ]
  },
  {
    "symbol": "⦾",
    "slug": "circled-white-bullet",
    "codepoints": [
      10686
    ],
    "primary": 10686,
    "name": "Circled White Bullet",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Mathematical Symbols B",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "bullet-symbols",
    "categoryName": "Bullet Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-bullet",
      "left-white-curly-bracket",
      "right-white-curly-bracket",
      "z-notation-left-image-bracket",
      "z-notation-right-image-bracket"
    ]
  },
  {
    "symbol": "⦿",
    "slug": "circled-bullet",
    "codepoints": [
      10687
    ],
    "primary": 10687,
    "name": "Circled Bullet",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Mathematical Symbols B",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "bullet-symbols",
    "categoryName": "Bullet Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-white-bullet",
      "left-white-curly-bracket",
      "right-white-curly-bracket",
      "z-notation-left-image-bracket",
      "z-notation-right-image-bracket"
    ]
  },
  {
    "symbol": "⁕",
    "slug": "flower-punctuation-mark",
    "codepoints": [
      8277
    ],
    "primary": 8277,
    "name": "Flower Punctuation Mark",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "bullet-symbols",
    "categoryName": "Bullet Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark"
    ]
  },
  {
    "symbol": "⁘",
    "slug": "four-dot-punctuation",
    "codepoints": [
      8280
    ],
    "primary": 8280,
    "name": "Four Dot Punctuation",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "bullet-symbols",
    "categoryName": "Bullet Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark"
    ]
  },
  {
    "symbol": "⁙",
    "slug": "five-dot-punctuation",
    "codepoints": [
      8281
    ],
    "primary": 8281,
    "name": "Five Dot Punctuation",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "bullet-symbols",
    "categoryName": "Bullet Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark"
    ]
  },
  {
    "symbol": "⁛",
    "slug": "four-dot-mark",
    "codepoints": [
      8283
    ],
    "primary": 8283,
    "name": "Four Dot Mark",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "bullet-symbols",
    "categoryName": "Bullet Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark"
    ]
  },
  {
    "symbol": "☙",
    "slug": "reversed-rotated-floral-heart-bullet",
    "codepoints": [
      9753
    ],
    "primary": 9753,
    "name": "Reversed Rotated Floral Heart Bullet",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "bullet-symbols",
    "categoryName": "Bullet Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "⸰",
    "slug": "ring-point",
    "codepoints": [
      11824
    ],
    "primary": 11824,
    "name": "Ring Point",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Punctuation",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "bullet-symbols",
    "categoryName": "Bullet Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "reversed-question-mark",
      "inverted-interrobang",
      "two-em-dash",
      "three-em-dash"
    ]
  },
  {
    "symbol": "‾",
    "slug": "overline",
    "codepoints": [
      8254
    ],
    "primary": 8254,
    "name": "Overline",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark"
    ]
  },
  {
    "symbol": "¯",
    "slug": "macron",
    "codepoints": [
      175
    ],
    "primary": 175,
    "name": "Macron",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Latin 1 Supplement",
    "script": "Common",
    "generalCategory": "Modifier Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "multiplication-sign",
      "division-sign",
      "plus-minus-sign",
      "not-sign",
      "pound-sign",
      "yen-sign",
      "cent-sign",
      "middle-dot",
      "pilcrow-sign",
      "section-sign",
      "inverted-question-mark",
      "inverted-exclamation-mark"
    ]
  },
  {
    "symbol": "‗",
    "slug": "double-low-line",
    "codepoints": [
      8215
    ],
    "primary": 8215,
    "name": "Double Low Line",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark"
    ]
  },
  {
    "symbol": "⎯",
    "slug": "horizontal-line-extension",
    "codepoints": [
      9135
    ],
    "primary": 9135,
    "name": "Horizontal Line Extension",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "⎺",
    "slug": "horizontal-scan-line-1",
    "codepoints": [
      9146
    ],
    "primary": 9146,
    "name": "Horizontal Scan Line-1",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "⎻",
    "slug": "horizontal-scan-line-3",
    "codepoints": [
      9147
    ],
    "primary": 9147,
    "name": "Horizontal Scan Line-3",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "⎼",
    "slug": "horizontal-scan-line-7",
    "codepoints": [
      9148
    ],
    "primary": 9148,
    "name": "Horizontal Scan Line-7",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "⎽",
    "slug": "horizontal-scan-line-9",
    "codepoints": [
      9149
    ],
    "primary": 9149,
    "name": "Horizontal Scan Line-9",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "▔",
    "slug": "upper-one-eighth-block",
    "codepoints": [
      9620
    ],
    "primary": 9620,
    "name": "Upper One Eighth Block",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Block Elements",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "lower-one-eighth-block",
      "upper-half-block",
      "lower-one-quarter-block",
      "lower-three-eighths-block",
      "lower-half-block",
      "lower-five-eighths-block",
      "lower-three-quarters-block",
      "lower-seven-eighths-block",
      "full-block",
      "left-seven-eighths-block",
      "left-three-quarters-block",
      "left-five-eighths-block"
    ]
  },
  {
    "symbol": "▁",
    "slug": "lower-one-eighth-block",
    "codepoints": [
      9601
    ],
    "primary": 9601,
    "name": "Lower One Eighth Block",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Block Elements",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "upper-one-eighth-block",
      "upper-half-block",
      "lower-one-quarter-block",
      "lower-three-eighths-block",
      "lower-half-block",
      "lower-five-eighths-block",
      "lower-three-quarters-block",
      "lower-seven-eighths-block",
      "full-block",
      "left-seven-eighths-block",
      "left-three-quarters-block",
      "left-five-eighths-block"
    ]
  },
  {
    "symbol": "﹉",
    "slug": "dashed-overline",
    "codepoints": [
      65097
    ],
    "primary": 65097,
    "name": "Dashed Overline",
    "nameSource": "ucd",
    "aliases": [],
    "block": "CJK Compatibility Forms",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "centreline-overline",
      "wavy-overline",
      "double-wavy-overline",
      "dashed-low-line",
      "centreline-low-line",
      "wavy-low-line"
    ]
  },
  {
    "symbol": "﹊",
    "slug": "centreline-overline",
    "codepoints": [
      65098
    ],
    "primary": 65098,
    "name": "Centreline Overline",
    "nameSource": "ucd",
    "aliases": [],
    "block": "CJK Compatibility Forms",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "dashed-overline",
      "wavy-overline",
      "double-wavy-overline",
      "dashed-low-line",
      "centreline-low-line",
      "wavy-low-line"
    ]
  },
  {
    "symbol": "﹋",
    "slug": "wavy-overline",
    "codepoints": [
      65099
    ],
    "primary": 65099,
    "name": "Wavy Overline",
    "nameSource": "ucd",
    "aliases": [],
    "block": "CJK Compatibility Forms",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "dashed-overline",
      "centreline-overline",
      "double-wavy-overline",
      "dashed-low-line",
      "centreline-low-line",
      "wavy-low-line"
    ]
  },
  {
    "symbol": "﹌",
    "slug": "double-wavy-overline",
    "codepoints": [
      65100
    ],
    "primary": 65100,
    "name": "Double Wavy Overline",
    "nameSource": "ucd",
    "aliases": [],
    "block": "CJK Compatibility Forms",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "dashed-overline",
      "centreline-overline",
      "wavy-overline",
      "dashed-low-line",
      "centreline-low-line",
      "wavy-low-line"
    ]
  },
  {
    "symbol": "﹍",
    "slug": "dashed-low-line",
    "codepoints": [
      65101
    ],
    "primary": 65101,
    "name": "Dashed Low Line",
    "nameSource": "ucd",
    "aliases": [],
    "block": "CJK Compatibility Forms",
    "script": "Common",
    "generalCategory": "Connector Punctuation",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "dashed-overline",
      "centreline-overline",
      "wavy-overline",
      "double-wavy-overline",
      "centreline-low-line",
      "wavy-low-line"
    ]
  },
  {
    "symbol": "﹎",
    "slug": "centreline-low-line",
    "codepoints": [
      65102
    ],
    "primary": 65102,
    "name": "Centreline Low Line",
    "nameSource": "ucd",
    "aliases": [],
    "block": "CJK Compatibility Forms",
    "script": "Common",
    "generalCategory": "Connector Punctuation",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "dashed-overline",
      "centreline-overline",
      "wavy-overline",
      "double-wavy-overline",
      "dashed-low-line",
      "wavy-low-line"
    ]
  },
  {
    "symbol": "﹏",
    "slug": "wavy-low-line",
    "codepoints": [
      65103
    ],
    "primary": 65103,
    "name": "Wavy Low Line",
    "nameSource": "ucd",
    "aliases": [],
    "block": "CJK Compatibility Forms",
    "script": "Common",
    "generalCategory": "Connector Punctuation",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "dashed-overline",
      "centreline-overline",
      "wavy-overline",
      "double-wavy-overline",
      "dashed-low-line",
      "centreline-low-line"
    ]
  },
  {
    "symbol": "＿",
    "slug": "fullwidth-low-line",
    "codepoints": [
      65343
    ],
    "primary": 65343,
    "name": "Fullwidth Low Line",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Halfwidth And Fullwidth Forms",
    "script": "Common",
    "generalCategory": "Connector Punctuation",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "fullwidth-cent-sign",
      "fullwidth-pound-sign",
      "fullwidth-yen-sign",
      "fullwidth-won-sign",
      "fullwidth-macron",
      "fullwidth-vertical-line",
      "fullwidth-broken-bar",
      "fullwidth-solidus",
      "fullwidth-reverse-solidus",
      "fullwidth-left-parenthesis",
      "fullwidth-right-parenthesis",
      "fullwidth-left-square-bracket"
    ]
  },
  {
    "symbol": "￣",
    "slug": "fullwidth-macron",
    "codepoints": [
      65507
    ],
    "primary": 65507,
    "name": "Fullwidth Macron",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Halfwidth And Fullwidth Forms",
    "script": "Common",
    "generalCategory": "Modifier Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "fullwidth-cent-sign",
      "fullwidth-pound-sign",
      "fullwidth-yen-sign",
      "fullwidth-won-sign",
      "fullwidth-low-line",
      "fullwidth-vertical-line",
      "fullwidth-broken-bar",
      "fullwidth-solidus",
      "fullwidth-reverse-solidus",
      "fullwidth-left-parenthesis",
      "fullwidth-right-parenthesis",
      "fullwidth-left-square-bracket"
    ]
  },
  {
    "symbol": "|",
    "slug": "vertical-line",
    "codepoints": [
      124
    ],
    "primary": 124,
    "name": "Vertical Line",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Basic Latin",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "plus-sign",
      "equals-sign",
      "dollar-sign",
      "left-parenthesis",
      "right-parenthesis",
      "left-square-bracket",
      "right-square-bracket",
      "left-curly-bracket",
      "right-curly-bracket",
      "quotation-mark",
      "apostrophe"
    ]
  },
  {
    "symbol": "¦",
    "slug": "broken-bar",
    "codepoints": [
      166
    ],
    "primary": 166,
    "name": "Broken Bar",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Latin 1 Supplement",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "multiplication-sign",
      "division-sign",
      "plus-minus-sign",
      "not-sign",
      "pound-sign",
      "yen-sign",
      "cent-sign",
      "middle-dot",
      "pilcrow-sign",
      "section-sign",
      "inverted-question-mark",
      "inverted-exclamation-mark"
    ]
  },
  {
    "symbol": "‖",
    "slug": "double-vertical-line",
    "codepoints": [
      8214
    ],
    "primary": 8214,
    "name": "Double Vertical Line",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark"
    ]
  },
  {
    "symbol": "⏐",
    "slug": "vertical-line-extension",
    "codepoints": [
      9168
    ],
    "primary": 9168,
    "name": "Vertical Line Extension",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "｜",
    "slug": "fullwidth-vertical-line",
    "codepoints": [
      65372
    ],
    "primary": 65372,
    "name": "Fullwidth Vertical Line",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Halfwidth And Fullwidth Forms",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "fullwidth-cent-sign",
      "fullwidth-pound-sign",
      "fullwidth-yen-sign",
      "fullwidth-won-sign",
      "fullwidth-low-line",
      "fullwidth-macron",
      "fullwidth-broken-bar",
      "fullwidth-solidus",
      "fullwidth-reverse-solidus",
      "fullwidth-left-parenthesis",
      "fullwidth-right-parenthesis",
      "fullwidth-left-square-bracket"
    ]
  },
  {
    "symbol": "￤",
    "slug": "fullwidth-broken-bar",
    "codepoints": [
      65508
    ],
    "primary": 65508,
    "name": "Fullwidth Broken Bar",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Halfwidth And Fullwidth Forms",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "fullwidth-cent-sign",
      "fullwidth-pound-sign",
      "fullwidth-yen-sign",
      "fullwidth-won-sign",
      "fullwidth-low-line",
      "fullwidth-macron",
      "fullwidth-vertical-line",
      "fullwidth-solidus",
      "fullwidth-reverse-solidus",
      "fullwidth-left-parenthesis",
      "fullwidth-right-parenthesis",
      "fullwidth-left-square-bracket"
    ]
  },
  {
    "symbol": "／",
    "slug": "fullwidth-solidus",
    "codepoints": [
      65295
    ],
    "primary": 65295,
    "name": "Fullwidth Solidus",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Halfwidth And Fullwidth Forms",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "fullwidth-cent-sign",
      "fullwidth-pound-sign",
      "fullwidth-yen-sign",
      "fullwidth-won-sign",
      "fullwidth-low-line",
      "fullwidth-macron",
      "fullwidth-vertical-line",
      "fullwidth-broken-bar",
      "fullwidth-reverse-solidus",
      "fullwidth-left-parenthesis",
      "fullwidth-right-parenthesis",
      "fullwidth-left-square-bracket"
    ]
  },
  {
    "symbol": "＼",
    "slug": "fullwidth-reverse-solidus",
    "codepoints": [
      65340
    ],
    "primary": 65340,
    "name": "Fullwidth Reverse Solidus",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Halfwidth And Fullwidth Forms",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "fullwidth-cent-sign",
      "fullwidth-pound-sign",
      "fullwidth-yen-sign",
      "fullwidth-won-sign",
      "fullwidth-low-line",
      "fullwidth-macron",
      "fullwidth-vertical-line",
      "fullwidth-broken-bar",
      "fullwidth-solidus",
      "fullwidth-left-parenthesis",
      "fullwidth-right-parenthesis",
      "fullwidth-left-square-bracket"
    ]
  },
  {
    "symbol": "⁓",
    "slug": "swung-dash",
    "codepoints": [
      8275
    ],
    "primary": 8275,
    "name": "Swung Dash",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark"
    ]
  },
  {
    "symbol": "〜",
    "slug": "wave-dash",
    "codepoints": [
      12316
    ],
    "primary": 12316,
    "name": "Wave Dash",
    "nameSource": "ucd",
    "aliases": [],
    "block": "CJK Symbols And Punctuation",
    "script": "Common",
    "generalCategory": "Dash Punctuation",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "wavy-dash",
      "left-double-angle-bracket",
      "right-double-angle-bracket",
      "left-black-lenticular-bracket",
      "right-black-lenticular-bracket",
      "left-angle-bracket",
      "right-angle-bracket",
      "left-white-square-bracket",
      "right-white-square-bracket",
      "left-white-lenticular-bracket",
      "right-white-lenticular-bracket",
      "left-white-tortoise-shell-bracket"
    ]
  },
  {
    "symbol": "〰",
    "slug": "wavy-dash",
    "codepoints": [
      12336
    ],
    "primary": 12336,
    "name": "Wavy Dash",
    "nameSource": "ucd",
    "aliases": [],
    "block": "CJK Symbols And Punctuation",
    "script": "Common",
    "generalCategory": "Dash Punctuation",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "wave-dash",
      "left-double-angle-bracket",
      "right-double-angle-bracket",
      "left-black-lenticular-bracket",
      "right-black-lenticular-bracket",
      "left-angle-bracket",
      "right-angle-bracket",
      "left-white-square-bracket",
      "right-white-square-bracket",
      "left-white-lenticular-bracket",
      "right-white-lenticular-bracket",
      "left-white-tortoise-shell-bracket"
    ]
  },
  {
    "symbol": "⸺",
    "slug": "two-em-dash",
    "codepoints": [
      11834
    ],
    "primary": 11834,
    "name": "Two-Em Dash",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Punctuation",
    "script": "Common",
    "generalCategory": "Dash Punctuation",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "reversed-question-mark",
      "inverted-interrobang",
      "ring-point",
      "three-em-dash"
    ]
  },
  {
    "symbol": "⸻",
    "slug": "three-em-dash",
    "codepoints": [
      11835
    ],
    "primary": 11835,
    "name": "Three-Em Dash",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Punctuation",
    "script": "Common",
    "generalCategory": "Dash Punctuation",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "reversed-question-mark",
      "inverted-interrobang",
      "ring-point",
      "two-em-dash"
    ]
  },
  {
    "symbol": "▀",
    "slug": "upper-half-block",
    "codepoints": [
      9600
    ],
    "primary": 9600,
    "name": "Upper Half Block",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Block Elements",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "upper-one-eighth-block",
      "lower-one-eighth-block",
      "lower-one-quarter-block",
      "lower-three-eighths-block",
      "lower-half-block",
      "lower-five-eighths-block",
      "lower-three-quarters-block",
      "lower-seven-eighths-block",
      "full-block",
      "left-seven-eighths-block",
      "left-three-quarters-block",
      "left-five-eighths-block"
    ]
  },
  {
    "symbol": "▂",
    "slug": "lower-one-quarter-block",
    "codepoints": [
      9602
    ],
    "primary": 9602,
    "name": "Lower One Quarter Block",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Block Elements",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "upper-one-eighth-block",
      "lower-one-eighth-block",
      "upper-half-block",
      "lower-three-eighths-block",
      "lower-half-block",
      "lower-five-eighths-block",
      "lower-three-quarters-block",
      "lower-seven-eighths-block",
      "full-block",
      "left-seven-eighths-block",
      "left-three-quarters-block",
      "left-five-eighths-block"
    ]
  },
  {
    "symbol": "▃",
    "slug": "lower-three-eighths-block",
    "codepoints": [
      9603
    ],
    "primary": 9603,
    "name": "Lower Three Eighths Block",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Block Elements",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "upper-one-eighth-block",
      "lower-one-eighth-block",
      "upper-half-block",
      "lower-one-quarter-block",
      "lower-half-block",
      "lower-five-eighths-block",
      "lower-three-quarters-block",
      "lower-seven-eighths-block",
      "full-block",
      "left-seven-eighths-block",
      "left-three-quarters-block",
      "left-five-eighths-block"
    ]
  },
  {
    "symbol": "▄",
    "slug": "lower-half-block",
    "codepoints": [
      9604
    ],
    "primary": 9604,
    "name": "Lower Half Block",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Block Elements",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "upper-one-eighth-block",
      "lower-one-eighth-block",
      "upper-half-block",
      "lower-one-quarter-block",
      "lower-three-eighths-block",
      "lower-five-eighths-block",
      "lower-three-quarters-block",
      "lower-seven-eighths-block",
      "full-block",
      "left-seven-eighths-block",
      "left-three-quarters-block",
      "left-five-eighths-block"
    ]
  },
  {
    "symbol": "▅",
    "slug": "lower-five-eighths-block",
    "codepoints": [
      9605
    ],
    "primary": 9605,
    "name": "Lower Five Eighths Block",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Block Elements",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "upper-one-eighth-block",
      "lower-one-eighth-block",
      "upper-half-block",
      "lower-one-quarter-block",
      "lower-three-eighths-block",
      "lower-half-block",
      "lower-three-quarters-block",
      "lower-seven-eighths-block",
      "full-block",
      "left-seven-eighths-block",
      "left-three-quarters-block",
      "left-five-eighths-block"
    ]
  },
  {
    "symbol": "▆",
    "slug": "lower-three-quarters-block",
    "codepoints": [
      9606
    ],
    "primary": 9606,
    "name": "Lower Three Quarters Block",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Block Elements",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "upper-one-eighth-block",
      "lower-one-eighth-block",
      "upper-half-block",
      "lower-one-quarter-block",
      "lower-three-eighths-block",
      "lower-half-block",
      "lower-five-eighths-block",
      "lower-seven-eighths-block",
      "full-block",
      "left-seven-eighths-block",
      "left-three-quarters-block",
      "left-five-eighths-block"
    ]
  },
  {
    "symbol": "▇",
    "slug": "lower-seven-eighths-block",
    "codepoints": [
      9607
    ],
    "primary": 9607,
    "name": "Lower Seven Eighths Block",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Block Elements",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "upper-one-eighth-block",
      "lower-one-eighth-block",
      "upper-half-block",
      "lower-one-quarter-block",
      "lower-three-eighths-block",
      "lower-half-block",
      "lower-five-eighths-block",
      "lower-three-quarters-block",
      "full-block",
      "left-seven-eighths-block",
      "left-three-quarters-block",
      "left-five-eighths-block"
    ]
  },
  {
    "symbol": "█",
    "slug": "full-block",
    "codepoints": [
      9608
    ],
    "primary": 9608,
    "name": "Full Block",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Block Elements",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "upper-one-eighth-block",
      "lower-one-eighth-block",
      "upper-half-block",
      "lower-one-quarter-block",
      "lower-three-eighths-block",
      "lower-half-block",
      "lower-five-eighths-block",
      "lower-three-quarters-block",
      "lower-seven-eighths-block",
      "left-seven-eighths-block",
      "left-three-quarters-block",
      "left-five-eighths-block"
    ]
  },
  {
    "symbol": "▉",
    "slug": "left-seven-eighths-block",
    "codepoints": [
      9609
    ],
    "primary": 9609,
    "name": "Left Seven Eighths Block",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Block Elements",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "upper-one-eighth-block",
      "lower-one-eighth-block",
      "upper-half-block",
      "lower-one-quarter-block",
      "lower-three-eighths-block",
      "lower-half-block",
      "lower-five-eighths-block",
      "lower-three-quarters-block",
      "lower-seven-eighths-block",
      "full-block",
      "left-three-quarters-block",
      "left-five-eighths-block"
    ]
  },
  {
    "symbol": "▊",
    "slug": "left-three-quarters-block",
    "codepoints": [
      9610
    ],
    "primary": 9610,
    "name": "Left Three Quarters Block",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Block Elements",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "upper-one-eighth-block",
      "lower-one-eighth-block",
      "upper-half-block",
      "lower-one-quarter-block",
      "lower-three-eighths-block",
      "lower-half-block",
      "lower-five-eighths-block",
      "lower-three-quarters-block",
      "lower-seven-eighths-block",
      "full-block",
      "left-seven-eighths-block",
      "left-five-eighths-block"
    ]
  },
  {
    "symbol": "▋",
    "slug": "left-five-eighths-block",
    "codepoints": [
      9611
    ],
    "primary": 9611,
    "name": "Left Five Eighths Block",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Block Elements",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "upper-one-eighth-block",
      "lower-one-eighth-block",
      "upper-half-block",
      "lower-one-quarter-block",
      "lower-three-eighths-block",
      "lower-half-block",
      "lower-five-eighths-block",
      "lower-three-quarters-block",
      "lower-seven-eighths-block",
      "full-block",
      "left-seven-eighths-block",
      "left-three-quarters-block"
    ]
  },
  {
    "symbol": "▌",
    "slug": "left-half-block",
    "codepoints": [
      9612
    ],
    "primary": 9612,
    "name": "Left Half Block",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Block Elements",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "upper-one-eighth-block",
      "lower-one-eighth-block",
      "upper-half-block",
      "lower-one-quarter-block",
      "lower-three-eighths-block",
      "lower-half-block",
      "lower-five-eighths-block",
      "lower-three-quarters-block",
      "lower-seven-eighths-block",
      "full-block",
      "left-seven-eighths-block",
      "left-three-quarters-block"
    ]
  },
  {
    "symbol": "▍",
    "slug": "left-three-eighths-block",
    "codepoints": [
      9613
    ],
    "primary": 9613,
    "name": "Left Three Eighths Block",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Block Elements",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "upper-one-eighth-block",
      "lower-one-eighth-block",
      "upper-half-block",
      "lower-one-quarter-block",
      "lower-three-eighths-block",
      "lower-half-block",
      "lower-five-eighths-block",
      "lower-three-quarters-block",
      "lower-seven-eighths-block",
      "full-block",
      "left-seven-eighths-block",
      "left-three-quarters-block"
    ]
  },
  {
    "symbol": "▎",
    "slug": "left-one-quarter-block",
    "codepoints": [
      9614
    ],
    "primary": 9614,
    "name": "Left One Quarter Block",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Block Elements",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "upper-one-eighth-block",
      "lower-one-eighth-block",
      "upper-half-block",
      "lower-one-quarter-block",
      "lower-three-eighths-block",
      "lower-half-block",
      "lower-five-eighths-block",
      "lower-three-quarters-block",
      "lower-seven-eighths-block",
      "full-block",
      "left-seven-eighths-block",
      "left-three-quarters-block"
    ]
  },
  {
    "symbol": "▏",
    "slug": "left-one-eighth-block",
    "codepoints": [
      9615
    ],
    "primary": 9615,
    "name": "Left One Eighth Block",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Block Elements",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "upper-one-eighth-block",
      "lower-one-eighth-block",
      "upper-half-block",
      "lower-one-quarter-block",
      "lower-three-eighths-block",
      "lower-half-block",
      "lower-five-eighths-block",
      "lower-three-quarters-block",
      "lower-seven-eighths-block",
      "full-block",
      "left-seven-eighths-block",
      "left-three-quarters-block"
    ]
  },
  {
    "symbol": "▐",
    "slug": "right-half-block",
    "codepoints": [
      9616
    ],
    "primary": 9616,
    "name": "Right Half Block",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Block Elements",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "upper-one-eighth-block",
      "lower-one-eighth-block",
      "upper-half-block",
      "lower-one-quarter-block",
      "lower-three-eighths-block",
      "lower-half-block",
      "lower-five-eighths-block",
      "lower-three-quarters-block",
      "lower-seven-eighths-block",
      "full-block",
      "left-seven-eighths-block",
      "left-three-quarters-block"
    ]
  },
  {
    "symbol": "░",
    "slug": "light-shade",
    "codepoints": [
      9617
    ],
    "primary": 9617,
    "name": "Light Shade",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Block Elements",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "upper-one-eighth-block",
      "lower-one-eighth-block",
      "upper-half-block",
      "lower-one-quarter-block",
      "lower-three-eighths-block",
      "lower-half-block",
      "lower-five-eighths-block",
      "lower-three-quarters-block",
      "lower-seven-eighths-block",
      "full-block",
      "left-seven-eighths-block",
      "left-three-quarters-block"
    ]
  },
  {
    "symbol": "▒",
    "slug": "medium-shade",
    "codepoints": [
      9618
    ],
    "primary": 9618,
    "name": "Medium Shade",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Block Elements",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "upper-one-eighth-block",
      "lower-one-eighth-block",
      "upper-half-block",
      "lower-one-quarter-block",
      "lower-three-eighths-block",
      "lower-half-block",
      "lower-five-eighths-block",
      "lower-three-quarters-block",
      "lower-seven-eighths-block",
      "full-block",
      "left-seven-eighths-block",
      "left-three-quarters-block"
    ]
  },
  {
    "symbol": "▓",
    "slug": "dark-shade",
    "codepoints": [
      9619
    ],
    "primary": 9619,
    "name": "Dark Shade",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Block Elements",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "upper-one-eighth-block",
      "lower-one-eighth-block",
      "upper-half-block",
      "lower-one-quarter-block",
      "lower-three-eighths-block",
      "lower-half-block",
      "lower-five-eighths-block",
      "lower-three-quarters-block",
      "lower-seven-eighths-block",
      "full-block",
      "left-seven-eighths-block",
      "left-three-quarters-block"
    ]
  },
  {
    "symbol": "▕",
    "slug": "right-one-eighth-block",
    "codepoints": [
      9621
    ],
    "primary": 9621,
    "name": "Right One Eighth Block",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Block Elements",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "upper-one-eighth-block",
      "lower-one-eighth-block",
      "upper-half-block",
      "lower-one-quarter-block",
      "lower-three-eighths-block",
      "lower-half-block",
      "lower-five-eighths-block",
      "lower-three-quarters-block",
      "lower-seven-eighths-block",
      "full-block",
      "left-seven-eighths-block",
      "left-three-quarters-block"
    ]
  },
  {
    "symbol": "▖",
    "slug": "quadrant-lower-left",
    "codepoints": [
      9622
    ],
    "primary": 9622,
    "name": "Quadrant Lower Left",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Block Elements",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "upper-one-eighth-block",
      "lower-one-eighth-block",
      "upper-half-block",
      "lower-one-quarter-block",
      "lower-three-eighths-block",
      "lower-half-block",
      "lower-five-eighths-block",
      "lower-three-quarters-block",
      "lower-seven-eighths-block",
      "full-block",
      "left-seven-eighths-block",
      "left-three-quarters-block"
    ]
  },
  {
    "symbol": "▗",
    "slug": "quadrant-lower-right",
    "codepoints": [
      9623
    ],
    "primary": 9623,
    "name": "Quadrant Lower Right",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Block Elements",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "upper-one-eighth-block",
      "lower-one-eighth-block",
      "upper-half-block",
      "lower-one-quarter-block",
      "lower-three-eighths-block",
      "lower-half-block",
      "lower-five-eighths-block",
      "lower-three-quarters-block",
      "lower-seven-eighths-block",
      "full-block",
      "left-seven-eighths-block",
      "left-three-quarters-block"
    ]
  },
  {
    "symbol": "▘",
    "slug": "quadrant-upper-left",
    "codepoints": [
      9624
    ],
    "primary": 9624,
    "name": "Quadrant Upper Left",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Block Elements",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "upper-one-eighth-block",
      "lower-one-eighth-block",
      "upper-half-block",
      "lower-one-quarter-block",
      "lower-three-eighths-block",
      "lower-half-block",
      "lower-five-eighths-block",
      "lower-three-quarters-block",
      "lower-seven-eighths-block",
      "full-block",
      "left-seven-eighths-block",
      "left-three-quarters-block"
    ]
  },
  {
    "symbol": "▙",
    "slug": "quadrant-upper-left-and-lower-left-and-lower-right",
    "codepoints": [
      9625
    ],
    "primary": 9625,
    "name": "Quadrant Upper Left And Lower Left And Lower Right",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Block Elements",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "upper-one-eighth-block",
      "lower-one-eighth-block",
      "upper-half-block",
      "lower-one-quarter-block",
      "lower-three-eighths-block",
      "lower-half-block",
      "lower-five-eighths-block",
      "lower-three-quarters-block",
      "lower-seven-eighths-block",
      "full-block",
      "left-seven-eighths-block",
      "left-three-quarters-block"
    ]
  },
  {
    "symbol": "▚",
    "slug": "quadrant-upper-left-and-lower-right",
    "codepoints": [
      9626
    ],
    "primary": 9626,
    "name": "Quadrant Upper Left And Lower Right",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Block Elements",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "upper-one-eighth-block",
      "lower-one-eighth-block",
      "upper-half-block",
      "lower-one-quarter-block",
      "lower-three-eighths-block",
      "lower-half-block",
      "lower-five-eighths-block",
      "lower-three-quarters-block",
      "lower-seven-eighths-block",
      "full-block",
      "left-seven-eighths-block",
      "left-three-quarters-block"
    ]
  },
  {
    "symbol": "▛",
    "slug": "quadrant-upper-left-and-upper-right-and-lower-left",
    "codepoints": [
      9627
    ],
    "primary": 9627,
    "name": "Quadrant Upper Left And Upper Right And Lower Left",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Block Elements",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "upper-one-eighth-block",
      "lower-one-eighth-block",
      "upper-half-block",
      "lower-one-quarter-block",
      "lower-three-eighths-block",
      "lower-half-block",
      "lower-five-eighths-block",
      "lower-three-quarters-block",
      "lower-seven-eighths-block",
      "full-block",
      "left-seven-eighths-block",
      "left-three-quarters-block"
    ]
  },
  {
    "symbol": "▜",
    "slug": "quadrant-upper-left-and-upper-right-and-lower-right",
    "codepoints": [
      9628
    ],
    "primary": 9628,
    "name": "Quadrant Upper Left And Upper Right And Lower Right",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Block Elements",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "upper-one-eighth-block",
      "lower-one-eighth-block",
      "upper-half-block",
      "lower-one-quarter-block",
      "lower-three-eighths-block",
      "lower-half-block",
      "lower-five-eighths-block",
      "lower-three-quarters-block",
      "lower-seven-eighths-block",
      "full-block",
      "left-seven-eighths-block",
      "left-three-quarters-block"
    ]
  },
  {
    "symbol": "▝",
    "slug": "quadrant-upper-right",
    "codepoints": [
      9629
    ],
    "primary": 9629,
    "name": "Quadrant Upper Right",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Block Elements",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "upper-one-eighth-block",
      "lower-one-eighth-block",
      "upper-half-block",
      "lower-one-quarter-block",
      "lower-three-eighths-block",
      "lower-half-block",
      "lower-five-eighths-block",
      "lower-three-quarters-block",
      "lower-seven-eighths-block",
      "full-block",
      "left-seven-eighths-block",
      "left-three-quarters-block"
    ]
  },
  {
    "symbol": "▞",
    "slug": "quadrant-upper-right-and-lower-left",
    "codepoints": [
      9630
    ],
    "primary": 9630,
    "name": "Quadrant Upper Right And Lower Left",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Block Elements",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "upper-one-eighth-block",
      "lower-one-eighth-block",
      "upper-half-block",
      "lower-one-quarter-block",
      "lower-three-eighths-block",
      "lower-half-block",
      "lower-five-eighths-block",
      "lower-three-quarters-block",
      "lower-seven-eighths-block",
      "full-block",
      "left-seven-eighths-block",
      "left-three-quarters-block"
    ]
  },
  {
    "symbol": "▟",
    "slug": "quadrant-upper-right-and-lower-left-and-lower-right",
    "codepoints": [
      9631
    ],
    "primary": 9631,
    "name": "Quadrant Upper Right And Lower Left And Lower Right",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Block Elements",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "line-symbols",
    "categoryName": "Line Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "upper-one-eighth-block",
      "lower-one-eighth-block",
      "upper-half-block",
      "lower-one-quarter-block",
      "lower-three-eighths-block",
      "lower-half-block",
      "lower-five-eighths-block",
      "lower-three-quarters-block",
      "lower-seven-eighths-block",
      "full-block",
      "left-seven-eighths-block",
      "left-three-quarters-block"
    ]
  },
  {
    "symbol": "(",
    "slug": "left-parenthesis",
    "codepoints": [
      40
    ],
    "primary": 40,
    "name": "Left Parenthesis",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Basic Latin",
    "script": "Common",
    "generalCategory": "Open Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "plus-sign",
      "equals-sign",
      "dollar-sign",
      "vertical-line",
      "right-parenthesis",
      "left-square-bracket",
      "right-square-bracket",
      "left-curly-bracket",
      "right-curly-bracket",
      "quotation-mark",
      "apostrophe"
    ]
  },
  {
    "symbol": ")",
    "slug": "right-parenthesis",
    "codepoints": [
      41
    ],
    "primary": 41,
    "name": "Right Parenthesis",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Basic Latin",
    "script": "Common",
    "generalCategory": "Close Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "plus-sign",
      "equals-sign",
      "dollar-sign",
      "vertical-line",
      "left-parenthesis",
      "left-square-bracket",
      "right-square-bracket",
      "left-curly-bracket",
      "right-curly-bracket",
      "quotation-mark",
      "apostrophe"
    ]
  },
  {
    "symbol": "（",
    "slug": "fullwidth-left-parenthesis",
    "codepoints": [
      65288
    ],
    "primary": 65288,
    "name": "Fullwidth Left Parenthesis",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Halfwidth And Fullwidth Forms",
    "script": "Common",
    "generalCategory": "Open Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "fullwidth-cent-sign",
      "fullwidth-pound-sign",
      "fullwidth-yen-sign",
      "fullwidth-won-sign",
      "fullwidth-low-line",
      "fullwidth-macron",
      "fullwidth-vertical-line",
      "fullwidth-broken-bar",
      "fullwidth-solidus",
      "fullwidth-reverse-solidus",
      "fullwidth-right-parenthesis",
      "fullwidth-left-square-bracket"
    ]
  },
  {
    "symbol": "）",
    "slug": "fullwidth-right-parenthesis",
    "codepoints": [
      65289
    ],
    "primary": 65289,
    "name": "Fullwidth Right Parenthesis",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Halfwidth And Fullwidth Forms",
    "script": "Common",
    "generalCategory": "Close Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "fullwidth-cent-sign",
      "fullwidth-pound-sign",
      "fullwidth-yen-sign",
      "fullwidth-won-sign",
      "fullwidth-low-line",
      "fullwidth-macron",
      "fullwidth-vertical-line",
      "fullwidth-broken-bar",
      "fullwidth-solidus",
      "fullwidth-reverse-solidus",
      "fullwidth-left-parenthesis",
      "fullwidth-left-square-bracket"
    ]
  },
  {
    "symbol": "❨",
    "slug": "medium-left-parenthesis-ornament",
    "codepoints": [
      10088
    ],
    "primary": 10088,
    "name": "Medium Left Parenthesis Ornament",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Open Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "❩",
    "slug": "medium-right-parenthesis-ornament",
    "codepoints": [
      10089
    ],
    "primary": 10089,
    "name": "Medium Right Parenthesis Ornament",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Close Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "[",
    "slug": "left-square-bracket",
    "codepoints": [
      91
    ],
    "primary": 91,
    "name": "Left Square Bracket",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Basic Latin",
    "script": "Common",
    "generalCategory": "Open Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "plus-sign",
      "equals-sign",
      "dollar-sign",
      "vertical-line",
      "left-parenthesis",
      "right-parenthesis",
      "right-square-bracket",
      "left-curly-bracket",
      "right-curly-bracket",
      "quotation-mark",
      "apostrophe"
    ]
  },
  {
    "symbol": "]",
    "slug": "right-square-bracket",
    "codepoints": [
      93
    ],
    "primary": 93,
    "name": "Right Square Bracket",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Basic Latin",
    "script": "Common",
    "generalCategory": "Close Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "plus-sign",
      "equals-sign",
      "dollar-sign",
      "vertical-line",
      "left-parenthesis",
      "right-parenthesis",
      "left-square-bracket",
      "left-curly-bracket",
      "right-curly-bracket",
      "quotation-mark",
      "apostrophe"
    ]
  },
  {
    "symbol": "［",
    "slug": "fullwidth-left-square-bracket",
    "codepoints": [
      65339
    ],
    "primary": 65339,
    "name": "Fullwidth Left Square Bracket",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Halfwidth And Fullwidth Forms",
    "script": "Common",
    "generalCategory": "Open Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "fullwidth-cent-sign",
      "fullwidth-pound-sign",
      "fullwidth-yen-sign",
      "fullwidth-won-sign",
      "fullwidth-low-line",
      "fullwidth-macron",
      "fullwidth-vertical-line",
      "fullwidth-broken-bar",
      "fullwidth-solidus",
      "fullwidth-reverse-solidus",
      "fullwidth-left-parenthesis",
      "fullwidth-right-parenthesis"
    ]
  },
  {
    "symbol": "］",
    "slug": "fullwidth-right-square-bracket",
    "codepoints": [
      65341
    ],
    "primary": 65341,
    "name": "Fullwidth Right Square Bracket",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Halfwidth And Fullwidth Forms",
    "script": "Common",
    "generalCategory": "Close Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "fullwidth-cent-sign",
      "fullwidth-pound-sign",
      "fullwidth-yen-sign",
      "fullwidth-won-sign",
      "fullwidth-low-line",
      "fullwidth-macron",
      "fullwidth-vertical-line",
      "fullwidth-broken-bar",
      "fullwidth-solidus",
      "fullwidth-reverse-solidus",
      "fullwidth-left-parenthesis",
      "fullwidth-right-parenthesis"
    ]
  },
  {
    "symbol": "⟦",
    "slug": "mathematical-left-white-square-bracket",
    "codepoints": [
      10214
    ],
    "primary": 10214,
    "name": "Mathematical Left White Square Bracket",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Mathematical Symbols A",
    "script": "Common",
    "generalCategory": "Open Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "mathematical-right-white-square-bracket",
      "mathematical-left-angle-bracket",
      "mathematical-right-angle-bracket",
      "mathematical-left-double-angle-bracket",
      "mathematical-right-double-angle-bracket"
    ]
  },
  {
    "symbol": "⟧",
    "slug": "mathematical-right-white-square-bracket",
    "codepoints": [
      10215
    ],
    "primary": 10215,
    "name": "Mathematical Right White Square Bracket",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Mathematical Symbols A",
    "script": "Common",
    "generalCategory": "Close Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "mathematical-left-white-square-bracket",
      "mathematical-left-angle-bracket",
      "mathematical-right-angle-bracket",
      "mathematical-left-double-angle-bracket",
      "mathematical-right-double-angle-bracket"
    ]
  },
  {
    "symbol": "{",
    "slug": "left-curly-bracket",
    "codepoints": [
      123
    ],
    "primary": 123,
    "name": "Left Curly Bracket",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Basic Latin",
    "script": "Common",
    "generalCategory": "Open Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "plus-sign",
      "equals-sign",
      "dollar-sign",
      "vertical-line",
      "left-parenthesis",
      "right-parenthesis",
      "left-square-bracket",
      "right-square-bracket",
      "right-curly-bracket",
      "quotation-mark",
      "apostrophe"
    ]
  },
  {
    "symbol": "}",
    "slug": "right-curly-bracket",
    "codepoints": [
      125
    ],
    "primary": 125,
    "name": "Right Curly Bracket",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Basic Latin",
    "script": "Common",
    "generalCategory": "Close Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "plus-sign",
      "equals-sign",
      "dollar-sign",
      "vertical-line",
      "left-parenthesis",
      "right-parenthesis",
      "left-square-bracket",
      "right-square-bracket",
      "left-curly-bracket",
      "quotation-mark",
      "apostrophe"
    ]
  },
  {
    "symbol": "｛",
    "slug": "fullwidth-left-curly-bracket",
    "codepoints": [
      65371
    ],
    "primary": 65371,
    "name": "Fullwidth Left Curly Bracket",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Halfwidth And Fullwidth Forms",
    "script": "Common",
    "generalCategory": "Open Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "fullwidth-cent-sign",
      "fullwidth-pound-sign",
      "fullwidth-yen-sign",
      "fullwidth-won-sign",
      "fullwidth-low-line",
      "fullwidth-macron",
      "fullwidth-vertical-line",
      "fullwidth-broken-bar",
      "fullwidth-solidus",
      "fullwidth-reverse-solidus",
      "fullwidth-left-parenthesis",
      "fullwidth-right-parenthesis"
    ]
  },
  {
    "symbol": "｝",
    "slug": "fullwidth-right-curly-bracket",
    "codepoints": [
      65373
    ],
    "primary": 65373,
    "name": "Fullwidth Right Curly Bracket",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Halfwidth And Fullwidth Forms",
    "script": "Common",
    "generalCategory": "Close Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "fullwidth-cent-sign",
      "fullwidth-pound-sign",
      "fullwidth-yen-sign",
      "fullwidth-won-sign",
      "fullwidth-low-line",
      "fullwidth-macron",
      "fullwidth-vertical-line",
      "fullwidth-broken-bar",
      "fullwidth-solidus",
      "fullwidth-reverse-solidus",
      "fullwidth-left-parenthesis",
      "fullwidth-right-parenthesis"
    ]
  },
  {
    "symbol": "❴",
    "slug": "medium-left-curly-bracket-ornament",
    "codepoints": [
      10100
    ],
    "primary": 10100,
    "name": "Medium Left Curly Bracket Ornament",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Open Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "❵",
    "slug": "medium-right-curly-bracket-ornament",
    "codepoints": [
      10101
    ],
    "primary": 10101,
    "name": "Medium Right Curly Bracket Ornament",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Close Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "⟨",
    "slug": "mathematical-left-angle-bracket",
    "codepoints": [
      10216
    ],
    "primary": 10216,
    "name": "Mathematical Left Angle Bracket",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Mathematical Symbols A",
    "script": "Common",
    "generalCategory": "Open Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "mathematical-left-white-square-bracket",
      "mathematical-right-white-square-bracket",
      "mathematical-right-angle-bracket",
      "mathematical-left-double-angle-bracket",
      "mathematical-right-double-angle-bracket"
    ]
  },
  {
    "symbol": "⟩",
    "slug": "mathematical-right-angle-bracket",
    "codepoints": [
      10217
    ],
    "primary": 10217,
    "name": "Mathematical Right Angle Bracket",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Mathematical Symbols A",
    "script": "Common",
    "generalCategory": "Close Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "mathematical-left-white-square-bracket",
      "mathematical-right-white-square-bracket",
      "mathematical-left-angle-bracket",
      "mathematical-left-double-angle-bracket",
      "mathematical-right-double-angle-bracket"
    ]
  },
  {
    "symbol": "⟪",
    "slug": "mathematical-left-double-angle-bracket",
    "codepoints": [
      10218
    ],
    "primary": 10218,
    "name": "Mathematical Left Double Angle Bracket",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Mathematical Symbols A",
    "script": "Common",
    "generalCategory": "Open Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "mathematical-left-white-square-bracket",
      "mathematical-right-white-square-bracket",
      "mathematical-left-angle-bracket",
      "mathematical-right-angle-bracket",
      "mathematical-right-double-angle-bracket"
    ]
  },
  {
    "symbol": "⟫",
    "slug": "mathematical-right-double-angle-bracket",
    "codepoints": [
      10219
    ],
    "primary": 10219,
    "name": "Mathematical Right Double Angle Bracket",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Mathematical Symbols A",
    "script": "Common",
    "generalCategory": "Close Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "mathematical-left-white-square-bracket",
      "mathematical-right-white-square-bracket",
      "mathematical-left-angle-bracket",
      "mathematical-right-angle-bracket",
      "mathematical-left-double-angle-bracket"
    ]
  },
  {
    "symbol": "《",
    "slug": "left-double-angle-bracket",
    "codepoints": [
      12298
    ],
    "primary": 12298,
    "name": "Left Double Angle Bracket",
    "nameSource": "ucd",
    "aliases": [],
    "block": "CJK Symbols And Punctuation",
    "script": "Common",
    "generalCategory": "Open Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "wave-dash",
      "wavy-dash",
      "right-double-angle-bracket",
      "left-black-lenticular-bracket",
      "right-black-lenticular-bracket",
      "left-angle-bracket",
      "right-angle-bracket",
      "left-white-square-bracket",
      "right-white-square-bracket",
      "left-white-lenticular-bracket",
      "right-white-lenticular-bracket",
      "left-white-tortoise-shell-bracket"
    ]
  },
  {
    "symbol": "》",
    "slug": "right-double-angle-bracket",
    "codepoints": [
      12299
    ],
    "primary": 12299,
    "name": "Right Double Angle Bracket",
    "nameSource": "ucd",
    "aliases": [],
    "block": "CJK Symbols And Punctuation",
    "script": "Common",
    "generalCategory": "Close Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "wave-dash",
      "wavy-dash",
      "left-double-angle-bracket",
      "left-black-lenticular-bracket",
      "right-black-lenticular-bracket",
      "left-angle-bracket",
      "right-angle-bracket",
      "left-white-square-bracket",
      "right-white-square-bracket",
      "left-white-lenticular-bracket",
      "right-white-lenticular-bracket",
      "left-white-tortoise-shell-bracket"
    ]
  },
  {
    "symbol": "⌈",
    "slug": "left-ceiling",
    "codepoints": [
      8968
    ],
    "primary": 8968,
    "name": "Left Ceiling",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Open Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "⌉",
    "slug": "right-ceiling",
    "codepoints": [
      8969
    ],
    "primary": 8969,
    "name": "Right Ceiling",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Close Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "⌊",
    "slug": "left-floor",
    "codepoints": [
      8970
    ],
    "primary": 8970,
    "name": "Left Floor",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Open Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "⌋",
    "slug": "right-floor",
    "codepoints": [
      8971
    ],
    "primary": 8971,
    "name": "Right Floor",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Close Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "【",
    "slug": "left-black-lenticular-bracket",
    "codepoints": [
      12304
    ],
    "primary": 12304,
    "name": "Left Black Lenticular Bracket",
    "nameSource": "ucd",
    "aliases": [],
    "block": "CJK Symbols And Punctuation",
    "script": "Common",
    "generalCategory": "Open Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "wave-dash",
      "wavy-dash",
      "left-double-angle-bracket",
      "right-double-angle-bracket",
      "right-black-lenticular-bracket",
      "left-angle-bracket",
      "right-angle-bracket",
      "left-white-square-bracket",
      "right-white-square-bracket",
      "left-white-lenticular-bracket",
      "right-white-lenticular-bracket",
      "left-white-tortoise-shell-bracket"
    ]
  },
  {
    "symbol": "】",
    "slug": "right-black-lenticular-bracket",
    "codepoints": [
      12305
    ],
    "primary": 12305,
    "name": "Right Black Lenticular Bracket",
    "nameSource": "ucd",
    "aliases": [],
    "block": "CJK Symbols And Punctuation",
    "script": "Common",
    "generalCategory": "Close Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "wave-dash",
      "wavy-dash",
      "left-double-angle-bracket",
      "right-double-angle-bracket",
      "left-black-lenticular-bracket",
      "left-angle-bracket",
      "right-angle-bracket",
      "left-white-square-bracket",
      "right-white-square-bracket",
      "left-white-lenticular-bracket",
      "right-white-lenticular-bracket",
      "left-white-tortoise-shell-bracket"
    ]
  },
  {
    "symbol": "〈",
    "slug": "left-angle-bracket",
    "codepoints": [
      12296
    ],
    "primary": 12296,
    "name": "Left Angle Bracket",
    "nameSource": "ucd",
    "aliases": [],
    "block": "CJK Symbols And Punctuation",
    "script": "Common",
    "generalCategory": "Open Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "wave-dash",
      "wavy-dash",
      "left-double-angle-bracket",
      "right-double-angle-bracket",
      "left-black-lenticular-bracket",
      "right-black-lenticular-bracket",
      "right-angle-bracket",
      "left-white-square-bracket",
      "right-white-square-bracket",
      "left-white-lenticular-bracket",
      "right-white-lenticular-bracket",
      "left-white-tortoise-shell-bracket"
    ]
  },
  {
    "symbol": "〉",
    "slug": "right-angle-bracket",
    "codepoints": [
      12297
    ],
    "primary": 12297,
    "name": "Right Angle Bracket",
    "nameSource": "ucd",
    "aliases": [],
    "block": "CJK Symbols And Punctuation",
    "script": "Common",
    "generalCategory": "Close Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "wave-dash",
      "wavy-dash",
      "left-double-angle-bracket",
      "right-double-angle-bracket",
      "left-black-lenticular-bracket",
      "right-black-lenticular-bracket",
      "left-angle-bracket",
      "left-white-square-bracket",
      "right-white-square-bracket",
      "left-white-lenticular-bracket",
      "right-white-lenticular-bracket",
      "left-white-tortoise-shell-bracket"
    ]
  },
  {
    "symbol": "⁅",
    "slug": "left-square-bracket-with-quill",
    "codepoints": [
      8261
    ],
    "primary": 8261,
    "name": "Left Square Bracket With Quill",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Open Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark"
    ]
  },
  {
    "symbol": "⁆",
    "slug": "right-square-bracket-with-quill",
    "codepoints": [
      8262
    ],
    "primary": 8262,
    "name": "Right Square Bracket With Quill",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Close Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark"
    ]
  },
  {
    "symbol": "⦃",
    "slug": "left-white-curly-bracket",
    "codepoints": [
      10627
    ],
    "primary": 10627,
    "name": "Left White Curly Bracket",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Mathematical Symbols B",
    "script": "Common",
    "generalCategory": "Open Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-white-bullet",
      "circled-bullet",
      "right-white-curly-bracket",
      "z-notation-left-image-bracket",
      "z-notation-right-image-bracket"
    ]
  },
  {
    "symbol": "⦄",
    "slug": "right-white-curly-bracket",
    "codepoints": [
      10628
    ],
    "primary": 10628,
    "name": "Right White Curly Bracket",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Mathematical Symbols B",
    "script": "Common",
    "generalCategory": "Close Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-white-bullet",
      "circled-bullet",
      "left-white-curly-bracket",
      "z-notation-left-image-bracket",
      "z-notation-right-image-bracket"
    ]
  },
  {
    "symbol": "〚",
    "slug": "left-white-square-bracket",
    "codepoints": [
      12314
    ],
    "primary": 12314,
    "name": "Left White Square Bracket",
    "nameSource": "ucd",
    "aliases": [],
    "block": "CJK Symbols And Punctuation",
    "script": "Common",
    "generalCategory": "Open Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "wave-dash",
      "wavy-dash",
      "left-double-angle-bracket",
      "right-double-angle-bracket",
      "left-black-lenticular-bracket",
      "right-black-lenticular-bracket",
      "left-angle-bracket",
      "right-angle-bracket",
      "right-white-square-bracket",
      "left-white-lenticular-bracket",
      "right-white-lenticular-bracket",
      "left-white-tortoise-shell-bracket"
    ]
  },
  {
    "symbol": "〛",
    "slug": "right-white-square-bracket",
    "codepoints": [
      12315
    ],
    "primary": 12315,
    "name": "Right White Square Bracket",
    "nameSource": "ucd",
    "aliases": [],
    "block": "CJK Symbols And Punctuation",
    "script": "Common",
    "generalCategory": "Close Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "wave-dash",
      "wavy-dash",
      "left-double-angle-bracket",
      "right-double-angle-bracket",
      "left-black-lenticular-bracket",
      "right-black-lenticular-bracket",
      "left-angle-bracket",
      "right-angle-bracket",
      "left-white-square-bracket",
      "left-white-lenticular-bracket",
      "right-white-lenticular-bracket",
      "left-white-tortoise-shell-bracket"
    ]
  },
  {
    "symbol": "〖",
    "slug": "left-white-lenticular-bracket",
    "codepoints": [
      12310
    ],
    "primary": 12310,
    "name": "Left White Lenticular Bracket",
    "nameSource": "ucd",
    "aliases": [],
    "block": "CJK Symbols And Punctuation",
    "script": "Common",
    "generalCategory": "Open Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "wave-dash",
      "wavy-dash",
      "left-double-angle-bracket",
      "right-double-angle-bracket",
      "left-black-lenticular-bracket",
      "right-black-lenticular-bracket",
      "left-angle-bracket",
      "right-angle-bracket",
      "left-white-square-bracket",
      "right-white-square-bracket",
      "right-white-lenticular-bracket",
      "left-white-tortoise-shell-bracket"
    ]
  },
  {
    "symbol": "〗",
    "slug": "right-white-lenticular-bracket",
    "codepoints": [
      12311
    ],
    "primary": 12311,
    "name": "Right White Lenticular Bracket",
    "nameSource": "ucd",
    "aliases": [],
    "block": "CJK Symbols And Punctuation",
    "script": "Common",
    "generalCategory": "Close Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "wave-dash",
      "wavy-dash",
      "left-double-angle-bracket",
      "right-double-angle-bracket",
      "left-black-lenticular-bracket",
      "right-black-lenticular-bracket",
      "left-angle-bracket",
      "right-angle-bracket",
      "left-white-square-bracket",
      "right-white-square-bracket",
      "left-white-lenticular-bracket",
      "left-white-tortoise-shell-bracket"
    ]
  },
  {
    "symbol": "〘",
    "slug": "left-white-tortoise-shell-bracket",
    "codepoints": [
      12312
    ],
    "primary": 12312,
    "name": "Left White Tortoise Shell Bracket",
    "nameSource": "ucd",
    "aliases": [],
    "block": "CJK Symbols And Punctuation",
    "script": "Common",
    "generalCategory": "Open Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "wave-dash",
      "wavy-dash",
      "left-double-angle-bracket",
      "right-double-angle-bracket",
      "left-black-lenticular-bracket",
      "right-black-lenticular-bracket",
      "left-angle-bracket",
      "right-angle-bracket",
      "left-white-square-bracket",
      "right-white-square-bracket",
      "left-white-lenticular-bracket",
      "right-white-lenticular-bracket"
    ]
  },
  {
    "symbol": "〙",
    "slug": "right-white-tortoise-shell-bracket",
    "codepoints": [
      12313
    ],
    "primary": 12313,
    "name": "Right White Tortoise Shell Bracket",
    "nameSource": "ucd",
    "aliases": [],
    "block": "CJK Symbols And Punctuation",
    "script": "Common",
    "generalCategory": "Close Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "wave-dash",
      "wavy-dash",
      "left-double-angle-bracket",
      "right-double-angle-bracket",
      "left-black-lenticular-bracket",
      "right-black-lenticular-bracket",
      "left-angle-bracket",
      "right-angle-bracket",
      "left-white-square-bracket",
      "right-white-square-bracket",
      "left-white-lenticular-bracket",
      "right-white-lenticular-bracket"
    ]
  },
  {
    "symbol": "〔",
    "slug": "left-tortoise-shell-bracket",
    "codepoints": [
      12308
    ],
    "primary": 12308,
    "name": "Left Tortoise Shell Bracket",
    "nameSource": "ucd",
    "aliases": [],
    "block": "CJK Symbols And Punctuation",
    "script": "Common",
    "generalCategory": "Open Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "wave-dash",
      "wavy-dash",
      "left-double-angle-bracket",
      "right-double-angle-bracket",
      "left-black-lenticular-bracket",
      "right-black-lenticular-bracket",
      "left-angle-bracket",
      "right-angle-bracket",
      "left-white-square-bracket",
      "right-white-square-bracket",
      "left-white-lenticular-bracket",
      "right-white-lenticular-bracket"
    ]
  },
  {
    "symbol": "〕",
    "slug": "right-tortoise-shell-bracket",
    "codepoints": [
      12309
    ],
    "primary": 12309,
    "name": "Right Tortoise Shell Bracket",
    "nameSource": "ucd",
    "aliases": [],
    "block": "CJK Symbols And Punctuation",
    "script": "Common",
    "generalCategory": "Close Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "wave-dash",
      "wavy-dash",
      "left-double-angle-bracket",
      "right-double-angle-bracket",
      "left-black-lenticular-bracket",
      "right-black-lenticular-bracket",
      "left-angle-bracket",
      "right-angle-bracket",
      "left-white-square-bracket",
      "right-white-square-bracket",
      "left-white-lenticular-bracket",
      "right-white-lenticular-bracket"
    ]
  },
  {
    "symbol": "❬",
    "slug": "medium-left-pointing-angle-bracket-ornament",
    "codepoints": [
      10092
    ],
    "primary": 10092,
    "name": "Medium Left-Pointing Angle Bracket Ornament",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Open Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "❭",
    "slug": "medium-right-pointing-angle-bracket-ornament",
    "codepoints": [
      10093
    ],
    "primary": 10093,
    "name": "Medium Right-Pointing Angle Bracket Ornament",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Close Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "❰",
    "slug": "heavy-left-pointing-angle-bracket-ornament",
    "codepoints": [
      10096
    ],
    "primary": 10096,
    "name": "Heavy Left-Pointing Angle Bracket Ornament",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Open Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "❱",
    "slug": "heavy-right-pointing-angle-bracket-ornament",
    "codepoints": [
      10097
    ],
    "primary": 10097,
    "name": "Heavy Right-Pointing Angle Bracket Ornament",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Close Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "⦇",
    "slug": "z-notation-left-image-bracket",
    "codepoints": [
      10631
    ],
    "primary": 10631,
    "name": "Z Notation Left Image Bracket",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Mathematical Symbols B",
    "script": "Common",
    "generalCategory": "Open Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-white-bullet",
      "circled-bullet",
      "left-white-curly-bracket",
      "right-white-curly-bracket",
      "z-notation-right-image-bracket"
    ]
  },
  {
    "symbol": "⦈",
    "slug": "z-notation-right-image-bracket",
    "codepoints": [
      10632
    ],
    "primary": 10632,
    "name": "Z Notation Right Image Bracket",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Mathematical Symbols B",
    "script": "Common",
    "generalCategory": "Close Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "circled-white-bullet",
      "circled-bullet",
      "left-white-curly-bracket",
      "right-white-curly-bracket",
      "z-notation-left-image-bracket"
    ]
  },
  {
    "symbol": "｢",
    "slug": "halfwidth-left-corner-bracket",
    "codepoints": [
      65378
    ],
    "primary": 65378,
    "name": "Halfwidth Left Corner Bracket",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Halfwidth And Fullwidth Forms",
    "script": "Common",
    "generalCategory": "Open Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "fullwidth-cent-sign",
      "fullwidth-pound-sign",
      "fullwidth-yen-sign",
      "fullwidth-won-sign",
      "fullwidth-low-line",
      "fullwidth-macron",
      "fullwidth-vertical-line",
      "fullwidth-broken-bar",
      "fullwidth-solidus",
      "fullwidth-reverse-solidus",
      "fullwidth-left-parenthesis",
      "fullwidth-right-parenthesis"
    ]
  },
  {
    "symbol": "｣",
    "slug": "halfwidth-right-corner-bracket",
    "codepoints": [
      65379
    ],
    "primary": 65379,
    "name": "Halfwidth Right Corner Bracket",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Halfwidth And Fullwidth Forms",
    "script": "Common",
    "generalCategory": "Close Punctuation",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "fullwidth-cent-sign",
      "fullwidth-pound-sign",
      "fullwidth-yen-sign",
      "fullwidth-won-sign",
      "fullwidth-low-line",
      "fullwidth-macron",
      "fullwidth-vertical-line",
      "fullwidth-broken-bar",
      "fullwidth-solidus",
      "fullwidth-reverse-solidus",
      "fullwidth-left-parenthesis",
      "fullwidth-right-parenthesis"
    ]
  },
  {
    "symbol": "⌜",
    "slug": "top-left-corner",
    "codepoints": [
      8988
    ],
    "primary": 8988,
    "name": "Top Left Corner",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "⌝",
    "slug": "top-right-corner",
    "codepoints": [
      8989
    ],
    "primary": 8989,
    "name": "Top Right Corner",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "⌞",
    "slug": "bottom-left-corner",
    "codepoints": [
      8990
    ],
    "primary": 8990,
    "name": "Bottom Left Corner",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "⌟",
    "slug": "bottom-right-corner",
    "codepoints": [
      8991
    ],
    "primary": 8991,
    "name": "Bottom Right Corner",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "bracket-symbols",
    "categoryName": "Bracket Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "\"",
    "slug": "quotation-mark",
    "codepoints": [
      34
    ],
    "primary": 34,
    "name": "Quotation Mark",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Basic Latin",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "quote-symbols",
    "categoryName": "Quote Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "plus-sign",
      "equals-sign",
      "dollar-sign",
      "vertical-line",
      "left-parenthesis",
      "right-parenthesis",
      "left-square-bracket",
      "right-square-bracket",
      "left-curly-bracket",
      "right-curly-bracket",
      "apostrophe"
    ]
  },
  {
    "symbol": "'",
    "slug": "apostrophe",
    "codepoints": [
      39
    ],
    "primary": 39,
    "name": "Apostrophe",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Basic Latin",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "quote-symbols",
    "categoryName": "Quote Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "plus-sign",
      "equals-sign",
      "dollar-sign",
      "vertical-line",
      "left-parenthesis",
      "right-parenthesis",
      "left-square-bracket",
      "right-square-bracket",
      "left-curly-bracket",
      "right-curly-bracket",
      "quotation-mark"
    ]
  },
  {
    "symbol": "‘",
    "slug": "left-single-quotation-mark",
    "codepoints": [
      8216
    ],
    "primary": 8216,
    "name": "Left Single Quotation Mark",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Initial Punctuation",
    "categorySlug": "quote-symbols",
    "categoryName": "Quote Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark"
    ]
  },
  {
    "symbol": "’",
    "slug": "right-single-quotation-mark",
    "codepoints": [
      8217
    ],
    "primary": 8217,
    "name": "Right Single Quotation Mark",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Final Punctuation",
    "categorySlug": "quote-symbols",
    "categoryName": "Quote Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark"
    ]
  },
  {
    "symbol": "‚",
    "slug": "single-low-9-quotation-mark",
    "codepoints": [
      8218
    ],
    "primary": 8218,
    "name": "Single Low-9 Quotation Mark",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Open Punctuation",
    "categorySlug": "quote-symbols",
    "categoryName": "Quote Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark"
    ]
  },
  {
    "symbol": "‛",
    "slug": "single-high-reversed-9-quotation-mark",
    "codepoints": [
      8219
    ],
    "primary": 8219,
    "name": "Single High-Reversed-9 Quotation Mark",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Initial Punctuation",
    "categorySlug": "quote-symbols",
    "categoryName": "Quote Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark"
    ]
  },
  {
    "symbol": "“",
    "slug": "left-double-quotation-mark",
    "codepoints": [
      8220
    ],
    "primary": 8220,
    "name": "Left Double Quotation Mark",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Initial Punctuation",
    "categorySlug": "quote-symbols",
    "categoryName": "Quote Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark"
    ]
  },
  {
    "symbol": "”",
    "slug": "right-double-quotation-mark",
    "codepoints": [
      8221
    ],
    "primary": 8221,
    "name": "Right Double Quotation Mark",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Final Punctuation",
    "categorySlug": "quote-symbols",
    "categoryName": "Quote Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark"
    ]
  },
  {
    "symbol": "„",
    "slug": "double-low-9-quotation-mark",
    "codepoints": [
      8222
    ],
    "primary": 8222,
    "name": "Double Low-9 Quotation Mark",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Open Punctuation",
    "categorySlug": "quote-symbols",
    "categoryName": "Quote Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark"
    ]
  },
  {
    "symbol": "‟",
    "slug": "double-high-reversed-9-quotation-mark",
    "codepoints": [
      8223
    ],
    "primary": 8223,
    "name": "Double High-Reversed-9 Quotation Mark",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Initial Punctuation",
    "categorySlug": "quote-symbols",
    "categoryName": "Quote Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark"
    ]
  },
  {
    "symbol": "«",
    "slug": "left-pointing-double-angle-quotation-mark",
    "codepoints": [
      171
    ],
    "primary": 171,
    "name": "Left-Pointing Double Angle Quotation Mark",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Latin 1 Supplement",
    "script": "Common",
    "generalCategory": "Initial Punctuation",
    "categorySlug": "quote-symbols",
    "categoryName": "Quote Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "multiplication-sign",
      "division-sign",
      "plus-minus-sign",
      "not-sign",
      "pound-sign",
      "yen-sign",
      "cent-sign",
      "middle-dot",
      "pilcrow-sign",
      "section-sign",
      "inverted-question-mark",
      "inverted-exclamation-mark"
    ]
  },
  {
    "symbol": "»",
    "slug": "right-pointing-double-angle-quotation-mark",
    "codepoints": [
      187
    ],
    "primary": 187,
    "name": "Right-Pointing Double Angle Quotation Mark",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Latin 1 Supplement",
    "script": "Common",
    "generalCategory": "Final Punctuation",
    "categorySlug": "quote-symbols",
    "categoryName": "Quote Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "multiplication-sign",
      "division-sign",
      "plus-minus-sign",
      "not-sign",
      "pound-sign",
      "yen-sign",
      "cent-sign",
      "middle-dot",
      "pilcrow-sign",
      "section-sign",
      "inverted-question-mark",
      "inverted-exclamation-mark"
    ]
  },
  {
    "symbol": "‹",
    "slug": "single-left-pointing-angle-quotation-mark",
    "codepoints": [
      8249
    ],
    "primary": 8249,
    "name": "Single Left-Pointing Angle Quotation Mark",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Initial Punctuation",
    "categorySlug": "quote-symbols",
    "categoryName": "Quote Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark"
    ]
  },
  {
    "symbol": "›",
    "slug": "single-right-pointing-angle-quotation-mark",
    "codepoints": [
      8250
    ],
    "primary": 8250,
    "name": "Single Right-Pointing Angle Quotation Mark",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Final Punctuation",
    "categorySlug": "quote-symbols",
    "categoryName": "Quote Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark"
    ]
  },
  {
    "symbol": "′",
    "slug": "prime",
    "codepoints": [
      8242
    ],
    "primary": 8242,
    "name": "Prime",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "quote-symbols",
    "categoryName": "Quote Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark"
    ]
  },
  {
    "symbol": "″",
    "slug": "double-prime",
    "codepoints": [
      8243
    ],
    "primary": 8243,
    "name": "Double Prime",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "quote-symbols",
    "categoryName": "Quote Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark"
    ]
  },
  {
    "symbol": "‴",
    "slug": "triple-prime",
    "codepoints": [
      8244
    ],
    "primary": 8244,
    "name": "Triple Prime",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "quote-symbols",
    "categoryName": "Quote Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark"
    ]
  },
  {
    "symbol": "‵",
    "slug": "reversed-prime",
    "codepoints": [
      8245
    ],
    "primary": 8245,
    "name": "Reversed Prime",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Other Punctuation",
    "categorySlug": "quote-symbols",
    "categoryName": "Quote Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark"
    ]
  },
  {
    "symbol": "「",
    "slug": "left-corner-bracket",
    "codepoints": [
      12300
    ],
    "primary": 12300,
    "name": "Left Corner Bracket",
    "nameSource": "ucd",
    "aliases": [],
    "block": "CJK Symbols And Punctuation",
    "script": "Common",
    "generalCategory": "Open Punctuation",
    "categorySlug": "quote-symbols",
    "categoryName": "Quote Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "wave-dash",
      "wavy-dash",
      "left-double-angle-bracket",
      "right-double-angle-bracket",
      "left-black-lenticular-bracket",
      "right-black-lenticular-bracket",
      "left-angle-bracket",
      "right-angle-bracket",
      "left-white-square-bracket",
      "right-white-square-bracket",
      "left-white-lenticular-bracket",
      "right-white-lenticular-bracket"
    ]
  },
  {
    "symbol": "」",
    "slug": "right-corner-bracket",
    "codepoints": [
      12301
    ],
    "primary": 12301,
    "name": "Right Corner Bracket",
    "nameSource": "ucd",
    "aliases": [],
    "block": "CJK Symbols And Punctuation",
    "script": "Common",
    "generalCategory": "Close Punctuation",
    "categorySlug": "quote-symbols",
    "categoryName": "Quote Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "wave-dash",
      "wavy-dash",
      "left-double-angle-bracket",
      "right-double-angle-bracket",
      "left-black-lenticular-bracket",
      "right-black-lenticular-bracket",
      "left-angle-bracket",
      "right-angle-bracket",
      "left-white-square-bracket",
      "right-white-square-bracket",
      "left-white-lenticular-bracket",
      "right-white-lenticular-bracket"
    ]
  },
  {
    "symbol": "『",
    "slug": "left-white-corner-bracket",
    "codepoints": [
      12302
    ],
    "primary": 12302,
    "name": "Left White Corner Bracket",
    "nameSource": "ucd",
    "aliases": [],
    "block": "CJK Symbols And Punctuation",
    "script": "Common",
    "generalCategory": "Open Punctuation",
    "categorySlug": "quote-symbols",
    "categoryName": "Quote Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "wave-dash",
      "wavy-dash",
      "left-double-angle-bracket",
      "right-double-angle-bracket",
      "left-black-lenticular-bracket",
      "right-black-lenticular-bracket",
      "left-angle-bracket",
      "right-angle-bracket",
      "left-white-square-bracket",
      "right-white-square-bracket",
      "left-white-lenticular-bracket",
      "right-white-lenticular-bracket"
    ]
  },
  {
    "symbol": "』",
    "slug": "right-white-corner-bracket",
    "codepoints": [
      12303
    ],
    "primary": 12303,
    "name": "Right White Corner Bracket",
    "nameSource": "ucd",
    "aliases": [],
    "block": "CJK Symbols And Punctuation",
    "script": "Common",
    "generalCategory": "Close Punctuation",
    "categorySlug": "quote-symbols",
    "categoryName": "Quote Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "wave-dash",
      "wavy-dash",
      "left-double-angle-bracket",
      "right-double-angle-bracket",
      "left-black-lenticular-bracket",
      "right-black-lenticular-bracket",
      "left-angle-bracket",
      "right-angle-bracket",
      "left-white-square-bracket",
      "right-white-square-bracket",
      "left-white-lenticular-bracket",
      "right-white-lenticular-bracket"
    ]
  },
  {
    "symbol": "❝",
    "slug": "heavy-double-turned-comma-quotation-mark-ornament",
    "codepoints": [
      10077
    ],
    "primary": 10077,
    "name": "Heavy Double Turned Comma Quotation Mark Ornament",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "quote-symbols",
    "categoryName": "Quote Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "❞",
    "slug": "heavy-double-comma-quotation-mark-ornament",
    "codepoints": [
      10078
    ],
    "primary": 10078,
    "name": "Heavy Double Comma Quotation Mark Ornament",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "quote-symbols",
    "categoryName": "Quote Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "⁰",
    "slug": "superscript-zero",
    "codepoints": [
      8304
    ],
    "primary": 8304,
    "name": "Superscript Zero",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-four",
      "superscript-five",
      "superscript-six",
      "superscript-seven",
      "superscript-eight",
      "superscript-nine",
      "superscript-latin-small-letter-i",
      "superscript-latin-small-letter-n",
      "superscript-plus-sign",
      "superscript-minus",
      "superscript-equals-sign",
      "superscript-left-parenthesis"
    ]
  },
  {
    "symbol": "¹",
    "slug": "superscript-one",
    "codepoints": [
      185
    ],
    "primary": 185,
    "name": "Superscript One",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Latin 1 Supplement",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "multiplication-sign",
      "division-sign",
      "plus-minus-sign",
      "not-sign",
      "pound-sign",
      "yen-sign",
      "cent-sign",
      "middle-dot",
      "pilcrow-sign",
      "section-sign",
      "inverted-question-mark",
      "inverted-exclamation-mark"
    ]
  },
  {
    "symbol": "²",
    "slug": "superscript-two",
    "codepoints": [
      178
    ],
    "primary": 178,
    "name": "Superscript Two",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Latin 1 Supplement",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "multiplication-sign",
      "division-sign",
      "plus-minus-sign",
      "not-sign",
      "pound-sign",
      "yen-sign",
      "cent-sign",
      "middle-dot",
      "pilcrow-sign",
      "section-sign",
      "inverted-question-mark",
      "inverted-exclamation-mark"
    ]
  },
  {
    "symbol": "³",
    "slug": "superscript-three",
    "codepoints": [
      179
    ],
    "primary": 179,
    "name": "Superscript Three",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Latin 1 Supplement",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "multiplication-sign",
      "division-sign",
      "plus-minus-sign",
      "not-sign",
      "pound-sign",
      "yen-sign",
      "cent-sign",
      "middle-dot",
      "pilcrow-sign",
      "section-sign",
      "inverted-question-mark",
      "inverted-exclamation-mark"
    ]
  },
  {
    "symbol": "⁴",
    "slug": "superscript-four",
    "codepoints": [
      8308
    ],
    "primary": 8308,
    "name": "Superscript Four",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-zero",
      "superscript-five",
      "superscript-six",
      "superscript-seven",
      "superscript-eight",
      "superscript-nine",
      "superscript-latin-small-letter-i",
      "superscript-latin-small-letter-n",
      "superscript-plus-sign",
      "superscript-minus",
      "superscript-equals-sign",
      "superscript-left-parenthesis"
    ]
  },
  {
    "symbol": "⁵",
    "slug": "superscript-five",
    "codepoints": [
      8309
    ],
    "primary": 8309,
    "name": "Superscript Five",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-zero",
      "superscript-four",
      "superscript-six",
      "superscript-seven",
      "superscript-eight",
      "superscript-nine",
      "superscript-latin-small-letter-i",
      "superscript-latin-small-letter-n",
      "superscript-plus-sign",
      "superscript-minus",
      "superscript-equals-sign",
      "superscript-left-parenthesis"
    ]
  },
  {
    "symbol": "⁶",
    "slug": "superscript-six",
    "codepoints": [
      8310
    ],
    "primary": 8310,
    "name": "Superscript Six",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-zero",
      "superscript-four",
      "superscript-five",
      "superscript-seven",
      "superscript-eight",
      "superscript-nine",
      "superscript-latin-small-letter-i",
      "superscript-latin-small-letter-n",
      "superscript-plus-sign",
      "superscript-minus",
      "superscript-equals-sign",
      "superscript-left-parenthesis"
    ]
  },
  {
    "symbol": "⁷",
    "slug": "superscript-seven",
    "codepoints": [
      8311
    ],
    "primary": 8311,
    "name": "Superscript Seven",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-zero",
      "superscript-four",
      "superscript-five",
      "superscript-six",
      "superscript-eight",
      "superscript-nine",
      "superscript-latin-small-letter-i",
      "superscript-latin-small-letter-n",
      "superscript-plus-sign",
      "superscript-minus",
      "superscript-equals-sign",
      "superscript-left-parenthesis"
    ]
  },
  {
    "symbol": "⁸",
    "slug": "superscript-eight",
    "codepoints": [
      8312
    ],
    "primary": 8312,
    "name": "Superscript Eight",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-zero",
      "superscript-four",
      "superscript-five",
      "superscript-six",
      "superscript-seven",
      "superscript-nine",
      "superscript-latin-small-letter-i",
      "superscript-latin-small-letter-n",
      "superscript-plus-sign",
      "superscript-minus",
      "superscript-equals-sign",
      "superscript-left-parenthesis"
    ]
  },
  {
    "symbol": "⁹",
    "slug": "superscript-nine",
    "codepoints": [
      8313
    ],
    "primary": 8313,
    "name": "Superscript Nine",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-zero",
      "superscript-four",
      "superscript-five",
      "superscript-six",
      "superscript-seven",
      "superscript-eight",
      "superscript-latin-small-letter-i",
      "superscript-latin-small-letter-n",
      "superscript-plus-sign",
      "superscript-minus",
      "superscript-equals-sign",
      "superscript-left-parenthesis"
    ]
  },
  {
    "symbol": "ⁱ",
    "slug": "superscript-latin-small-letter-i",
    "codepoints": [
      8305
    ],
    "primary": 8305,
    "name": "Superscript Latin Small Letter I",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Latin",
    "generalCategory": "Modifier Letter",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-zero",
      "superscript-four",
      "superscript-five",
      "superscript-six",
      "superscript-seven",
      "superscript-eight",
      "superscript-nine",
      "superscript-latin-small-letter-n",
      "superscript-plus-sign",
      "superscript-minus",
      "superscript-equals-sign",
      "superscript-left-parenthesis"
    ]
  },
  {
    "symbol": "ⁿ",
    "slug": "superscript-latin-small-letter-n",
    "codepoints": [
      8319
    ],
    "primary": 8319,
    "name": "Superscript Latin Small Letter N",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Latin",
    "generalCategory": "Modifier Letter",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-zero",
      "superscript-four",
      "superscript-five",
      "superscript-six",
      "superscript-seven",
      "superscript-eight",
      "superscript-nine",
      "superscript-latin-small-letter-i",
      "superscript-plus-sign",
      "superscript-minus",
      "superscript-equals-sign",
      "superscript-left-parenthesis"
    ]
  },
  {
    "symbol": "⁺",
    "slug": "superscript-plus-sign",
    "codepoints": [
      8314
    ],
    "primary": 8314,
    "name": "Superscript Plus Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-zero",
      "superscript-four",
      "superscript-five",
      "superscript-six",
      "superscript-seven",
      "superscript-eight",
      "superscript-nine",
      "superscript-latin-small-letter-i",
      "superscript-latin-small-letter-n",
      "superscript-minus",
      "superscript-equals-sign",
      "superscript-left-parenthesis"
    ]
  },
  {
    "symbol": "⁻",
    "slug": "superscript-minus",
    "codepoints": [
      8315
    ],
    "primary": 8315,
    "name": "Superscript Minus",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-zero",
      "superscript-four",
      "superscript-five",
      "superscript-six",
      "superscript-seven",
      "superscript-eight",
      "superscript-nine",
      "superscript-latin-small-letter-i",
      "superscript-latin-small-letter-n",
      "superscript-plus-sign",
      "superscript-equals-sign",
      "superscript-left-parenthesis"
    ]
  },
  {
    "symbol": "⁼",
    "slug": "superscript-equals-sign",
    "codepoints": [
      8316
    ],
    "primary": 8316,
    "name": "Superscript Equals Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-zero",
      "superscript-four",
      "superscript-five",
      "superscript-six",
      "superscript-seven",
      "superscript-eight",
      "superscript-nine",
      "superscript-latin-small-letter-i",
      "superscript-latin-small-letter-n",
      "superscript-plus-sign",
      "superscript-minus",
      "superscript-left-parenthesis"
    ]
  },
  {
    "symbol": "⁽",
    "slug": "superscript-left-parenthesis",
    "codepoints": [
      8317
    ],
    "primary": 8317,
    "name": "Superscript Left Parenthesis",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Common",
    "generalCategory": "Open Punctuation",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-zero",
      "superscript-four",
      "superscript-five",
      "superscript-six",
      "superscript-seven",
      "superscript-eight",
      "superscript-nine",
      "superscript-latin-small-letter-i",
      "superscript-latin-small-letter-n",
      "superscript-plus-sign",
      "superscript-minus",
      "superscript-equals-sign"
    ]
  },
  {
    "symbol": "⁾",
    "slug": "superscript-right-parenthesis",
    "codepoints": [
      8318
    ],
    "primary": 8318,
    "name": "Superscript Right Parenthesis",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Common",
    "generalCategory": "Close Punctuation",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-zero",
      "superscript-four",
      "superscript-five",
      "superscript-six",
      "superscript-seven",
      "superscript-eight",
      "superscript-nine",
      "superscript-latin-small-letter-i",
      "superscript-latin-small-letter-n",
      "superscript-plus-sign",
      "superscript-minus",
      "superscript-equals-sign"
    ]
  },
  {
    "symbol": "₀",
    "slug": "subscript-zero",
    "codepoints": [
      8320
    ],
    "primary": 8320,
    "name": "Subscript Zero",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-zero",
      "superscript-four",
      "superscript-five",
      "superscript-six",
      "superscript-seven",
      "superscript-eight",
      "superscript-nine",
      "superscript-latin-small-letter-i",
      "superscript-latin-small-letter-n",
      "superscript-plus-sign",
      "superscript-minus",
      "superscript-equals-sign"
    ]
  },
  {
    "symbol": "₁",
    "slug": "subscript-one",
    "codepoints": [
      8321
    ],
    "primary": 8321,
    "name": "Subscript One",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-zero",
      "superscript-four",
      "superscript-five",
      "superscript-six",
      "superscript-seven",
      "superscript-eight",
      "superscript-nine",
      "superscript-latin-small-letter-i",
      "superscript-latin-small-letter-n",
      "superscript-plus-sign",
      "superscript-minus",
      "superscript-equals-sign"
    ]
  },
  {
    "symbol": "₂",
    "slug": "subscript-two",
    "codepoints": [
      8322
    ],
    "primary": 8322,
    "name": "Subscript Two",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-zero",
      "superscript-four",
      "superscript-five",
      "superscript-six",
      "superscript-seven",
      "superscript-eight",
      "superscript-nine",
      "superscript-latin-small-letter-i",
      "superscript-latin-small-letter-n",
      "superscript-plus-sign",
      "superscript-minus",
      "superscript-equals-sign"
    ]
  },
  {
    "symbol": "₃",
    "slug": "subscript-three",
    "codepoints": [
      8323
    ],
    "primary": 8323,
    "name": "Subscript Three",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-zero",
      "superscript-four",
      "superscript-five",
      "superscript-six",
      "superscript-seven",
      "superscript-eight",
      "superscript-nine",
      "superscript-latin-small-letter-i",
      "superscript-latin-small-letter-n",
      "superscript-plus-sign",
      "superscript-minus",
      "superscript-equals-sign"
    ]
  },
  {
    "symbol": "₄",
    "slug": "subscript-four",
    "codepoints": [
      8324
    ],
    "primary": 8324,
    "name": "Subscript Four",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-zero",
      "superscript-four",
      "superscript-five",
      "superscript-six",
      "superscript-seven",
      "superscript-eight",
      "superscript-nine",
      "superscript-latin-small-letter-i",
      "superscript-latin-small-letter-n",
      "superscript-plus-sign",
      "superscript-minus",
      "superscript-equals-sign"
    ]
  },
  {
    "symbol": "₅",
    "slug": "subscript-five",
    "codepoints": [
      8325
    ],
    "primary": 8325,
    "name": "Subscript Five",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-zero",
      "superscript-four",
      "superscript-five",
      "superscript-six",
      "superscript-seven",
      "superscript-eight",
      "superscript-nine",
      "superscript-latin-small-letter-i",
      "superscript-latin-small-letter-n",
      "superscript-plus-sign",
      "superscript-minus",
      "superscript-equals-sign"
    ]
  },
  {
    "symbol": "₆",
    "slug": "subscript-six",
    "codepoints": [
      8326
    ],
    "primary": 8326,
    "name": "Subscript Six",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-zero",
      "superscript-four",
      "superscript-five",
      "superscript-six",
      "superscript-seven",
      "superscript-eight",
      "superscript-nine",
      "superscript-latin-small-letter-i",
      "superscript-latin-small-letter-n",
      "superscript-plus-sign",
      "superscript-minus",
      "superscript-equals-sign"
    ]
  },
  {
    "symbol": "₇",
    "slug": "subscript-seven",
    "codepoints": [
      8327
    ],
    "primary": 8327,
    "name": "Subscript Seven",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-zero",
      "superscript-four",
      "superscript-five",
      "superscript-six",
      "superscript-seven",
      "superscript-eight",
      "superscript-nine",
      "superscript-latin-small-letter-i",
      "superscript-latin-small-letter-n",
      "superscript-plus-sign",
      "superscript-minus",
      "superscript-equals-sign"
    ]
  },
  {
    "symbol": "₈",
    "slug": "subscript-eight",
    "codepoints": [
      8328
    ],
    "primary": 8328,
    "name": "Subscript Eight",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-zero",
      "superscript-four",
      "superscript-five",
      "superscript-six",
      "superscript-seven",
      "superscript-eight",
      "superscript-nine",
      "superscript-latin-small-letter-i",
      "superscript-latin-small-letter-n",
      "superscript-plus-sign",
      "superscript-minus",
      "superscript-equals-sign"
    ]
  },
  {
    "symbol": "₉",
    "slug": "subscript-nine",
    "codepoints": [
      8329
    ],
    "primary": 8329,
    "name": "Subscript Nine",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-zero",
      "superscript-four",
      "superscript-five",
      "superscript-six",
      "superscript-seven",
      "superscript-eight",
      "superscript-nine",
      "superscript-latin-small-letter-i",
      "superscript-latin-small-letter-n",
      "superscript-plus-sign",
      "superscript-minus",
      "superscript-equals-sign"
    ]
  },
  {
    "symbol": "₊",
    "slug": "subscript-plus-sign",
    "codepoints": [
      8330
    ],
    "primary": 8330,
    "name": "Subscript Plus Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-zero",
      "superscript-four",
      "superscript-five",
      "superscript-six",
      "superscript-seven",
      "superscript-eight",
      "superscript-nine",
      "superscript-latin-small-letter-i",
      "superscript-latin-small-letter-n",
      "superscript-plus-sign",
      "superscript-minus",
      "superscript-equals-sign"
    ]
  },
  {
    "symbol": "₋",
    "slug": "subscript-minus",
    "codepoints": [
      8331
    ],
    "primary": 8331,
    "name": "Subscript Minus",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-zero",
      "superscript-four",
      "superscript-five",
      "superscript-six",
      "superscript-seven",
      "superscript-eight",
      "superscript-nine",
      "superscript-latin-small-letter-i",
      "superscript-latin-small-letter-n",
      "superscript-plus-sign",
      "superscript-minus",
      "superscript-equals-sign"
    ]
  },
  {
    "symbol": "₌",
    "slug": "subscript-equals-sign",
    "codepoints": [
      8332
    ],
    "primary": 8332,
    "name": "Subscript Equals Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-zero",
      "superscript-four",
      "superscript-five",
      "superscript-six",
      "superscript-seven",
      "superscript-eight",
      "superscript-nine",
      "superscript-latin-small-letter-i",
      "superscript-latin-small-letter-n",
      "superscript-plus-sign",
      "superscript-minus",
      "superscript-equals-sign"
    ]
  },
  {
    "symbol": "₍",
    "slug": "subscript-left-parenthesis",
    "codepoints": [
      8333
    ],
    "primary": 8333,
    "name": "Subscript Left Parenthesis",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Common",
    "generalCategory": "Open Punctuation",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-zero",
      "superscript-four",
      "superscript-five",
      "superscript-six",
      "superscript-seven",
      "superscript-eight",
      "superscript-nine",
      "superscript-latin-small-letter-i",
      "superscript-latin-small-letter-n",
      "superscript-plus-sign",
      "superscript-minus",
      "superscript-equals-sign"
    ]
  },
  {
    "symbol": "₎",
    "slug": "subscript-right-parenthesis",
    "codepoints": [
      8334
    ],
    "primary": 8334,
    "name": "Subscript Right Parenthesis",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Common",
    "generalCategory": "Close Punctuation",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-zero",
      "superscript-four",
      "superscript-five",
      "superscript-six",
      "superscript-seven",
      "superscript-eight",
      "superscript-nine",
      "superscript-latin-small-letter-i",
      "superscript-latin-small-letter-n",
      "superscript-plus-sign",
      "superscript-minus",
      "superscript-equals-sign"
    ]
  },
  {
    "symbol": "ₐ",
    "slug": "latin-subscript-small-letter-a",
    "codepoints": [
      8336
    ],
    "primary": 8336,
    "name": "Latin Subscript Small Letter A",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Latin",
    "generalCategory": "Modifier Letter",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-zero",
      "superscript-four",
      "superscript-five",
      "superscript-six",
      "superscript-seven",
      "superscript-eight",
      "superscript-nine",
      "superscript-latin-small-letter-i",
      "superscript-latin-small-letter-n",
      "superscript-plus-sign",
      "superscript-minus",
      "superscript-equals-sign"
    ]
  },
  {
    "symbol": "ₑ",
    "slug": "latin-subscript-small-letter-e",
    "codepoints": [
      8337
    ],
    "primary": 8337,
    "name": "Latin Subscript Small Letter E",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Latin",
    "generalCategory": "Modifier Letter",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-zero",
      "superscript-four",
      "superscript-five",
      "superscript-six",
      "superscript-seven",
      "superscript-eight",
      "superscript-nine",
      "superscript-latin-small-letter-i",
      "superscript-latin-small-letter-n",
      "superscript-plus-sign",
      "superscript-minus",
      "superscript-equals-sign"
    ]
  },
  {
    "symbol": "ₒ",
    "slug": "latin-subscript-small-letter-o",
    "codepoints": [
      8338
    ],
    "primary": 8338,
    "name": "Latin Subscript Small Letter O",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Latin",
    "generalCategory": "Modifier Letter",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-zero",
      "superscript-four",
      "superscript-five",
      "superscript-six",
      "superscript-seven",
      "superscript-eight",
      "superscript-nine",
      "superscript-latin-small-letter-i",
      "superscript-latin-small-letter-n",
      "superscript-plus-sign",
      "superscript-minus",
      "superscript-equals-sign"
    ]
  },
  {
    "symbol": "ₓ",
    "slug": "latin-subscript-small-letter-x",
    "codepoints": [
      8339
    ],
    "primary": 8339,
    "name": "Latin Subscript Small Letter X",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Latin",
    "generalCategory": "Modifier Letter",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-zero",
      "superscript-four",
      "superscript-five",
      "superscript-six",
      "superscript-seven",
      "superscript-eight",
      "superscript-nine",
      "superscript-latin-small-letter-i",
      "superscript-latin-small-letter-n",
      "superscript-plus-sign",
      "superscript-minus",
      "superscript-equals-sign"
    ]
  },
  {
    "symbol": "ₔ",
    "slug": "latin-subscript-small-letter-schwa",
    "codepoints": [
      8340
    ],
    "primary": 8340,
    "name": "Latin Subscript Small Letter Schwa",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Latin",
    "generalCategory": "Modifier Letter",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-zero",
      "superscript-four",
      "superscript-five",
      "superscript-six",
      "superscript-seven",
      "superscript-eight",
      "superscript-nine",
      "superscript-latin-small-letter-i",
      "superscript-latin-small-letter-n",
      "superscript-plus-sign",
      "superscript-minus",
      "superscript-equals-sign"
    ]
  },
  {
    "symbol": "ₕ",
    "slug": "latin-subscript-small-letter-h",
    "codepoints": [
      8341
    ],
    "primary": 8341,
    "name": "Latin Subscript Small Letter H",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Latin",
    "generalCategory": "Modifier Letter",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-zero",
      "superscript-four",
      "superscript-five",
      "superscript-six",
      "superscript-seven",
      "superscript-eight",
      "superscript-nine",
      "superscript-latin-small-letter-i",
      "superscript-latin-small-letter-n",
      "superscript-plus-sign",
      "superscript-minus",
      "superscript-equals-sign"
    ]
  },
  {
    "symbol": "ₖ",
    "slug": "latin-subscript-small-letter-k",
    "codepoints": [
      8342
    ],
    "primary": 8342,
    "name": "Latin Subscript Small Letter K",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Latin",
    "generalCategory": "Modifier Letter",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-zero",
      "superscript-four",
      "superscript-five",
      "superscript-six",
      "superscript-seven",
      "superscript-eight",
      "superscript-nine",
      "superscript-latin-small-letter-i",
      "superscript-latin-small-letter-n",
      "superscript-plus-sign",
      "superscript-minus",
      "superscript-equals-sign"
    ]
  },
  {
    "symbol": "ₗ",
    "slug": "latin-subscript-small-letter-l",
    "codepoints": [
      8343
    ],
    "primary": 8343,
    "name": "Latin Subscript Small Letter L",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Latin",
    "generalCategory": "Modifier Letter",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-zero",
      "superscript-four",
      "superscript-five",
      "superscript-six",
      "superscript-seven",
      "superscript-eight",
      "superscript-nine",
      "superscript-latin-small-letter-i",
      "superscript-latin-small-letter-n",
      "superscript-plus-sign",
      "superscript-minus",
      "superscript-equals-sign"
    ]
  },
  {
    "symbol": "ₘ",
    "slug": "latin-subscript-small-letter-m",
    "codepoints": [
      8344
    ],
    "primary": 8344,
    "name": "Latin Subscript Small Letter M",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Latin",
    "generalCategory": "Modifier Letter",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-zero",
      "superscript-four",
      "superscript-five",
      "superscript-six",
      "superscript-seven",
      "superscript-eight",
      "superscript-nine",
      "superscript-latin-small-letter-i",
      "superscript-latin-small-letter-n",
      "superscript-plus-sign",
      "superscript-minus",
      "superscript-equals-sign"
    ]
  },
  {
    "symbol": "ₙ",
    "slug": "latin-subscript-small-letter-n",
    "codepoints": [
      8345
    ],
    "primary": 8345,
    "name": "Latin Subscript Small Letter N",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Latin",
    "generalCategory": "Modifier Letter",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-zero",
      "superscript-four",
      "superscript-five",
      "superscript-six",
      "superscript-seven",
      "superscript-eight",
      "superscript-nine",
      "superscript-latin-small-letter-i",
      "superscript-latin-small-letter-n",
      "superscript-plus-sign",
      "superscript-minus",
      "superscript-equals-sign"
    ]
  },
  {
    "symbol": "ₚ",
    "slug": "latin-subscript-small-letter-p",
    "codepoints": [
      8346
    ],
    "primary": 8346,
    "name": "Latin Subscript Small Letter P",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Latin",
    "generalCategory": "Modifier Letter",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-zero",
      "superscript-four",
      "superscript-five",
      "superscript-six",
      "superscript-seven",
      "superscript-eight",
      "superscript-nine",
      "superscript-latin-small-letter-i",
      "superscript-latin-small-letter-n",
      "superscript-plus-sign",
      "superscript-minus",
      "superscript-equals-sign"
    ]
  },
  {
    "symbol": "ₛ",
    "slug": "latin-subscript-small-letter-s",
    "codepoints": [
      8347
    ],
    "primary": 8347,
    "name": "Latin Subscript Small Letter S",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Latin",
    "generalCategory": "Modifier Letter",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-zero",
      "superscript-four",
      "superscript-five",
      "superscript-six",
      "superscript-seven",
      "superscript-eight",
      "superscript-nine",
      "superscript-latin-small-letter-i",
      "superscript-latin-small-letter-n",
      "superscript-plus-sign",
      "superscript-minus",
      "superscript-equals-sign"
    ]
  },
  {
    "symbol": "ₜ",
    "slug": "latin-subscript-small-letter-t",
    "codepoints": [
      8348
    ],
    "primary": 8348,
    "name": "Latin Subscript Small Letter T",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Superscripts And Subscripts",
    "script": "Latin",
    "generalCategory": "Modifier Letter",
    "categorySlug": "superscript-subscript-symbols",
    "categoryName": "Superscript and Subscript Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "superscript-zero",
      "superscript-four",
      "superscript-five",
      "superscript-six",
      "superscript-seven",
      "superscript-eight",
      "superscript-nine",
      "superscript-latin-small-letter-i",
      "superscript-latin-small-letter-n",
      "superscript-plus-sign",
      "superscript-minus",
      "superscript-equals-sign"
    ]
  },
  {
    "symbol": "½",
    "slug": "vulgar-fraction-one-half",
    "codepoints": [
      189
    ],
    "primary": 189,
    "name": "Vulgar Fraction One Half",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Latin 1 Supplement",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "fraction-symbols",
    "categoryName": "Fraction Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "multiplication-sign",
      "division-sign",
      "plus-minus-sign",
      "not-sign",
      "pound-sign",
      "yen-sign",
      "cent-sign",
      "middle-dot",
      "pilcrow-sign",
      "section-sign",
      "inverted-question-mark",
      "inverted-exclamation-mark"
    ]
  },
  {
    "symbol": "⅓",
    "slug": "vulgar-fraction-one-third",
    "codepoints": [
      8531
    ],
    "primary": 8531,
    "name": "Vulgar Fraction One Third",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "fraction-symbols",
    "categoryName": "Fraction Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve"
    ]
  },
  {
    "symbol": "⅔",
    "slug": "vulgar-fraction-two-thirds",
    "codepoints": [
      8532
    ],
    "primary": 8532,
    "name": "Vulgar Fraction Two Thirds",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "fraction-symbols",
    "categoryName": "Fraction Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve"
    ]
  },
  {
    "symbol": "¼",
    "slug": "vulgar-fraction-one-quarter",
    "codepoints": [
      188
    ],
    "primary": 188,
    "name": "Vulgar Fraction One Quarter",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Latin 1 Supplement",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "fraction-symbols",
    "categoryName": "Fraction Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "multiplication-sign",
      "division-sign",
      "plus-minus-sign",
      "not-sign",
      "pound-sign",
      "yen-sign",
      "cent-sign",
      "middle-dot",
      "pilcrow-sign",
      "section-sign",
      "inverted-question-mark",
      "inverted-exclamation-mark"
    ]
  },
  {
    "symbol": "¾",
    "slug": "vulgar-fraction-three-quarters",
    "codepoints": [
      190
    ],
    "primary": 190,
    "name": "Vulgar Fraction Three Quarters",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Latin 1 Supplement",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "fraction-symbols",
    "categoryName": "Fraction Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "multiplication-sign",
      "division-sign",
      "plus-minus-sign",
      "not-sign",
      "pound-sign",
      "yen-sign",
      "cent-sign",
      "middle-dot",
      "pilcrow-sign",
      "section-sign",
      "inverted-question-mark",
      "inverted-exclamation-mark"
    ]
  },
  {
    "symbol": "⅕",
    "slug": "vulgar-fraction-one-fifth",
    "codepoints": [
      8533
    ],
    "primary": 8533,
    "name": "Vulgar Fraction One Fifth",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "fraction-symbols",
    "categoryName": "Fraction Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve"
    ]
  },
  {
    "symbol": "⅖",
    "slug": "vulgar-fraction-two-fifths",
    "codepoints": [
      8534
    ],
    "primary": 8534,
    "name": "Vulgar Fraction Two Fifths",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "fraction-symbols",
    "categoryName": "Fraction Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve"
    ]
  },
  {
    "symbol": "⅗",
    "slug": "vulgar-fraction-three-fifths",
    "codepoints": [
      8535
    ],
    "primary": 8535,
    "name": "Vulgar Fraction Three Fifths",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "fraction-symbols",
    "categoryName": "Fraction Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve"
    ]
  },
  {
    "symbol": "⅘",
    "slug": "vulgar-fraction-four-fifths",
    "codepoints": [
      8536
    ],
    "primary": 8536,
    "name": "Vulgar Fraction Four Fifths",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "fraction-symbols",
    "categoryName": "Fraction Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve"
    ]
  },
  {
    "symbol": "⅙",
    "slug": "vulgar-fraction-one-sixth",
    "codepoints": [
      8537
    ],
    "primary": 8537,
    "name": "Vulgar Fraction One Sixth",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "fraction-symbols",
    "categoryName": "Fraction Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve"
    ]
  },
  {
    "symbol": "⅚",
    "slug": "vulgar-fraction-five-sixths",
    "codepoints": [
      8538
    ],
    "primary": 8538,
    "name": "Vulgar Fraction Five Sixths",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "fraction-symbols",
    "categoryName": "Fraction Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve"
    ]
  },
  {
    "symbol": "⅛",
    "slug": "vulgar-fraction-one-eighth",
    "codepoints": [
      8539
    ],
    "primary": 8539,
    "name": "Vulgar Fraction One Eighth",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "fraction-symbols",
    "categoryName": "Fraction Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve"
    ]
  },
  {
    "symbol": "⅜",
    "slug": "vulgar-fraction-three-eighths",
    "codepoints": [
      8540
    ],
    "primary": 8540,
    "name": "Vulgar Fraction Three Eighths",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "fraction-symbols",
    "categoryName": "Fraction Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve"
    ]
  },
  {
    "symbol": "⅝",
    "slug": "vulgar-fraction-five-eighths",
    "codepoints": [
      8541
    ],
    "primary": 8541,
    "name": "Vulgar Fraction Five Eighths",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "fraction-symbols",
    "categoryName": "Fraction Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve"
    ]
  },
  {
    "symbol": "⅞",
    "slug": "vulgar-fraction-seven-eighths",
    "codepoints": [
      8542
    ],
    "primary": 8542,
    "name": "Vulgar Fraction Seven Eighths",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "fraction-symbols",
    "categoryName": "Fraction Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve"
    ]
  },
  {
    "symbol": "⅐",
    "slug": "vulgar-fraction-one-seventh",
    "codepoints": [
      8528
    ],
    "primary": 8528,
    "name": "Vulgar Fraction One Seventh",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "fraction-symbols",
    "categoryName": "Fraction Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve"
    ]
  },
  {
    "symbol": "⅑",
    "slug": "vulgar-fraction-one-ninth",
    "codepoints": [
      8529
    ],
    "primary": 8529,
    "name": "Vulgar Fraction One Ninth",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "fraction-symbols",
    "categoryName": "Fraction Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve"
    ]
  },
  {
    "symbol": "⅒",
    "slug": "vulgar-fraction-one-tenth",
    "codepoints": [
      8530
    ],
    "primary": 8530,
    "name": "Vulgar Fraction One Tenth",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "fraction-symbols",
    "categoryName": "Fraction Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve"
    ]
  },
  {
    "symbol": "⁄",
    "slug": "fraction-slash",
    "codepoints": [
      8260
    ],
    "primary": 8260,
    "name": "Fraction Slash",
    "nameSource": "ucd",
    "aliases": [],
    "block": "General Punctuation",
    "script": "Common",
    "generalCategory": "Math Symbol",
    "categorySlug": "fraction-symbols",
    "categoryName": "Fraction Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "asterism",
      "two-asterisks-aligned-vertically",
      "horizontal-ellipsis",
      "en-dash",
      "em-dash",
      "hyphen",
      "non-breaking-hyphen",
      "figure-dash",
      "horizontal-bar",
      "hyphenation-point",
      "reference-mark",
      "double-exclamation-mark"
    ]
  },
  {
    "symbol": "⅟",
    "slug": "fraction-numerator-one",
    "codepoints": [
      8543
    ],
    "primary": 8543,
    "name": "Fraction Numerator One",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Number Forms",
    "script": "Common",
    "generalCategory": "Other Number",
    "categorySlug": "fraction-symbols",
    "categoryName": "Fraction Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "roman-numeral-one",
      "roman-numeral-two",
      "roman-numeral-three",
      "roman-numeral-four",
      "roman-numeral-five",
      "roman-numeral-six",
      "roman-numeral-seven",
      "roman-numeral-eight",
      "roman-numeral-nine",
      "roman-numeral-ten",
      "roman-numeral-eleven",
      "roman-numeral-twelve"
    ]
  },
  {
    "symbol": "─",
    "slug": "box-drawings-light-horizontal",
    "codepoints": [
      9472
    ],
    "primary": 9472,
    "name": "Box Drawings Light Horizontal",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Box Drawing",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "box-drawing-symbols",
    "categoryName": "Box Drawing Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "box-drawings-light-vertical",
      "box-drawings-light-down-and-right",
      "box-drawings-light-down-and-left",
      "box-drawings-light-up-and-right",
      "box-drawings-light-up-and-left",
      "box-drawings-light-vertical-and-right",
      "box-drawings-light-vertical-and-left",
      "box-drawings-light-down-and-horizontal",
      "box-drawings-light-up-and-horizontal",
      "box-drawings-light-vertical-and-horizontal",
      "box-drawings-heavy-horizontal",
      "box-drawings-heavy-vertical"
    ]
  },
  {
    "symbol": "│",
    "slug": "box-drawings-light-vertical",
    "codepoints": [
      9474
    ],
    "primary": 9474,
    "name": "Box Drawings Light Vertical",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Box Drawing",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "box-drawing-symbols",
    "categoryName": "Box Drawing Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "box-drawings-light-horizontal",
      "box-drawings-light-down-and-right",
      "box-drawings-light-down-and-left",
      "box-drawings-light-up-and-right",
      "box-drawings-light-up-and-left",
      "box-drawings-light-vertical-and-right",
      "box-drawings-light-vertical-and-left",
      "box-drawings-light-down-and-horizontal",
      "box-drawings-light-up-and-horizontal",
      "box-drawings-light-vertical-and-horizontal",
      "box-drawings-heavy-horizontal",
      "box-drawings-heavy-vertical"
    ]
  },
  {
    "symbol": "┌",
    "slug": "box-drawings-light-down-and-right",
    "codepoints": [
      9484
    ],
    "primary": 9484,
    "name": "Box Drawings Light Down And Right",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Box Drawing",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "box-drawing-symbols",
    "categoryName": "Box Drawing Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "box-drawings-light-horizontal",
      "box-drawings-light-vertical",
      "box-drawings-light-down-and-left",
      "box-drawings-light-up-and-right",
      "box-drawings-light-up-and-left",
      "box-drawings-light-vertical-and-right",
      "box-drawings-light-vertical-and-left",
      "box-drawings-light-down-and-horizontal",
      "box-drawings-light-up-and-horizontal",
      "box-drawings-light-vertical-and-horizontal",
      "box-drawings-heavy-horizontal",
      "box-drawings-heavy-vertical"
    ]
  },
  {
    "symbol": "┐",
    "slug": "box-drawings-light-down-and-left",
    "codepoints": [
      9488
    ],
    "primary": 9488,
    "name": "Box Drawings Light Down And Left",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Box Drawing",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "box-drawing-symbols",
    "categoryName": "Box Drawing Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "box-drawings-light-horizontal",
      "box-drawings-light-vertical",
      "box-drawings-light-down-and-right",
      "box-drawings-light-up-and-right",
      "box-drawings-light-up-and-left",
      "box-drawings-light-vertical-and-right",
      "box-drawings-light-vertical-and-left",
      "box-drawings-light-down-and-horizontal",
      "box-drawings-light-up-and-horizontal",
      "box-drawings-light-vertical-and-horizontal",
      "box-drawings-heavy-horizontal",
      "box-drawings-heavy-vertical"
    ]
  },
  {
    "symbol": "└",
    "slug": "box-drawings-light-up-and-right",
    "codepoints": [
      9492
    ],
    "primary": 9492,
    "name": "Box Drawings Light Up And Right",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Box Drawing",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "box-drawing-symbols",
    "categoryName": "Box Drawing Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "box-drawings-light-horizontal",
      "box-drawings-light-vertical",
      "box-drawings-light-down-and-right",
      "box-drawings-light-down-and-left",
      "box-drawings-light-up-and-left",
      "box-drawings-light-vertical-and-right",
      "box-drawings-light-vertical-and-left",
      "box-drawings-light-down-and-horizontal",
      "box-drawings-light-up-and-horizontal",
      "box-drawings-light-vertical-and-horizontal",
      "box-drawings-heavy-horizontal",
      "box-drawings-heavy-vertical"
    ]
  },
  {
    "symbol": "┘",
    "slug": "box-drawings-light-up-and-left",
    "codepoints": [
      9496
    ],
    "primary": 9496,
    "name": "Box Drawings Light Up And Left",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Box Drawing",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "box-drawing-symbols",
    "categoryName": "Box Drawing Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "box-drawings-light-horizontal",
      "box-drawings-light-vertical",
      "box-drawings-light-down-and-right",
      "box-drawings-light-down-and-left",
      "box-drawings-light-up-and-right",
      "box-drawings-light-vertical-and-right",
      "box-drawings-light-vertical-and-left",
      "box-drawings-light-down-and-horizontal",
      "box-drawings-light-up-and-horizontal",
      "box-drawings-light-vertical-and-horizontal",
      "box-drawings-heavy-horizontal",
      "box-drawings-heavy-vertical"
    ]
  },
  {
    "symbol": "├",
    "slug": "box-drawings-light-vertical-and-right",
    "codepoints": [
      9500
    ],
    "primary": 9500,
    "name": "Box Drawings Light Vertical And Right",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Box Drawing",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "box-drawing-symbols",
    "categoryName": "Box Drawing Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "box-drawings-light-horizontal",
      "box-drawings-light-vertical",
      "box-drawings-light-down-and-right",
      "box-drawings-light-down-and-left",
      "box-drawings-light-up-and-right",
      "box-drawings-light-up-and-left",
      "box-drawings-light-vertical-and-left",
      "box-drawings-light-down-and-horizontal",
      "box-drawings-light-up-and-horizontal",
      "box-drawings-light-vertical-and-horizontal",
      "box-drawings-heavy-horizontal",
      "box-drawings-heavy-vertical"
    ]
  },
  {
    "symbol": "┤",
    "slug": "box-drawings-light-vertical-and-left",
    "codepoints": [
      9508
    ],
    "primary": 9508,
    "name": "Box Drawings Light Vertical And Left",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Box Drawing",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "box-drawing-symbols",
    "categoryName": "Box Drawing Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "box-drawings-light-horizontal",
      "box-drawings-light-vertical",
      "box-drawings-light-down-and-right",
      "box-drawings-light-down-and-left",
      "box-drawings-light-up-and-right",
      "box-drawings-light-up-and-left",
      "box-drawings-light-vertical-and-right",
      "box-drawings-light-down-and-horizontal",
      "box-drawings-light-up-and-horizontal",
      "box-drawings-light-vertical-and-horizontal",
      "box-drawings-heavy-horizontal",
      "box-drawings-heavy-vertical"
    ]
  },
  {
    "symbol": "┬",
    "slug": "box-drawings-light-down-and-horizontal",
    "codepoints": [
      9516
    ],
    "primary": 9516,
    "name": "Box Drawings Light Down And Horizontal",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Box Drawing",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "box-drawing-symbols",
    "categoryName": "Box Drawing Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "box-drawings-light-horizontal",
      "box-drawings-light-vertical",
      "box-drawings-light-down-and-right",
      "box-drawings-light-down-and-left",
      "box-drawings-light-up-and-right",
      "box-drawings-light-up-and-left",
      "box-drawings-light-vertical-and-right",
      "box-drawings-light-vertical-and-left",
      "box-drawings-light-up-and-horizontal",
      "box-drawings-light-vertical-and-horizontal",
      "box-drawings-heavy-horizontal",
      "box-drawings-heavy-vertical"
    ]
  },
  {
    "symbol": "┴",
    "slug": "box-drawings-light-up-and-horizontal",
    "codepoints": [
      9524
    ],
    "primary": 9524,
    "name": "Box Drawings Light Up And Horizontal",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Box Drawing",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "box-drawing-symbols",
    "categoryName": "Box Drawing Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "box-drawings-light-horizontal",
      "box-drawings-light-vertical",
      "box-drawings-light-down-and-right",
      "box-drawings-light-down-and-left",
      "box-drawings-light-up-and-right",
      "box-drawings-light-up-and-left",
      "box-drawings-light-vertical-and-right",
      "box-drawings-light-vertical-and-left",
      "box-drawings-light-down-and-horizontal",
      "box-drawings-light-vertical-and-horizontal",
      "box-drawings-heavy-horizontal",
      "box-drawings-heavy-vertical"
    ]
  },
  {
    "symbol": "┼",
    "slug": "box-drawings-light-vertical-and-horizontal",
    "codepoints": [
      9532
    ],
    "primary": 9532,
    "name": "Box Drawings Light Vertical And Horizontal",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Box Drawing",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "box-drawing-symbols",
    "categoryName": "Box Drawing Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "box-drawings-light-horizontal",
      "box-drawings-light-vertical",
      "box-drawings-light-down-and-right",
      "box-drawings-light-down-and-left",
      "box-drawings-light-up-and-right",
      "box-drawings-light-up-and-left",
      "box-drawings-light-vertical-and-right",
      "box-drawings-light-vertical-and-left",
      "box-drawings-light-down-and-horizontal",
      "box-drawings-light-up-and-horizontal",
      "box-drawings-heavy-horizontal",
      "box-drawings-heavy-vertical"
    ]
  },
  {
    "symbol": "━",
    "slug": "box-drawings-heavy-horizontal",
    "codepoints": [
      9473
    ],
    "primary": 9473,
    "name": "Box Drawings Heavy Horizontal",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Box Drawing",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "box-drawing-symbols",
    "categoryName": "Box Drawing Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "box-drawings-light-horizontal",
      "box-drawings-light-vertical",
      "box-drawings-light-down-and-right",
      "box-drawings-light-down-and-left",
      "box-drawings-light-up-and-right",
      "box-drawings-light-up-and-left",
      "box-drawings-light-vertical-and-right",
      "box-drawings-light-vertical-and-left",
      "box-drawings-light-down-and-horizontal",
      "box-drawings-light-up-and-horizontal",
      "box-drawings-light-vertical-and-horizontal",
      "box-drawings-heavy-vertical"
    ]
  },
  {
    "symbol": "┃",
    "slug": "box-drawings-heavy-vertical",
    "codepoints": [
      9475
    ],
    "primary": 9475,
    "name": "Box Drawings Heavy Vertical",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Box Drawing",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "box-drawing-symbols",
    "categoryName": "Box Drawing Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "box-drawings-light-horizontal",
      "box-drawings-light-vertical",
      "box-drawings-light-down-and-right",
      "box-drawings-light-down-and-left",
      "box-drawings-light-up-and-right",
      "box-drawings-light-up-and-left",
      "box-drawings-light-vertical-and-right",
      "box-drawings-light-vertical-and-left",
      "box-drawings-light-down-and-horizontal",
      "box-drawings-light-up-and-horizontal",
      "box-drawings-light-vertical-and-horizontal",
      "box-drawings-heavy-horizontal"
    ]
  },
  {
    "symbol": "┏",
    "slug": "box-drawings-heavy-down-and-right",
    "codepoints": [
      9487
    ],
    "primary": 9487,
    "name": "Box Drawings Heavy Down And Right",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Box Drawing",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "box-drawing-symbols",
    "categoryName": "Box Drawing Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "box-drawings-light-horizontal",
      "box-drawings-light-vertical",
      "box-drawings-light-down-and-right",
      "box-drawings-light-down-and-left",
      "box-drawings-light-up-and-right",
      "box-drawings-light-up-and-left",
      "box-drawings-light-vertical-and-right",
      "box-drawings-light-vertical-and-left",
      "box-drawings-light-down-and-horizontal",
      "box-drawings-light-up-and-horizontal",
      "box-drawings-light-vertical-and-horizontal",
      "box-drawings-heavy-horizontal"
    ]
  },
  {
    "symbol": "┓",
    "slug": "box-drawings-heavy-down-and-left",
    "codepoints": [
      9491
    ],
    "primary": 9491,
    "name": "Box Drawings Heavy Down And Left",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Box Drawing",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "box-drawing-symbols",
    "categoryName": "Box Drawing Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "box-drawings-light-horizontal",
      "box-drawings-light-vertical",
      "box-drawings-light-down-and-right",
      "box-drawings-light-down-and-left",
      "box-drawings-light-up-and-right",
      "box-drawings-light-up-and-left",
      "box-drawings-light-vertical-and-right",
      "box-drawings-light-vertical-and-left",
      "box-drawings-light-down-and-horizontal",
      "box-drawings-light-up-and-horizontal",
      "box-drawings-light-vertical-and-horizontal",
      "box-drawings-heavy-horizontal"
    ]
  },
  {
    "symbol": "┗",
    "slug": "box-drawings-heavy-up-and-right",
    "codepoints": [
      9495
    ],
    "primary": 9495,
    "name": "Box Drawings Heavy Up And Right",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Box Drawing",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "box-drawing-symbols",
    "categoryName": "Box Drawing Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "box-drawings-light-horizontal",
      "box-drawings-light-vertical",
      "box-drawings-light-down-and-right",
      "box-drawings-light-down-and-left",
      "box-drawings-light-up-and-right",
      "box-drawings-light-up-and-left",
      "box-drawings-light-vertical-and-right",
      "box-drawings-light-vertical-and-left",
      "box-drawings-light-down-and-horizontal",
      "box-drawings-light-up-and-horizontal",
      "box-drawings-light-vertical-and-horizontal",
      "box-drawings-heavy-horizontal"
    ]
  },
  {
    "symbol": "┛",
    "slug": "box-drawings-heavy-up-and-left",
    "codepoints": [
      9499
    ],
    "primary": 9499,
    "name": "Box Drawings Heavy Up And Left",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Box Drawing",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "box-drawing-symbols",
    "categoryName": "Box Drawing Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "box-drawings-light-horizontal",
      "box-drawings-light-vertical",
      "box-drawings-light-down-and-right",
      "box-drawings-light-down-and-left",
      "box-drawings-light-up-and-right",
      "box-drawings-light-up-and-left",
      "box-drawings-light-vertical-and-right",
      "box-drawings-light-vertical-and-left",
      "box-drawings-light-down-and-horizontal",
      "box-drawings-light-up-and-horizontal",
      "box-drawings-light-vertical-and-horizontal",
      "box-drawings-heavy-horizontal"
    ]
  },
  {
    "symbol": "┣",
    "slug": "box-drawings-heavy-vertical-and-right",
    "codepoints": [
      9507
    ],
    "primary": 9507,
    "name": "Box Drawings Heavy Vertical And Right",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Box Drawing",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "box-drawing-symbols",
    "categoryName": "Box Drawing Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "box-drawings-light-horizontal",
      "box-drawings-light-vertical",
      "box-drawings-light-down-and-right",
      "box-drawings-light-down-and-left",
      "box-drawings-light-up-and-right",
      "box-drawings-light-up-and-left",
      "box-drawings-light-vertical-and-right",
      "box-drawings-light-vertical-and-left",
      "box-drawings-light-down-and-horizontal",
      "box-drawings-light-up-and-horizontal",
      "box-drawings-light-vertical-and-horizontal",
      "box-drawings-heavy-horizontal"
    ]
  },
  {
    "symbol": "┫",
    "slug": "box-drawings-heavy-vertical-and-left",
    "codepoints": [
      9515
    ],
    "primary": 9515,
    "name": "Box Drawings Heavy Vertical And Left",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Box Drawing",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "box-drawing-symbols",
    "categoryName": "Box Drawing Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "box-drawings-light-horizontal",
      "box-drawings-light-vertical",
      "box-drawings-light-down-and-right",
      "box-drawings-light-down-and-left",
      "box-drawings-light-up-and-right",
      "box-drawings-light-up-and-left",
      "box-drawings-light-vertical-and-right",
      "box-drawings-light-vertical-and-left",
      "box-drawings-light-down-and-horizontal",
      "box-drawings-light-up-and-horizontal",
      "box-drawings-light-vertical-and-horizontal",
      "box-drawings-heavy-horizontal"
    ]
  },
  {
    "symbol": "┳",
    "slug": "box-drawings-heavy-down-and-horizontal",
    "codepoints": [
      9523
    ],
    "primary": 9523,
    "name": "Box Drawings Heavy Down And Horizontal",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Box Drawing",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "box-drawing-symbols",
    "categoryName": "Box Drawing Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "box-drawings-light-horizontal",
      "box-drawings-light-vertical",
      "box-drawings-light-down-and-right",
      "box-drawings-light-down-and-left",
      "box-drawings-light-up-and-right",
      "box-drawings-light-up-and-left",
      "box-drawings-light-vertical-and-right",
      "box-drawings-light-vertical-and-left",
      "box-drawings-light-down-and-horizontal",
      "box-drawings-light-up-and-horizontal",
      "box-drawings-light-vertical-and-horizontal",
      "box-drawings-heavy-horizontal"
    ]
  },
  {
    "symbol": "┻",
    "slug": "box-drawings-heavy-up-and-horizontal",
    "codepoints": [
      9531
    ],
    "primary": 9531,
    "name": "Box Drawings Heavy Up And Horizontal",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Box Drawing",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "box-drawing-symbols",
    "categoryName": "Box Drawing Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "box-drawings-light-horizontal",
      "box-drawings-light-vertical",
      "box-drawings-light-down-and-right",
      "box-drawings-light-down-and-left",
      "box-drawings-light-up-and-right",
      "box-drawings-light-up-and-left",
      "box-drawings-light-vertical-and-right",
      "box-drawings-light-vertical-and-left",
      "box-drawings-light-down-and-horizontal",
      "box-drawings-light-up-and-horizontal",
      "box-drawings-light-vertical-and-horizontal",
      "box-drawings-heavy-horizontal"
    ]
  },
  {
    "symbol": "╋",
    "slug": "box-drawings-heavy-vertical-and-horizontal",
    "codepoints": [
      9547
    ],
    "primary": 9547,
    "name": "Box Drawings Heavy Vertical And Horizontal",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Box Drawing",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "box-drawing-symbols",
    "categoryName": "Box Drawing Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "box-drawings-light-horizontal",
      "box-drawings-light-vertical",
      "box-drawings-light-down-and-right",
      "box-drawings-light-down-and-left",
      "box-drawings-light-up-and-right",
      "box-drawings-light-up-and-left",
      "box-drawings-light-vertical-and-right",
      "box-drawings-light-vertical-and-left",
      "box-drawings-light-down-and-horizontal",
      "box-drawings-light-up-and-horizontal",
      "box-drawings-light-vertical-and-horizontal",
      "box-drawings-heavy-horizontal"
    ]
  },
  {
    "symbol": "═",
    "slug": "box-drawings-double-horizontal",
    "codepoints": [
      9552
    ],
    "primary": 9552,
    "name": "Box Drawings Double Horizontal",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Box Drawing",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "box-drawing-symbols",
    "categoryName": "Box Drawing Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "box-drawings-light-horizontal",
      "box-drawings-light-vertical",
      "box-drawings-light-down-and-right",
      "box-drawings-light-down-and-left",
      "box-drawings-light-up-and-right",
      "box-drawings-light-up-and-left",
      "box-drawings-light-vertical-and-right",
      "box-drawings-light-vertical-and-left",
      "box-drawings-light-down-and-horizontal",
      "box-drawings-light-up-and-horizontal",
      "box-drawings-light-vertical-and-horizontal",
      "box-drawings-heavy-horizontal"
    ]
  },
  {
    "symbol": "║",
    "slug": "box-drawings-double-vertical",
    "codepoints": [
      9553
    ],
    "primary": 9553,
    "name": "Box Drawings Double Vertical",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Box Drawing",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "box-drawing-symbols",
    "categoryName": "Box Drawing Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "box-drawings-light-horizontal",
      "box-drawings-light-vertical",
      "box-drawings-light-down-and-right",
      "box-drawings-light-down-and-left",
      "box-drawings-light-up-and-right",
      "box-drawings-light-up-and-left",
      "box-drawings-light-vertical-and-right",
      "box-drawings-light-vertical-and-left",
      "box-drawings-light-down-and-horizontal",
      "box-drawings-light-up-and-horizontal",
      "box-drawings-light-vertical-and-horizontal",
      "box-drawings-heavy-horizontal"
    ]
  },
  {
    "symbol": "╔",
    "slug": "box-drawings-double-down-and-right",
    "codepoints": [
      9556
    ],
    "primary": 9556,
    "name": "Box Drawings Double Down And Right",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Box Drawing",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "box-drawing-symbols",
    "categoryName": "Box Drawing Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "box-drawings-light-horizontal",
      "box-drawings-light-vertical",
      "box-drawings-light-down-and-right",
      "box-drawings-light-down-and-left",
      "box-drawings-light-up-and-right",
      "box-drawings-light-up-and-left",
      "box-drawings-light-vertical-and-right",
      "box-drawings-light-vertical-and-left",
      "box-drawings-light-down-and-horizontal",
      "box-drawings-light-up-and-horizontal",
      "box-drawings-light-vertical-and-horizontal",
      "box-drawings-heavy-horizontal"
    ]
  },
  {
    "symbol": "╗",
    "slug": "box-drawings-double-down-and-left",
    "codepoints": [
      9559
    ],
    "primary": 9559,
    "name": "Box Drawings Double Down And Left",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Box Drawing",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "box-drawing-symbols",
    "categoryName": "Box Drawing Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "box-drawings-light-horizontal",
      "box-drawings-light-vertical",
      "box-drawings-light-down-and-right",
      "box-drawings-light-down-and-left",
      "box-drawings-light-up-and-right",
      "box-drawings-light-up-and-left",
      "box-drawings-light-vertical-and-right",
      "box-drawings-light-vertical-and-left",
      "box-drawings-light-down-and-horizontal",
      "box-drawings-light-up-and-horizontal",
      "box-drawings-light-vertical-and-horizontal",
      "box-drawings-heavy-horizontal"
    ]
  },
  {
    "symbol": "╚",
    "slug": "box-drawings-double-up-and-right",
    "codepoints": [
      9562
    ],
    "primary": 9562,
    "name": "Box Drawings Double Up And Right",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Box Drawing",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "box-drawing-symbols",
    "categoryName": "Box Drawing Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "box-drawings-light-horizontal",
      "box-drawings-light-vertical",
      "box-drawings-light-down-and-right",
      "box-drawings-light-down-and-left",
      "box-drawings-light-up-and-right",
      "box-drawings-light-up-and-left",
      "box-drawings-light-vertical-and-right",
      "box-drawings-light-vertical-and-left",
      "box-drawings-light-down-and-horizontal",
      "box-drawings-light-up-and-horizontal",
      "box-drawings-light-vertical-and-horizontal",
      "box-drawings-heavy-horizontal"
    ]
  },
  {
    "symbol": "╝",
    "slug": "box-drawings-double-up-and-left",
    "codepoints": [
      9565
    ],
    "primary": 9565,
    "name": "Box Drawings Double Up And Left",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Box Drawing",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "box-drawing-symbols",
    "categoryName": "Box Drawing Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "box-drawings-light-horizontal",
      "box-drawings-light-vertical",
      "box-drawings-light-down-and-right",
      "box-drawings-light-down-and-left",
      "box-drawings-light-up-and-right",
      "box-drawings-light-up-and-left",
      "box-drawings-light-vertical-and-right",
      "box-drawings-light-vertical-and-left",
      "box-drawings-light-down-and-horizontal",
      "box-drawings-light-up-and-horizontal",
      "box-drawings-light-vertical-and-horizontal",
      "box-drawings-heavy-horizontal"
    ]
  },
  {
    "symbol": "╠",
    "slug": "box-drawings-double-vertical-and-right",
    "codepoints": [
      9568
    ],
    "primary": 9568,
    "name": "Box Drawings Double Vertical And Right",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Box Drawing",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "box-drawing-symbols",
    "categoryName": "Box Drawing Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "box-drawings-light-horizontal",
      "box-drawings-light-vertical",
      "box-drawings-light-down-and-right",
      "box-drawings-light-down-and-left",
      "box-drawings-light-up-and-right",
      "box-drawings-light-up-and-left",
      "box-drawings-light-vertical-and-right",
      "box-drawings-light-vertical-and-left",
      "box-drawings-light-down-and-horizontal",
      "box-drawings-light-up-and-horizontal",
      "box-drawings-light-vertical-and-horizontal",
      "box-drawings-heavy-horizontal"
    ]
  },
  {
    "symbol": "╣",
    "slug": "box-drawings-double-vertical-and-left",
    "codepoints": [
      9571
    ],
    "primary": 9571,
    "name": "Box Drawings Double Vertical And Left",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Box Drawing",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "box-drawing-symbols",
    "categoryName": "Box Drawing Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "box-drawings-light-horizontal",
      "box-drawings-light-vertical",
      "box-drawings-light-down-and-right",
      "box-drawings-light-down-and-left",
      "box-drawings-light-up-and-right",
      "box-drawings-light-up-and-left",
      "box-drawings-light-vertical-and-right",
      "box-drawings-light-vertical-and-left",
      "box-drawings-light-down-and-horizontal",
      "box-drawings-light-up-and-horizontal",
      "box-drawings-light-vertical-and-horizontal",
      "box-drawings-heavy-horizontal"
    ]
  },
  {
    "symbol": "╦",
    "slug": "box-drawings-double-down-and-horizontal",
    "codepoints": [
      9574
    ],
    "primary": 9574,
    "name": "Box Drawings Double Down And Horizontal",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Box Drawing",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "box-drawing-symbols",
    "categoryName": "Box Drawing Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "box-drawings-light-horizontal",
      "box-drawings-light-vertical",
      "box-drawings-light-down-and-right",
      "box-drawings-light-down-and-left",
      "box-drawings-light-up-and-right",
      "box-drawings-light-up-and-left",
      "box-drawings-light-vertical-and-right",
      "box-drawings-light-vertical-and-left",
      "box-drawings-light-down-and-horizontal",
      "box-drawings-light-up-and-horizontal",
      "box-drawings-light-vertical-and-horizontal",
      "box-drawings-heavy-horizontal"
    ]
  },
  {
    "symbol": "╩",
    "slug": "box-drawings-double-up-and-horizontal",
    "codepoints": [
      9577
    ],
    "primary": 9577,
    "name": "Box Drawings Double Up And Horizontal",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Box Drawing",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "box-drawing-symbols",
    "categoryName": "Box Drawing Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "box-drawings-light-horizontal",
      "box-drawings-light-vertical",
      "box-drawings-light-down-and-right",
      "box-drawings-light-down-and-left",
      "box-drawings-light-up-and-right",
      "box-drawings-light-up-and-left",
      "box-drawings-light-vertical-and-right",
      "box-drawings-light-vertical-and-left",
      "box-drawings-light-down-and-horizontal",
      "box-drawings-light-up-and-horizontal",
      "box-drawings-light-vertical-and-horizontal",
      "box-drawings-heavy-horizontal"
    ]
  },
  {
    "symbol": "╬",
    "slug": "box-drawings-double-vertical-and-horizontal",
    "codepoints": [
      9580
    ],
    "primary": 9580,
    "name": "Box Drawings Double Vertical And Horizontal",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Box Drawing",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "box-drawing-symbols",
    "categoryName": "Box Drawing Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "box-drawings-light-horizontal",
      "box-drawings-light-vertical",
      "box-drawings-light-down-and-right",
      "box-drawings-light-down-and-left",
      "box-drawings-light-up-and-right",
      "box-drawings-light-up-and-left",
      "box-drawings-light-vertical-and-right",
      "box-drawings-light-vertical-and-left",
      "box-drawings-light-down-and-horizontal",
      "box-drawings-light-up-and-horizontal",
      "box-drawings-light-vertical-and-horizontal",
      "box-drawings-heavy-horizontal"
    ]
  },
  {
    "symbol": "╭",
    "slug": "box-drawings-light-arc-down-and-right",
    "codepoints": [
      9581
    ],
    "primary": 9581,
    "name": "Box Drawings Light Arc Down And Right",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Box Drawing",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "box-drawing-symbols",
    "categoryName": "Box Drawing Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "box-drawings-light-horizontal",
      "box-drawings-light-vertical",
      "box-drawings-light-down-and-right",
      "box-drawings-light-down-and-left",
      "box-drawings-light-up-and-right",
      "box-drawings-light-up-and-left",
      "box-drawings-light-vertical-and-right",
      "box-drawings-light-vertical-and-left",
      "box-drawings-light-down-and-horizontal",
      "box-drawings-light-up-and-horizontal",
      "box-drawings-light-vertical-and-horizontal",
      "box-drawings-heavy-horizontal"
    ]
  },
  {
    "symbol": "╮",
    "slug": "box-drawings-light-arc-down-and-left",
    "codepoints": [
      9582
    ],
    "primary": 9582,
    "name": "Box Drawings Light Arc Down And Left",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Box Drawing",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "box-drawing-symbols",
    "categoryName": "Box Drawing Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "box-drawings-light-horizontal",
      "box-drawings-light-vertical",
      "box-drawings-light-down-and-right",
      "box-drawings-light-down-and-left",
      "box-drawings-light-up-and-right",
      "box-drawings-light-up-and-left",
      "box-drawings-light-vertical-and-right",
      "box-drawings-light-vertical-and-left",
      "box-drawings-light-down-and-horizontal",
      "box-drawings-light-up-and-horizontal",
      "box-drawings-light-vertical-and-horizontal",
      "box-drawings-heavy-horizontal"
    ]
  },
  {
    "symbol": "╯",
    "slug": "box-drawings-light-arc-up-and-left",
    "codepoints": [
      9583
    ],
    "primary": 9583,
    "name": "Box Drawings Light Arc Up And Left",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Box Drawing",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "box-drawing-symbols",
    "categoryName": "Box Drawing Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "box-drawings-light-horizontal",
      "box-drawings-light-vertical",
      "box-drawings-light-down-and-right",
      "box-drawings-light-down-and-left",
      "box-drawings-light-up-and-right",
      "box-drawings-light-up-and-left",
      "box-drawings-light-vertical-and-right",
      "box-drawings-light-vertical-and-left",
      "box-drawings-light-down-and-horizontal",
      "box-drawings-light-up-and-horizontal",
      "box-drawings-light-vertical-and-horizontal",
      "box-drawings-heavy-horizontal"
    ]
  },
  {
    "symbol": "╰",
    "slug": "box-drawings-light-arc-up-and-right",
    "codepoints": [
      9584
    ],
    "primary": 9584,
    "name": "Box Drawings Light Arc Up And Right",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Box Drawing",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "box-drawing-symbols",
    "categoryName": "Box Drawing Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "box-drawings-light-horizontal",
      "box-drawings-light-vertical",
      "box-drawings-light-down-and-right",
      "box-drawings-light-down-and-left",
      "box-drawings-light-up-and-right",
      "box-drawings-light-up-and-left",
      "box-drawings-light-vertical-and-right",
      "box-drawings-light-vertical-and-left",
      "box-drawings-light-down-and-horizontal",
      "box-drawings-light-up-and-horizontal",
      "box-drawings-light-vertical-and-horizontal",
      "box-drawings-heavy-horizontal"
    ]
  },
  {
    "symbol": "╱",
    "slug": "box-drawings-light-diagonal-upper-right-to-lower-left",
    "codepoints": [
      9585
    ],
    "primary": 9585,
    "name": "Box Drawings Light Diagonal Upper Right To Lower Left",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Box Drawing",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "box-drawing-symbols",
    "categoryName": "Box Drawing Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "box-drawings-light-horizontal",
      "box-drawings-light-vertical",
      "box-drawings-light-down-and-right",
      "box-drawings-light-down-and-left",
      "box-drawings-light-up-and-right",
      "box-drawings-light-up-and-left",
      "box-drawings-light-vertical-and-right",
      "box-drawings-light-vertical-and-left",
      "box-drawings-light-down-and-horizontal",
      "box-drawings-light-up-and-horizontal",
      "box-drawings-light-vertical-and-horizontal",
      "box-drawings-heavy-horizontal"
    ]
  },
  {
    "symbol": "╲",
    "slug": "box-drawings-light-diagonal-upper-left-to-lower-right",
    "codepoints": [
      9586
    ],
    "primary": 9586,
    "name": "Box Drawings Light Diagonal Upper Left To Lower Right",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Box Drawing",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "box-drawing-symbols",
    "categoryName": "Box Drawing Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "box-drawings-light-horizontal",
      "box-drawings-light-vertical",
      "box-drawings-light-down-and-right",
      "box-drawings-light-down-and-left",
      "box-drawings-light-up-and-right",
      "box-drawings-light-up-and-left",
      "box-drawings-light-vertical-and-right",
      "box-drawings-light-vertical-and-left",
      "box-drawings-light-down-and-horizontal",
      "box-drawings-light-up-and-horizontal",
      "box-drawings-light-vertical-and-horizontal",
      "box-drawings-heavy-horizontal"
    ]
  },
  {
    "symbol": "╳",
    "slug": "box-drawings-light-diagonal-cross",
    "codepoints": [
      9587
    ],
    "primary": 9587,
    "name": "Box Drawings Light Diagonal Cross",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Box Drawing",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "box-drawing-symbols",
    "categoryName": "Box Drawing Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "box-drawings-light-horizontal",
      "box-drawings-light-vertical",
      "box-drawings-light-down-and-right",
      "box-drawings-light-down-and-left",
      "box-drawings-light-up-and-right",
      "box-drawings-light-up-and-left",
      "box-drawings-light-vertical-and-right",
      "box-drawings-light-vertical-and-left",
      "box-drawings-light-down-and-horizontal",
      "box-drawings-light-up-and-horizontal",
      "box-drawings-light-vertical-and-horizontal",
      "box-drawings-heavy-horizontal"
    ]
  },
  {
    "symbol": "☉",
    "slug": "sun",
    "codepoints": [
      9737
    ],
    "primary": 9737,
    "name": "Sun",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "planet-symbols",
    "categoryName": "Planet Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "☽",
    "slug": "first-quarter-moon",
    "codepoints": [
      9789
    ],
    "primary": 9789,
    "name": "First Quarter Moon",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "planet-symbols",
    "categoryName": "Planet Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "☾",
    "slug": "last-quarter-moon",
    "codepoints": [
      9790
    ],
    "primary": 9790,
    "name": "Last Quarter Moon",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "planet-symbols",
    "categoryName": "Planet Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "☿",
    "slug": "mercury",
    "codepoints": [
      9791
    ],
    "primary": 9791,
    "name": "Mercury",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "planet-symbols",
    "categoryName": "Planet Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♁",
    "slug": "earth",
    "codepoints": [
      9793
    ],
    "primary": 9793,
    "name": "Earth",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "planet-symbols",
    "categoryName": "Planet Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♃",
    "slug": "jupiter",
    "codepoints": [
      9795
    ],
    "primary": 9795,
    "name": "Jupiter",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "planet-symbols",
    "categoryName": "Planet Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♄",
    "slug": "saturn",
    "codepoints": [
      9796
    ],
    "primary": 9796,
    "name": "Saturn",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "planet-symbols",
    "categoryName": "Planet Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♅",
    "slug": "uranus",
    "codepoints": [
      9797
    ],
    "primary": 9797,
    "name": "Uranus",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "planet-symbols",
    "categoryName": "Planet Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♆",
    "slug": "neptune",
    "codepoints": [
      9798
    ],
    "primary": 9798,
    "name": "Neptune",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "planet-symbols",
    "categoryName": "Planet Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♇",
    "slug": "pluto",
    "codepoints": [
      9799
    ],
    "primary": 9799,
    "name": "Pluto",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "planet-symbols",
    "categoryName": "Planet Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "⛢",
    "slug": "astronomical-symbol-for-uranus",
    "codepoints": [
      9954
    ],
    "primary": 9954,
    "name": "Astronomical Symbol For Uranus",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "planet-symbols",
    "categoryName": "Planet Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "☄",
    "slug": "comet",
    "codepoints": [
      9732
    ],
    "primary": 9732,
    "name": "Comet",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "planet-symbols",
    "categoryName": "Planet Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "⚳",
    "slug": "ceres",
    "codepoints": [
      9907
    ],
    "primary": 9907,
    "name": "Ceres",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "planet-symbols",
    "categoryName": "Planet Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "⚴",
    "slug": "pallas",
    "codepoints": [
      9908
    ],
    "primary": 9908,
    "name": "Pallas",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "planet-symbols",
    "categoryName": "Planet Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "⚵",
    "slug": "juno",
    "codepoints": [
      9909
    ],
    "primary": 9909,
    "name": "Juno",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "planet-symbols",
    "categoryName": "Planet Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "⚶",
    "slug": "vesta",
    "codepoints": [
      9910
    ],
    "primary": 9910,
    "name": "Vesta",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "planet-symbols",
    "categoryName": "Planet Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "⚷",
    "slug": "chiron",
    "codepoints": [
      9911
    ],
    "primary": 9911,
    "name": "Chiron",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "planet-symbols",
    "categoryName": "Planet Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "⚸",
    "slug": "black-moon-lilith",
    "codepoints": [
      9912
    ],
    "primary": 9912,
    "name": "Black Moon Lilith",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "planet-symbols",
    "categoryName": "Planet Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "☊",
    "slug": "ascending-node",
    "codepoints": [
      9738
    ],
    "primary": 9738,
    "name": "Ascending Node",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "planet-symbols",
    "categoryName": "Planet Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "☋",
    "slug": "descending-node",
    "codepoints": [
      9739
    ],
    "primary": 9739,
    "name": "Descending Node",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "planet-symbols",
    "categoryName": "Planet Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "⚀",
    "slug": "die-face-1",
    "codepoints": [
      9856
    ],
    "primary": 9856,
    "name": "Die Face-1",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "⚁",
    "slug": "die-face-2",
    "codepoints": [
      9857
    ],
    "primary": 9857,
    "name": "Die Face-2",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "⚂",
    "slug": "die-face-3",
    "codepoints": [
      9858
    ],
    "primary": 9858,
    "name": "Die Face-3",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "⚃",
    "slug": "die-face-4",
    "codepoints": [
      9859
    ],
    "primary": 9859,
    "name": "Die Face-4",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "⚄",
    "slug": "die-face-5",
    "codepoints": [
      9860
    ],
    "primary": 9860,
    "name": "Die Face-5",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "⚅",
    "slug": "die-face-6",
    "codepoints": [
      9861
    ],
    "primary": 9861,
    "name": "Die Face-6",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♠",
    "slug": "black-spade-suit",
    "codepoints": [
      9824
    ],
    "primary": 9824,
    "name": "Black Spade Suit",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♤",
    "slug": "white-spade-suit",
    "codepoints": [
      9828
    ],
    "primary": 9828,
    "name": "White Spade Suit",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♦",
    "slug": "black-diamond-suit",
    "codepoints": [
      9830
    ],
    "primary": 9830,
    "name": "Black Diamond Suit",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♢",
    "slug": "white-diamond-suit",
    "codepoints": [
      9826
    ],
    "primary": 9826,
    "name": "White Diamond Suit",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♣",
    "slug": "black-club-suit",
    "codepoints": [
      9827
    ],
    "primary": 9827,
    "name": "Black Club Suit",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♧",
    "slug": "white-club-suit",
    "codepoints": [
      9831
    ],
    "primary": 9831,
    "name": "White Club Suit",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "🂡",
    "slug": "playing-card-ace-of-spades",
    "codepoints": [
      127137
    ],
    "primary": 127137,
    "name": "Playing Card Ace Of Spades",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades",
      "playing-card-king-of-spades"
    ]
  },
  {
    "symbol": "🂢",
    "slug": "playing-card-two-of-spades",
    "codepoints": [
      127138
    ],
    "primary": 127138,
    "name": "Playing Card Two Of Spades",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades",
      "playing-card-king-of-spades"
    ]
  },
  {
    "symbol": "🂣",
    "slug": "playing-card-three-of-spades",
    "codepoints": [
      127139
    ],
    "primary": 127139,
    "name": "Playing Card Three Of Spades",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades",
      "playing-card-king-of-spades"
    ]
  },
  {
    "symbol": "🂤",
    "slug": "playing-card-four-of-spades",
    "codepoints": [
      127140
    ],
    "primary": 127140,
    "name": "Playing Card Four Of Spades",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades",
      "playing-card-king-of-spades"
    ]
  },
  {
    "symbol": "🂥",
    "slug": "playing-card-five-of-spades",
    "codepoints": [
      127141
    ],
    "primary": 127141,
    "name": "Playing Card Five Of Spades",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades",
      "playing-card-king-of-spades"
    ]
  },
  {
    "symbol": "🂦",
    "slug": "playing-card-six-of-spades",
    "codepoints": [
      127142
    ],
    "primary": 127142,
    "name": "Playing Card Six Of Spades",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades",
      "playing-card-king-of-spades"
    ]
  },
  {
    "symbol": "🂧",
    "slug": "playing-card-seven-of-spades",
    "codepoints": [
      127143
    ],
    "primary": 127143,
    "name": "Playing Card Seven Of Spades",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades",
      "playing-card-king-of-spades"
    ]
  },
  {
    "symbol": "🂨",
    "slug": "playing-card-eight-of-spades",
    "codepoints": [
      127144
    ],
    "primary": 127144,
    "name": "Playing Card Eight Of Spades",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades",
      "playing-card-king-of-spades"
    ]
  },
  {
    "symbol": "🂩",
    "slug": "playing-card-nine-of-spades",
    "codepoints": [
      127145
    ],
    "primary": 127145,
    "name": "Playing Card Nine Of Spades",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades",
      "playing-card-king-of-spades"
    ]
  },
  {
    "symbol": "🂪",
    "slug": "playing-card-ten-of-spades",
    "codepoints": [
      127146
    ],
    "primary": 127146,
    "name": "Playing Card Ten Of Spades",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades",
      "playing-card-king-of-spades"
    ]
  },
  {
    "symbol": "🂫",
    "slug": "playing-card-jack-of-spades",
    "codepoints": [
      127147
    ],
    "primary": 127147,
    "name": "Playing Card Jack Of Spades",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-queen-of-spades",
      "playing-card-king-of-spades"
    ]
  },
  {
    "symbol": "🂭",
    "slug": "playing-card-queen-of-spades",
    "codepoints": [
      127149
    ],
    "primary": 127149,
    "name": "Playing Card Queen Of Spades",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-king-of-spades"
    ]
  },
  {
    "symbol": "🂮",
    "slug": "playing-card-king-of-spades",
    "codepoints": [
      127150
    ],
    "primary": 127150,
    "name": "Playing Card King Of Spades",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🂱",
    "slug": "playing-card-ace-of-hearts",
    "codepoints": [
      127153
    ],
    "primary": 127153,
    "name": "Playing Card Ace Of Hearts",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🂲",
    "slug": "playing-card-two-of-hearts",
    "codepoints": [
      127154
    ],
    "primary": 127154,
    "name": "Playing Card Two Of Hearts",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🂳",
    "slug": "playing-card-three-of-hearts",
    "codepoints": [
      127155
    ],
    "primary": 127155,
    "name": "Playing Card Three Of Hearts",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🂴",
    "slug": "playing-card-four-of-hearts",
    "codepoints": [
      127156
    ],
    "primary": 127156,
    "name": "Playing Card Four Of Hearts",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🂵",
    "slug": "playing-card-five-of-hearts",
    "codepoints": [
      127157
    ],
    "primary": 127157,
    "name": "Playing Card Five Of Hearts",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🂶",
    "slug": "playing-card-six-of-hearts",
    "codepoints": [
      127158
    ],
    "primary": 127158,
    "name": "Playing Card Six Of Hearts",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🂷",
    "slug": "playing-card-seven-of-hearts",
    "codepoints": [
      127159
    ],
    "primary": 127159,
    "name": "Playing Card Seven Of Hearts",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🂸",
    "slug": "playing-card-eight-of-hearts",
    "codepoints": [
      127160
    ],
    "primary": 127160,
    "name": "Playing Card Eight Of Hearts",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🂹",
    "slug": "playing-card-nine-of-hearts",
    "codepoints": [
      127161
    ],
    "primary": 127161,
    "name": "Playing Card Nine Of Hearts",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🂺",
    "slug": "playing-card-ten-of-hearts",
    "codepoints": [
      127162
    ],
    "primary": 127162,
    "name": "Playing Card Ten Of Hearts",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🂻",
    "slug": "playing-card-jack-of-hearts",
    "codepoints": [
      127163
    ],
    "primary": 127163,
    "name": "Playing Card Jack Of Hearts",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🂽",
    "slug": "playing-card-queen-of-hearts",
    "codepoints": [
      127165
    ],
    "primary": 127165,
    "name": "Playing Card Queen Of Hearts",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🂾",
    "slug": "playing-card-king-of-hearts",
    "codepoints": [
      127166
    ],
    "primary": 127166,
    "name": "Playing Card King Of Hearts",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🃁",
    "slug": "playing-card-ace-of-diamonds",
    "codepoints": [
      127169
    ],
    "primary": 127169,
    "name": "Playing Card Ace Of Diamonds",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🃂",
    "slug": "playing-card-two-of-diamonds",
    "codepoints": [
      127170
    ],
    "primary": 127170,
    "name": "Playing Card Two Of Diamonds",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🃃",
    "slug": "playing-card-three-of-diamonds",
    "codepoints": [
      127171
    ],
    "primary": 127171,
    "name": "Playing Card Three Of Diamonds",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🃄",
    "slug": "playing-card-four-of-diamonds",
    "codepoints": [
      127172
    ],
    "primary": 127172,
    "name": "Playing Card Four Of Diamonds",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🃅",
    "slug": "playing-card-five-of-diamonds",
    "codepoints": [
      127173
    ],
    "primary": 127173,
    "name": "Playing Card Five Of Diamonds",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🃆",
    "slug": "playing-card-six-of-diamonds",
    "codepoints": [
      127174
    ],
    "primary": 127174,
    "name": "Playing Card Six Of Diamonds",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🃇",
    "slug": "playing-card-seven-of-diamonds",
    "codepoints": [
      127175
    ],
    "primary": 127175,
    "name": "Playing Card Seven Of Diamonds",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🃈",
    "slug": "playing-card-eight-of-diamonds",
    "codepoints": [
      127176
    ],
    "primary": 127176,
    "name": "Playing Card Eight Of Diamonds",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🃉",
    "slug": "playing-card-nine-of-diamonds",
    "codepoints": [
      127177
    ],
    "primary": 127177,
    "name": "Playing Card Nine Of Diamonds",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🃊",
    "slug": "playing-card-ten-of-diamonds",
    "codepoints": [
      127178
    ],
    "primary": 127178,
    "name": "Playing Card Ten Of Diamonds",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🃋",
    "slug": "playing-card-jack-of-diamonds",
    "codepoints": [
      127179
    ],
    "primary": 127179,
    "name": "Playing Card Jack Of Diamonds",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🃍",
    "slug": "playing-card-queen-of-diamonds",
    "codepoints": [
      127181
    ],
    "primary": 127181,
    "name": "Playing Card Queen Of Diamonds",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🃎",
    "slug": "playing-card-king-of-diamonds",
    "codepoints": [
      127182
    ],
    "primary": 127182,
    "name": "Playing Card King Of Diamonds",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🃑",
    "slug": "playing-card-ace-of-clubs",
    "codepoints": [
      127185
    ],
    "primary": 127185,
    "name": "Playing Card Ace Of Clubs",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🃒",
    "slug": "playing-card-two-of-clubs",
    "codepoints": [
      127186
    ],
    "primary": 127186,
    "name": "Playing Card Two Of Clubs",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🃓",
    "slug": "playing-card-three-of-clubs",
    "codepoints": [
      127187
    ],
    "primary": 127187,
    "name": "Playing Card Three Of Clubs",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🃔",
    "slug": "playing-card-four-of-clubs",
    "codepoints": [
      127188
    ],
    "primary": 127188,
    "name": "Playing Card Four Of Clubs",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🃕",
    "slug": "playing-card-five-of-clubs",
    "codepoints": [
      127189
    ],
    "primary": 127189,
    "name": "Playing Card Five Of Clubs",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🃖",
    "slug": "playing-card-six-of-clubs",
    "codepoints": [
      127190
    ],
    "primary": 127190,
    "name": "Playing Card Six Of Clubs",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🃗",
    "slug": "playing-card-seven-of-clubs",
    "codepoints": [
      127191
    ],
    "primary": 127191,
    "name": "Playing Card Seven Of Clubs",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🃘",
    "slug": "playing-card-eight-of-clubs",
    "codepoints": [
      127192
    ],
    "primary": 127192,
    "name": "Playing Card Eight Of Clubs",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🃙",
    "slug": "playing-card-nine-of-clubs",
    "codepoints": [
      127193
    ],
    "primary": 127193,
    "name": "Playing Card Nine Of Clubs",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🃚",
    "slug": "playing-card-ten-of-clubs",
    "codepoints": [
      127194
    ],
    "primary": 127194,
    "name": "Playing Card Ten Of Clubs",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🃛",
    "slug": "playing-card-jack-of-clubs",
    "codepoints": [
      127195
    ],
    "primary": 127195,
    "name": "Playing Card Jack Of Clubs",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🃝",
    "slug": "playing-card-queen-of-clubs",
    "codepoints": [
      127197
    ],
    "primary": 127197,
    "name": "Playing Card Queen Of Clubs",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🃞",
    "slug": "playing-card-king-of-clubs",
    "codepoints": [
      127198
    ],
    "primary": 127198,
    "name": "Playing Card King Of Clubs",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🂠",
    "slug": "playing-card-back",
    "codepoints": [
      127136
    ],
    "primary": 127136,
    "name": "Playing Card Back",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🂿",
    "slug": "playing-card-red-joker",
    "codepoints": [
      127167
    ],
    "primary": 127167,
    "name": "Playing Card Red Joker",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🃏",
    "slug": "playing-card-black-joker",
    "codepoints": [
      127183
    ],
    "primary": 127183,
    "name": "Playing Card Black Joker",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "🃟",
    "slug": "playing-card-white-joker",
    "codepoints": [
      127199
    ],
    "primary": 127199,
    "name": "Playing Card White Joker",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Playing Cards",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "card-dice-symbols",
    "categoryName": "Card and Dice Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "playing-card-ace-of-spades",
      "playing-card-two-of-spades",
      "playing-card-three-of-spades",
      "playing-card-four-of-spades",
      "playing-card-five-of-spades",
      "playing-card-six-of-spades",
      "playing-card-seven-of-spades",
      "playing-card-eight-of-spades",
      "playing-card-nine-of-spades",
      "playing-card-ten-of-spades",
      "playing-card-jack-of-spades",
      "playing-card-queen-of-spades"
    ]
  },
  {
    "symbol": "⚠",
    "slug": "warning-sign",
    "codepoints": [
      9888
    ],
    "primary": 9888,
    "name": "Warning Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "warning-symbols",
    "categoryName": "Warning Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "☢",
    "slug": "radioactive-sign",
    "codepoints": [
      9762
    ],
    "primary": 9762,
    "name": "Radioactive Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "warning-symbols",
    "categoryName": "Warning Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "☣",
    "slug": "biohazard-sign",
    "codepoints": [
      9763
    ],
    "primary": 9763,
    "name": "Biohazard Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "warning-symbols",
    "categoryName": "Warning Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "☠",
    "slug": "skull-and-crossbones",
    "codepoints": [
      9760
    ],
    "primary": 9760,
    "name": "Skull And Crossbones",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "warning-symbols",
    "categoryName": "Warning Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "☡",
    "slug": "caution-sign",
    "codepoints": [
      9761
    ],
    "primary": 9761,
    "name": "Caution Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "warning-symbols",
    "categoryName": "Warning Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "⛔",
    "slug": "no-entry",
    "codepoints": [
      9940
    ],
    "primary": 9940,
    "name": "No Entry",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "warning-symbols",
    "categoryName": "Warning Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "⚡",
    "slug": "high-voltage-sign",
    "codepoints": [
      9889
    ],
    "primary": 9889,
    "name": "High Voltage Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "warning-symbols",
    "categoryName": "Warning Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "⌁",
    "slug": "electric-arrow",
    "codepoints": [
      8961
    ],
    "primary": 8961,
    "name": "Electric Arrow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "warning-symbols",
    "categoryName": "Warning Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "⏚",
    "slug": "earth-ground",
    "codepoints": [
      9178
    ],
    "primary": 9178,
    "name": "Earth Ground",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "warning-symbols",
    "categoryName": "Warning Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "⏛",
    "slug": "fuse",
    "codepoints": [
      9179
    ],
    "primary": 9179,
    "name": "Fuse",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Technical",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "warning-symbols",
    "categoryName": "Warning Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "not-check-mark",
      "apl-functional-symbol-circle-stile",
      "watch",
      "position-indicator",
      "viewdata-square",
      "benzene-ring",
      "power-symbol",
      "power-on-off-symbol",
      "power-on-symbol",
      "power-sleep-symbol",
      "x-in-a-rectangle-box",
      "alarm-clock"
    ]
  },
  {
    "symbol": "🚫",
    "slug": "no-entry-sign",
    "codepoints": [
      128683
    ],
    "primary": 128683,
    "name": "No Entry Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "warning-symbols",
    "categoryName": "Warning Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom",
      "baby-symbol"
    ]
  },
  {
    "symbol": "🛑",
    "slug": "octagonal-sign",
    "codepoints": [
      128721
    ],
    "primary": 128721,
    "name": "Octagonal Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "warning-symbols",
    "categoryName": "Warning Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom",
      "baby-symbol"
    ]
  },
  {
    "symbol": "⛑",
    "slug": "helmet-with-white-cross",
    "codepoints": [
      9937
    ],
    "primary": 9937,
    "name": "Helmet With White Cross",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "warning-symbols",
    "categoryName": "Warning Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "🔞",
    "slug": "no-one-under-eighteen-symbol",
    "codepoints": [
      128286
    ],
    "primary": 128286,
    "name": "No One Under Eighteen Symbol",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "warning-symbols",
    "categoryName": "Warning Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🆘",
    "slug": "squared-sos",
    "codepoints": [
      127384
    ],
    "primary": 127384,
    "name": "Squared Sos",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Enclosed Alphanumeric Supplement",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "warning-symbols",
    "categoryName": "Warning Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": []
  },
  {
    "symbol": "🚸",
    "slug": "children-crossing",
    "codepoints": [
      128696
    ],
    "primary": 128696,
    "name": "Children Crossing",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "warning-symbols",
    "categoryName": "Warning Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom",
      "baby-symbol"
    ]
  },
  {
    "symbol": "🚷",
    "slug": "no-pedestrians",
    "codepoints": [
      128695
    ],
    "primary": 128695,
    "name": "No Pedestrians",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "warning-symbols",
    "categoryName": "Warning Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom",
      "baby-symbol"
    ]
  },
  {
    "symbol": "🚭",
    "slug": "no-smoking-symbol",
    "codepoints": [
      128685
    ],
    "primary": 128685,
    "name": "No Smoking Symbol",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "warning-symbols",
    "categoryName": "Warning Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom",
      "baby-symbol"
    ]
  },
  {
    "symbol": "🚳",
    "slug": "no-bicycles",
    "codepoints": [
      128691
    ],
    "primary": 128691,
    "name": "No Bicycles",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "warning-symbols",
    "categoryName": "Warning Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom",
      "baby-symbol"
    ]
  },
  {
    "symbol": "🚱",
    "slug": "non-potable-water-symbol",
    "codepoints": [
      128689
    ],
    "primary": 128689,
    "name": "Non-Potable Water Symbol",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "warning-symbols",
    "categoryName": "Warning Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom",
      "baby-symbol"
    ]
  },
  {
    "symbol": "📵",
    "slug": "no-mobile-phones",
    "codepoints": [
      128245
    ],
    "primary": 128245,
    "name": "No Mobile Phones",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "warning-symbols",
    "categoryName": "Warning Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🚯",
    "slug": "do-not-litter-symbol",
    "codepoints": [
      128687
    ],
    "primary": 128687,
    "name": "Do Not Litter Symbol",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "warning-symbols",
    "categoryName": "Warning Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom",
      "baby-symbol"
    ]
  },
  {
    "symbol": "⚕",
    "slug": "staff-of-aesculapius",
    "codepoints": [
      9877
    ],
    "primary": 9877,
    "name": "Staff Of Aesculapius",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "medical-symbols",
    "categoryName": "Medical Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "☤",
    "slug": "caduceus",
    "codepoints": [
      9764
    ],
    "primary": 9764,
    "name": "Caduceus",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "medical-symbols",
    "categoryName": "Medical Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "⚚",
    "slug": "staff-of-hermes",
    "codepoints": [
      9882
    ],
    "primary": 9882,
    "name": "Staff Of Hermes",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "medical-symbols",
    "categoryName": "Medical Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "💊",
    "slug": "pill",
    "codepoints": [
      128138
    ],
    "primary": 128138,
    "name": "Pill",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "medical-symbols",
    "categoryName": "Medical Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "💉",
    "slug": "syringe",
    "codepoints": [
      128137
    ],
    "primary": 128137,
    "name": "Syringe",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "medical-symbols",
    "categoryName": "Medical Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🩺",
    "slug": "stethoscope",
    "codepoints": [
      129658
    ],
    "primary": 129658,
    "name": "Stethoscope",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Symbols And Pictographs Extended A",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "medical-symbols",
    "categoryName": "Medical Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "pink-heart",
      "light-blue-heart",
      "grey-heart",
      "adhesive-bandage",
      "crutch",
      "x-ray",
      "drop-of-blood",
      "anatomical-heart",
      "lungs",
      "potted-plant",
      "wood",
      "rock"
    ]
  },
  {
    "symbol": "🩹",
    "slug": "adhesive-bandage",
    "codepoints": [
      129657
    ],
    "primary": 129657,
    "name": "Adhesive Bandage",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Symbols And Pictographs Extended A",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "medical-symbols",
    "categoryName": "Medical Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "pink-heart",
      "light-blue-heart",
      "grey-heart",
      "stethoscope",
      "crutch",
      "x-ray",
      "drop-of-blood",
      "anatomical-heart",
      "lungs",
      "potted-plant",
      "wood",
      "rock"
    ]
  },
  {
    "symbol": "🩼",
    "slug": "crutch",
    "codepoints": [
      129660
    ],
    "primary": 129660,
    "name": "Crutch",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Symbols And Pictographs Extended A",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "medical-symbols",
    "categoryName": "Medical Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "pink-heart",
      "light-blue-heart",
      "grey-heart",
      "stethoscope",
      "adhesive-bandage",
      "x-ray",
      "drop-of-blood",
      "anatomical-heart",
      "lungs",
      "potted-plant",
      "wood",
      "rock"
    ]
  },
  {
    "symbol": "🩻",
    "slug": "x-ray",
    "codepoints": [
      129659
    ],
    "primary": 129659,
    "name": "X-Ray",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Symbols And Pictographs Extended A",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "medical-symbols",
    "categoryName": "Medical Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "pink-heart",
      "light-blue-heart",
      "grey-heart",
      "stethoscope",
      "adhesive-bandage",
      "crutch",
      "drop-of-blood",
      "anatomical-heart",
      "lungs",
      "potted-plant",
      "wood",
      "rock"
    ]
  },
  {
    "symbol": "🏥",
    "slug": "hospital",
    "codepoints": [
      127973
    ],
    "primary": 127973,
    "name": "Hospital",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "medical-symbols",
    "categoryName": "Medical Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🩸",
    "slug": "drop-of-blood",
    "codepoints": [
      129656
    ],
    "primary": 129656,
    "name": "Drop Of Blood",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Symbols And Pictographs Extended A",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "medical-symbols",
    "categoryName": "Medical Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "pink-heart",
      "light-blue-heart",
      "grey-heart",
      "stethoscope",
      "adhesive-bandage",
      "crutch",
      "x-ray",
      "anatomical-heart",
      "lungs",
      "potted-plant",
      "wood",
      "rock"
    ]
  },
  {
    "symbol": "🫀",
    "slug": "anatomical-heart",
    "codepoints": [
      129728
    ],
    "primary": 129728,
    "name": "Anatomical Heart",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Symbols And Pictographs Extended A",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "medical-symbols",
    "categoryName": "Medical Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "pink-heart",
      "light-blue-heart",
      "grey-heart",
      "stethoscope",
      "adhesive-bandage",
      "crutch",
      "x-ray",
      "drop-of-blood",
      "lungs",
      "potted-plant",
      "wood",
      "rock"
    ]
  },
  {
    "symbol": "🫁",
    "slug": "lungs",
    "codepoints": [
      129729
    ],
    "primary": 129729,
    "name": "Lungs",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Symbols And Pictographs Extended A",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "medical-symbols",
    "categoryName": "Medical Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "pink-heart",
      "light-blue-heart",
      "grey-heart",
      "stethoscope",
      "adhesive-bandage",
      "crutch",
      "x-ray",
      "drop-of-blood",
      "anatomical-heart",
      "potted-plant",
      "wood",
      "rock"
    ]
  },
  {
    "symbol": "🧬",
    "slug": "dna-double-helix",
    "codepoints": [
      129516
    ],
    "primary": 129516,
    "name": "Dna Double Helix",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "medical-symbols",
    "categoryName": "Medical Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan",
      "guide-dog"
    ]
  },
  {
    "symbol": "🦠",
    "slug": "microbe",
    "codepoints": [
      129440
    ],
    "primary": 129440,
    "name": "Microbe",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "medical-symbols",
    "categoryName": "Medical Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan",
      "guide-dog"
    ]
  },
  {
    "symbol": "🧪",
    "slug": "test-tube",
    "codepoints": [
      129514
    ],
    "primary": 129514,
    "name": "Test Tube",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "medical-symbols",
    "categoryName": "Medical Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan",
      "guide-dog"
    ]
  },
  {
    "symbol": "🧫",
    "slug": "petri-dish",
    "codepoints": [
      129515
    ],
    "primary": 129515,
    "name": "Petri Dish",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "medical-symbols",
    "categoryName": "Medical Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan",
      "guide-dog"
    ]
  },
  {
    "symbol": "🌡",
    "slug": "thermometer",
    "codepoints": [
      127777
    ],
    "primary": 127777,
    "name": "Thermometer",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "medical-symbols",
    "categoryName": "Medical Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🦽",
    "slug": "manual-wheelchair",
    "codepoints": [
      129469
    ],
    "primary": 129469,
    "name": "Manual Wheelchair",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "medical-symbols",
    "categoryName": "Medical Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "motorized-wheelchair",
      "gorilla",
      "orangutan",
      "guide-dog"
    ]
  },
  {
    "symbol": "🦼",
    "slug": "motorized-wheelchair",
    "codepoints": [
      129468
    ],
    "primary": 129468,
    "name": "Motorized Wheelchair",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "medical-symbols",
    "categoryName": "Medical Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "gorilla",
      "orangutan",
      "guide-dog"
    ]
  },
  {
    "symbol": "🌲",
    "slug": "evergreen-tree",
    "codepoints": [
      127794
    ],
    "primary": 127794,
    "name": "Evergreen Tree",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "nature-symbols",
    "categoryName": "Nature Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🌳",
    "slug": "deciduous-tree",
    "codepoints": [
      127795
    ],
    "primary": 127795,
    "name": "Deciduous Tree",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "nature-symbols",
    "categoryName": "Nature Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🌴",
    "slug": "palm-tree",
    "codepoints": [
      127796
    ],
    "primary": 127796,
    "name": "Palm Tree",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "nature-symbols",
    "categoryName": "Nature Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🌵",
    "slug": "cactus",
    "codepoints": [
      127797
    ],
    "primary": 127797,
    "name": "Cactus",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "nature-symbols",
    "categoryName": "Nature Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🌱",
    "slug": "seedling",
    "codepoints": [
      127793
    ],
    "primary": 127793,
    "name": "Seedling",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "nature-symbols",
    "categoryName": "Nature Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🌿",
    "slug": "herb",
    "codepoints": [
      127807
    ],
    "primary": 127807,
    "name": "Herb",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "nature-symbols",
    "categoryName": "Nature Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "☘",
    "slug": "shamrock",
    "codepoints": [
      9752
    ],
    "primary": 9752,
    "name": "Shamrock",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "nature-symbols",
    "categoryName": "Nature Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "🍀",
    "slug": "four-leaf-clover",
    "codepoints": [
      127808
    ],
    "primary": 127808,
    "name": "Four Leaf Clover",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "nature-symbols",
    "categoryName": "Nature Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🍃",
    "slug": "leaf-fluttering-in-wind",
    "codepoints": [
      127811
    ],
    "primary": 127811,
    "name": "Leaf Fluttering In Wind",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "nature-symbols",
    "categoryName": "Nature Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🍂",
    "slug": "fallen-leaf",
    "codepoints": [
      127810
    ],
    "primary": 127810,
    "name": "Fallen Leaf",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "nature-symbols",
    "categoryName": "Nature Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🍁",
    "slug": "maple-leaf",
    "codepoints": [
      127809
    ],
    "primary": 127809,
    "name": "Maple Leaf",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "nature-symbols",
    "categoryName": "Nature Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🪴",
    "slug": "potted-plant",
    "codepoints": [
      129716
    ],
    "primary": 129716,
    "name": "Potted Plant",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Symbols And Pictographs Extended A",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "nature-symbols",
    "categoryName": "Nature Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "pink-heart",
      "light-blue-heart",
      "grey-heart",
      "stethoscope",
      "adhesive-bandage",
      "crutch",
      "x-ray",
      "drop-of-blood",
      "anatomical-heart",
      "lungs",
      "wood",
      "rock"
    ]
  },
  {
    "symbol": "🌾",
    "slug": "ear-of-rice",
    "codepoints": [
      127806
    ],
    "primary": 127806,
    "name": "Ear Of Rice",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "nature-symbols",
    "categoryName": "Nature Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🌰",
    "slug": "chestnut",
    "codepoints": [
      127792
    ],
    "primary": 127792,
    "name": "Chestnut",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "nature-symbols",
    "categoryName": "Nature Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🍄",
    "slug": "mushroom",
    "codepoints": [
      127812
    ],
    "primary": 127812,
    "name": "Mushroom",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "nature-symbols",
    "categoryName": "Nature Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🪵",
    "slug": "wood",
    "codepoints": [
      129717
    ],
    "primary": 129717,
    "name": "Wood",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Symbols And Pictographs Extended A",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "nature-symbols",
    "categoryName": "Nature Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "pink-heart",
      "light-blue-heart",
      "grey-heart",
      "stethoscope",
      "adhesive-bandage",
      "crutch",
      "x-ray",
      "drop-of-blood",
      "anatomical-heart",
      "lungs",
      "potted-plant",
      "rock"
    ]
  },
  {
    "symbol": "🪨",
    "slug": "rock",
    "codepoints": [
      129704
    ],
    "primary": 129704,
    "name": "Rock",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Symbols And Pictographs Extended A",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "nature-symbols",
    "categoryName": "Nature Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "pink-heart",
      "light-blue-heart",
      "grey-heart",
      "stethoscope",
      "adhesive-bandage",
      "crutch",
      "x-ray",
      "drop-of-blood",
      "anatomical-heart",
      "lungs",
      "potted-plant",
      "wood"
    ]
  },
  {
    "symbol": "🌍",
    "slug": "earth-globe-europe-africa",
    "codepoints": [
      127757
    ],
    "primary": 127757,
    "name": "Earth Globe Europe-Africa",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "nature-symbols",
    "categoryName": "Nature Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🌎",
    "slug": "earth-globe-americas",
    "codepoints": [
      127758
    ],
    "primary": 127758,
    "name": "Earth Globe Americas",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "nature-symbols",
    "categoryName": "Nature Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🌏",
    "slug": "earth-globe-asia-australia",
    "codepoints": [
      127759
    ],
    "primary": 127759,
    "name": "Earth Globe Asia-Australia",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "nature-symbols",
    "categoryName": "Nature Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🌋",
    "slug": "volcano",
    "codepoints": [
      127755
    ],
    "primary": 127755,
    "name": "Volcano",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "nature-symbols",
    "categoryName": "Nature Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "⛰",
    "slug": "mountain",
    "codepoints": [
      9968
    ],
    "primary": 9968,
    "name": "Mountain",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "nature-symbols",
    "categoryName": "Nature Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "🏔",
    "slug": "snow-capped-mountain",
    "codepoints": [
      127956
    ],
    "primary": 127956,
    "name": "Snow Capped Mountain",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "nature-symbols",
    "categoryName": "Nature Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🗻",
    "slug": "mount-fuji",
    "codepoints": [
      128507
    ],
    "primary": 128507,
    "name": "Mount Fuji",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "nature-symbols",
    "categoryName": "Nature Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🪺",
    "slug": "nest-with-eggs",
    "codepoints": [
      129722
    ],
    "primary": 129722,
    "name": "Nest With Eggs",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Symbols And Pictographs Extended A",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "nature-symbols",
    "categoryName": "Nature Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "pink-heart",
      "light-blue-heart",
      "grey-heart",
      "stethoscope",
      "adhesive-bandage",
      "crutch",
      "x-ray",
      "drop-of-blood",
      "anatomical-heart",
      "lungs",
      "potted-plant",
      "wood"
    ]
  },
  {
    "symbol": "🐵",
    "slug": "monkey-face",
    "codepoints": [
      128053
    ],
    "primary": 128053,
    "name": "Monkey Face",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐒",
    "slug": "monkey",
    "codepoints": [
      128018
    ],
    "primary": 128018,
    "name": "Monkey",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🦍",
    "slug": "gorilla",
    "codepoints": [
      129421
    ],
    "primary": 129421,
    "name": "Gorilla",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "orangutan",
      "guide-dog"
    ]
  },
  {
    "symbol": "🦧",
    "slug": "orangutan",
    "codepoints": [
      129447
    ],
    "primary": 129447,
    "name": "Orangutan",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "guide-dog"
    ]
  },
  {
    "symbol": "🐶",
    "slug": "dog-face",
    "codepoints": [
      128054
    ],
    "primary": 128054,
    "name": "Dog Face",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐕",
    "slug": "dog",
    "codepoints": [
      128021
    ],
    "primary": 128021,
    "name": "Dog",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🦮",
    "slug": "guide-dog",
    "codepoints": [
      129454
    ],
    "primary": 129454,
    "name": "Guide Dog",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🐩",
    "slug": "poodle",
    "codepoints": [
      128041
    ],
    "primary": 128041,
    "name": "Poodle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐺",
    "slug": "wolf-face",
    "codepoints": [
      128058
    ],
    "primary": 128058,
    "name": "Wolf Face",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🦊",
    "slug": "fox-face",
    "codepoints": [
      129418
    ],
    "primary": 129418,
    "name": "Fox Face",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🦝",
    "slug": "raccoon",
    "codepoints": [
      129437
    ],
    "primary": 129437,
    "name": "Raccoon",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🐱",
    "slug": "cat-face",
    "codepoints": [
      128049
    ],
    "primary": 128049,
    "name": "Cat Face",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐈",
    "slug": "cat",
    "codepoints": [
      128008
    ],
    "primary": 128008,
    "name": "Cat",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🦁",
    "slug": "lion-face",
    "codepoints": [
      129409
    ],
    "primary": 129409,
    "name": "Lion Face",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🐯",
    "slug": "tiger-face",
    "codepoints": [
      128047
    ],
    "primary": 128047,
    "name": "Tiger Face",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐅",
    "slug": "tiger",
    "codepoints": [
      128005
    ],
    "primary": 128005,
    "name": "Tiger",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐆",
    "slug": "leopard",
    "codepoints": [
      128006
    ],
    "primary": 128006,
    "name": "Leopard",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐴",
    "slug": "horse-face",
    "codepoints": [
      128052
    ],
    "primary": 128052,
    "name": "Horse Face",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🫎",
    "slug": "moose",
    "codepoints": [
      129742
    ],
    "primary": 129742,
    "name": "Moose",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Symbols And Pictographs Extended A",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "pink-heart",
      "light-blue-heart",
      "grey-heart",
      "stethoscope",
      "adhesive-bandage",
      "crutch",
      "x-ray",
      "drop-of-blood",
      "anatomical-heart",
      "lungs",
      "potted-plant",
      "wood"
    ]
  },
  {
    "symbol": "🐎",
    "slug": "horse",
    "codepoints": [
      128014
    ],
    "primary": 128014,
    "name": "Horse",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🦄",
    "slug": "unicorn-face",
    "codepoints": [
      129412
    ],
    "primary": 129412,
    "name": "Unicorn Face",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🦓",
    "slug": "zebra-face",
    "codepoints": [
      129427
    ],
    "primary": 129427,
    "name": "Zebra Face",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🦌",
    "slug": "deer",
    "codepoints": [
      129420
    ],
    "primary": 129420,
    "name": "Deer",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🦬",
    "slug": "bison",
    "codepoints": [
      129452
    ],
    "primary": 129452,
    "name": "Bison",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🐮",
    "slug": "cow-face",
    "codepoints": [
      128046
    ],
    "primary": 128046,
    "name": "Cow Face",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐂",
    "slug": "ox",
    "codepoints": [
      128002
    ],
    "primary": 128002,
    "name": "Ox",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐃",
    "slug": "water-buffalo",
    "codepoints": [
      128003
    ],
    "primary": 128003,
    "name": "Water Buffalo",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐄",
    "slug": "cow",
    "codepoints": [
      128004
    ],
    "primary": 128004,
    "name": "Cow",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐷",
    "slug": "pig-face",
    "codepoints": [
      128055
    ],
    "primary": 128055,
    "name": "Pig Face",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐖",
    "slug": "pig",
    "codepoints": [
      128022
    ],
    "primary": 128022,
    "name": "Pig",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐗",
    "slug": "boar",
    "codepoints": [
      128023
    ],
    "primary": 128023,
    "name": "Boar",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐽",
    "slug": "pig-nose",
    "codepoints": [
      128061
    ],
    "primary": 128061,
    "name": "Pig Nose",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐏",
    "slug": "ram",
    "codepoints": [
      128015
    ],
    "primary": 128015,
    "name": "Ram",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐑",
    "slug": "sheep",
    "codepoints": [
      128017
    ],
    "primary": 128017,
    "name": "Sheep",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐐",
    "slug": "goat",
    "codepoints": [
      128016
    ],
    "primary": 128016,
    "name": "Goat",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐪",
    "slug": "dromedary-camel",
    "codepoints": [
      128042
    ],
    "primary": 128042,
    "name": "Dromedary Camel",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐫",
    "slug": "bactrian-camel",
    "codepoints": [
      128043
    ],
    "primary": 128043,
    "name": "Bactrian Camel",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🦙",
    "slug": "llama",
    "codepoints": [
      129433
    ],
    "primary": 129433,
    "name": "Llama",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🦒",
    "slug": "giraffe-face",
    "codepoints": [
      129426
    ],
    "primary": 129426,
    "name": "Giraffe Face",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🐘",
    "slug": "elephant",
    "codepoints": [
      128024
    ],
    "primary": 128024,
    "name": "Elephant",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🦣",
    "slug": "mammoth",
    "codepoints": [
      129443
    ],
    "primary": 129443,
    "name": "Mammoth",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🦏",
    "slug": "rhinoceros",
    "codepoints": [
      129423
    ],
    "primary": 129423,
    "name": "Rhinoceros",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🦛",
    "slug": "hippopotamus",
    "codepoints": [
      129435
    ],
    "primary": 129435,
    "name": "Hippopotamus",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🐭",
    "slug": "mouse-face",
    "codepoints": [
      128045
    ],
    "primary": 128045,
    "name": "Mouse Face",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐁",
    "slug": "mouse",
    "codepoints": [
      128001
    ],
    "primary": 128001,
    "name": "Mouse",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐀",
    "slug": "rat",
    "codepoints": [
      128000
    ],
    "primary": 128000,
    "name": "Rat",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐹",
    "slug": "hamster-face",
    "codepoints": [
      128057
    ],
    "primary": 128057,
    "name": "Hamster Face",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐰",
    "slug": "rabbit-face",
    "codepoints": [
      128048
    ],
    "primary": 128048,
    "name": "Rabbit Face",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐇",
    "slug": "rabbit",
    "codepoints": [
      128007
    ],
    "primary": 128007,
    "name": "Rabbit",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐿",
    "slug": "chipmunk",
    "codepoints": [
      128063
    ],
    "primary": 128063,
    "name": "Chipmunk",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🦫",
    "slug": "beaver",
    "codepoints": [
      129451
    ],
    "primary": 129451,
    "name": "Beaver",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🦔",
    "slug": "hedgehog",
    "codepoints": [
      129428
    ],
    "primary": 129428,
    "name": "Hedgehog",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🦇",
    "slug": "bat",
    "codepoints": [
      129415
    ],
    "primary": 129415,
    "name": "Bat",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🐻",
    "slug": "bear-face",
    "codepoints": [
      128059
    ],
    "primary": 128059,
    "name": "Bear Face",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐨",
    "slug": "koala",
    "codepoints": [
      128040
    ],
    "primary": 128040,
    "name": "Koala",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐼",
    "slug": "panda-face",
    "codepoints": [
      128060
    ],
    "primary": 128060,
    "name": "Panda Face",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🦥",
    "slug": "sloth",
    "codepoints": [
      129445
    ],
    "primary": 129445,
    "name": "Sloth",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🦦",
    "slug": "otter",
    "codepoints": [
      129446
    ],
    "primary": 129446,
    "name": "Otter",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🦨",
    "slug": "skunk",
    "codepoints": [
      129448
    ],
    "primary": 129448,
    "name": "Skunk",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🦘",
    "slug": "kangaroo",
    "codepoints": [
      129432
    ],
    "primary": 129432,
    "name": "Kangaroo",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🦡",
    "slug": "badger",
    "codepoints": [
      129441
    ],
    "primary": 129441,
    "name": "Badger",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🐾",
    "slug": "paw-prints",
    "codepoints": [
      128062
    ],
    "primary": 128062,
    "name": "Paw Prints",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🦃",
    "slug": "turkey",
    "codepoints": [
      129411
    ],
    "primary": 129411,
    "name": "Turkey",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🐔",
    "slug": "chicken",
    "codepoints": [
      128020
    ],
    "primary": 128020,
    "name": "Chicken",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐓",
    "slug": "rooster",
    "codepoints": [
      128019
    ],
    "primary": 128019,
    "name": "Rooster",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐣",
    "slug": "hatching-chick",
    "codepoints": [
      128035
    ],
    "primary": 128035,
    "name": "Hatching Chick",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐤",
    "slug": "baby-chick",
    "codepoints": [
      128036
    ],
    "primary": 128036,
    "name": "Baby Chick",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐥",
    "slug": "front-facing-baby-chick",
    "codepoints": [
      128037
    ],
    "primary": 128037,
    "name": "Front-Facing Baby Chick",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐦",
    "slug": "bird",
    "codepoints": [
      128038
    ],
    "primary": 128038,
    "name": "Bird",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐧",
    "slug": "penguin",
    "codepoints": [
      128039
    ],
    "primary": 128039,
    "name": "Penguin",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🕊",
    "slug": "dove-of-peace",
    "codepoints": [
      128330
    ],
    "primary": 128330,
    "name": "Dove Of Peace",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🦅",
    "slug": "eagle",
    "codepoints": [
      129413
    ],
    "primary": 129413,
    "name": "Eagle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🦆",
    "slug": "duck",
    "codepoints": [
      129414
    ],
    "primary": 129414,
    "name": "Duck",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🦢",
    "slug": "swan",
    "codepoints": [
      129442
    ],
    "primary": 129442,
    "name": "Swan",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🦉",
    "slug": "owl",
    "codepoints": [
      129417
    ],
    "primary": 129417,
    "name": "Owl",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🦤",
    "slug": "dodo",
    "codepoints": [
      129444
    ],
    "primary": 129444,
    "name": "Dodo",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🪶",
    "slug": "feather",
    "codepoints": [
      129718
    ],
    "primary": 129718,
    "name": "Feather",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Symbols And Pictographs Extended A",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "pink-heart",
      "light-blue-heart",
      "grey-heart",
      "stethoscope",
      "adhesive-bandage",
      "crutch",
      "x-ray",
      "drop-of-blood",
      "anatomical-heart",
      "lungs",
      "potted-plant",
      "wood"
    ]
  },
  {
    "symbol": "🦩",
    "slug": "flamingo",
    "codepoints": [
      129449
    ],
    "primary": 129449,
    "name": "Flamingo",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🦚",
    "slug": "peacock",
    "codepoints": [
      129434
    ],
    "primary": 129434,
    "name": "Peacock",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🦜",
    "slug": "parrot",
    "codepoints": [
      129436
    ],
    "primary": 129436,
    "name": "Parrot",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🪽",
    "slug": "wing",
    "codepoints": [
      129725
    ],
    "primary": 129725,
    "name": "Wing",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Symbols And Pictographs Extended A",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "pink-heart",
      "light-blue-heart",
      "grey-heart",
      "stethoscope",
      "adhesive-bandage",
      "crutch",
      "x-ray",
      "drop-of-blood",
      "anatomical-heart",
      "lungs",
      "potted-plant",
      "wood"
    ]
  },
  {
    "symbol": "🪿",
    "slug": "goose",
    "codepoints": [
      129727
    ],
    "primary": 129727,
    "name": "Goose",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Symbols And Pictographs Extended A",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "pink-heart",
      "light-blue-heart",
      "grey-heart",
      "stethoscope",
      "adhesive-bandage",
      "crutch",
      "x-ray",
      "drop-of-blood",
      "anatomical-heart",
      "lungs",
      "potted-plant",
      "wood"
    ]
  },
  {
    "symbol": "🐸",
    "slug": "frog-face",
    "codepoints": [
      128056
    ],
    "primary": 128056,
    "name": "Frog Face",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐊",
    "slug": "crocodile",
    "codepoints": [
      128010
    ],
    "primary": 128010,
    "name": "Crocodile",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐢",
    "slug": "turtle",
    "codepoints": [
      128034
    ],
    "primary": 128034,
    "name": "Turtle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🦎",
    "slug": "lizard",
    "codepoints": [
      129422
    ],
    "primary": 129422,
    "name": "Lizard",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🐍",
    "slug": "snake",
    "codepoints": [
      128013
    ],
    "primary": 128013,
    "name": "Snake",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐲",
    "slug": "dragon-face",
    "codepoints": [
      128050
    ],
    "primary": 128050,
    "name": "Dragon Face",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐉",
    "slug": "dragon",
    "codepoints": [
      128009
    ],
    "primary": 128009,
    "name": "Dragon",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🦕",
    "slug": "sauropod",
    "codepoints": [
      129429
    ],
    "primary": 129429,
    "name": "Sauropod",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🦖",
    "slug": "t-rex",
    "codepoints": [
      129430
    ],
    "primary": 129430,
    "name": "T-Rex",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🐳",
    "slug": "spouting-whale",
    "codepoints": [
      128051
    ],
    "primary": 128051,
    "name": "Spouting Whale",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🦈",
    "slug": "shark",
    "codepoints": [
      129416
    ],
    "primary": 129416,
    "name": "Shark",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🐬",
    "slug": "dolphin",
    "codepoints": [
      128044
    ],
    "primary": 128044,
    "name": "Dolphin",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🦭",
    "slug": "seal",
    "codepoints": [
      129453
    ],
    "primary": 129453,
    "name": "Seal",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🐟",
    "slug": "fish",
    "codepoints": [
      128031
    ],
    "primary": 128031,
    "name": "Fish",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐠",
    "slug": "tropical-fish",
    "codepoints": [
      128032
    ],
    "primary": 128032,
    "name": "Tropical Fish",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐡",
    "slug": "blowfish",
    "codepoints": [
      128033
    ],
    "primary": 128033,
    "name": "Blowfish",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🪸",
    "slug": "coral",
    "codepoints": [
      129720
    ],
    "primary": 129720,
    "name": "Coral",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Symbols And Pictographs Extended A",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "pink-heart",
      "light-blue-heart",
      "grey-heart",
      "stethoscope",
      "adhesive-bandage",
      "crutch",
      "x-ray",
      "drop-of-blood",
      "anatomical-heart",
      "lungs",
      "potted-plant",
      "wood"
    ]
  },
  {
    "symbol": "🐙",
    "slug": "octopus",
    "codepoints": [
      128025
    ],
    "primary": 128025,
    "name": "Octopus",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐚",
    "slug": "spiral-shell",
    "codepoints": [
      128026
    ],
    "primary": 128026,
    "name": "Spiral Shell",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🪼",
    "slug": "jellyfish",
    "codepoints": [
      129724
    ],
    "primary": 129724,
    "name": "Jellyfish",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Symbols And Pictographs Extended A",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "pink-heart",
      "light-blue-heart",
      "grey-heart",
      "stethoscope",
      "adhesive-bandage",
      "crutch",
      "x-ray",
      "drop-of-blood",
      "anatomical-heart",
      "lungs",
      "potted-plant",
      "wood"
    ]
  },
  {
    "symbol": "🐌",
    "slug": "snail",
    "codepoints": [
      128012
    ],
    "primary": 128012,
    "name": "Snail",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🦋",
    "slug": "butterfly",
    "codepoints": [
      129419
    ],
    "primary": 129419,
    "name": "Butterfly",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🐛",
    "slug": "bug",
    "codepoints": [
      128027
    ],
    "primary": 128027,
    "name": "Bug",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐜",
    "slug": "ant",
    "codepoints": [
      128028
    ],
    "primary": 128028,
    "name": "Ant",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🐝",
    "slug": "honeybee",
    "codepoints": [
      128029
    ],
    "primary": 128029,
    "name": "Honeybee",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🪲",
    "slug": "beetle",
    "codepoints": [
      129714
    ],
    "primary": 129714,
    "name": "Beetle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Symbols And Pictographs Extended A",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "pink-heart",
      "light-blue-heart",
      "grey-heart",
      "stethoscope",
      "adhesive-bandage",
      "crutch",
      "x-ray",
      "drop-of-blood",
      "anatomical-heart",
      "lungs",
      "potted-plant",
      "wood"
    ]
  },
  {
    "symbol": "🐞",
    "slug": "lady-beetle",
    "codepoints": [
      128030
    ],
    "primary": 128030,
    "name": "Lady Beetle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🦗",
    "slug": "cricket",
    "codepoints": [
      129431
    ],
    "primary": 129431,
    "name": "Cricket",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🪳",
    "slug": "cockroach",
    "codepoints": [
      129715
    ],
    "primary": 129715,
    "name": "Cockroach",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Symbols And Pictographs Extended A",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "pink-heart",
      "light-blue-heart",
      "grey-heart",
      "stethoscope",
      "adhesive-bandage",
      "crutch",
      "x-ray",
      "drop-of-blood",
      "anatomical-heart",
      "lungs",
      "potted-plant",
      "wood"
    ]
  },
  {
    "symbol": "🕷",
    "slug": "spider",
    "codepoints": [
      128375
    ],
    "primary": 128375,
    "name": "Spider",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🕸",
    "slug": "spider-web",
    "codepoints": [
      128376
    ],
    "primary": 128376,
    "name": "Spider Web",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🦂",
    "slug": "scorpion",
    "codepoints": [
      129410
    ],
    "primary": 129410,
    "name": "Scorpion",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🦟",
    "slug": "mosquito",
    "codepoints": [
      129439
    ],
    "primary": 129439,
    "name": "Mosquito",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🪰",
    "slug": "fly",
    "codepoints": [
      129712
    ],
    "primary": 129712,
    "name": "Fly",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Symbols And Pictographs Extended A",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "animal-symbols",
    "categoryName": "Animal Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "pink-heart",
      "light-blue-heart",
      "grey-heart",
      "stethoscope",
      "adhesive-bandage",
      "crutch",
      "x-ray",
      "drop-of-blood",
      "anatomical-heart",
      "lungs",
      "potted-plant",
      "wood"
    ]
  },
  {
    "symbol": "🌸",
    "slug": "cherry-blossom",
    "codepoints": [
      127800
    ],
    "primary": 127800,
    "name": "Cherry Blossom",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "flower-symbols",
    "categoryName": "Flower Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🌺",
    "slug": "hibiscus",
    "codepoints": [
      127802
    ],
    "primary": 127802,
    "name": "Hibiscus",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "flower-symbols",
    "categoryName": "Flower Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🌻",
    "slug": "sunflower",
    "codepoints": [
      127803
    ],
    "primary": 127803,
    "name": "Sunflower",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "flower-symbols",
    "categoryName": "Flower Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🌷",
    "slug": "tulip",
    "codepoints": [
      127799
    ],
    "primary": 127799,
    "name": "Tulip",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "flower-symbols",
    "categoryName": "Flower Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🌹",
    "slug": "rose",
    "codepoints": [
      127801
    ],
    "primary": 127801,
    "name": "Rose",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "flower-symbols",
    "categoryName": "Flower Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🌼",
    "slug": "blossom",
    "codepoints": [
      127804
    ],
    "primary": 127804,
    "name": "Blossom",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "flower-symbols",
    "categoryName": "Flower Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "💐",
    "slug": "bouquet",
    "codepoints": [
      128144
    ],
    "primary": 128144,
    "name": "Bouquet",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "flower-symbols",
    "categoryName": "Flower Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🏵",
    "slug": "rosette",
    "codepoints": [
      127989
    ],
    "primary": 127989,
    "name": "Rosette",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "flower-symbols",
    "categoryName": "Flower Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🪷",
    "slug": "lotus",
    "codepoints": [
      129719
    ],
    "primary": 129719,
    "name": "Lotus",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Symbols And Pictographs Extended A",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "flower-symbols",
    "categoryName": "Flower Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "pink-heart",
      "light-blue-heart",
      "grey-heart",
      "stethoscope",
      "adhesive-bandage",
      "crutch",
      "x-ray",
      "drop-of-blood",
      "anatomical-heart",
      "lungs",
      "potted-plant",
      "wood"
    ]
  },
  {
    "symbol": "🥀",
    "slug": "wilted-flower",
    "codepoints": [
      129344
    ],
    "primary": 129344,
    "name": "Wilted Flower",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "flower-symbols",
    "categoryName": "Flower Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "⚘",
    "slug": "flower",
    "codepoints": [
      9880
    ],
    "primary": 9880,
    "name": "Flower",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "flower-symbols",
    "categoryName": "Flower Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "❀",
    "slug": "white-florette",
    "codepoints": [
      10048
    ],
    "primary": 10048,
    "name": "White Florette",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "flower-symbols",
    "categoryName": "Flower Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "✿",
    "slug": "black-florette",
    "codepoints": [
      10047
    ],
    "primary": 10047,
    "name": "Black Florette",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "flower-symbols",
    "categoryName": "Flower Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "❁",
    "slug": "eight-petalled-outlined-black-florette",
    "codepoints": [
      10049
    ],
    "primary": 10049,
    "name": "Eight Petalled Outlined Black Florette",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "flower-symbols",
    "categoryName": "Flower Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "💮",
    "slug": "white-flower",
    "codepoints": [
      128174
    ],
    "primary": 128174,
    "name": "White Flower",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "flower-symbols",
    "categoryName": "Flower Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🪻",
    "slug": "hyacinth",
    "codepoints": [
      129723
    ],
    "primary": 129723,
    "name": "Hyacinth",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Symbols And Pictographs Extended A",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "flower-symbols",
    "categoryName": "Flower Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "pink-heart",
      "light-blue-heart",
      "grey-heart",
      "stethoscope",
      "adhesive-bandage",
      "crutch",
      "x-ray",
      "drop-of-blood",
      "anatomical-heart",
      "lungs",
      "potted-plant",
      "wood"
    ]
  },
  {
    "symbol": "✾",
    "slug": "six-petalled-black-and-white-florette",
    "codepoints": [
      10046
    ],
    "primary": 10046,
    "name": "Six Petalled Black And White Florette",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "flower-symbols",
    "categoryName": "Flower Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "⚜",
    "slug": "fleur-de-lis",
    "codepoints": [
      9884
    ],
    "primary": 9884,
    "name": "Fleur-De-Lis",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "flower-symbols",
    "categoryName": "Flower Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "✝",
    "slug": "latin-cross",
    "codepoints": [
      10013
    ],
    "primary": 10013,
    "name": "Latin Cross",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "religious-symbols",
    "categoryName": "Religious Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "✞",
    "slug": "shadowed-white-latin-cross",
    "codepoints": [
      10014
    ],
    "primary": 10014,
    "name": "Shadowed White Latin Cross",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "religious-symbols",
    "categoryName": "Religious Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "✟",
    "slug": "outlined-latin-cross",
    "codepoints": [
      10015
    ],
    "primary": 10015,
    "name": "Outlined Latin Cross",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "religious-symbols",
    "categoryName": "Religious Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "☦",
    "slug": "orthodox-cross",
    "codepoints": [
      9766
    ],
    "primary": 9766,
    "name": "Orthodox Cross",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "religious-symbols",
    "categoryName": "Religious Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "☧",
    "slug": "chi-rho",
    "codepoints": [
      9767
    ],
    "primary": 9767,
    "name": "Chi Rho",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "religious-symbols",
    "categoryName": "Religious Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "☨",
    "slug": "cross-of-lorraine",
    "codepoints": [
      9768
    ],
    "primary": 9768,
    "name": "Cross Of Lorraine",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "religious-symbols",
    "categoryName": "Religious Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "☩",
    "slug": "cross-of-jerusalem",
    "codepoints": [
      9769
    ],
    "primary": 9769,
    "name": "Cross Of Jerusalem",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "religious-symbols",
    "categoryName": "Religious Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "✠",
    "slug": "maltese-cross",
    "codepoints": [
      10016
    ],
    "primary": 10016,
    "name": "Maltese Cross",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "religious-symbols",
    "categoryName": "Religious Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "✡",
    "slug": "star-of-david",
    "codepoints": [
      10017
    ],
    "primary": 10017,
    "name": "Star Of David",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "religious-symbols",
    "categoryName": "Religious Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "☪",
    "slug": "star-and-crescent",
    "codepoints": [
      9770
    ],
    "primary": 9770,
    "name": "Star And Crescent",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "religious-symbols",
    "categoryName": "Religious Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "☬",
    "slug": "adi-shakti",
    "codepoints": [
      9772
    ],
    "primary": 9772,
    "name": "Adi Shakti",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "religious-symbols",
    "categoryName": "Religious Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "☸",
    "slug": "wheel-of-dharma",
    "codepoints": [
      9784
    ],
    "primary": 9784,
    "name": "Wheel Of Dharma",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "religious-symbols",
    "categoryName": "Religious Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "☯",
    "slug": "yin-yang",
    "codepoints": [
      9775
    ],
    "primary": 9775,
    "name": "Yin Yang",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "religious-symbols",
    "categoryName": "Religious Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "☮",
    "slug": "peace-symbol",
    "codepoints": [
      9774
    ],
    "primary": 9774,
    "name": "Peace Symbol",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "religious-symbols",
    "categoryName": "Religious Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "☥",
    "slug": "ankh",
    "codepoints": [
      9765
    ],
    "primary": 9765,
    "name": "Ankh",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "religious-symbols",
    "categoryName": "Religious Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "🕉",
    "slug": "om-symbol",
    "codepoints": [
      128329
    ],
    "primary": 128329,
    "name": "Om Symbol",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "religious-symbols",
    "categoryName": "Religious Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🔯",
    "slug": "six-pointed-star-with-middle-dot",
    "codepoints": [
      128303
    ],
    "primary": 128303,
    "name": "Six Pointed Star With Middle Dot",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "religious-symbols",
    "categoryName": "Religious Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "⛤",
    "slug": "pentagram",
    "codepoints": [
      9956
    ],
    "primary": 9956,
    "name": "Pentagram",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "religious-symbols",
    "categoryName": "Religious Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "⛪",
    "slug": "church",
    "codepoints": [
      9962
    ],
    "primary": 9962,
    "name": "Church",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "religious-symbols",
    "categoryName": "Religious Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "🕌",
    "slug": "mosque",
    "codepoints": [
      128332
    ],
    "primary": 128332,
    "name": "Mosque",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "religious-symbols",
    "categoryName": "Religious Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🕍",
    "slug": "synagogue",
    "codepoints": [
      128333
    ],
    "primary": 128333,
    "name": "Synagogue",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "religious-symbols",
    "categoryName": "Religious Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🛕",
    "slug": "hindu-temple",
    "codepoints": [
      128725
    ],
    "primary": 128725,
    "name": "Hindu Temple",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "religious-symbols",
    "categoryName": "Religious Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "mens-symbol",
      "womens-symbol",
      "restroom",
      "baby-symbol"
    ]
  },
  {
    "symbol": "🕋",
    "slug": "kaaba",
    "codepoints": [
      128331
    ],
    "primary": 128331,
    "name": "Kaaba",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "religious-symbols",
    "categoryName": "Religious Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "📿",
    "slug": "prayer-beads",
    "codepoints": [
      128255
    ],
    "primary": 128255,
    "name": "Prayer Beads",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "religious-symbols",
    "categoryName": "Religious Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "♰",
    "slug": "west-syriac-cross",
    "codepoints": [
      9840
    ],
    "primary": 9840,
    "name": "West Syriac Cross",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "religious-symbols",
    "categoryName": "Religious Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♱",
    "slug": "east-syriac-cross",
    "codepoints": [
      9841
    ],
    "primary": 9841,
    "name": "East Syriac Cross",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "religious-symbols",
    "categoryName": "Religious Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "☫",
    "slug": "farsi-symbol",
    "codepoints": [
      9771
    ],
    "primary": 9771,
    "name": "Farsi Symbol",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "religious-symbols",
    "categoryName": "Religious Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "🕎",
    "slug": "menorah-with-nine-branches",
    "codepoints": [
      128334
    ],
    "primary": 128334,
    "name": "Menorah With Nine Branches",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "religious-symbols",
    "categoryName": "Religious Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "⛨",
    "slug": "black-cross-on-shield",
    "codepoints": [
      9960
    ],
    "primary": 9960,
    "name": "Black Cross On Shield",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "religious-symbols",
    "categoryName": "Religious Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♀",
    "slug": "female-sign",
    "codepoints": [
      9792
    ],
    "primary": 9792,
    "name": "Female Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "gender-symbols",
    "categoryName": "Gender Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "♂",
    "slug": "male-sign",
    "codepoints": [
      9794
    ],
    "primary": 9794,
    "name": "Male Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "gender-symbols",
    "categoryName": "Gender Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "⚢",
    "slug": "doubled-female-sign",
    "codepoints": [
      9890
    ],
    "primary": 9890,
    "name": "Doubled Female Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "gender-symbols",
    "categoryName": "Gender Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "⚣",
    "slug": "doubled-male-sign",
    "codepoints": [
      9891
    ],
    "primary": 9891,
    "name": "Doubled Male Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "gender-symbols",
    "categoryName": "Gender Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "⚤",
    "slug": "interlocked-female-and-male-sign",
    "codepoints": [
      9892
    ],
    "primary": 9892,
    "name": "Interlocked Female And Male Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "gender-symbols",
    "categoryName": "Gender Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "⚥",
    "slug": "male-and-female-sign",
    "codepoints": [
      9893
    ],
    "primary": 9893,
    "name": "Male And Female Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "gender-symbols",
    "categoryName": "Gender Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "⚦",
    "slug": "male-with-stroke-sign",
    "codepoints": [
      9894
    ],
    "primary": 9894,
    "name": "Male With Stroke Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "gender-symbols",
    "categoryName": "Gender Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "⚧",
    "slug": "male-with-stroke-and-male-and-female-sign",
    "codepoints": [
      9895
    ],
    "primary": 9895,
    "name": "Male With Stroke And Male And Female Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "gender-symbols",
    "categoryName": "Gender Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "⚨",
    "slug": "vertical-male-with-stroke-sign",
    "codepoints": [
      9896
    ],
    "primary": 9896,
    "name": "Vertical Male With Stroke Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "gender-symbols",
    "categoryName": "Gender Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "⚩",
    "slug": "horizontal-male-with-stroke-sign",
    "codepoints": [
      9897
    ],
    "primary": 9897,
    "name": "Horizontal Male With Stroke Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "gender-symbols",
    "categoryName": "Gender Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "⚲",
    "slug": "neuter",
    "codepoints": [
      9906
    ],
    "primary": 9906,
    "name": "Neuter",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "gender-symbols",
    "categoryName": "Gender Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "⚭",
    "slug": "marriage-symbol",
    "codepoints": [
      9901
    ],
    "primary": 9901,
    "name": "Marriage Symbol",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "gender-symbols",
    "categoryName": "Gender Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "⚮",
    "slug": "divorce-symbol",
    "codepoints": [
      9902
    ],
    "primary": 9902,
    "name": "Divorce Symbol",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "gender-symbols",
    "categoryName": "Gender Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "⚯",
    "slug": "unmarried-partnership-symbol",
    "codepoints": [
      9903
    ],
    "primary": 9903,
    "name": "Unmarried Partnership Symbol",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "gender-symbols",
    "categoryName": "Gender Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "🚹",
    "slug": "mens-symbol",
    "codepoints": [
      128697
    ],
    "primary": 128697,
    "name": "Mens Symbol",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "gender-symbols",
    "categoryName": "Gender Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "womens-symbol",
      "restroom",
      "baby-symbol"
    ]
  },
  {
    "symbol": "🚺",
    "slug": "womens-symbol",
    "codepoints": [
      128698
    ],
    "primary": 128698,
    "name": "Womens Symbol",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "gender-symbols",
    "categoryName": "Gender Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "restroom",
      "baby-symbol"
    ]
  },
  {
    "symbol": "🚻",
    "slug": "restroom",
    "codepoints": [
      128699
    ],
    "primary": 128699,
    "name": "Restroom",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "gender-symbols",
    "categoryName": "Gender Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "baby-symbol"
    ]
  },
  {
    "symbol": "🚼",
    "slug": "baby-symbol",
    "codepoints": [
      128700
    ],
    "primary": 128700,
    "name": "Baby Symbol",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "gender-symbols",
    "categoryName": "Gender Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom"
    ]
  },
  {
    "symbol": "©",
    "slug": "copyright-sign",
    "codepoints": [
      169
    ],
    "primary": 169,
    "name": "Copyright Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Latin 1 Supplement",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "office-copyright-trademark-symbols",
    "categoryName": "Office, Copyright and Trademark Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "multiplication-sign",
      "division-sign",
      "plus-minus-sign",
      "not-sign",
      "pound-sign",
      "yen-sign",
      "cent-sign",
      "middle-dot",
      "pilcrow-sign",
      "section-sign",
      "inverted-question-mark",
      "inverted-exclamation-mark"
    ]
  },
  {
    "symbol": "®",
    "slug": "registered-sign",
    "codepoints": [
      174
    ],
    "primary": 174,
    "name": "Registered Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Latin 1 Supplement",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "office-copyright-trademark-symbols",
    "categoryName": "Office, Copyright and Trademark Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "multiplication-sign",
      "division-sign",
      "plus-minus-sign",
      "not-sign",
      "pound-sign",
      "yen-sign",
      "cent-sign",
      "middle-dot",
      "pilcrow-sign",
      "section-sign",
      "inverted-question-mark",
      "inverted-exclamation-mark"
    ]
  },
  {
    "symbol": "™",
    "slug": "trade-mark-sign",
    "codepoints": [
      8482
    ],
    "primary": 8482,
    "name": "Trade Mark Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Letterlike Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "office-copyright-trademark-symbols",
    "categoryName": "Office, Copyright and Trademark Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "service-mark",
      "sound-recording-copyright",
      "numero-sign",
      "care-of"
    ]
  },
  {
    "symbol": "℠",
    "slug": "service-mark",
    "codepoints": [
      8480
    ],
    "primary": 8480,
    "name": "Service Mark",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Letterlike Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "office-copyright-trademark-symbols",
    "categoryName": "Office, Copyright and Trademark Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "trade-mark-sign",
      "sound-recording-copyright",
      "numero-sign",
      "care-of"
    ]
  },
  {
    "symbol": "℗",
    "slug": "sound-recording-copyright",
    "codepoints": [
      8471
    ],
    "primary": 8471,
    "name": "Sound Recording Copyright",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Letterlike Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "office-copyright-trademark-symbols",
    "categoryName": "Office, Copyright and Trademark Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "trade-mark-sign",
      "service-mark",
      "numero-sign",
      "care-of"
    ]
  },
  {
    "symbol": "№",
    "slug": "numero-sign",
    "codepoints": [
      8470
    ],
    "primary": 8470,
    "name": "Numero Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Letterlike Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "office-copyright-trademark-symbols",
    "categoryName": "Office, Copyright and Trademark Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "trade-mark-sign",
      "service-mark",
      "sound-recording-copyright",
      "care-of"
    ]
  },
  {
    "symbol": "℅",
    "slug": "care-of",
    "codepoints": [
      8453
    ],
    "primary": 8453,
    "name": "Care Of",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Letterlike Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "office-copyright-trademark-symbols",
    "categoryName": "Office, Copyright and Trademark Symbols",
    "isEmoji": false,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": false,
    "defaultPresentation": null,
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "trade-mark-sign",
      "service-mark",
      "sound-recording-copyright",
      "numero-sign"
    ]
  },
  {
    "symbol": "📎",
    "slug": "paperclip",
    "codepoints": [
      128206
    ],
    "primary": 128206,
    "name": "Paperclip",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "office-copyright-trademark-symbols",
    "categoryName": "Office, Copyright and Trademark Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "📌",
    "slug": "pushpin",
    "codepoints": [
      128204
    ],
    "primary": 128204,
    "name": "Pushpin",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "office-copyright-trademark-symbols",
    "categoryName": "Office, Copyright and Trademark Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "📍",
    "slug": "round-pushpin",
    "codepoints": [
      128205
    ],
    "primary": 128205,
    "name": "Round Pushpin",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "office-copyright-trademark-symbols",
    "categoryName": "Office, Copyright and Trademark Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "📋",
    "slug": "clipboard",
    "codepoints": [
      128203
    ],
    "primary": 128203,
    "name": "Clipboard",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "office-copyright-trademark-symbols",
    "categoryName": "Office, Copyright and Trademark Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "📁",
    "slug": "file-folder",
    "codepoints": [
      128193
    ],
    "primary": 128193,
    "name": "File Folder",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "office-copyright-trademark-symbols",
    "categoryName": "Office, Copyright and Trademark Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "📂",
    "slug": "open-file-folder",
    "codepoints": [
      128194
    ],
    "primary": 128194,
    "name": "Open File Folder",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "office-copyright-trademark-symbols",
    "categoryName": "Office, Copyright and Trademark Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "📅",
    "slug": "calendar",
    "codepoints": [
      128197
    ],
    "primary": 128197,
    "name": "Calendar",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "office-copyright-trademark-symbols",
    "categoryName": "Office, Copyright and Trademark Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "📈",
    "slug": "chart-with-upwards-trend",
    "codepoints": [
      128200
    ],
    "primary": 128200,
    "name": "Chart With Upwards Trend",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "office-copyright-trademark-symbols",
    "categoryName": "Office, Copyright and Trademark Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "📉",
    "slug": "chart-with-downwards-trend",
    "codepoints": [
      128201
    ],
    "primary": 128201,
    "name": "Chart With Downwards Trend",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "office-copyright-trademark-symbols",
    "categoryName": "Office, Copyright and Trademark Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "📊",
    "slug": "bar-chart",
    "codepoints": [
      128202
    ],
    "primary": 128202,
    "name": "Bar Chart",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "office-copyright-trademark-symbols",
    "categoryName": "Office, Copyright and Trademark Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "💼",
    "slug": "briefcase",
    "codepoints": [
      128188
    ],
    "primary": 128188,
    "name": "Briefcase",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "office-copyright-trademark-symbols",
    "categoryName": "Office, Copyright and Trademark Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "📐",
    "slug": "triangular-ruler",
    "codepoints": [
      128208
    ],
    "primary": 128208,
    "name": "Triangular Ruler",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "office-copyright-trademark-symbols",
    "categoryName": "Office, Copyright and Trademark Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "📏",
    "slug": "straight-ruler",
    "codepoints": [
      128207
    ],
    "primary": 128207,
    "name": "Straight Ruler",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "office-copyright-trademark-symbols",
    "categoryName": "Office, Copyright and Trademark Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "✂",
    "slug": "black-scissors",
    "codepoints": [
      9986
    ],
    "primary": 9986,
    "name": "Black Scissors",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "office-copyright-trademark-symbols",
    "categoryName": "Office, Copyright and Trademark Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "📝",
    "slug": "memo",
    "codepoints": [
      128221
    ],
    "primary": 128221,
    "name": "Memo",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "office-copyright-trademark-symbols",
    "categoryName": "Office, Copyright and Trademark Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🖨",
    "slug": "printer",
    "codepoints": [
      128424
    ],
    "primary": 128424,
    "name": "Printer",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "office-copyright-trademark-symbols",
    "categoryName": "Office, Copyright and Trademark Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🖇",
    "slug": "linked-paperclips",
    "codepoints": [
      128391
    ],
    "primary": 128391,
    "name": "Linked Paperclips",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "office-copyright-trademark-symbols",
    "categoryName": "Office, Copyright and Trademark Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🚗",
    "slug": "automobile",
    "codepoints": [
      128663
    ],
    "primary": 128663,
    "name": "Automobile",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom"
    ]
  },
  {
    "symbol": "🚕",
    "slug": "taxi",
    "codepoints": [
      128661
    ],
    "primary": 128661,
    "name": "Taxi",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom"
    ]
  },
  {
    "symbol": "🚌",
    "slug": "bus",
    "codepoints": [
      128652
    ],
    "primary": 128652,
    "name": "Bus",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom"
    ]
  },
  {
    "symbol": "🚑",
    "slug": "ambulance",
    "codepoints": [
      128657
    ],
    "primary": 128657,
    "name": "Ambulance",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom"
    ]
  },
  {
    "symbol": "🚒",
    "slug": "fire-engine",
    "codepoints": [
      128658
    ],
    "primary": 128658,
    "name": "Fire Engine",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom"
    ]
  },
  {
    "symbol": "🚓",
    "slug": "police-car",
    "codepoints": [
      128659
    ],
    "primary": 128659,
    "name": "Police Car",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom"
    ]
  },
  {
    "symbol": "🚚",
    "slug": "delivery-truck",
    "codepoints": [
      128666
    ],
    "primary": 128666,
    "name": "Delivery Truck",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom"
    ]
  },
  {
    "symbol": "🚜",
    "slug": "tractor",
    "codepoints": [
      128668
    ],
    "primary": 128668,
    "name": "Tractor",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom"
    ]
  },
  {
    "symbol": "🏍",
    "slug": "racing-motorcycle",
    "codepoints": [
      127949
    ],
    "primary": 127949,
    "name": "Racing Motorcycle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🚲",
    "slug": "bicycle",
    "codepoints": [
      128690
    ],
    "primary": 128690,
    "name": "Bicycle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom"
    ]
  },
  {
    "symbol": "🚂",
    "slug": "steam-locomotive",
    "codepoints": [
      128642
    ],
    "primary": 128642,
    "name": "Steam Locomotive",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom"
    ]
  },
  {
    "symbol": "🚆",
    "slug": "train",
    "codepoints": [
      128646
    ],
    "primary": 128646,
    "name": "Train",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom"
    ]
  },
  {
    "symbol": "🚄",
    "slug": "high-speed-train",
    "codepoints": [
      128644
    ],
    "primary": 128644,
    "name": "High-Speed Train",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom"
    ]
  },
  {
    "symbol": "🚇",
    "slug": "metro",
    "codepoints": [
      128647
    ],
    "primary": 128647,
    "name": "Metro",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom"
    ]
  },
  {
    "symbol": "🚊",
    "slug": "tram",
    "codepoints": [
      128650
    ],
    "primary": 128650,
    "name": "Tram",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom"
    ]
  },
  {
    "symbol": "✈",
    "slug": "airplane",
    "codepoints": [
      9992
    ],
    "primary": 9992,
    "name": "Airplane",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "🚁",
    "slug": "helicopter",
    "codepoints": [
      128641
    ],
    "primary": 128641,
    "name": "Helicopter",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom"
    ]
  },
  {
    "symbol": "🚀",
    "slug": "rocket",
    "codepoints": [
      128640
    ],
    "primary": 128640,
    "name": "Rocket",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom"
    ]
  },
  {
    "symbol": "🛸",
    "slug": "flying-saucer",
    "codepoints": [
      128760
    ],
    "primary": 128760,
    "name": "Flying Saucer",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom"
    ]
  },
  {
    "symbol": "⛵",
    "slug": "sailboat",
    "codepoints": [
      9973
    ],
    "primary": 9973,
    "name": "Sailboat",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "⛴",
    "slug": "ferry",
    "codepoints": [
      9972
    ],
    "primary": 9972,
    "name": "Ferry",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "🚢",
    "slug": "ship",
    "codepoints": [
      128674
    ],
    "primary": 128674,
    "name": "Ship",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom"
    ]
  },
  {
    "symbol": "⚓",
    "slug": "anchor",
    "codepoints": [
      9875
    ],
    "primary": 9875,
    "name": "Anchor",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "🗺",
    "slug": "world-map",
    "codepoints": [
      128506
    ],
    "primary": 128506,
    "name": "World Map",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🧭",
    "slug": "compass",
    "codepoints": [
      129517
    ],
    "primary": 129517,
    "name": "Compass",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🛣",
    "slug": "motorway",
    "codepoints": [
      128739
    ],
    "primary": 128739,
    "name": "Motorway",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom"
    ]
  },
  {
    "symbol": "🛤",
    "slug": "railway-track",
    "codepoints": [
      128740
    ],
    "primary": 128740,
    "name": "Railway Track",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom"
    ]
  },
  {
    "symbol": "🚦",
    "slug": "vertical-traffic-light",
    "codepoints": [
      128678
    ],
    "primary": 128678,
    "name": "Vertical Traffic Light",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom"
    ]
  },
  {
    "symbol": "⛽",
    "slug": "fuel-pump",
    "codepoints": [
      9981
    ],
    "primary": 9981,
    "name": "Fuel Pump",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "🚧",
    "slug": "construction-sign",
    "codepoints": [
      128679
    ],
    "primary": 128679,
    "name": "Construction Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom"
    ]
  },
  {
    "symbol": "🚙",
    "slug": "recreational-vehicle",
    "codepoints": [
      128665
    ],
    "primary": 128665,
    "name": "Recreational Vehicle",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom"
    ]
  },
  {
    "symbol": "🚐",
    "slug": "minibus",
    "codepoints": [
      128656
    ],
    "primary": 128656,
    "name": "Minibus",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom"
    ]
  },
  {
    "symbol": "🚛",
    "slug": "articulated-lorry",
    "codepoints": [
      128667
    ],
    "primary": 128667,
    "name": "Articulated Lorry",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom"
    ]
  },
  {
    "symbol": "🛻",
    "slug": "pickup-truck",
    "codepoints": [
      128763
    ],
    "primary": 128763,
    "name": "Pickup Truck",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom"
    ]
  },
  {
    "symbol": "🏎",
    "slug": "racing-car",
    "codepoints": [
      127950
    ],
    "primary": 127950,
    "name": "Racing Car",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🚝",
    "slug": "monorail",
    "codepoints": [
      128669
    ],
    "primary": 128669,
    "name": "Monorail",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom"
    ]
  },
  {
    "symbol": "🚞",
    "slug": "mountain-railway",
    "codepoints": [
      128670
    ],
    "primary": 128670,
    "name": "Mountain Railway",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom"
    ]
  },
  {
    "symbol": "🚋",
    "slug": "tram-car",
    "codepoints": [
      128651
    ],
    "primary": 128651,
    "name": "Tram Car",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom"
    ]
  },
  {
    "symbol": "🚉",
    "slug": "station",
    "codepoints": [
      128649
    ],
    "primary": 128649,
    "name": "Station",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom"
    ]
  },
  {
    "symbol": "🛺",
    "slug": "auto-rickshaw",
    "codepoints": [
      128762
    ],
    "primary": 128762,
    "name": "Auto Rickshaw",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom"
    ]
  },
  {
    "symbol": "🛵",
    "slug": "motor-scooter",
    "codepoints": [
      128757
    ],
    "primary": 128757,
    "name": "Motor Scooter",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom"
    ]
  },
  {
    "symbol": "🚏",
    "slug": "bus-stop",
    "codepoints": [
      128655
    ],
    "primary": 128655,
    "name": "Bus Stop",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Transport And Map Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "transport-map-symbols",
    "categoryName": "Transport and Map Symbols",
    "isEmoji": true,
    "isEmojiModifierBase": false,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "no-entry-sign",
      "octagonal-sign",
      "children-crossing",
      "no-pedestrians",
      "no-smoking-symbol",
      "no-bicycles",
      "non-potable-water-symbol",
      "do-not-litter-symbol",
      "hindu-temple",
      "mens-symbol",
      "womens-symbol",
      "restroom"
    ]
  },
  {
    "symbol": "👋",
    "slug": "waving-hand-sign",
    "codepoints": [
      128075
    ],
    "primary": 128075,
    "name": "Waving Hand Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "✋",
    "slug": "raised-hand",
    "codepoints": [
      9995
    ],
    "primary": 9995,
    "name": "Raised Hand",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "🤚",
    "slug": "raised-back-of-hand",
    "codepoints": [
      129306
    ],
    "primary": 129306,
    "name": "Raised Back Of Hand",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🖐",
    "slug": "raised-hand-with-fingers-splayed",
    "codepoints": [
      128400
    ],
    "primary": 128400,
    "name": "Raised Hand With Fingers Splayed",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🖖",
    "slug": "raised-hand-with-part-between-middle-and-ring-fingers",
    "codepoints": [
      128406
    ],
    "primary": 128406,
    "name": "Raised Hand With Part Between Middle And Ring Fingers",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "👌",
    "slug": "ok-hand-sign",
    "codepoints": [
      128076
    ],
    "primary": 128076,
    "name": "Ok Hand Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🤌",
    "slug": "pinched-fingers",
    "codepoints": [
      129292
    ],
    "primary": 129292,
    "name": "Pinched Fingers",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🤏",
    "slug": "pinching-hand",
    "codepoints": [
      129295
    ],
    "primary": 129295,
    "name": "Pinching Hand",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "✌",
    "slug": "victory-hand",
    "codepoints": [
      9996
    ],
    "primary": 9996,
    "name": "Victory Hand",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "🤞",
    "slug": "hand-with-index-and-middle-fingers-crossed",
    "codepoints": [
      129310
    ],
    "primary": 129310,
    "name": "Hand With Index And Middle Fingers Crossed",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🤟",
    "slug": "i-love-you-hand-sign",
    "codepoints": [
      129311
    ],
    "primary": 129311,
    "name": "I Love You Hand Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🤘",
    "slug": "sign-of-the-horns",
    "codepoints": [
      129304
    ],
    "primary": 129304,
    "name": "Sign Of The Horns",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🤙",
    "slug": "call-me-hand",
    "codepoints": [
      129305
    ],
    "primary": 129305,
    "name": "Call Me Hand",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "👈",
    "slug": "white-left-pointing-backhand-index",
    "codepoints": [
      128072
    ],
    "primary": 128072,
    "name": "White Left Pointing Backhand Index",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "👉",
    "slug": "white-right-pointing-backhand-index",
    "codepoints": [
      128073
    ],
    "primary": 128073,
    "name": "White Right Pointing Backhand Index",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "👆",
    "slug": "white-up-pointing-backhand-index",
    "codepoints": [
      128070
    ],
    "primary": 128070,
    "name": "White Up Pointing Backhand Index",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🖕",
    "slug": "reversed-hand-with-middle-finger-extended",
    "codepoints": [
      128405
    ],
    "primary": 128405,
    "name": "Reversed Hand With Middle Finger Extended",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "👇",
    "slug": "white-down-pointing-backhand-index",
    "codepoints": [
      128071
    ],
    "primary": 128071,
    "name": "White Down Pointing Backhand Index",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "☝",
    "slug": "white-up-pointing-index",
    "codepoints": [
      9757
    ],
    "primary": 9757,
    "name": "White Up Pointing Index",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "black-heart-suit",
      "white-heart-suit",
      "black-star",
      "white-star",
      "outlined-white-star",
      "ballot-box-with-check",
      "ballot-box",
      "ballot-box-with-x",
      "saltire",
      "aries",
      "taurus",
      "gemini"
    ]
  },
  {
    "symbol": "👍",
    "slug": "thumbs-up-sign",
    "codepoints": [
      128077
    ],
    "primary": 128077,
    "name": "Thumbs Up Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "👎",
    "slug": "thumbs-down-sign",
    "codepoints": [
      128078
    ],
    "primary": 128078,
    "name": "Thumbs Down Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "✊",
    "slug": "raised-fist",
    "codepoints": [
      9994
    ],
    "primary": 9994,
    "name": "Raised Fist",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "👊",
    "slug": "fisted-hand-sign",
    "codepoints": [
      128074
    ],
    "primary": 128074,
    "name": "Fisted Hand Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🤛",
    "slug": "left-facing-fist",
    "codepoints": [
      129307
    ],
    "primary": 129307,
    "name": "Left-Facing Fist",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🤜",
    "slug": "right-facing-fist",
    "codepoints": [
      129308
    ],
    "primary": 129308,
    "name": "Right-Facing Fist",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "👏",
    "slug": "clapping-hands-sign",
    "codepoints": [
      128079
    ],
    "primary": 128079,
    "name": "Clapping Hands Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🙌",
    "slug": "person-raising-both-hands-in-celebration",
    "codepoints": [
      128588
    ],
    "primary": 128588,
    "name": "Person Raising Both Hands In Celebration",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Emoticons",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "person-with-folded-hands"
    ]
  },
  {
    "symbol": "👐",
    "slug": "open-hands-sign",
    "codepoints": [
      128080
    ],
    "primary": 128080,
    "name": "Open Hands Sign",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🤲",
    "slug": "palms-up-together",
    "codepoints": [
      129330
    ],
    "primary": 129330,
    "name": "Palms Up Together",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🤝",
    "slug": "handshake",
    "codepoints": [
      129309
    ],
    "primary": 129309,
    "name": "Handshake",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🙏",
    "slug": "person-with-folded-hands",
    "codepoints": [
      128591
    ],
    "primary": 128591,
    "name": "Person With Folded Hands",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Emoticons",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "person-raising-both-hands-in-celebration"
    ]
  },
  {
    "symbol": "✍",
    "slug": "writing-hand",
    "codepoints": [
      9997
    ],
    "primary": 9997,
    "name": "Writing Hand",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Dingbats",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "text",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "heavy-black-heart",
      "heavy-heart-exclamation-mark-ornament",
      "rotated-heavy-black-heart-bullet",
      "floral-heart",
      "rotated-floral-heart-bullet",
      "black-four-pointed-star",
      "white-four-pointed-star",
      "stress-outlined-white-star",
      "circled-white-star",
      "open-centre-black-star",
      "black-centre-white-star",
      "outlined-black-star"
    ]
  },
  {
    "symbol": "💅",
    "slug": "nail-polish",
    "codepoints": [
      128133
    ],
    "primary": 128133,
    "name": "Nail Polish",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🤳",
    "slug": "selfie",
    "codepoints": [
      129331
    ],
    "primary": 129331,
    "name": "Selfie",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "💪",
    "slug": "flexed-biceps",
    "codepoints": [
      128170
    ],
    "primary": 128170,
    "name": "Flexed Biceps",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🦵",
    "slug": "leg",
    "codepoints": [
      129461
    ],
    "primary": 129461,
    "name": "Leg",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "🦶",
    "slug": "foot",
    "codepoints": [
      129462
    ],
    "primary": 129462,
    "name": "Foot",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "👂",
    "slug": "ear",
    "codepoints": [
      128066
    ],
    "primary": 128066,
    "name": "Ear",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🦻",
    "slug": "ear-with-hearing-aid",
    "codepoints": [
      129467
    ],
    "primary": 129467,
    "name": "Ear With Hearing Aid",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "👃",
    "slug": "nose",
    "codepoints": [
      128067
    ],
    "primary": 128067,
    "name": "Nose",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "👶",
    "slug": "baby",
    "codepoints": [
      128118
    ],
    "primary": 128118,
    "name": "Baby",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🧒",
    "slug": "child",
    "codepoints": [
      129490
    ],
    "primary": 129490,
    "name": "Child",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "👦",
    "slug": "boy",
    "codepoints": [
      128102
    ],
    "primary": 128102,
    "name": "Boy",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "👧",
    "slug": "girl",
    "codepoints": [
      128103
    ],
    "primary": 128103,
    "name": "Girl",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🧑",
    "slug": "adult",
    "codepoints": [
      129489
    ],
    "primary": 129489,
    "name": "Adult",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "👱",
    "slug": "person-with-blond-hair",
    "codepoints": [
      128113
    ],
    "primary": 128113,
    "name": "Person With Blond Hair",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "👨",
    "slug": "man",
    "codepoints": [
      128104
    ],
    "primary": 128104,
    "name": "Man",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🧔",
    "slug": "bearded-person",
    "codepoints": [
      129492
    ],
    "primary": 129492,
    "name": "Bearded Person",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "👩",
    "slug": "woman",
    "codepoints": [
      128105
    ],
    "primary": 128105,
    "name": "Woman",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "🧓",
    "slug": "older-adult",
    "codepoints": [
      129491
    ],
    "primary": 129491,
    "name": "Older Adult",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Supplemental Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "orange-heart",
      "white-heart",
      "brown-heart",
      "drum-with-drumsticks",
      "dna-double-helix",
      "microbe",
      "test-tube",
      "petri-dish",
      "manual-wheelchair",
      "motorized-wheelchair",
      "gorilla",
      "orangutan"
    ]
  },
  {
    "symbol": "👴",
    "slug": "older-man",
    "codepoints": [
      128116
    ],
    "primary": 128116,
    "name": "Older Man",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  },
  {
    "symbol": "👵",
    "slug": "older-woman",
    "codepoints": [
      128117
    ],
    "primary": 128117,
    "name": "Older Woman",
    "nameSource": "ucd",
    "aliases": [],
    "block": "Miscellaneous Symbols And Pictographs",
    "script": "Common",
    "generalCategory": "Other Symbol",
    "categorySlug": "people-hands",
    "categoryName": "People & Hands",
    "isEmoji": true,
    "isEmojiModifierBase": true,
    "supportsVariationSelector": true,
    "defaultPresentation": "emoji",
    "hasZwj": false,
    "lookalikes": [],
    "blockNeighbors": [
      "yellow-heart",
      "green-heart",
      "blue-heart",
      "purple-heart",
      "black-heart",
      "two-hearts",
      "sparkling-heart",
      "growing-heart",
      "heart-with-arrow",
      "heart-with-ribbon",
      "revolving-hearts",
      "heart-decoration"
    ]
  }
];

const _bySymbol = new Map<string, SymbolRecord>(SYMBOLS.map((r) => [r.symbol, r]));
const _bySlug = new Map<string, SymbolRecord>(SYMBOLS.map((r) => [r.slug, r]));

export function getRecordBySymbol(s: string): SymbolRecord | undefined {
  return _bySymbol.get(s);
}
export function getRecordBySlug(slug: string): SymbolRecord | undefined {
  return _bySlug.get(slug);
}
